export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * The `BigInt` scalar type represents non-fractional whole numeric values.
   * `BigInt` is not constrained to 32-bit like the `Int` type and thus is a less
   * compatible type.
   */
  BigInt: any;
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: any;
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: any;
  /**
   * The `GenericScalar` scalar type represents a generic
   * GraphQL scalar value that could be:
   * String, Boolean, Int, Float, List or Object.
   */
  GenericScalar: any;
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: any;
  SocialCamelJSON: any;
  /**
   * Leverages the internal Python implementation of UUID (uuid.UUID) to provide native UUID objects
   * in fields, resolvers and input.
   */
  UUID: any;
};

export type AdsInstallationLandingInput = {
  login: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Create an owner on Azure Devops Services. */
export type AdsInstallationLandingPayload = {
  __typename?: 'ADSInstallationLandingPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type AdsOrganization = {
  __typename?: 'ADSOrganization';
  /** Organization on Azure DevOps Services */
  login?: Maybe<Scalars['String']>;
  /** Whether the current user is the owner of this org on Azure DevOps Services. */
  isViewerOwner?: Maybe<Scalars['Boolean']>;
  /** True if the project has already installed DeepSource. */
  hasInstalled?: Maybe<Scalars['Boolean']>;
  /** Boolean that indicates whether third party application access is enabled on the organization. */
  hasEnabledThirdPartyAccess?: Maybe<Scalars['Boolean']>;
  /** URL for the organization's settings page. */
  orgSettingsUrl?: Maybe<Scalars['String']>;
};

/** An AI-generated code review issue. */
export type AiReviewIssue = {
  __typename?: 'AIReviewIssue';
  id: Scalars['ID'];
  path: Scalars['String'];
  severity: IssueSeverity;
  category: IssueType;
  text?: Maybe<Scalars['String']>;
  explanation?: Maybe<Scalars['String']>;
  shortExplanation?: Maybe<Scalars['String']>;
  isSuppressed: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  beginLine: Scalars['Int'];
  beginColumn: Scalars['Int'];
  endLine: Scalars['Int'];
  endColumn: Scalars['Int'];
  sourceCodeRendered?: Maybe<Scalars['String']>;
};

export type AcceptGroupInviteInput = {
  invitationCode: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type AcceptGroupInvitePayload = {
  __typename?: 'AcceptGroupInvitePayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type AcceptTeamMemberAdditionRequestInput = {
  additionRequestId: Scalars['ID'];
  role: TeamMemberRoleChoices;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type AcceptTeamMemberAdditionRequestPayload = {
  __typename?: 'AcceptTeamMemberAdditionRequestPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** AccessToken GQL Type. The value of `token` is not exposed. */
export type AccessToken = MaskPrimaryKeyNode & {
  __typename?: 'AccessToken';
  description: Scalars['String'];
  expiresAt: Scalars['DateTime'];
  lastUsedAt?: Maybe<Scalars['DateTime']>;
  /** The ID of the object */
  id: Scalars['ID'];
  /** Token's expiration status. */
  expirationStatus?: Maybe<AccessTokenExpirationStatus>;
};

export type AccessTokenConnection = {
  __typename?: 'AccessTokenConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AccessTokenEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `AccessToken` and its cursor. */
export type AccessTokenEdge = {
  __typename?: 'AccessTokenEdge';
  /** The item at the end of the edge */
  node?: Maybe<AccessToken>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export enum AccessTokenExpirationStatus {
  Active = 'ACTIVE',
  DoesNotExpire = 'DOES_NOT_EXPIRE',
  Expired = 'EXPIRED'
}

export enum ActionChoice {
  Add = 'ADD',
  Remove = 'REMOVE'
}

export type ActivateGsrRepositoryInput = {
  config: Scalars['String'];
  defaultBranchName: Scalars['String'];
  repositoryId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/**
 * Update the config and the default branch name of a repository (as
 * supplied by the user) and activate the repository.
 */
export type ActivateGsrRepositoryPayload = {
  __typename?: 'ActivateGSRRepositoryPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type ActivateRepositoryTargetInput = {
  targetId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Activate a repository target. */
export type ActivateRepositoryTargetPayload = {
  __typename?: 'ActivateRepositoryTargetPayload';
  ok: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type ActiveThirdPartyVulnerabilitiesReportItem = {
  __typename?: 'ActiveThirdPartyVulnerabilitiesReportItem';
  slug?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  value: Scalars['Int'];
};

export type AddAnalyzerFeedbackInput = {
  feedback: Scalars['String'];
  analyzerShortcode: Scalars['String'];
  okToContact: Scalars['Boolean'];
  isAlreadyUsing: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Add analyzer feedback */
export type AddAnalyzerFeedbackPayload = {
  __typename?: 'AddAnalyzerFeedbackPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type AddIdentityProviderInput = {
  teamId: Scalars['ID'];
  xmlMetadataUrl: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type AddIdentityProviderPayload = {
  __typename?: 'AddIdentityProviderPayload';
  ok: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type AddRepositoriesToRepositoryGroupInput = {
  /** GraphQL node ID of the repository group. */
  repositoryGroupId: Scalars['ID'];
  /** List of GraphQL node IDs of the repositories to add. */
  repositoryIds: Array<Scalars['ID']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Add repositories to a repository group. */
export type AddRepositoriesToRepositoryGroupPayload = {
  __typename?: 'AddRepositoriesToRepositoryGroupPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type AddSubRepoInput = {
  /** GraphQL node ID of the repository. */
  monorepoId: Scalars['ID'];
  defaultBranchName: Scalars['String'];
  path: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Create a `SubRepo` under a `Monorepo`. */
export type AddSubRepoPayload = {
  __typename?: 'AddSubRepoPayload';
  ok?: Maybe<Scalars['Boolean']>;
  repository?: Maybe<Repository>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type AddTeamToGroupInput = {
  groupId: Scalars['ID'];
  teamId: Scalars['ID'];
  role?: Maybe<TeamMemberRoleChoices>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type AddTeamToGroupPayload = {
  __typename?: 'AddTeamToGroupPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type AddTransformerFeedbackInput = {
  feedback: Scalars['String'];
  shortcode: Scalars['String'];
  okToContact: Scalars['Boolean'];
  isAlreadyUsing: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type AddTransformerFeedbackPayload = {
  __typename?: 'AddTransformerFeedbackPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type AddUserToGroupInput = {
  groupId: Scalars['ID'];
  userId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type AddUserToGroupPayload = {
  __typename?: 'AddUserToGroupPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type AgentsProduct = MaskPrimaryKeyNode & {
  __typename?: 'AgentsProduct';
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  /** The ID of the object */
  id: Scalars['ID'];
  plan: AgentsProductPlan;
  eventQuantity: Scalars['Int'];
};

/** An enumeration. */
export enum AgentsProductPlan {
  PlanFree = 'PLAN_FREE',
  PlanPro = 'PLAN_PRO'
}

/** An error that occurred during analysis. */
export type AnalysisError = {
  __typename?: 'AnalysisError';
  /** The error message. */
  message: Scalars['String'];
  /** The error level. */
  level: Scalars['Int'];
};

/** Union type representing either a static analysis issue or an AI review issue. */
export type AnalysisIssueUnion = StaticAnalysisIssue | AiReviewIssue;

export type AnalysisIssueUnionConnection = {
  __typename?: 'AnalysisIssueUnionConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AnalysisIssueUnionEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `AnalysisIssueUnion` and its cursor. */
export type AnalysisIssueUnionEdge = {
  __typename?: 'AnalysisIssueUnionEdge';
  /** The item at the end of the edge */
  node?: Maybe<AnalysisIssueUnion>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** An analyzer on DeepSource. */
export type Analyzer = MaskPrimaryKeyNode & {
  __typename?: 'Analyzer';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  category?: Maybe<Scalars['String']>;
  documentationUrl?: Maybe<Scalars['String']>;
  discussUrl?: Maybe<Scalars['String']>;
  /** Version of the image used for this analyzer. */
  version: Scalars['String'];
  /** Unique identifier for this analyzer globally. */
  shortcode: Scalars['String'];
  /** Path to the macro source code repository */
  macroPath?: Maybe<Scalars['String']>;
  /** Human-friendly name for this analyzer. */
  name: Scalars['String'];
  accessKey: Scalars['UUID'];
  logo?: Maybe<Scalars['String']>;
  /** Verbose description, written in Markdown. */
  description: Scalars['String'];
  analyzerType: AnalyzerAnalyzerType;
  status: AnalyzerStatus;
  /** Command that should be used to start this analyzer. */
  command?: Maybe<Scalars['String']>;
  /** Command that should be used to start this analyzer autofixer. */
  autofixerCommand?: Maybe<Scalars['String']>;
  /** CPU shares (in millicores) to allot for this analyzer to run. */
  minCpuLimit: Scalars['Int'];
  /** Memory allowed (in megabytes) for this analyzer to run. */
  minMemoryLimit: Scalars['Int'];
  maxCpuLimit: Scalars['Int'];
  maxMemoryLimit: Scalars['Int'];
  /** Schema of the meta fields accepted by the analyzer in .deepsource.toml. */
  metaSchema: Scalars['JSONString'];
  runtimeVersions: Array<Scalars['String']>;
  trigger: AnalyzerTrigger;
  repository?: Maybe<Repository>;
  owner?: Maybe<Scalars['String']>;
  isPrimary: Scalars['Boolean'];
  starIssues: IssueConnection;
  exampleConfig?: Maybe<Scalars['String']>;
  defaultTestPatterns: Array<Scalars['String']>;
  supportedFilesRegex?: Maybe<Scalars['String']>;
  cacheVersion: Scalars['Int'];
  reviews: AnalyzerReviewConnection;
  ciSnippets?: Maybe<AnalyzerCiSnippetConnection>;
  syncJobs?: Maybe<AnalyzerSyncJobConnection>;
  issues: IssueConnection;
  metrics: MetricConnection;
  checks: CheckConnection;
  repositories: RepositoryConnection;
  userSet: UserConnection;
  autofixRuns: AutofixRunConnection;
  transformertoolSet: TransformerToolConnection;
  transformerRuns: TransformerRunConnection;
  analyzerLogo?: Maybe<Scalars['String']>;
  descriptionRendered?: Maybe<Scalars['String']>;
  publishedOn?: Maybe<Scalars['Date']>;
  updatedOn?: Maybe<Scalars['Date']>;
  issuesCount?: Maybe<Scalars['Int']>;
  autofixableIssuesCount?: Maybe<Scalars['Int']>;
  isSyncable: Scalars['Boolean'];
  issueDistribution?: Maybe<Scalars['GenericScalar']>;
  issueTypeDistribution?: Maybe<Scalars['GenericScalar']>;
};


/** An analyzer on DeepSource. */
export type AnalyzerStarIssuesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  issueType?: Maybe<Scalars['String']>;
  autofixAvailable?: Maybe<Scalars['Boolean']>;
  autofixAiAvailable?: Maybe<Scalars['Boolean']>;
  auditRequired?: Maybe<Scalars['Boolean']>;
  severity?: Maybe<Scalars['String']>;
  severityIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  sort?: Maybe<Scalars['String']>;
};


/** An analyzer on DeepSource. */
export type AnalyzerReviewsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** An analyzer on DeepSource. */
export type AnalyzerCiSnippetsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** An analyzer on DeepSource. */
export type AnalyzerSyncJobsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** An analyzer on DeepSource. */
export type AnalyzerIssuesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  issueType?: Maybe<Scalars['String']>;
  autofixAvailable?: Maybe<Scalars['Boolean']>;
  autofixAiAvailable?: Maybe<Scalars['Boolean']>;
  auditRequired?: Maybe<Scalars['Boolean']>;
  severity?: Maybe<Scalars['String']>;
  severityIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  sort?: Maybe<Scalars['String']>;
};


/** An analyzer on DeepSource. */
export type AnalyzerMetricsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** An analyzer on DeepSource. */
export type AnalyzerChecksArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** An analyzer on DeepSource. */
export type AnalyzerRepositoriesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  vcsProvider?: Maybe<VcsProviderChoices>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  isActivated?: Maybe<Scalars['Boolean']>;
  errorCode?: Maybe<Scalars['Int']>;
  name_Icontains?: Maybe<Scalars['String']>;
  nameFuzzy?: Maybe<Scalars['String']>;
};


/** An analyzer on DeepSource. */
export type AnalyzerUserSetArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** An analyzer on DeepSource. */
export type AnalyzerAutofixRunsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  status_In?: Maybe<Array<Maybe<Scalars['String']>>>;
  pullRequestStatus_In?: Maybe<Array<Maybe<Scalars['String']>>>;
  q?: Maybe<Scalars['String']>;
};


/** An analyzer on DeepSource. */
export type AnalyzerTransformertoolSetArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  language?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** An analyzer on DeepSource. */
export type AnalyzerTransformerRunsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
};


/** An analyzer on DeepSource. */
export type AnalyzerIssueTypeDistributionArgs = {
  q?: Maybe<Scalars['String']>;
  issueType?: Maybe<Scalars['String']>;
  autofixAvailable?: Maybe<Scalars['Boolean']>;
  autofixAiAvailable?: Maybe<Scalars['Boolean']>;
  auditRequired?: Maybe<Scalars['Boolean']>;
  severity?: Maybe<Scalars['String']>;
  severityIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  sort?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum AnalyzerAnalyzerType {
  /** Core */
  Core = 'CORE',
  /** Community */
  Community = 'COMMUNITY',
  /** Custom */
  Custom = 'CUSTOM'
}

export type AnalyzerAutofixableIssues = {
  __typename?: 'AnalyzerAutofixableIssues';
  analyzer?: Maybe<Analyzer>;
  filesAffected?: Maybe<Scalars['Int']>;
  issueCount?: Maybe<Scalars['Int']>;
  raisedInFiles?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** An analyzer CI snippet. */
export type AnalyzerCiSnippet = MaskPrimaryKeyNode & {
  __typename?: 'AnalyzerCISnippet';
  /** The CI snippet */
  snippet: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  provider?: Maybe<CiProvider>;
};

export type AnalyzerCiSnippetConnection = {
  __typename?: 'AnalyzerCISnippetConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AnalyzerCiSnippetEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `AnalyzerCISnippet` and its cursor. */
export type AnalyzerCiSnippetEdge = {
  __typename?: 'AnalyzerCISnippetEdge';
  /** The item at the end of the edge */
  node?: Maybe<AnalyzerCiSnippet>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type AnalyzerConnection = {
  __typename?: 'AnalyzerConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AnalyzerEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Analyzer` and its cursor. */
export type AnalyzerEdge = {
  __typename?: 'AnalyzerEdge';
  /** The item at the end of the edge */
  node?: Maybe<Analyzer>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** An analyzer review on DeepSource. */
export type AnalyzerReview = MaskPrimaryKeyNode & {
  __typename?: 'AnalyzerReview';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  analyzer: Analyzer;
  name: Scalars['String'];
  avatar: Scalars['String'];
  comment: Scalars['String'];
};

export type AnalyzerReviewConnection = {
  __typename?: 'AnalyzerReviewConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AnalyzerReviewEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `AnalyzerReview` and its cursor. */
export type AnalyzerReviewEdge = {
  __typename?: 'AnalyzerReviewEdge';
  /** The item at the end of the edge */
  node?: Maybe<AnalyzerReview>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** An enumeration. */
export enum AnalyzerStatus {
  /** Active */
  Active = 'ACTIVE',
  /** Draft */
  Draft = 'DRAFT',
  /** Archived */
  Archived = 'ARCHIVED'
}

export type AnalyzerSyncJob = MaskPrimaryKeyNode & {
  __typename?: 'AnalyzerSyncJob';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  status: AnalyzerSyncJobStatus;
  /** This can be a commit oid, branch name or a tag */
  repositoryRef: Scalars['String'];
  /** Version of the analyzer when the sync job started. */
  oldVersion?: Maybe<Scalars['String']>;
  /** Version of the analyzer when the sync job finished. */
  newVersion: Scalars['String'];
  /** Stores any errors that might occur while syncing. */
  errors?: Maybe<Scalars['String']>;
};

export type AnalyzerSyncJobConnection = {
  __typename?: 'AnalyzerSyncJobConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AnalyzerSyncJobEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `AnalyzerSyncJob` and its cursor. */
export type AnalyzerSyncJobEdge = {
  __typename?: 'AnalyzerSyncJobEdge';
  /** The item at the end of the edge */
  node?: Maybe<AnalyzerSyncJob>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** An enumeration. */
export enum AnalyzerSyncJobStatus {
  Success = 'SUCCESS',
  Failed = 'FAILED'
}

/** An enumeration. */
export enum AnalyzerTrigger {
  /** On code push */
  Code = 'CODE',
  /** On data capture */
  Data = 'DATA'
}

/** An enumeration. */
export enum AnalyzerTypeChoices {
  Core = 'CORE',
  Community = 'COMMUNITY',
  Custom = 'CUSTOM'
}

export type AppliedCoupon = {
  __typename?: 'AppliedCoupon';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type ApplyCreditsToOwnerInput = {
  /** Owner's gql ID */
  id?: Maybe<Scalars['ID']>;
  ownerId?: Maybe<Scalars['Int']>;
  amount: Scalars['Int'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type ApplyCreditsToOwnerPayload = {
  __typename?: 'ApplyCreditsToOwnerPayload';
  ok?: Maybe<Scalars['Boolean']>;
  availableCredits?: Maybe<Scalars['Int']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type ArchiveCustomAnalyzerInput = {
  analyzerId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Archive a custom analyzer. */
export type ArchiveCustomAnalyzerPayload = {
  __typename?: 'ArchiveCustomAnalyzerPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Representation of a file attachment. */
export type Attachment = {
  /** The deepsource upload token for the attachment. */
  token: Scalars['UUID'];
  /** Filename of the attachment */
  filename: Scalars['String'];
};

export type AuditLog = MaskPrimaryKeyNode & {
  __typename?: 'AuditLog';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  eventName: Scalars['String'];
  description: Scalars['String'];
  actor?: Maybe<User>;
  ipAddress?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
};

export type AuditLogConnection = {
  __typename?: 'AuditLogConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AuditLogEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `AuditLog` and its cursor. */
export type AuditLogEdge = {
  __typename?: 'AuditLogEdge';
  /** The item at the end of the edge */
  node?: Maybe<AuditLog>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type AuthUrl = {
  __typename?: 'AuthUrl';
  /** The display name for this URL. */
  name: Scalars['String'];
  /** The authorization URL. */
  url: Scalars['String'];
  /** The VCS provider for this URL. */
  provider: VcsProviderChoices;
};

export type AutoOnboardEvent = MaskPrimaryKeyNode & {
  __typename?: 'AutoOnboardEvent';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  pullRequestNumber?: Maybe<Scalars['Int']>;
  owner: Owner;
  repository: Repository;
  template: ConfigTemplate;
  createdBy?: Maybe<User>;
  status: AutoOnboardEventStatus;
  vcsPrUrl?: Maybe<Scalars['String']>;
};

export type AutoOnboardEventConnection = {
  __typename?: 'AutoOnboardEventConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AutoOnboardEventEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `AutoOnboardEvent` and its cursor. */
export type AutoOnboardEventEdge = {
  __typename?: 'AutoOnboardEventEdge';
  /** The item at the end of the edge */
  node?: Maybe<AutoOnboardEvent>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** An enumeration. */
export enum AutoOnboardEventStatus {
  /** Pending */
  Pend = 'PEND',
  /** Closed */
  Clsd = 'CLSD',
  /** Failed to create PR */
  Fail = 'FAIL',
  /** Merged */
  Mrgd = 'MRGD',
  /** Open */
  Open = 'OPEN'
}

export type AutoOnboardInput = {
  templateShortcode: Scalars['String'];
  repoIds: Array<Maybe<Scalars['ID']>>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type AutoOnboardPayload = {
  __typename?: 'AutoOnboardPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Status of the autofix installation. */
export enum AutofixInstallationStatus {
  Installed = 'INSTALLED',
  NotInstalled = 'NOT_INSTALLED',
  NoPermission = 'NO_PERMISSION'
}

export type AutofixRun = MaskPrimaryKeyNode & {
  __typename?: 'AutofixRun';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  runId: Scalars['UUID'];
  commitOid?: Maybe<Scalars['String']>;
  status: AutofixRunStatus;
  finishedAt?: Maybe<Scalars['DateTime']>;
  errors?: Maybe<Scalars['JSONString']>;
  config?: Maybe<Scalars['JSONString']>;
  resolvedIssuesMetadata: Scalars['JSONString'];
  pullRequestNumber?: Maybe<Scalars['Int']>;
  pullRequestStatus: AutofixRunPullRequestStatus;
  committedToBranchStatus: AutofixRunCommittedToBranchStatus;
  extraData: Scalars['JSONString'];
  /** User who created the autofix run */
  createdBy?: Maybe<User>;
  issue?: Maybe<Issue>;
  analyzer?: Maybe<Analyzer>;
  repository: Repository;
  checkIssues: CheckIssueConnection;
  filesAffected?: Maybe<Scalars['Int']>;
  issuesAffected?: Maybe<Scalars['Int']>;
  affectedIssues?: Maybe<IssueConnection>;
  changeset?: Maybe<Scalars['GenericScalar']>;
  errorsRendered?: Maybe<Scalars['GenericScalar']>;
  finishedIn?: Maybe<Scalars['Int']>;
  vcsPrUrl?: Maybe<Scalars['String']>;
  resolvedIssuesCount?: Maybe<Scalars['Int']>;
  gitCompareDisplay?: Maybe<Scalars['String']>;
  isGeneratedFromPr?: Maybe<Scalars['Boolean']>;
  pullRequestTitle?: Maybe<Scalars['String']>;
  staleRedirectUrl?: Maybe<Scalars['String']>;
};


export type AutofixRunCheckIssuesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  shortcode?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
};


export type AutofixRunAffectedIssuesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  issueType?: Maybe<Scalars['String']>;
  autofixAvailable?: Maybe<Scalars['Boolean']>;
  autofixAiAvailable?: Maybe<Scalars['Boolean']>;
  auditRequired?: Maybe<Scalars['Boolean']>;
  severity?: Maybe<Scalars['String']>;
  severityIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  sort?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum AutofixRunCommittedToBranchStatus {
  /** Not committed to branch */
  Ncb = 'NCB',
  /** Commit in progress */
  Cip = 'CIP',
  /** Committed to branch */
  Ctb = 'CTB',
  /** Failed to commit */
  Ctf = 'CTF'
}

export type AutofixRunConnection = {
  __typename?: 'AutofixRunConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AutofixRunEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `AutofixRun` and its cursor. */
export type AutofixRunEdge = {
  __typename?: 'AutofixRunEdge';
  /** The item at the end of the edge */
  node?: Maybe<AutofixRun>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** An enumeration. */
export enum AutofixRunPullRequestStatus {
  /** Pull Request not created */
  Pnc = 'PNC',
  /** Pull Request in progress */
  Prp = 'PRP',
  /** Pull Request opened */
  Pro = 'PRO',
  /** Pull Request merged */
  Prm = 'PRM',
  /** Pull Request closed */
  Prc = 'PRC',
  /** Failed to create Pull Request */
  Prf = 'PRF'
}

/** An enumeration. */
export enum AutofixRunStatus {
  /** Pending */
  Pend = 'PEND',
  /** Success */
  Pass = 'PASS',
  /** Timed out */
  Timo = 'TIMO',
  /** Cancelled */
  Cncl = 'CNCL',
  /** Failure */
  Fail = 'FAIL',
  /** Stale */
  Stal = 'STAL'
}

export type AutofixableIssueDetail = {
  __typename?: 'AutofixableIssueDetail';
  shortcode?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  occurrenceCount?: Maybe<Scalars['Int']>;
};

export type AutofixableIssuesMetadata = {
  __typename?: 'AutofixableIssuesMetadata';
  autofixableIssueCount?: Maybe<Scalars['Int']>;
};


export type BilledRepositoryTarget = MaskPrimaryKeyNode & {
  __typename?: 'BilledRepositoryTarget';
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  /** The ID of the object */
  id: Scalars['ID'];
  repository: Repository;
  manifestPath?: Maybe<Scalars['String']>;
  lockfilePath: Scalars['String'];
  target?: Maybe<RepositoryTarget>;
  product: ScaProduct;
};

export type BilledRepositoryTargetConnection = {
  __typename?: 'BilledRepositoryTargetConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BilledRepositoryTargetEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `BilledRepositoryTarget` and its cursor. */
export type BilledRepositoryTargetEdge = {
  __typename?: 'BilledRepositoryTargetEdge';
  /** The item at the end of the edge */
  node?: Maybe<BilledRepositoryTarget>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type BillingAddress = {
  __typename?: 'BillingAddress';
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum BillingBackend {
  Stripe = 'STRIPE',
  Github = 'GITHUB',
  Manual = 'MANUAL',
  StripeV2 = 'STRIPE_V2'
}

export type BillingDetails = {
  __typename?: 'BillingDetails';
  id: Scalars['ID'];
  billingEmail?: Maybe<Scalars['String']>;
  billingAddress?: Maybe<BillingAddress>;
  billingInterval?: Maybe<BillingInterval>;
  nextBillingCycle?: Maybe<Scalars['DateTime']>;
  trialEndsAt?: Maybe<Scalars['DateTime']>;
  upcomingBillingAmount?: Maybe<Scalars['Int']>;
  cancelAtPeriodEnd?: Maybe<Scalars['Boolean']>;
  lastBillingAmount?: Maybe<Scalars['Int']>;
  card?: Maybe<Card>;
  cards?: Maybe<Array<Maybe<Card>>>;
  invoices?: Maybe<Array<Maybe<Invoice>>>;
  usageCredits?: Maybe<Scalars['Int']>;
  promotionalCredits?: Maybe<Scalars['Int']>;
};

export type BillingInfo = {
  __typename?: 'BillingInfo';
  planSlug?: Maybe<Scalars['String']>;
  seatsTotal?: Maybe<Scalars['Int']>;
  seatsUsed?: Maybe<Scalars['Int']>;
  lastBillAmount?: Maybe<Scalars['Float']>;
  upcomingBillAmount?: Maybe<Scalars['Float']>;
  lastPaymentDate?: Maybe<Scalars['DateTime']>;
  upcomingPaymentDate?: Maybe<Scalars['DateTime']>;
  upcomingCancellationDate?: Maybe<Scalars['DateTime']>;
  lastInvoiceUrl?: Maybe<Scalars['String']>;
  couponApplied?: Maybe<AppliedCoupon>;
  activeCard?: Maybe<Card>;
  invoices?: Maybe<Array<Maybe<Invoice>>>;
  outstandingCredits?: Maybe<Scalars['Float']>;
  upgradePlans?: Maybe<Array<Maybe<Scalars['String']>>>;
  downgradePlans?: Maybe<Array<Maybe<Scalars['String']>>>;
  status: SubscriptionStatusChoice;
  billingEmail?: Maybe<Scalars['String']>;
  billingAddress?: Maybe<Scalars['String']>;
  cancelAtPeriodEnd?: Maybe<Scalars['Boolean']>;
  billingBackend?: Maybe<Scalars['String']>;
  pendingUpdate?: Maybe<Scalars['Boolean']>;
  synced?: Maybe<Scalars['Boolean']>;
  /** The secret to use when performing SCA */
  clientSecret?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum BillingInterval {
  Monthly = 'MONTHLY',
  Annual = 'ANNUAL'
}

/** The billing management flow to use. */
export enum BillingManagementFlow {
  PaymentMethodUpdate = 'PAYMENT_METHOD_UPDATE',
  SubscriptionCancel = 'SUBSCRIPTION_CANCEL',
  SubscriptionUpdate = 'SUBSCRIPTION_UPDATE'
}

export type BitbucketDataCenterInstallationLandingInput = {
  projectKey: Scalars['String'];
  projectName: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Create an owner for a project on Bitbucket Data Center. */
export type BitbucketDataCenterInstallationLandingPayload = {
  __typename?: 'BitbucketDataCenterInstallationLandingPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type BitbucketDataCenterProject = {
  __typename?: 'BitbucketDataCenterProject';
  key: Scalars['String'];
  name: Scalars['String'];
  /** Whether the current user has admin access of this project on VCS. */
  isViewerOwner: Scalars['Boolean'];
  /** True if the project has already installed DeepSource. */
  hasInstalled: Scalars['Boolean'];
};

export type BitbucketInstallationLandingInput = {
  queryParams?: Maybe<Scalars['GenericScalar']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type BitbucketInstallationLandingPayload = {
  __typename?: 'BitbucketInstallationLandingPayload';
  message?: Maybe<Scalars['String']>;
  nextAction?: Maybe<NextActionChoice>;
  vcsProvider?: Maybe<VcsProviderChoices>;
  login?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum CiProvider {
  GithubActions = 'GITHUB_ACTIONS',
  Gitlab = 'GITLAB',
  Travis = 'TRAVIS',
  Circle = 'CIRCLE',
  Jenkins = 'JENKINS',
  Azure = 'AZURE'
}

/** A vulnerability call stack frame. */
export type CallStackFrame = MaskPrimaryKeyNode & {
  __typename?: 'CallStackFrame';
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  /** The ID of the object */
  id: Scalars['ID'];
  /** Code snippet */
  code: Scalars['String'];
  /** File path of the code */
  filepath: Scalars['String'];
  /** Method in which the code is */
  method: Scalars['String'];
  /** Starting line number of the code */
  lineNumber: Scalars['Int'];
  callStack: VulnerabilityCallStack;
  /** The link to the file path. */
  filepathLink?: Maybe<Scalars['String']>;
};

export type CallStackFrameConnection = {
  __typename?: 'CallStackFrameConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CallStackFrameEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `CallStackFrame` and its cursor. */
export type CallStackFrameEdge = {
  __typename?: 'CallStackFrameEdge';
  /** The item at the end of the edge */
  node?: Maybe<CallStackFrame>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type CancelCodeQualitySubscriptionInput = {
  /** Owner's gql ID */
  id?: Maybe<Scalars['ID']>;
  ownerId?: Maybe<Scalars['Int']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CancelCodeQualitySubscriptionPayload = {
  __typename?: 'CancelCodeQualitySubscriptionPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CancelUnifiedSubscriptionInput = {
  /** The owner's node ID */
  ownerId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Cancel a unified subscription (downgrade to free). */
export type CancelUnifiedSubscriptionPayload = {
  __typename?: 'CancelUnifiedSubscriptionPayload';
  subscription?: Maybe<ProductSubscription>;
  ok?: Maybe<Scalars['Boolean']>;
  error?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type Card = {
  __typename?: 'Card';
  /** Payment method ID for the card */
  id?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  endingIn?: Maybe<Scalars['String']>;
  expYear?: Maybe<Scalars['Int']>;
  expMonth?: Maybe<Scalars['Int']>;
  isDefault?: Maybe<Scalars['Boolean']>;
};

/** A check instance. */
export type Check = MaskPrimaryKeyNode & {
  __typename?: 'Check';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  checkSeq: Scalars['Int'];
  analyzer?: Maybe<Analyzer>;
  status: CheckStatus;
  run: Run;
  triggeredAt?: Maybe<Scalars['DateTime']>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  resolvedIssues: RepositoryIssueConnection;
  extraData: Scalars['JSONString'];
  errors?: Maybe<Scalars['GenericScalar']>;
  metrics: Scalars['JSONString'];
  /** Metrics captured as part of this check. */
  metricsCaptured?: Maybe<Array<Maybe<RepositoryMetricValue>>>;
  checkIssues: CheckIssueConnection;
  /** list of concrete issues raised in the given check */
  concreteIssues?: Maybe<IssueConnection>;
  /** Combined view of static analysis issues and AI review issues */
  allIssues?: Maybe<AnalysisIssueUnionConnection>;
  /** Time taken for this check to finish. */
  finishedIn?: Maybe<Scalars['Int']>;
  /** Human-readable representation of time take to finish this check. */
  finishedInDisplay?: Maybe<Scalars['String']>;
  errorsRendered?: Maybe<Scalars['GenericScalar']>;
  issuesRaisedCount: Scalars['Int'];
  issuesResolvedCount: Scalars['Int'];
  issuesSuppressedCount: Scalars['Int'];
  autofixableIssues?: Maybe<Array<Maybe<AutofixableIssueDetail>>>;
  filesAffectedByAutofix?: Maybe<Scalars['Int']>;
  hasInferredArtifacts?: Maybe<Scalars['Boolean']>;
  /** The `PR` this `Check` inferred artifacts from. */
  inferredArtifactsPr?: Maybe<Pr>;
  /** Whether this check can be retried for analysis or not. */
  isRetryable: Scalars['Boolean'];
};


/** A check instance. */
export type CheckResolvedIssuesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  recommended?: Maybe<Scalars['Boolean']>;
  issueType?: Maybe<Scalars['String']>;
  analyzer?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['String']>;
  severityIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  autofixAvailable?: Maybe<Scalars['Boolean']>;
  auditRequired?: Maybe<Scalars['Boolean']>;
  q?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
};


/** A check instance. */
export type CheckCheckIssuesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  shortcode?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
};


/** A check instance. */
export type CheckConcreteIssuesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  issueType?: Maybe<Scalars['String']>;
  autofixAvailable?: Maybe<Scalars['Boolean']>;
  autofixAiAvailable?: Maybe<Scalars['Boolean']>;
  auditRequired?: Maybe<Scalars['Boolean']>;
  severity?: Maybe<Scalars['String']>;
  severityIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  sort?: Maybe<Scalars['String']>;
};


/** A check instance. */
export type CheckAllIssuesArgs = {
  category?: Maybe<IssueType>;
  severity?: Maybe<IssueSeverity>;
  q?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type CheckConnection = {
  __typename?: 'CheckConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CheckEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Check` and its cursor. */
export type CheckEdge = {
  __typename?: 'CheckEdge';
  /** The item at the end of the edge */
  node?: Maybe<Check>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** A check issue. */
export type CheckIssue = MaskPrimaryKeyNode & {
  __typename?: 'CheckIssue';
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  checkInstance: Check;
  concreteIssue?: Maybe<Issue>;
  severity: CheckIssueSeverity;
  isSuppressed?: Maybe<Scalars['Boolean']>;
  /** The reason for suppressing this issue. */
  suppressionReason?: Maybe<Scalars['String']>;
  path: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  aiText?: Maybe<Scalars['String']>;
  explanation?: Maybe<Scalars['String']>;
  shortExplanation?: Maybe<Scalars['String']>;
  occurrenceType: CheckIssueOccurrenceType;
  validityStatus?: Maybe<OccurrenceValidityStatusChoices>;
  beginLine: Scalars['Int'];
  beginColumn: Scalars['Int'];
  endLine: Scalars['Int'];
  endColumn: Scalars['Int'];
  /** The identifier to use when fetching the source code snippet from runner. */
  sourceCodeIdentifier?: Maybe<Scalars['String']>;
  extraData: Scalars['JSONString'];
  sourceCodeMarkup?: Maybe<Scalars['String']>;
  issueType?: Maybe<Scalars['String']>;
  shortcode?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type CheckIssueConnection = {
  __typename?: 'CheckIssueConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CheckIssueEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `CheckIssue` and its cursor. */
export type CheckIssueEdge = {
  __typename?: 'CheckIssueEdge';
  /** The item at the end of the edge */
  node?: Maybe<CheckIssue>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** An enumeration. */
export enum CheckIssueOccurrenceType {
  /** Existing */
  Exist = 'EXIST',
  /** New */
  New = 'NEW'
}

/** An enumeration. */
export enum CheckIssueSeverity {
  /** Critical */
  Critical = 'CRITICAL',
  /** Major */
  Major = 'MAJOR',
  /** Minor */
  Minor = 'MINOR'
}

/** A check package. */
export type CheckPackage = MaskPrimaryKeyNode & {
  __typename?: 'CheckPackage';
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  /** The ID of the object */
  id: Scalars['ID'];
  packageGroup: PackageGroup;
  packageType: PackageType;
  /** Whether the dependency version is pinned in the user's target. */
  isPinned?: Maybe<Scalars['Boolean']>;
  target: RepositoryTarget;
  package: Package;
  packageVersion: PackageVersion;
  /** List of vulnerability occurrences. */
  vulnerabilityOccurrences: VulnerabilityOccurrenceConnection;
};


/** A check package. */
export type CheckPackageVulnerabilityOccurrencesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  targetId?: Maybe<Scalars['ID']>;
  packageType?: Maybe<PackageType>;
  severityIn?: Maybe<Array<Maybe<VulnerabilitySeverity>>>;
  reachabilityIn?: Maybe<Array<Maybe<VulnerabilityOccurrenceReachability>>>;
  fixabilityIn?: Maybe<Array<Maybe<VulnerabilityOccurrenceFixability>>>;
  dynamicRiskLevelIn?: Maybe<Array<Maybe<DynamicRiskLevel>>>;
  cvssScoreMin?: Maybe<Scalars['Float']>;
  cvssScoreMax?: Maybe<Scalars['Float']>;
  epssScoreMin?: Maybe<Scalars['Float']>;
  epssScoreMax?: Maybe<Scalars['Float']>;
  epssPercentileMin?: Maybe<Scalars['Float']>;
  epssPercentileMax?: Maybe<Scalars['Float']>;
  q?: Maybe<Scalars['String']>;
};

export type CheckPackageConnection = {
  __typename?: 'CheckPackageConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CheckPackageEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `CheckPackage` and its cursor. */
export type CheckPackageEdge = {
  __typename?: 'CheckPackageEdge';
  /** The item at the end of the edge */
  node?: Maybe<CheckPackage>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** An enumeration. */
export enum CheckStatus {
  /** Waiting */
  Wait = 'WAIT',
  /** Pending */
  Pend = 'PEND',
  /** Success */
  Pass = 'PASS',
  /** Failure */
  Fail = 'FAIL',
  /** Timed out */
  Timo = 'TIMO',
  /** Cancelled */
  Cncl = 'CNCL',
  /** Ready */
  Read = 'READ',
  /** Neutral */
  Neut = 'NEUT',
  /** Artifact not reported */
  Atmo = 'ATMO',
  /** Skipped */
  Skip = 'SKIP'
}

export type ClearIntegrationRepositorySettingsInput = {
  shortcode: Scalars['String'];
  repositoryId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type ClearIntegrationRepositorySettingsPayload = {
  __typename?: 'ClearIntegrationRepositorySettingsPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Status of the code analysis. */
export enum CodeAnalysisStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Error = 'ERROR',
  Adhoc = 'ADHOC'
}

export type CodeQualityProduct = MaskPrimaryKeyNode & {
  __typename?: 'CodeQualityProduct';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  plan: CodeQualityProductPlan;
  seats: Scalars['Int'];
  dataRetentionPeriod?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum CodeQualityProductPlan {
  PlanFree = 'PLAN_FREE',
  PlanStarter = 'PLAN_STARTER',
  PlanPremium = 'PLAN_PREMIUM',
  PlanEnterprise = 'PLAN_ENTERPRISE'
}

export type CommitAdhocConfigInput = {
  /** GraphQL node ID of repository. */
  repositoryId: Scalars['ID'];
  /** Create a pull request with the config. */
  createPullRequest?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CommitAdhocConfigPayload = {
  __typename?: 'CommitAdhocConfigPayload';
  ok?: Maybe<Scalars['Boolean']>;
  /** URL of the PR created if createPullRequest is true. null is returned otherwise. */
  vcsPrUrl?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CommitChangesToPrInput = {
  patches: Array<Maybe<Scalars['Int']>>;
  autofixRunId: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Create a commit on PR with selected patches. */
export type CommitChangesToPrPayload = {
  __typename?: 'CommitChangesToPRPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CommitConfigToVcsInput = {
  config: Scalars['String'];
  /** GraphQL node ID of the repository. */
  repositoryId: Scalars['ID'];
  /** Create a pull request with the config. */
  createPullRequest?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Commit the generated config to VCS provider. */
export type CommitConfigToVcsPayload = {
  __typename?: 'CommitConfigToVCSPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export enum CompanySizeChoices {
  UpTo_5 = 'UP_TO_5',
  Size_5_25 = 'SIZE_5_25',
  Size_26_100 = 'SIZE_26_100',
  Size_101_250 = 'SIZE_101_250',
  Size_251_1000 = 'SIZE_251_1000',
  Size_1000Plus = 'SIZE_1000_PLUS'
}

/** Enum for categories used in compliance issues. */
export enum ComplianceCategory {
  Mandatory = 'MANDATORY',
  Required = 'REQUIRED',
  Advisory = 'ADVISORY'
}

export type ComplianceIssue = {
  __typename?: 'ComplianceIssue';
  issueId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  category?: Maybe<ComplianceCategory>;
  occurrence?: Maybe<ComplianceIssueOccurrence>;
  rank?: Maybe<Scalars['String']>;
};

export type ComplianceIssueOccurrence = {
  __typename?: 'ComplianceIssueOccurrence';
  high?: Maybe<Scalars['Int']>;
  medium?: Maybe<Scalars['Int']>;
  low?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

/** A config generation run. */
export type ConfigGenerationRun = MaskPrimaryKeyNode & {
  __typename?: 'ConfigGenerationRun';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  runId: Scalars['UUID'];
  status: ConfigGenerationRunStatus;
  finishedAt?: Maybe<Scalars['DateTime']>;
  repository: Repository;
  branchName?: Maybe<Scalars['String']>;
  commitOid?: Maybe<Scalars['String']>;
  generatedConfig?: Maybe<Scalars['GenericScalar']>;
  errors?: Maybe<Scalars['GenericScalar']>;
  extraData: Scalars['JSONString'];
};

export type ConfigGenerationRunConnection = {
  __typename?: 'ConfigGenerationRunConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ConfigGenerationRunEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ConfigGenerationRun` and its cursor. */
export type ConfigGenerationRunEdge = {
  __typename?: 'ConfigGenerationRunEdge';
  /** The item at the end of the edge */
  node?: Maybe<ConfigGenerationRun>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** An enumeration. */
export enum ConfigGenerationRunStatus {
  /** Pending */
  Pend = 'PEND',
  /** Success */
  Pass = 'PASS',
  /** Failure */
  Fail = 'FAIL',
  /** Timed out */
  Timo = 'TIMO'
}

export type ConfigTemplate = MaskPrimaryKeyNode & {
  __typename?: 'ConfigTemplate';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  owner: Owner;
  shortcode: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
  config: Scalars['JSONString'];
  events: AutoOnboardEventConnection;
};


export type ConfigTemplateEventsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  owner?: Maybe<Scalars['ID']>;
};

export type ConfigTemplateConnection = {
  __typename?: 'ConfigTemplateConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ConfigTemplateEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ConfigTemplate` and its cursor. */
export type ConfigTemplateEdge = {
  __typename?: 'ConfigTemplateEdge';
  /** The item at the end of the edge */
  node?: Maybe<ConfigTemplate>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type ConfirmInvitationInput = {
  action?: Maybe<InviteActions>;
  invitationCode: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type ConfirmInvitationPayload = {
  __typename?: 'ConfirmInvitationPayload';
  ok?: Maybe<Scalars['Boolean']>;
  teamName?: Maybe<Scalars['String']>;
  teamLogin?: Maybe<Scalars['String']>;
  teamLogo?: Maybe<Scalars['String']>;
  vcsProvider?: Maybe<Scalars['String']>;
  role?: Maybe<TeamMemberRoleChoices>;
  viewer?: Maybe<User>;
  message?: Maybe<Scalars['String']>;
  joined?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Common context. */
export type Context = {
  __typename?: 'Context';
  staticRoot?: Maybe<Scalars['String']>;
  apiRoot?: Maybe<Scalars['String']>;
  websocketUrl?: Maybe<Scalars['String']>;
  installationProvidersUrl?: Maybe<Scalars['String']>;
  installationUrls?: Maybe<Scalars['GenericScalar']>;
  stripePublishableKey?: Maybe<Scalars['String']>;
  appEnv?: Maybe<Scalars['String']>;
  emptyAvatarUrl?: Maybe<Scalars['String']>;
  debug?: Maybe<Scalars['String']>;
  sentryDsn?: Maybe<Scalars['String']>;
  userGroupUrl?: Maybe<Scalars['String']>;
  weeklyLiveDemoUrl?: Maybe<Scalars['String']>;
  onPrem?: Maybe<Scalars['String']>;
  deepsourceCloudProduction?: Maybe<Scalars['String']>;
  githubEnabled?: Maybe<Scalars['Boolean']>;
  gitlabEnabled?: Maybe<Scalars['Boolean']>;
  bitbucketEnabled?: Maybe<Scalars['Boolean']>;
  supportEmail?: Maybe<Scalars['String']>;
  isTransformersLicensed?: Maybe<Scalars['Boolean']>;
  toOnboard?: Maybe<Scalars['Boolean']>;
  plans?: Maybe<Scalars['GenericScalar']>;
  platformStatus?: Maybe<PlatformStatus>;
  isRunner?: Maybe<Scalars['Boolean']>;
  runnerBaseUrl?: Maybe<Scalars['String']>;
};

export type CouponInfo = {
  __typename?: 'CouponInfo';
  currentCycleDiscount: Scalars['Float'];
  nextCycleDiscount: Scalars['Float'];
  isApplied: Scalars['Boolean'];
  description: Scalars['String'];
};

/** Status of the code coverage. */
export enum CoverageStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type CreateAccessTokenInput = {
  /** A note on why this token is being created. */
  description: Scalars['String'];
  /** Number of days from today this token should expire. */
  expireInDays?: Maybe<Scalars['Int']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Mutation to create a access token for a user */
export type CreateAccessTokenPayload = {
  __typename?: 'CreateAccessTokenPayload';
  /** Value of the newly generated token. */
  token?: Maybe<Scalars['String']>;
  /** The newly created token object. */
  accessToken?: Maybe<AccessToken>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CreateAutofixRunForAnalyzerInput = {
  analyzerId: Scalars['ID'];
  repositoryId: Scalars['ID'];
  inputFiles?: Maybe<Array<Maybe<Scalars['String']>>>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Create autofix run for repository issues of an Analyzer */
export type CreateAutofixRunForAnalyzerPayload = {
  __typename?: 'CreateAutofixRunForAnalyzerPayload';
  runId?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CreateAutofixRunForPullRequestInput = {
  checkId: Scalars['ID'];
  issues: Array<Maybe<Scalars['String']>>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CreateAutofixRunForPullRequestPayload = {
  __typename?: 'CreateAutofixRunForPullRequestPayload';
  autofixRunId?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CreateAutofixRunInput = {
  inputFiles: Array<Maybe<Scalars['String']>>;
  repoIssueId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Create new autofix run as the class name says :/ */
export type CreateAutofixRunPayload = {
  __typename?: 'CreateAutofixRunPayload';
  runId?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CreateBillingPortalSessionInput = {
  /** The owner's node ID */
  ownerId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Generate a URL to redirect the user to the Stripe billing portal. */
export type CreateBillingPortalSessionPayload = {
  __typename?: 'CreateBillingPortalSessionPayload';
  /** The billing portal URL */
  url?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CreateCheckoutSessionForUnifiedSubscriptionInput = {
  ownerId: Scalars['ID'];
  pricingPlan: UnifiedProductPlan;
  /** UI mode for checkout session */
  uiMode?: Maybe<Scalars['String']>;
  billingInterval?: Maybe<BillingInterval>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Create a Stripe Checkout Session for unified subscription. */
export type CreateCheckoutSessionForUnifiedSubscriptionPayload = {
  __typename?: 'CreateCheckoutSessionForUnifiedSubscriptionPayload';
  seats: Scalars['Int'];
  targetQuantity: Scalars['Int'];
  additionalTargetQuantity: Scalars['Int'];
  aiCredits: Scalars['Int'];
  checkoutSessionUrl?: Maybe<Scalars['String']>;
  checkoutSessionSecret?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CreateConfigTemplateInput = {
  ownerId: Scalars['ID'];
  config: Scalars['JSONString'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CreateConfigTemplatePayload = {
  __typename?: 'CreateConfigTemplatePayload';
  template?: Maybe<ConfigTemplate>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CreateCustomAnalyzerInput = {
  repositoryId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Create a custom analyzer from a repository. */
export type CreateCustomAnalyzerPayload = {
  __typename?: 'CreateCustomAnalyzerPayload';
  ok?: Maybe<Scalars['Boolean']>;
  customAnalyzer?: Maybe<Analyzer>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CreateGroupInput = {
  name: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CreateGroupPayload = {
  __typename?: 'CreateGroupPayload';
  group?: Maybe<EnterpriseGroup>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CreateIssueOnIntegrationInput = {
  integrationShortcode: Scalars['String'];
  repositoryIssueId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CreateIssueOnIntegrationPayload = {
  __typename?: 'CreateIssueOnIntegrationPayload';
  ok?: Maybe<Scalars['Boolean']>;
  issueCode?: Maybe<Scalars['String']>;
  issueUrl?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CreateManualTopupInput = {
  /** The owner's node ID */
  ownerId: Scalars['ID'];
  /** Amount to top up in cents */
  amountCents: Scalars['Int'];
  /** Stripe payment method ID to use for payment */
  paymentMethodId?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Create a manual top-up invoice with a specified amount and optional payment method. */
export type CreateManualTopupPayload = {
  __typename?: 'CreateManualTopupPayload';
  invoiceId?: Maybe<Scalars['String']>;
  amountCents?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CreatePublicReportInput = {
  level: ReportLevel;
  ownerLogin?: Maybe<Scalars['String']>;
  repositoryName?: Maybe<Scalars['String']>;
  vcsProvider?: Maybe<VcsProviderChoices>;
  label: Scalars['String'];
  isRestricted?: Maybe<Scalars['Boolean']>;
  password?: Maybe<Scalars['String']>;
  shareHistoricalData?: Maybe<Scalars['Boolean']>;
  reportKeys: Array<Maybe<Scalars['String']>>;
  source?: Maybe<ReportSource>;
  sourcedRepositories?: Maybe<Array<Maybe<Scalars['ID']>>>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Create a public report. */
export type CreatePublicReportPayload = {
  __typename?: 'CreatePublicReportPayload';
  report?: Maybe<PublicReport>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CreatePullRequestInput = {
  patches: Array<Maybe<Scalars['Int']>>;
  autofixRunId: Scalars['String'];
  repoId?: Maybe<Scalars['ID']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Submit list of patch id's to create PR */
export type CreatePullRequestPayload = {
  __typename?: 'CreatePullRequestPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CreateRemediationPatchForVulnerabilityOccurrenceInput = {
  fixPathId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CreateRemediationPatchForVulnerabilityOccurrencePayload = {
  __typename?: 'CreateRemediationPatchForVulnerabilityOccurrencePayload';
  ok: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CreateRepositoryGroupInput = {
  /** Name of the repository group. */
  name: Scalars['String'];
  /** GraphQL node ID of the owner. */
  ownerId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Create a new repository group. */
export type CreateRepositoryGroupPayload = {
  __typename?: 'CreateRepositoryGroupPayload';
  repositoryGroup?: Maybe<RepositoryGroup>;
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CreateRepositoryTargetInput = {
  repositoryId: Scalars['ID'];
  lockfilePath: Scalars['String'];
  manifestPath?: Maybe<Scalars['String']>;
  packageManager: PackageManager;
  /** Activate the target. */
  activate?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Create a new repository target. */
export type CreateRepositoryTargetPayload = {
  __typename?: 'CreateRepositoryTargetPayload';
  repositoryTarget?: Maybe<RepositoryTarget>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CreateSetupCheckoutSessionInput = {
  /** The owner's node ID */
  ownerId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Create a Stripe Checkout Session in setup mode for adding a payment method. */
export type CreateSetupCheckoutSessionPayload = {
  __typename?: 'CreateSetupCheckoutSessionPayload';
  clientSecret?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CreateWebhookInput = {
  url: Scalars['String'];
  secret: Scalars['String'];
  apiSigning: Scalars['Boolean'];
  eventsSubscribed: Array<Maybe<Scalars['String']>>;
  ownerId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Mutation to create a webhook for an owner */
export type CreateWebhookPayload = {
  __typename?: 'CreateWebhookPayload';
  webhook?: Maybe<Webhook>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CreditsInfo = {
  __typename?: 'CreditsInfo';
  currentCycleDiscount: Scalars['Float'];
  nextCycleDiscount: Scalars['Float'];
  isApplied: Scalars['Boolean'];
};



export type DeactivateRepositoryTargetInput = {
  targetId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Deactivate a repository target. */
export type DeactivateRepositoryTargetPayload = {
  __typename?: 'DeactivateRepositoryTargetPayload';
  ok: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum DefaultRepositoryPermissionChoices {
  None = 'NONE',
  Read = 'READ',
  Write = 'WRITE',
  Admin = 'ADMIN'
}

export type DeleteAccessTokenInput = {
  tokenId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Mutation to delete access token for an owner */
export type DeleteAccessTokenPayload = {
  __typename?: 'DeleteAccessTokenPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type DeleteAllAccessTokensInput = {
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Mutation to delete all access tokens */
export type DeleteAllAccessTokensPayload = {
  __typename?: 'DeleteAllAccessTokensPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type DeleteConfigTemplateInput = {
  shortcode: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type DeleteConfigTemplatePayload = {
  __typename?: 'DeleteConfigTemplatePayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type DeleteGroupInput = {
  groupId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type DeleteGroupPayload = {
  __typename?: 'DeleteGroupPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type DeleteIdentityProviderInput = {
  teamId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type DeleteIdentityProviderPayload = {
  __typename?: 'DeleteIdentityProviderPayload';
  ok: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type DeleteJsonWebTokenCookie = {
  __typename?: 'DeleteJSONWebTokenCookie';
  deleted: Scalars['Boolean'];
};

export type DeletePublicReportInput = {
  /** The `reportId` of the public report to delete. */
  reportId: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Delete a public report */
export type DeletePublicReportPayload = {
  __typename?: 'DeletePublicReportPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type DeleteRefreshTokenCookie = {
  __typename?: 'DeleteRefreshTokenCookie';
  deleted: Scalars['Boolean'];
};

export type DeleteRepositoryGroupInput = {
  /** GraphQL node ID of the repository group. */
  repositoryGroupId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Delete a repository group. */
export type DeleteRepositoryGroupPayload = {
  __typename?: 'DeleteRepositoryGroupPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type DeleteRepositoryTargetInput = {
  targetId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Delete a repository target. */
export type DeleteRepositoryTargetPayload = {
  __typename?: 'DeleteRepositoryTargetPayload';
  ok: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type DeleteRequestingUserInput = {
  sendEmail?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type DeleteRequestingUserPayload = {
  __typename?: 'DeleteRequestingUserPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type DeleteSilenceRuleInput = {
  /** ID of the silence rule to be deleted. */
  silenceRuleId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Delete a silence rule in a repository. */
export type DeleteSilenceRulePayload = {
  __typename?: 'DeleteSilenceRulePayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type DeleteSubRepoInput = {
  /** GraphQL node ID of the repository. */
  subRepoId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Delete an existing `SubRepo` under a `Monorepo`. */
export type DeleteSubRepoPayload = {
  __typename?: 'DeleteSubRepoPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type DeleteTeamInput = {
  teamId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type DeleteTeamPayload = {
  __typename?: 'DeleteTeamPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type DeleteUserInput = {
  userId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type DeleteWebhookInput = {
  webhookId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Mutation to delete a webhook */
export type DeleteWebhookPayload = {
  __typename?: 'DeleteWebhookPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type DetachSavedCardInput = {
  /** The owner's node ID */
  ownerId: Scalars['ID'];
  /** Stripe payment method ID to detach */
  paymentMethodId: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Detach a saved payment method (card) from the owner's Stripe customer. */
export type DetachSavedCardPayload = {
  __typename?: 'DetachSavedCardPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type DisableMonorepoModeInput = {
  /** GraphQL node ID of the repository. */
  repositoryId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Disable Monorepo mode for a `Repository`. */
export type DisableMonorepoModePayload = {
  __typename?: 'DisableMonorepoModePayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type DisableWebhookInput = {
  webhookId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Mutation to disable a webhook */
export type DisableWebhookPayload = {
  __typename?: 'DisableWebhookPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type Discount = {
  __typename?: 'Discount';
  coupon?: Maybe<CouponInfo>;
  credits?: Maybe<CreditsInfo>;
};

export type DowngradeToFreePlanInput = {
  /** The owner's node ID */
  ownerId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Downgrade a trial subscription to the free plan. */
export type DowngradeToFreePlanPayload = {
  __typename?: 'DowngradeToFreePlanPayload';
  ok?: Maybe<Scalars['Boolean']>;
  error?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Input for dynamic risk configuration. */
export type DynamicRiskConfigInput = {
  /** Weight for CVSS score in the base score calculation */
  cvssWeight?: Maybe<Scalars['Float']>;
  /** Weight for EPSS score in the base score calculation */
  epssWeight?: Maybe<Scalars['Float']>;
  /** Strategy for weighting EPSS percentile */
  percentileStrategy?: Maybe<PercentileStrategy>;
  /** Weight for reachable vulnerabilities */
  reachableWeight?: Maybe<Scalars['Float']>;
  /** Weight for unreachable vulnerabilities */
  unreachableWeight?: Maybe<Scalars['Float']>;
  /** Weight for vulnerabilities with unknown reachability */
  unknownWeight?: Maybe<Scalars['Float']>;
};

/** An enumeration. */
export enum DynamicRiskLevel {
  Limited = 'LIMITED',
  Elevated = 'ELEVATED',
  Imminent = 'IMMINENT'
}

/**
 * Ecosystems of packages supported by OSV.dev
 *
 * Ref: https://ossf.github.io/osv-schema/#affectedpackage-field
 */
export enum Ecosystem {
  Almalinux = 'ALMALINUX',
  Alpine = 'ALPINE',
  Android = 'ANDROID',
  Bioconductor = 'BIOCONDUCTOR',
  Bitnami = 'BITNAMI',
  ConanCenter = 'CONAN_CENTER',
  Cran = 'CRAN',
  CratesIo = 'CRATES_IO',
  Debian = 'DEBIAN',
  Ghc = 'GHC',
  GithubActions = 'GITHUB_ACTIONS',
  Go = 'GO',
  Hackage = 'HACKAGE',
  Hex = 'HEX',
  Linux = 'LINUX',
  Maven = 'MAVEN',
  Npm = 'NPM',
  Nuget = 'NUGET',
  OssFuzz = 'OSS_FUZZ',
  Packagist = 'PACKAGIST',
  PhotonOs = 'PHOTON_OS',
  Pub = 'PUB',
  Pypi = 'PYPI',
  RockyLinux = 'ROCKY_LINUX',
  Rubygems = 'RUBYGEMS',
  Swift = 'SWIFT',
  Ubuntu = 'UBUNTU'
}

export type EnableMonorepoModeInput = {
  /** GraphQL node ID of the repository. */
  repositoryId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Enable Monorepo mode for a `Repository`. */
export type EnableMonorepoModePayload = {
  __typename?: 'EnableMonorepoModePayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type EnterpriseBilledRepositoryTarget = MaskPrimaryKeyNode & {
  __typename?: 'EnterpriseBilledRepositoryTarget';
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  repository: Repository;
  manifestPath?: Maybe<Scalars['String']>;
  lockfilePath: Scalars['String'];
  target?: Maybe<RepositoryTarget>;
};

export type EnterpriseBilledRepositoryTargetConnection = {
  __typename?: 'EnterpriseBilledRepositoryTargetConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EnterpriseBilledRepositoryTargetEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `EnterpriseBilledRepositoryTarget` and its cursor. */
export type EnterpriseBilledRepositoryTargetEdge = {
  __typename?: 'EnterpriseBilledRepositoryTargetEdge';
  /** The item at the end of the edge */
  node?: Maybe<EnterpriseBilledRepositoryTarget>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type EnterpriseGroup = MaskPrimaryKeyNode & {
  __typename?: 'EnterpriseGroup';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  /** A unique identifier for a SCIM resource as defined by the service provider. */
  scimId?: Maybe<Scalars['String']>;
  /** A string that is an identifier for the resource as defined by the provisioning client. */
  scimExternalId?: Maybe<Scalars['String']>;
  /** A human-readable name for the Group. */
  scimDisplayName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  members?: Maybe<EnterpriseUserConnection>;
  teams: EnterpriseTeamConnection;
  invitationCode?: Maybe<Scalars['String']>;
  groupTeams?: Maybe<GroupTeamMembershipConnection>;
  groupUsers?: Maybe<GroupUserMembershipConnection>;
  allTeams?: Maybe<TeamConnection>;
  invitationUrl?: Maybe<Scalars['String']>;
  scimEnabled?: Maybe<Scalars['Boolean']>;
};


export type EnterpriseGroupMembersArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  isSuperuser?: Maybe<Scalars['Boolean']>;
};


export type EnterpriseGroupTeamsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
};


export type EnterpriseGroupGroupTeamsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
};


export type EnterpriseGroupGroupUsersArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
};


export type EnterpriseGroupAllTeamsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
};

export type EnterpriseGroupConnection = {
  __typename?: 'EnterpriseGroupConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EnterpriseGroupEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `EnterpriseGroup` and its cursor. */
export type EnterpriseGroupEdge = {
  __typename?: 'EnterpriseGroupEdge';
  /** The item at the end of the edge */
  node?: Maybe<EnterpriseGroup>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type EnterpriseInstallationRoot = {
  __typename?: 'EnterpriseInstallationRoot';
  installation?: Maybe<EnterpriseInstallationSetup>;
  license?: Maybe<EnterpriseLicense>;
  /** Lookup one group by GQL ID */
  group?: Maybe<EnterpriseGroup>;
  groups?: Maybe<EnterpriseGroupConnection>;
  /** Lookup one user by GQL ID */
  user?: Maybe<EnterpriseUser>;
  users?: Maybe<EnterpriseUserConnection>;
  superusers?: Maybe<EnterpriseUserConnection>;
  /** Lookup one team by GQL ID */
  team?: Maybe<EnterpriseTeam>;
  teams?: Maybe<EnterpriseTeamConnection>;
  personalAccounts?: Maybe<OwnerConnection>;
  /** Replicated management console URL */
  managementConsoleUrl?: Maybe<Scalars['String']>;
  /** Indicates whether SCIM provisioning is enabled */
  isScimEnabled?: Maybe<Scalars['Boolean']>;
  /** List of billed repository targets */
  billedTargets?: Maybe<EnterpriseBilledRepositoryTargetConnection>;
};


export type EnterpriseInstallationRootGroupArgs = {
  id: Scalars['ID'];
};


export type EnterpriseInstallationRootGroupsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
};


export type EnterpriseInstallationRootUserArgs = {
  id: Scalars['ID'];
};


export type EnterpriseInstallationRootUsersArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  isSuperuser?: Maybe<Scalars['Boolean']>;
};


export type EnterpriseInstallationRootSuperusersArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  isSuperuser?: Maybe<Scalars['Boolean']>;
};


export type EnterpriseInstallationRootTeamArgs = {
  id: Scalars['ID'];
};


export type EnterpriseInstallationRootTeamsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
};


export type EnterpriseInstallationRootPersonalAccountsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type EnterpriseInstallationRootBilledTargetsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type EnterpriseInstallationSetup = MaskPrimaryKeyNode & {
  __typename?: 'EnterpriseInstallationSetup';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  name: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
};

export type EnterpriseLicense = {
  __typename?: 'EnterpriseLicense';
  seatsTotal?: Maybe<Scalars['Int']>;
  seatsUsed?: Maybe<Scalars['Int']>;
  targetsTotal?: Maybe<Scalars['Int']>;
  targetsUsed?: Maybe<Scalars['Int']>;
  plan?: Maybe<Scalars['String']>;
  licenseExpiry?: Maybe<Scalars['String']>;
  seatUsageTrend?: Maybe<Scalars['GenericScalar']>;
};


export type EnterpriseLicenseSeatUsageTrendArgs = {
  lastDays: Scalars['Int'];
  trendType: TrendType;
};

export enum EnterprisePilotLicenseSeatChoices {
  Blw_50 = 'BLW_50',
  Btw_50_99 = 'BTW_50_99',
  Btw_100_249 = 'BTW_100_249',
  Btw_250_499 = 'BTW_250_499',
  Btw_500_999 = 'BTW_500_999',
  Btw_1000_2499 = 'BTW_1000_2499',
  Btw_2500_4999 = 'BTW_2500_4999',
  Abv_5000 = 'ABV_5000'
}

/** An enumeration. */
export enum EnterprisePilotLicenseVcsChoices {
  GithubCloud = 'GITHUB_CLOUD',
  GithubEnterpriseServer = 'GITHUB_ENTERPRISE_SERVER',
  GithubEnterpriseCloud = 'GITHUB_ENTERPRISE_CLOUD',
  GitlabCloud = 'GITLAB_CLOUD',
  GitlabSelfHostedCe = 'GITLAB_SELF_HOSTED_CE',
  GitlabSelfHostedEe = 'GITLAB_SELF_HOSTED_EE',
  BitbucketCloud = 'BITBUCKET_CLOUD',
  BitbucketDatacenter = 'BITBUCKET_DATACENTER',
  AzureDevopsServices = 'AZURE_DEVOPS_SERVICES'
}

export type EnterpriseTeam = MaskPrimaryKeyNode & {
  __typename?: 'EnterpriseTeam';
  ownerPtr: Owner;
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  /** The unique identifier (or username) of the account. */
  login: Scalars['String'];
  avatar?: Maybe<Scalars['String']>;
  /** VCS provider of this owner's origin. */
  vcsProvider: OwnerVcsProvider;
  /** Unique identity of this owner in the VCS, if available. */
  vcsAccountUid: Scalars['String'];
  /** Pricing plan which this owner is subscribed to. */
  plan?: Maybe<OwnerPlan>;
  customerId?: Maybe<Scalars['String']>;
  primaryUser?: Maybe<User>;
  gsrSetupPending: Scalars['Boolean'];
  resourceSelector?: Maybe<OwnerResourceSelector>;
  runner?: Maybe<Runner>;
  runnerApp?: Maybe<RunnerApp>;
  IsBetaTester?: Maybe<Scalars['Boolean']>;
  billingVersion?: Maybe<OwnerBillingVersion>;
  /** The team's public name. */
  name: Scalars['String'];
  members: UserConnection;
  invitationCode?: Maybe<Scalars['String']>;
  syncPermissionsWithVcs: Scalars['Boolean'];
  features: FeatureDefinitionConnection;
  memberAdditionRequests: TeamMemberAdditionRequestConnection;
  /** Get IdentityProvider for the team. */
  identityProvider?: Maybe<IdentityProvider>;
  basePermissionSet?: Maybe<TeamBasePermissionSet>;
  /** Slack Connect channel for this team (trial customers). */
  slackConnectChannel?: Maybe<SlackConnectChannelType>;
  analyzers: AnalyzerConnection;
  productSubscriptions: ProductSubscriptionConnection;
  team?: Maybe<EnterpriseTeam>;
  repositories: RepositoryConnection;
  issuePriorities: IssuePriorityConnection;
  userSet: UserConnection;
  configTemplates: ConfigTemplateConnection;
  onboardingEvents: AutoOnboardEventConnection;
  repositoryGroups: RepositoryGroupConnection;
  ownerSetting?: Maybe<OwnerSetting>;
  profile?: Maybe<OwnerProfile>;
  /** The owner for which this report was created. Corresponds to owner level reports. */
  publicReports: PublicReportConnection;
  webhooks: WebhookConnection;
  billingEmail?: Maybe<Scalars['String']>;
  billingAddress?: Maybe<Scalars['String']>;
  numMembersTotal?: Maybe<Scalars['Int']>;
  isViewerPrimaryUser?: Maybe<Scalars['Boolean']>;
  /** Members of this team. */
  teamMembers: TeamMemberConnection;
  /** Team invites that are pending in this team. */
  invites?: Maybe<TeamMemberInvitationConnection>;
  /** Sharable invitation link for the team */
  invitationUrl?: Maybe<Scalars['String']>;
  /** Requests to join the team */
  additionRequests?: Maybe<TeamMemberAdditionRequestConnection>;
  /** List of audit logs */
  logs?: Maybe<AuditLogConnection>;
  accountSetupStatus?: Maybe<Scalars['GenericScalar']>;
  roleInGroup?: Maybe<TeamMemberRoleChoices>;
  isDirectMember?: Maybe<Scalars['Boolean']>;
  /** Repository collaborators in all repositories of this team. */
  repositoryCollaborators: RepositoryCollaboratorConnection;
  activeRepositoryCount?: Maybe<Scalars['Int']>;
  /** Get VerifiableDomain for the team. */
  verifiableDomain?: Maybe<VerifiableDomain>;
  /** List of all audit logs concerning the team's members */
  allLogs?: Maybe<AuditLogConnection>;
};


export type EnterpriseTeamMembersArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type EnterpriseTeamFeaturesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type EnterpriseTeamMemberAdditionRequestsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  status?: Maybe<TeamMemberAdditionRequestStatus>;
};


export type EnterpriseTeamAnalyzersArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  categoryIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  q?: Maybe<Scalars['String']>;
  exclude?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type EnterpriseTeamProductSubscriptionsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  productType?: Maybe<ProductChoice>;
};


export type EnterpriseTeamRepositoriesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  vcsProvider?: Maybe<VcsProviderChoices>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  isActivated?: Maybe<Scalars['Boolean']>;
  errorCode?: Maybe<Scalars['Int']>;
  name_Icontains?: Maybe<Scalars['String']>;
  nameFuzzy?: Maybe<Scalars['String']>;
};


export type EnterpriseTeamIssuePrioritiesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type EnterpriseTeamUserSetArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type EnterpriseTeamConfigTemplatesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  shortcode?: Maybe<Scalars['String']>;
  title_Icontains?: Maybe<Scalars['String']>;
};


export type EnterpriseTeamOnboardingEventsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  owner?: Maybe<Scalars['ID']>;
};


export type EnterpriseTeamRepositoryGroupsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_Icontains?: Maybe<Scalars['String']>;
};


export type EnterpriseTeamPublicReportsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  q?: Maybe<Scalars['String']>;
};


export type EnterpriseTeamWebhooksArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type EnterpriseTeamTeamMembersArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  role?: Maybe<Array<Maybe<Scalars['String']>>>;
  isAddedFromVcs?: Maybe<Scalars['Boolean']>;
  isRoleFromVcs?: Maybe<Scalars['Boolean']>;
};


export type EnterpriseTeamInvitesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};


export type EnterpriseTeamAdditionRequestsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  status?: Maybe<TeamMemberAdditionRequestStatus>;
};


export type EnterpriseTeamLogsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  actorIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  eventIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  ipAddressIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdAtGte?: Maybe<Scalars['Date']>;
  createdAtLte?: Maybe<Scalars['Date']>;
  q?: Maybe<Scalars['String']>;
};


export type EnterpriseTeamRepositoryCollaboratorsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  permission?: Maybe<Scalars['String']>;
  isAddedFromVcs?: Maybe<Scalars['Boolean']>;
  isPermFromVcs?: Maybe<Scalars['Boolean']>;
};


export type EnterpriseTeamAllLogsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  actorIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  eventIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  ipAddressIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdAtGte?: Maybe<Scalars['Date']>;
  createdAtLte?: Maybe<Scalars['Date']>;
  q?: Maybe<Scalars['String']>;
};

export type EnterpriseTeamConnection = {
  __typename?: 'EnterpriseTeamConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EnterpriseTeamEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `EnterpriseTeam` and its cursor. */
export type EnterpriseTeamEdge = {
  __typename?: 'EnterpriseTeamEdge';
  /** The item at the end of the edge */
  node?: Maybe<EnterpriseTeam>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type EnterpriseUser = MaskPrimaryKeyNode & {
  __typename?: 'EnterpriseUser';
  id: Scalars['ID'];
  lastLogin?: Maybe<Scalars['DateTime']>;
  /** Designates that this user has all permissions without explicitly assigning them. */
  isSuperuser: Scalars['Boolean'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  /** Designates whether the user can log into this admin site. */
  isStaff: Scalars['Boolean'];
  /** Designates whether this user should be treated as active. Unselect this instead of deleting accounts. */
  isActive: Scalars['Boolean'];
  dateJoined: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  /** A unique identifier for a SCIM resource as defined by the service provider. */
  scimId?: Maybe<Scalars['String']>;
  /** A string that is an identifier for the resource as defined by the provisioning client. */
  scimExternalId?: Maybe<Scalars['String']>;
  /** A service provider's unique identifier for the user */
  scimUsername?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  primaryOwner?: Maybe<Owner>;
  /** Avatar URL. */
  avatar?: Maybe<Scalars['String']>;
  preferredTechnologies: AnalyzerConnection;
  bookmarkedIssues: RepositoryIssueConnection;
  preference?: Maybe<UserPreference>;
  customerId?: Maybe<Scalars['String']>;
  IsBetaTester: Scalars['Boolean'];
  deleted?: Maybe<Scalars['DateTime']>;
  /** Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only. */
  username: Scalars['String'];
  socialAuth: UserSocialConnectionConnection;
  accessTokens: AccessTokenConnection;
  primaryOwnerships: OwnerConnection;
  productSubscriptions: ProductSubscriptionConnection;
  teams: EnterpriseTeamConnection;
  teamMemberships: TeamMemberConnection;
  teamAdditionRequests: TeamMemberAdditionRequestConnection;
  transactions: TransactionConnection;
  scimGroups: EnterpriseGroupConnection;
  onboardingEvents: AutoOnboardEventConnection;
  /** Linked DeepSource user (if they have an account) */
  prAuthorships: PrAuthorConnection;
  repoGroups: RepositoryGroupConnection;
  profile?: Maybe<UserProfile>;
  vulnerabilityremediationpatchrunSet: VulnerabilityRemediationPatchRunConnection;
  silenceRulesCreated: SilenceRuleConnection;
  /** Full name of the user. */
  fullName?: Maybe<Scalars['String']>;
  /** Get all the team user has access to directly or through groups */
  team?: Maybe<TeamConnection>;
  scimEnabled?: Maybe<Scalars['Boolean']>;
};


export type EnterpriseUserPreferredTechnologiesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  categoryIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  q?: Maybe<Scalars['String']>;
  exclude?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type EnterpriseUserBookmarkedIssuesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  recommended?: Maybe<Scalars['Boolean']>;
  issueType?: Maybe<Scalars['String']>;
  analyzer?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['String']>;
  severityIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  autofixAvailable?: Maybe<Scalars['Boolean']>;
  auditRequired?: Maybe<Scalars['Boolean']>;
  q?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
};


export type EnterpriseUserSocialAuthArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type EnterpriseUserAccessTokensArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type EnterpriseUserPrimaryOwnershipsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type EnterpriseUserProductSubscriptionsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  productType?: Maybe<ProductChoice>;
};


export type EnterpriseUserTeamsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
};


export type EnterpriseUserTeamMembershipsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  role?: Maybe<Array<Maybe<Scalars['String']>>>;
  isAddedFromVcs?: Maybe<Scalars['Boolean']>;
  isRoleFromVcs?: Maybe<Scalars['Boolean']>;
};


export type EnterpriseUserTeamAdditionRequestsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  status?: Maybe<TeamMemberAdditionRequestStatus>;
};


export type EnterpriseUserTransactionsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  transactionType?: Maybe<TransactionTransactionType>;
};


export type EnterpriseUserScimGroupsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
};


export type EnterpriseUserOnboardingEventsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  owner?: Maybe<Scalars['ID']>;
};


export type EnterpriseUserPrAuthorshipsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type EnterpriseUserRepoGroupsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_Icontains?: Maybe<Scalars['String']>;
};


export type EnterpriseUserVulnerabilityremediationpatchrunSetArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type EnterpriseUserSilenceRulesCreatedArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  creator?: Maybe<Scalars['ID']>;
  issueTitle?: Maybe<Scalars['String']>;
  issueCode?: Maybe<Scalars['String']>;
  filePath?: Maybe<Scalars['String']>;
  silenceLevel?: Maybe<SilenceRuleSilenceLevel>;
};


export type EnterpriseUserTeamArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
};

export type EnterpriseUserConnection = {
  __typename?: 'EnterpriseUserConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EnterpriseUserEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `EnterpriseUser` and its cursor. */
export type EnterpriseUserEdge = {
  __typename?: 'EnterpriseUserEdge';
  /** The item at the end of the edge */
  node?: Maybe<EnterpriseUser>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type ExportAuditLogsInput = {
  /** GraphQL node ID of the team or repository. */
  objectId: Scalars['ID'];
  /** Filter start date. */
  createdAtGte: Scalars['Date'];
  /** Filter end date. */
  createdAtLte: Scalars['Date'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type ExportAuditLogsPayload = {
  __typename?: 'ExportAuditLogsPayload';
  ok: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Export formats for vulnerability occurrences. */
export enum ExportFormat {
  Csv = 'CSV',
  Json = 'JSON'
}

export type ExportRepositoryTargetSbomInput = {
  /** GraphQL node ID of repository target. */
  objectId: Scalars['ID'];
  /** The export format for the SBOM report. */
  exportFormat: SbomExportFormat;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type ExportRepositoryTargetSbomPayload = {
  __typename?: 'ExportRepositoryTargetSBOMPayload';
  ok: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type ExportVulnerabilityOccurrencesInput = {
  /** GraphQL node ID of repository target or repository. */
  objectId: Scalars['ID'];
  /** The export format for the vulnerability occurrences. */
  exportFormat: ExportFormat;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type ExportVulnerabilityOccurrencesPayload = {
  __typename?: 'ExportVulnerabilityOccurrencesPayload';
  ok: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** A Feature definition. */
export type FeatureDefinition = MaskPrimaryKeyNode & {
  __typename?: 'FeatureDefinition';
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  shortcode: Scalars['String'];
  featureType: FeatureFeatureType;
  showUpgradeCta: Scalars['Boolean'];
  subscribedOwners: OwnerConnection;
  /** The ID of the object */
  id: Scalars['ID'];
};


/** A Feature definition. */
export type FeatureDefinitionSubscribedOwnersArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type FeatureDefinitionConnection = {
  __typename?: 'FeatureDefinitionConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FeatureDefinitionEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `FeatureDefinition` and its cursor. */
export type FeatureDefinitionEdge = {
  __typename?: 'FeatureDefinitionEdge';
  /** The item at the end of the edge */
  node?: Maybe<FeatureDefinition>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** An enumeration. */
export enum FeatureFeatureType {
  /** Billing */
  A_1 = 'A_1',
  /** Experimental */
  A_2 = 'A_2'
}

export type FeatureInfo = {
  __typename?: 'FeatureInfo';
  feature?: Maybe<FeatureDefinition>;
  enabled?: Maybe<Scalars['Boolean']>;
};

export type GsrInstallationLandingInput = {
  login: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Create owner for GSR. */
export type GsrInstallationLandingPayload = {
  __typename?: 'GSRInstallationLandingPayload';
  ok?: Maybe<Scalars['Boolean']>;
  reauth?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type GsrProject = {
  __typename?: 'GSRProject';
  /** Project id on GCP. */
  login?: Maybe<Scalars['String']>;
  /** Project name on GCP. */
  name?: Maybe<Scalars['String']>;
  /** True if the project has already installed DeepSource. */
  hasInstalled?: Maybe<Scalars['Boolean']>;
  /** True if verification steps are pending for this owner */
  isSetupPending?: Maybe<Scalars['Boolean']>;
};

export type GenerateKeyPairForOwnerInput = {
  /** GraphQL node ID of the owner. */
  ownerId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Generate (or regenerate) a new RSA key pair for an owner. */
export type GenerateKeyPairForOwnerPayload = {
  __typename?: 'GenerateKeyPairForOwnerPayload';
  publicKey?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type GenerateKeyPairForRepositoryGroupInput = {
  /** GraphQL node ID of the repository group. */
  repositoryGroupId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Generate a new key pair for the repository group. */
export type GenerateKeyPairForRepositoryGroupPayload = {
  __typename?: 'GenerateKeyPairForRepositoryGroupPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type GenerateKeyPairForRepositoryInput = {
  /** GraphQL node ID of the repository. */
  repositoryId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Generate (or regenerate) a new RSA key pair for a repository. */
export type GenerateKeyPairForRepositoryPayload = {
  __typename?: 'GenerateKeyPairForRepositoryPayload';
  repository?: Maybe<Repository>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type GeneratePackageUpgradeSummaryInput = {
  ecosystem: Ecosystem;
  packageName: Scalars['String'];
  fromVersion: Scalars['String'];
  toVersion: Scalars['String'];
  /** Global ID of the owner. */
  ownerId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/**
 * Generate a summary of changes between two package versions. If
 * the summary already exists, it will be returned instead.
 */
export type GeneratePackageUpgradeSummaryPayload = {
  __typename?: 'GeneratePackageUpgradeSummaryPayload';
  isGenerated: Scalars['Boolean'];
  summary?: Maybe<PackageUpgradeSummary>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type GenerateRepositoryConfigInput = {
  /** GraphQL node ID of the repository. */
  repositoryId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Trigger config generation for a repository. */
export type GenerateRepositoryConfigPayload = {
  __typename?: 'GenerateRepositoryConfigPayload';
  /** UUID of the config generation run for tracking. */
  runId?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};


export type GetAuthTokenForPublicReportInput = {
  /** The public report ID. */
  reportId: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Get an auth token for a public report. */
export type GetAuthTokenForPublicReportPayload = {
  __typename?: 'GetAuthTokenForPublicReportPayload';
  token?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type GetBillingInfoInput = {
  productSlug: Scalars['String'];
  planSlug: Scalars['String'];
  quantity: Scalars['Int'];
  couponCode?: Maybe<Scalars['String']>;
  /** Owner's gql ID */
  id?: Maybe<Scalars['ID']>;
  ownerId?: Maybe<Scalars['Int']>;
  isTrial: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type GetBillingInfoPayload = {
  __typename?: 'GetBillingInfoPayload';
  amountPayableThisCycle: Scalars['Float'];
  amountPayableNextCycle: Scalars['Float'];
  nextBillingCycle: Scalars['DateTime'];
  netPayableThisCycle: Scalars['Float'];
  netPayableNextCycle: Scalars['Float'];
  discounts: Discount;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type GetIntegrationInstallationUrlInput = {
  /** The integration shortcode */
  shortcode: Scalars['String'];
  /** The ID of the owner for whom the installation is being triggered. */
  ownerId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type GetIntegrationInstallationUrlPayload = {
  __typename?: 'GetIntegrationInstallationURLPayload';
  /** The installation URL */
  url?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type GetSubscriptionCheckoutUrlForIdeInput = {
  plan: IdeProductPlan;
  interval: BillingInterval;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type GetSubscriptionCheckoutUrlForIdePayload = {
  __typename?: 'GetSubscriptionCheckoutURLForIDEPayload';
  url: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type GetSubscriptionCheckoutUrlForScaInput = {
  ownerId: Scalars['ID'];
  plan: ScaProductPlan;
  interval: BillingInterval;
  targetQuantity?: Maybe<Scalars['Int']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type GetSubscriptionCheckoutUrlForScaPayload = {
  __typename?: 'GetSubscriptionCheckoutURLForSCAPayload';
  url: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type GetSubscriptionManagementUrlForIde = {
  __typename?: 'GetSubscriptionManagementURLForIDE';
  url: Scalars['String'];
};

export type GetSubscriptionManagementUrlForScaInput = {
  subscriptionId: Scalars['ID'];
  /** The billing management flow to use. */
  flow: BillingManagementFlow;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type GetSubscriptionManagementUrlForScaPayload = {
  __typename?: 'GetSubscriptionManagementURLForSCAPayload';
  url: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type GetTeamMemberRequestStatus = {
  __typename?: 'GetTeamMemberRequestStatus';
  status?: Maybe<TeamMemberAdditionRequestStatus>;
};

export type GetUpgradeCodeQualitySubscriptionPlanInfoInput = {
  /** Owner's gql ID */
  id?: Maybe<Scalars['ID']>;
  ownerId?: Maybe<Scalars['Int']>;
  planSlug: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type GetUpgradeCodeQualitySubscriptionPlanInfoPayload = {
  __typename?: 'GetUpgradeCodeQualitySubscriptionPlanInfoPayload';
  endingBalance?: Maybe<Scalars['Float']>;
  upcomingBillAmount?: Maybe<Scalars['Float']>;
  upcomingBillDate?: Maybe<Scalars['DateTime']>;
  prorationAmount?: Maybe<Scalars['Float']>;
  proratedForDays?: Maybe<Scalars['Int']>;
  billedImmediately?: Maybe<Scalars['Boolean']>;
  quantity?: Maybe<Scalars['Int']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type GithubEnterpriseInstallationLandingInput = {
  queryParams?: Maybe<Scalars['GenericScalar']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type GithubEnterpriseInstallationLandingPayload = {
  __typename?: 'GithubEnterpriseInstallationLandingPayload';
  message?: Maybe<Scalars['String']>;
  nextAction?: Maybe<NextActionChoice>;
  vcsProvider?: Maybe<VcsProviderChoices>;
  login?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type GithubInstallationLandingInput = {
  queryParams?: Maybe<Scalars['GenericScalar']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type GithubInstallationLandingPayload = {
  __typename?: 'GithubInstallationLandingPayload';
  message?: Maybe<Scalars['String']>;
  nextAction?: Maybe<NextActionChoice>;
  vcsProvider?: Maybe<VcsProviderChoices>;
  login?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type GitlabInstallationLandingInput = {
  login: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Create an owner on Gitlab. */
export type GitlabInstallationLandingPayload = {
  __typename?: 'GitlabInstallationLandingPayload';
  ok?: Maybe<Scalars['Boolean']>;
  reauth?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type GroupInviteInfo = {
  __typename?: 'GroupInviteInfo';
  name?: Maybe<Scalars['String']>;
};

export type GroupTeamMembership = MaskPrimaryKeyNode & {
  __typename?: 'GroupTeamMembership';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  role?: Maybe<TeamMemberRoleChoices>;
  team: EnterpriseTeam;
  group: EnterpriseGroup;
};

export type GroupTeamMembershipConnection = {
  __typename?: 'GroupTeamMembershipConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GroupTeamMembershipEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `GroupTeamMembership` and its cursor. */
export type GroupTeamMembershipEdge = {
  __typename?: 'GroupTeamMembershipEdge';
  /** The item at the end of the edge */
  node?: Maybe<GroupTeamMembership>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GroupUserMembership = MaskPrimaryKeyNode & {
  __typename?: 'GroupUserMembership';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  user: User;
  group: EnterpriseGroup;
};

export type GroupUserMembershipConnection = {
  __typename?: 'GroupUserMembershipConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GroupUserMembershipEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `GroupUserMembership` and its cursor. */
export type GroupUserMembershipEdge = {
  __typename?: 'GroupUserMembershipEdge';
  /** The item at the end of the edge */
  node?: Maybe<GroupUserMembership>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GroupedUsageMetric = {
  __typename?: 'GroupedUsageMetric';
  labels: Array<Scalars['String']>;
  series: Array<UsageMetricSeries>;
};

export type IdeProduct = MaskPrimaryKeyNode & {
  __typename?: 'IDEProduct';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  plan: IdeProductPlan;
};

/** An enumeration. */
export enum IdeProductPlan {
  PlanFree = 'PLAN_FREE',
  PlanPro = 'PLAN_PRO',
  PlanSponsored = 'PLAN_SPONSORED'
}

export type IdentityProvider = MaskPrimaryKeyNode & {
  __typename?: 'IdentityProvider';
  /** The ID of the object */
  id: Scalars['ID'];
  xmlMetadataUrl: Scalars['String'];
  domain: VerifiableDomain;
  provider: Scalars['String'];
  isScimEnabled: Scalars['Boolean'];
  isScimAuthTokenSet: Scalars['Boolean'];
};

export type IgnoreAiReviewIssueInput = {
  /** ID of the AI Review Issue. */
  id: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Ignore a specific AI Review issue. */
export type IgnoreAiReviewIssuePayload = {
  __typename?: 'IgnoreAIReviewIssuePayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export enum IgnoreCheckIssueActionChoice {
  Suppress = 'SUPPRESS',
  Delete = 'DELETE',
  RemoveFromRepository = 'REMOVE_FROM_REPOSITORY',
  RemoveFromCheck = 'REMOVE_FROM_CHECK'
}

export type IgnoreCheckIssueInput = {
  /** ID of the CheckIssue. */
  checkIssueId: Scalars['ID'];
  action?: Maybe<IgnoreCheckIssueActionChoice>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Ignore a particular check issue. */
export type IgnoreCheckIssuePayload = {
  __typename?: 'IgnoreCheckIssuePayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type IgnoreCheckMetricInput = {
  /** Check ID */
  checkId: Scalars['ID'];
  /** Metric shortcode */
  metricShortcode: Scalars['String'];
  /** Namespace key identifying the analyzer */
  key: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Ignore a particular failing metric reported by a check. */
export type IgnoreCheckMetricPayload = {
  __typename?: 'IgnoreCheckMetricPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type IgnoreIssueForFilePatternInRepositoryInput = {
  /** ID of the RepositoryIssue. */
  repoIssueId?: Maybe<Scalars['ID']>;
  /** ID of the Repository. */
  repositoryId?: Maybe<Scalars['ID']>;
  /** ID of the Check. */
  checkId?: Maybe<Scalars['ID']>;
  /** shortcode of the issue */
  issueShortcode?: Maybe<Scalars['String']>;
  /** Glob pattern of the files to create the rule. */
  pattern: Scalars['String'];
  /** When using checkId: also create a persistent ignore rule in addition to suppressing occurrences in the current check. */
  alsoCreateRule?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Ignore issue for a file pattern in a repository. */
export type IgnoreIssueForFilePatternInRepositoryPayload = {
  __typename?: 'IgnoreIssueForFilePatternInRepositoryPayload';
  ok?: Maybe<Scalars['Boolean']>;
  /** IDs of CheckIssues that have been removed as part of creating this rule. */
  checkIssueIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** True if a matching ignore rule already existed (no new rule created). */
  ruleAlreadyExisted?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type IgnoreIssueForRepositoryInput = {
  /** ID of the RepositoryIssue. */
  repoIssueId?: Maybe<Scalars['ID']>;
  /** ID of the Repository. */
  repositoryId?: Maybe<Scalars['ID']>;
  /** ID of the Check. */
  checkId?: Maybe<Scalars['ID']>;
  /** shortcode of the issue */
  issueShortcode?: Maybe<Scalars['String']>;
  /** Optional. File path for which issue is being ignored. */
  filePath?: Maybe<Scalars['String']>;
  /** When using checkId: also create a persistent ignore rule in addition to suppressing occurrences in the current check. */
  alsoCreateRule?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Ignore an issue for a repository, from a RepositoryIssue. */
export type IgnoreIssueForRepositoryPayload = {
  __typename?: 'IgnoreIssueForRepositoryPayload';
  ok?: Maybe<Scalars['Boolean']>;
  /** IDs of CheckIssues that have been removed as part of creating this rule. */
  checkIssueIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** True if a matching ignore rule already existed (no new rule created). */
  ruleAlreadyExisted?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type IgnoreIssueForTestPatternsInRepositoryInput = {
  /** ID of the RepositoryIssue. */
  repoIssueId?: Maybe<Scalars['ID']>;
  /** ID of the Repository. */
  repositoryId?: Maybe<Scalars['ID']>;
  /** ID of the Check. */
  checkId?: Maybe<Scalars['ID']>;
  /** shortcode of the issue */
  issueShortcode?: Maybe<Scalars['String']>;
  /** When using checkId: also create a persistent ignore rule in addition to suppressing occurrences in the current check. */
  alsoCreateRule?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Ignore issue for a test patterns defined in the repository's config. */
export type IgnoreIssueForTestPatternsInRepositoryPayload = {
  __typename?: 'IgnoreIssueForTestPatternsInRepositoryPayload';
  ok?: Maybe<Scalars['Boolean']>;
  /** IDs of CheckIssues that have been removed as part of creating this rule. */
  checkIssueIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** True if a matching ignore rule already existed (no new rule created). */
  ruleAlreadyExisted?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type InstallIntegrationInput = {
  step: IntegrationInstallationStep;
  shortcode: Scalars['String'];
  ownerId: Scalars['ID'];
  code: Scalars['String'];
  state: Scalars['String'];
  settings?: Maybe<Scalars['GenericScalar']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type InstallIntegrationPayload = {
  __typename?: 'InstallIntegrationPayload';
  nextStep?: Maybe<IntegrationInstallationStep>;
  options?: Maybe<Scalars['GenericScalar']>;
  installingOn?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export enum IntegrationFeature {
  FeatureNotify = 'FEATURE_NOTIFY',
  FeatureIssue = 'FEATURE_ISSUE'
}

export enum IntegrationInstallationStep {
  Install = 'INSTALL',
  ConfigReqd = 'CONFIG_REQD',
  Complete = 'COMPLETE',
  Expired = 'EXPIRED'
}

export type IntegrationProvider = {
  __typename?: 'IntegrationProvider';
  /** Shortcode of the integration provider */
  shortcode?: Maybe<Scalars['String']>;
  /** The name of the integration */
  name?: Maybe<Scalars['String']>;
  /** URL pointing to the logo for this integration */
  logo?: Maybe<Scalars['String']>;
  /** Whether the integration is installed or not */
  installed?: Maybe<Scalars['Boolean']>;
  /** The team/workspace/etc. the integration is installed on */
  installedOn?: Maybe<Scalars['String']>;
  /** Status of the integration installation */
  status?: Maybe<IntegrationProviderStatus>;
  /** The user that installed the integration */
  enabledBy?: Maybe<User>;
  /** The date & time the integration was enabled */
  enabledOn?: Maybe<Scalars['DateTime']>;
  /** The owner settings for this integration */
  settings?: Maybe<Scalars['GenericScalar']>;
  /** The available options for the settings of this integration */
  options?: Maybe<Scalars['GenericScalar']>;
};

/** An enumeration. */
export enum IntegrationProviderStatus {
  Active = 'ACTIVE',
  Paused = 'PAUSED',
  Error = 'ERROR',
  ConfigRequired = 'CONFIG_REQUIRED'
}

export enum IntegrationSettingsLevel {
  Repository = 'REPOSITORY',
  Owner = 'OWNER'
}

export enum InviteActions {
  View = 'VIEW',
  Accept = 'ACCEPT'
}

export enum InviteTeamMemberActionChoice {
  Create = 'CREATE',
  Cancel = 'CANCEL'
}

export type InviteTeamMemberInput = {
  ownerId?: Maybe<Scalars['Int']>;
  ownerPk?: Maybe<Scalars['ID']>;
  email: Scalars['String'];
  action: InviteTeamMemberActionChoice;
  role: TeamMemberRoleChoices;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type InviteTeamMemberPayload = {
  __typename?: 'InviteTeamMemberPayload';
  invitationUrl?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type InviteTeamMembersInput = {
  invitees: Array<Maybe<Invitee>>;
  ownerId: Scalars['ID'];
  action: InviteTeamMemberActionChoice;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type InviteTeamMembersPayload = {
  __typename?: 'InviteTeamMembersPayload';
  /** True if the operation is successful. */
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type Invitee = {
  email: Scalars['String'];
  role: TeamMemberRoleChoices;
};

export type Invoice = {
  __typename?: 'Invoice';
  id?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
  amount?: Maybe<Scalars['Float']>;
  amountCents?: Maybe<Scalars['Int']>;
  status?: Maybe<InvoiceStatus>;
  url?: Maybe<Scalars['String']>;
};

export enum InvoiceStatus {
  Draft = 'DRAFT',
  Open = 'OPEN',
  Paid = 'PAID',
  Uncollectible = 'UNCOLLECTIBLE',
  Void = 'VOID'
}

/** An issue. */
export type Issue = MaskPrimaryKeyNode & {
  __typename?: 'Issue';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  shortcode: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
  severity: IssueSeverity;
  analyzer: Analyzer;
  /** Dimension this issue belongs to for Run Report Card */
  dimension?: Maybe<IssueDimension>;
  autofixAvailable: Scalars['Boolean'];
  autofixAiAvailable?: Maybe<Scalars['Boolean']>;
  autofixTitle?: Maybe<Scalars['String']>;
  isRecommended: Scalars['Boolean'];
  weight: Scalars['Int'];
  auditRequired?: Maybe<Scalars['Boolean']>;
  starIssueInAnalyzers: AnalyzerConnection;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  linkedMetrics: MetricConnection;
  checkIssues: CheckIssueConnection;
  repoIssues: RepositoryIssueConnection;
  issuePriorities: IssuePriorityConnection;
  autofixRuns: AutofixRunConnection;
  suppressedByOwners: OwnerSettingConnection;
  occurrenceCount?: Maybe<Scalars['Int']>;
  issueType?: Maybe<Scalars['String']>;
  seenIn?: Maybe<Scalars['String']>;
  descriptionRendered?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  shortDescriptionRendered?: Maybe<Scalars['String']>;
  /** Issue priority for this issue in the passed context (repo/owner) */
  issuePriority?: Maybe<IssuePriority>;
};


/** An issue. */
export type IssueStarIssueInAnalyzersArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  categoryIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  q?: Maybe<Scalars['String']>;
  exclude?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** An issue. */
export type IssueLinkedMetricsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** An issue. */
export type IssueCheckIssuesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  shortcode?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
};


/** An issue. */
export type IssueRepoIssuesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  recommended?: Maybe<Scalars['Boolean']>;
  issueType?: Maybe<Scalars['String']>;
  analyzer?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['String']>;
  severityIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  autofixAvailable?: Maybe<Scalars['Boolean']>;
  auditRequired?: Maybe<Scalars['Boolean']>;
  q?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
};


/** An issue. */
export type IssueIssuePrioritiesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** An issue. */
export type IssueAutofixRunsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  status_In?: Maybe<Array<Maybe<Scalars['String']>>>;
  pullRequestStatus_In?: Maybe<Array<Maybe<Scalars['String']>>>;
  q?: Maybe<Scalars['String']>;
};


/** An issue. */
export type IssueSuppressedByOwnersArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** An issue. */
export type IssueIssuePriorityArgs = {
  objectId: Scalars['ID'];
  level: IssuePriorityLevel;
};

export type IssueConnection = {
  __typename?: 'IssueConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<IssueEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum IssueDimension {
  /** Reliability */
  Reliability = 'RELIABILITY',
  /** Complexity */
  Complexity = 'COMPLEXITY',
  /** Hygiene */
  Hygiene = 'HYGIENE',
  /** Coverage */
  Coverage = 'COVERAGE',
  /** Security */
  Security = 'SECURITY'
}

export type IssueDistribution = {
  __typename?: 'IssueDistribution';
  slug?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
  logoUrl?: Maybe<Scalars['String']>;
};

/** The sort key for sorting issue distribution in reports. */
export enum IssueDistributionSortKey {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** A Relay edge containing a `Issue` and its cursor. */
export type IssueEdge = {
  __typename?: 'IssueEdge';
  /** The item at the end of the edge */
  node?: Maybe<Issue>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type IssueOccurrenceFrequency = {
  __typename?: 'IssueOccurrenceFrequency';
  /** Unique identifier that is either the product category or issue type. */
  key: Scalars['String'];
  /** Verbose name for the key. */
  label: Scalars['String'];
  /** Count of issue occurrences. */
  count: Scalars['Int'];
};

/** An issue with issue priority info */
export type IssuePriority = MaskPrimaryKeyNode & {
  __typename?: 'IssuePriority';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  issuePriorityType: IssuePriorityType;
  concreteIssue: Issue;
  repository?: Maybe<Repository>;
  owner?: Maybe<Owner>;
  repositoryIssuePriority?: Maybe<IssuePriorityType>;
  ownerIssuePriority?: Maybe<IssuePriorityType>;
  cascadingIssuePriority?: Maybe<IssuePriorityType>;
  source?: Maybe<IssuePriorityLevel>;
};

export type IssuePriorityConnection = {
  __typename?: 'IssuePriorityConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<IssuePriorityEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `IssuePriority` and its cursor. */
export type IssuePriorityEdge = {
  __typename?: 'IssuePriorityEdge';
  /** The item at the end of the edge */
  node?: Maybe<IssuePriority>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export enum IssuePriorityLevel {
  Repository = 'REPOSITORY',
  Owner = 'OWNER',
  Enterprise = 'ENTERPRISE'
}

export type IssuePrioritySetting = {
  __typename?: 'IssuePrioritySetting';
  slug?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Int']>;
  verboseName?: Maybe<Scalars['String']>;
  isIgnoredInCheckStatus?: Maybe<Scalars['Boolean']>;
  isIgnoredToDisplay?: Maybe<Scalars['Boolean']>;
};

export type IssuePriorityType = MaskPrimaryKeyNode & {
  __typename?: 'IssuePriorityType';
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  weight?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  verboseName?: Maybe<Scalars['String']>;
  issuePriorities: IssuePriorityConnection;
  /** The ID of the object */
  id: Scalars['ID'];
};


export type IssuePriorityTypeIssuePrioritiesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type IssuePriorityTypeConnection = {
  __typename?: 'IssuePriorityTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<IssuePriorityTypeEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `IssuePriorityType` and its cursor. */
export type IssuePriorityTypeEdge = {
  __typename?: 'IssuePriorityTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<IssuePriorityType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** An enumeration. */
export enum IssueSeverity {
  Critical = 'CRITICAL',
  Major = 'MAJOR',
  Minor = 'MINOR'
}

export type IssueSeveritySetting = {
  __typename?: 'IssueSeveritySetting';
  severity: IssueSeverity;
  isIgnoredInCheckStatus: Scalars['Boolean'];
  isIgnoredToDisplay: Scalars['Boolean'];
};

export type IssueSeveritySettingInput = {
  severity: IssueSeverity;
  isIgnoredInCheckStatus: Scalars['Boolean'];
  isIgnoredToDisplay: Scalars['Boolean'];
};

export type IssueTrend = {
  __typename?: 'IssueTrend';
  trendValue?: Maybe<Scalars['Int']>;
  trendHint?: Maybe<Scalars['String']>;
  trendDirection?: Maybe<TrendDirection>;
  trendPositive?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum IssueType {
  AntiPattern = 'ANTI_PATTERN',
  BugRisk = 'BUG_RISK',
  Performance = 'PERFORMANCE',
  Security = 'SECURITY',
  Coverage = 'COVERAGE',
  Typecheck = 'TYPECHECK',
  Style = 'STYLE',
  Documentation = 'DOCUMENTATION',
  Secrets = 'SECRETS'
}

export type IssueTypeSetting = {
  __typename?: 'IssueTypeSetting';
  slug?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  isIgnoredInCheckStatus?: Maybe<Scalars['Boolean']>;
  isIgnoredToDisplay?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
};

export type IssueTypeSettingInput = {
  slug?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  isIgnoredInCheckStatus?: Maybe<Scalars['Boolean']>;
  isIgnoredToDisplay?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
};


export type License = MaskPrimaryKeyNode & {
  __typename?: 'License';
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  /** Identifier of the license */
  identifier: Scalars['String'];
  /** Name of the license */
  name: Scalars['String'];
  /** Text of the license */
  text?: Maybe<Scalars['String']>;
  /** Is the license OSI approved? */
  isOsiApproved: Scalars['Boolean'];
  /** Whether the license is Free/Libre as per FSF */
  isFsfFreeLibre: Scalars['Boolean'];
  /** Is the license deprecated? */
  isDeprecated: Scalars['Boolean'];
  /** SPDX version which deprecated the license */
  deprecatedSinceVersion?: Maybe<Scalars['String']>;
  /** Whether the license is safe or not. */
  isSafe?: Maybe<Scalars['Boolean']>;
};

export type LicenseConnection = {
  __typename?: 'LicenseConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LicenseEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `License` and its cursor. */
export type LicenseEdge = {
  __typename?: 'LicenseEdge';
  /** The item at the end of the edge */
  node?: Maybe<License>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export enum LicenseSafetyFilter {
  Safe = 'SAFE',
  Unsafe = 'UNSAFE'
}

export type LogOutInput = {
  clientMutationId?: Maybe<Scalars['String']>;
};

export type LogOutPayload = {
  __typename?: 'LogOutPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Custom node class to prevent leaking primary keys as integers */
export type MaskPrimaryKeyNode = {
  /** The ID of the object */
  id: Scalars['ID'];
};

/** A Metric instance */
export type Metric = MaskPrimaryKeyNode & {
  __typename?: 'Metric';
  /** Unique identifier for this metric. */
  shortcode: Scalars['String'];
  /** Human-friendly name for this metric. */
  name: Scalars['String'];
  /** Verbose description, written in Markdown. */
  description: Scalars['String'];
  /** Unit to be shown to the user for this metric */
  unit?: Maybe<Scalars['String']>;
  /** Whether this metric supports threshold on aggregate namespace */
  supportsAggregateThreshold: Scalars['Boolean'];
  /** The ID of the object */
  id: Scalars['ID'];
  category?: Maybe<Scalars['String']>;
  namespaces?: Maybe<Array<Maybe<MetricNamespace>>>;
  namespacesTrends?: Maybe<Array<Maybe<MetricNamespaceTrend>>>;
  newCodeMetricShortcode?: Maybe<Scalars['String']>;
  trendPositive: Scalars['Boolean'];
};


/** A Metric instance */
export type MetricNamespacesTrendsArgs = {
  lastDays: Scalars['Int'];
};

export type MetricConnection = {
  __typename?: 'MetricConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MetricEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Metric` and its cursor. */
export type MetricEdge = {
  __typename?: 'MetricEdge';
  /** The item at the end of the edge */
  node?: Maybe<Metric>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** A RepositoryMetric instance as a namespace under Metric. */
export type MetricNamespace = {
  __typename?: 'MetricNamespace';
  key?: Maybe<Scalars['String']>;
  threshold?: Maybe<Scalars['Int']>;
  newCodeThreshold?: Maybe<Scalars['Int']>;
  analyzerShortcode?: Maybe<Scalars['String']>;
  analyzerLogo?: Maybe<Scalars['String']>;
};

/** Returns namespaces valid for default branch only. */
export type MetricNamespaceTrend = {
  __typename?: 'MetricNamespaceTrend';
  isPassing?: Maybe<Scalars['Boolean']>;
  valueDisplay?: Maybe<Scalars['String']>;
  valueTrend?: Maybe<Scalars['GenericScalar']>;
  key?: Maybe<Scalars['String']>;
  threshold?: Maybe<Scalars['Int']>;
  newCodeThreshold?: Maybe<Scalars['Int']>;
  analyzerShortcode?: Maybe<Scalars['String']>;
  analyzerLogo?: Maybe<Scalars['String']>;
};

export type MetricSetting = {
  __typename?: 'MetricSetting';
  shortcode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  isIgnoredInCheckStatus?: Maybe<Scalars['Boolean']>;
  isIgnoredToDisplay?: Maybe<Scalars['Boolean']>;
};

export type MetricSettingsInput = {
  shortcode: Scalars['String'];
  isIgnoredInCheckStatus: Scalars['Boolean'];
  isIgnoredToDisplay: Scalars['Boolean'];
};

/** What filtering scheme to use for returning metrics */
export enum MetricTypeChoices {
  /** Return metrics captured only for the repository's default branch */
  DefaultBranchOnly = 'DEFAULT_BRANCH_ONLY',
  /** Return metrics captured only for pull requests */
  PullRequestOnly = 'PULL_REQUEST_ONLY',
  /** Return metrics captured for any branch */
  All = 'ALL'
}

export type MigrateToUnifiedBillingInput = {
  /** The owner's node ID */
  ownerId: Scalars['ID'];
  /** Set to true to perform migration, false to only validate eligibility */
  confirm: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Migrate from legacy billing to unified billing. */
export type MigrateToUnifiedBillingPayload = {
  __typename?: 'MigrateToUnifiedBillingPayload';
  subscription?: Maybe<ProductSubscription>;
  ok?: Maybe<Scalars['Boolean']>;
  error?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** The root query for implementing GraphQL mutations. */
export type Mutation = {
  __typename?: 'Mutation';
  /** Create a Stripe Checkout Session for unified subscription. */
  createCheckoutSessionForUnifiedSubscription?: Maybe<CreateCheckoutSessionForUnifiedSubscriptionPayload>;
  /** Cancel a unified subscription (downgrade to free). */
  cancelUnifiedSubscription?: Maybe<CancelUnifiedSubscriptionPayload>;
  /** Resume a unified subscription that is pending cancellation. */
  resumeUnifiedSubscription?: Maybe<ResumeUnifiedSubscriptionPayload>;
  /** Downgrade a trial subscription to the free plan. */
  downgradeToFreePlan?: Maybe<DowngradeToFreePlanPayload>;
  /** Update auto top-up settings for a unified subscription. */
  updateAutoTopup?: Maybe<UpdateAutoTopupPayload>;
  /** Detach a saved payment method (card) from the owner's Stripe customer. */
  detachSavedCard?: Maybe<DetachSavedCardPayload>;
  /** Set a saved payment method (card) as the default for the owner's Stripe customer. */
  setDefaultCard?: Maybe<SetDefaultCardPayload>;
  /** Create a Stripe Checkout Session in setup mode for adding a payment method. */
  createSetupCheckoutSession?: Maybe<CreateSetupCheckoutSessionPayload>;
  /** Create a manual top-up invoice with a specified amount and optional payment method. */
  createManualTopup?: Maybe<CreateManualTopupPayload>;
  /** Generate a URL to redirect the user to the Stripe billing portal. */
  createBillingPortalSession?: Maybe<CreateBillingPortalSessionPayload>;
  /** Migrate from legacy billing to unified billing. */
  migrateToUnifiedBilling?: Maybe<MigrateToUnifiedBillingPayload>;
  /** Export vulnerability occurrences for a repository or repository target. */
  exportVulnerabilityOccurrences?: Maybe<ExportVulnerabilityOccurrencesPayload>;
  /** Create a new repository target. */
  createRepositoryTarget?: Maybe<CreateRepositoryTargetPayload>;
  /** Auto sync repository targets. */
  syncRepositoryTargets?: Maybe<SyncRepositoryTargetsPayload>;
  /** Activate a repository target. */
  activateRepositoryTarget?: Maybe<ActivateRepositoryTargetPayload>;
  /** Deactivate a repository target. */
  deactivateRepositoryTarget?: Maybe<DeactivateRepositoryTargetPayload>;
  /** Delete a repository target. */
  deleteRepositoryTarget?: Maybe<DeleteRepositoryTargetPayload>;
  /** Update a repository target. */
  updateRepositoryTarget?: Maybe<UpdateRepositoryTargetPayload>;
  /** Export SBOM Report for a repository target. */
  exportRepositoryTargetSbom?: Maybe<ExportRepositoryTargetSbomPayload>;
  /** Mutation to create a new repository group */
  createRepositoryGroup?: Maybe<CreateRepositoryGroupPayload>;
  /** Mutation to generate a new key pair for the repository group */
  generateKeyPairForRepositoryGroup?: Maybe<GenerateKeyPairForRepositoryGroupPayload>;
  /** Mutation to remove the key pair for the repository group */
  removeKeyPairForRepositoryGroup?: Maybe<RemoveKeyPairForRepositoryGroupPayload>;
  /** Mutation to update a repository group's VCS reporting options enabled setting. */
  updateRepositoryGroupVcsReportingOptionsEnabled?: Maybe<UpdateRepositoryGroupVcsReportingOptionsEnabledPayload>;
  /** Mutation to update reports to be shown on repository group dashboard. */
  updateRepositoryGroupPinnedReports?: Maybe<UpdateRepositoryGroupPinnedReportsPayload>;
  /** Mutation to update a repository group's settings. */
  updateRepositoryGroupSettings?: Maybe<UpdateRepositoryGroupSettingsPayload>;
  /** Mutation to update the lead of a repository group. */
  updateRepositoryGroupLead?: Maybe<UpdateRepositoryGroupLeadPayload>;
  /** Mutation to add repositories to a repository group. */
  addRepositoriesToRepositoryGroup?: Maybe<AddRepositoriesToRepositoryGroupPayload>;
  /** Mutation to remove repositories from a repository group. */
  removeRepositoriesFromRepositoryGroup?: Maybe<RemoveRepositoriesFromRepositoryGroupPayload>;
  /** Mutation to delete a repository group. */
  deleteRepositoryGroup?: Maybe<DeleteRepositoryGroupPayload>;
  /** Mutation to create a public report. */
  createPublicReport?: Maybe<CreatePublicReportPayload>;
  /** Mutation to delete a public report. */
  deletePublicReport?: Maybe<DeletePublicReportPayload>;
  /** Mutation to add or remove sourced repositories in a public report. */
  updatePublicReportSourcedRepositories?: Maybe<UpdatePublicReportSourcedRepositoriesPayload>;
  /** Mutation to update fields in a public report. */
  updatePublicReport?: Maybe<UpdatePublicReportPayload>;
  /** Mutation to verify the password for a public report */
  verifyPasswordForPublicReport?: Maybe<VerifyPasswordForPublicReportPayload>;
  /** Mutation to get the auth token for a public report. */
  getAuthTokenForPublicReport?: Maybe<GetAuthTokenForPublicReportPayload>;
  createRemediationPatchForVulnerabilityOccurrence?: Maybe<CreateRemediationPatchForVulnerabilityOccurrencePayload>;
  triggerRemediationRun?: Maybe<TriggerRemediationRunPayload>;
  /**
   * Generate a summary of changes between two package versions. If
   * the summary already exists, it will be returned instead.
   */
  generatePackageUpgradeSummary?: Maybe<GeneratePackageUpgradeSummaryPayload>;
  getSubscriptionCheckoutUrlForIde?: Maybe<GetSubscriptionCheckoutUrlForIdePayload>;
  getSubscriptionManagementUrlForIde?: Maybe<GetSubscriptionManagementUrlForIde>;
  getSubscriptionCheckoutUrlForSca?: Maybe<GetSubscriptionCheckoutUrlForScaPayload>;
  getSubscriptionManagementUrlForSca?: Maybe<GetSubscriptionManagementUrlForScaPayload>;
  /** Update SCA policy for a owner. */
  updateOwnerScaPolicy?: Maybe<UpdateOwnerScaPolicyPayload>;
  /** Update license policy for a owner. */
  updateOwnerLicensePolicy?: Maybe<UpdateOwnerLicenseScaPolicyPayload>;
  /** Update AI policy for a owner. */
  updateOwnerAiPolicy?: Maybe<UpdateOwnerAiPolicyPayload>;
  /** Add analyzer feedback */
  addAnalyzerFeedback?: Maybe<AddAnalyzerFeedbackPayload>;
  /** Create a custom analyzer from a repository. */
  createCustomAnalyzer?: Maybe<CreateCustomAnalyzerPayload>;
  /** Trigger sync for a custom analyzer. */
  syncCustomAnalyzer?: Maybe<SyncCustomAnalyzerPayload>;
  /** Archive a custom analyzer. */
  archiveCustomAnalyzer?: Maybe<ArchiveCustomAnalyzerPayload>;
  /** Unarchive a custom analyzer. */
  unarchiveCustomAnalyzer?: Maybe<UnarchiveCustomAnalyzerPayload>;
  /** Enable Monorepo mode for a `Repository`. */
  enableMonorepoMode?: Maybe<EnableMonorepoModePayload>;
  /** Disable Monorepo mode for a `Repository`. */
  disableMonorepoMode?: Maybe<DisableMonorepoModePayload>;
  /** Create a `SubRepo` under a `Monorepo`. */
  addSubRepo?: Maybe<AddSubRepoPayload>;
  /** Delete an existing `SubRepo` under a `Monorepo`. */
  deleteSubRepo?: Maybe<DeleteSubRepoPayload>;
  /** Mutation to create a Webhook for an owner */
  createWebhook?: Maybe<CreateWebhookPayload>;
  /** Mutation to test webhook payload */
  testWebhook?: Maybe<TestWebhookPayload>;
  /** Mutation to update a webhook */
  updateWebhook?: Maybe<UpdateWebhookPayload>;
  /** Mutation to disable a webhook */
  disableWebhook?: Maybe<DisableWebhookPayload>;
  /** Mutation to delete a webhook */
  deleteWebhook?: Maybe<DeleteWebhookPayload>;
  /** Export audit logs for a team or repository. */
  exportAuditLogs?: Maybe<ExportAuditLogsPayload>;
  /** Add new configuration template. */
  createConfigTemplate?: Maybe<CreateConfigTemplatePayload>;
  /** Update an existing template. */
  updateConfigTemplate?: Maybe<UpdateConfigTemplatePayload>;
  /** Delete a template. */
  deleteConfigTemplate?: Maybe<DeleteConfigTemplatePayload>;
  /** Trigger the AutoOnboarding process. */
  autoOnboard?: Maybe<AutoOnboardPayload>;
  /** Add an IdentityProvider for a team. */
  addIdentityProvider?: Maybe<AddIdentityProviderPayload>;
  /** Delete the IdentityProvider for a team. */
  deleteIdentityProvider?: Maybe<DeleteIdentityProviderPayload>;
  /** Update the IdentityProvider for a team. */
  updateIdentityProvider?: Maybe<UpdateIdentityProviderPayload>;
  updateDynamicRiskConfig?: Maybe<UpdateDynamicRiskConfigPayload>;
  /**
   * Retry analysis for the given checks in a run.
   * This operation is only allowed for the latest run on a PR and if checks' statuses are errored or timed-out.
   */
  retryChecksInRun?: Maybe<RetryChecksInRunPayload>;
  /** Update basic info of the setup */
  updateEnterpriseInstallation?: Maybe<UpdateEnterpriseInstallationPayload>;
  /** Create a group */
  createGroup?: Maybe<CreateGroupPayload>;
  /** Update a group */
  updateGroup?: Maybe<UpdateGroupPayload>;
  /** Delete a group */
  deleteGroup?: Maybe<DeleteGroupPayload>;
  /** Reset the invitation link for a group */
  resetGroupInvitationLink?: Maybe<ResetGroupInvitationLinkPayload>;
  /** Add a user to the group */
  addUserToGroup?: Maybe<AddUserToGroupPayload>;
  /** Remove a user from the group */
  removeUserFromGroup?: Maybe<RemoveUserFromGroupPayload>;
  /** Add a team to the group */
  addTeamToGroup?: Maybe<AddTeamToGroupPayload>;
  /** Remove a team from the group */
  removeTeamFromGroup?: Maybe<RemoveTeamFromGroupPayload>;
  /** Update the role of the group-team-membership */
  updateGroupTeamRole?: Maybe<UpdateGroupTeamRolePayload>;
  /** Mutation to mark a user as active or inactive */
  toggleUserActive?: Maybe<ToggleUserActivePayload>;
  /** Delete a user */
  deleteUser?: Maybe<DeleteUserPayload>;
  /** Join the group using invite URL. */
  acceptGroupInvite?: Maybe<AcceptGroupInvitePayload>;
  /** Request and enterprise pilot license. */
  requestEnterprisePilotLicense?: Maybe<RequestEnterprisePilotLicensePayload>;
  socialAuth?: Maybe<SocialAuthJwt>;
  revokeToken?: Maybe<Revoke>;
  deleteTokenCookie?: Maybe<DeleteJsonWebTokenCookie>;
  deleteRefreshTokenCookie?: Maybe<DeleteRefreshTokenCookie>;
  /** Logout the user */
  logout?: Maybe<LogOutPayload>;
  verifyToken?: Maybe<Verify>;
  /** Refresh the token */
  refreshToken?: Maybe<RefreshToken>;
  /** Toggle analysis activation of a repository. */
  toggleRepositoryActivation?: Maybe<ToggleRepositoryActivationPayload>;
  /** Update settings of a repository. */
  updateRepositorySettings?: Maybe<UpdateRepositorySettingsPayload>;
  /** Update settings of an owner. */
  updateOwnerSettings?: Maybe<UpdateOwnerSettingsPayload>;
  /** Update owner profile for product interests. */
  updateOwnerProfile?: Maybe<UpdateOwnerProfilePayload>;
  /** Update user profile for onboarding or profile edits. */
  updateUserProfile?: Maybe<UpdateUserProfilePayload>;
  /** Get billing information. */
  getBillingInfo?: Maybe<GetBillingInfoPayload>;
  /** Ignore an issue for a repository. */
  ignoreIssueForRepository?: Maybe<IgnoreIssueForRepositoryPayload>;
  /** Ignore an issue for a file pattern in a repository. */
  ignoreIssueForFilePatternInRepository?: Maybe<IgnoreIssueForFilePatternInRepositoryPayload>;
  /** Ignore an issue for all test patterns in a repository. */
  ignoreIssueForTestPatternsInRepository?: Maybe<IgnoreIssueForTestPatternsInRepositoryPayload>;
  /** Report an issue occurrence as false positive. */
  reportIssueFalsePositive?: Maybe<ReportIssueFalsePositivePayload>;
  /** Ignore a check issue manually in a check. */
  ignoreCheckIssue?: Maybe<IgnoreCheckIssuePayload>;
  /** Ignore a specific AI Review issue. */
  ignoreAiReviewIssue?: Maybe<IgnoreAiReviewIssuePayload>;
  /** Report an AI review issue as false positive. */
  reportAiReviewIssueFalsePositive?: Maybe<ReportAiReviewIssueFalsePositivePayload>;
  /** Update the `validity_status` for a `CheckIssue`. */
  updateCheckIssueValidity?: Maybe<UpdateCheckIssueValidityPayload>;
  /** Generate a new RSA key pair for a repository. */
  generateKeyPairForRepository?: Maybe<GenerateKeyPairForRepositoryPayload>;
  /** Remove the RSA key pair for a repository. */
  removeKeyPairForRepository?: Maybe<RemoveKeyPairForRepositoryPayload>;
  /** Generate a new RSA key pair for an owner. */
  generateKeyPairForOwner?: Maybe<GenerateKeyPairForOwnerPayload>;
  /** Remove the RSA key pair for the owner. */
  removeKeyPairForOwner?: Maybe<RemoveKeyPairForOwnerPayload>;
  /** Update this setting to control whether data-triggered checks be marked as timed out if no artifacts are reported. */
  updateTimeoutSetting?: Maybe<UpdateTimeoutSettingPayload>;
  /** Update reports to be shown on owner dashboard. */
  updateOwnerPinnedReports?: Maybe<UpdateOwnerPinnedReportsPayload>;
  /** Update vulnerability notification settings for an owner. Configure email addresses and severity threshold for periodic scan vulnerability notifications. */
  updateVulnerabilityNotificationSettings?: Maybe<UpdateVulnerabilityNotificationSettingsPayload>;
  /** Update reports to be shown on repository dashboard. */
  updateRepositoryPinnedReports?: Maybe<UpdateRepositoryPinnedReportsPayload>;
  /** Update the order of default widgets. */
  updateRepositoryWidgets?: Maybe<UpdateRepositoryWidgetsPayload>;
  /** Update a repository's `RepositorySetting.vcs_reporting_options_enabled` field. */
  updateRepositoryVcsReportingOptionsEnabled?: Maybe<UpdateRepositoryVcsReportingOptionsEnabledPayload>;
  /** Regenerate a repository's DSN. */
  regenerateRepositoryDSN?: Maybe<RegenerateRepositoryDsnPayload>;
  /** Delete a silence rule in a repository. */
  deleteSilenceRule?: Maybe<DeleteSilenceRulePayload>;
  /** Update the default dashboard context for a user. */
  updateDefaultDashboardContextForUser?: Maybe<UpdateDefaultDashboardContextForUserPayload>;
  /** Update billing info for an owner. */
  updateBillingInfo?: Maybe<UpdateBillingInfoPayload>;
  /** Subscribe to a plan using token. */
  subscriptionCheckout?: Maybe<SubscriptionCheckoutPayload>;
  /** Update the default payment source for the customer. */
  updateDefaultPaymentSource?: Maybe<UpdateDefaultPaymentSourcePayload>;
  /** Cancel the code quality for the customer. */
  cancelCodeQualitySubscription?: Maybe<CancelCodeQualitySubscriptionPayload>;
  /** Update the seats for the code quality subscription */
  updateCodeQualitySubscriptionSeats?: Maybe<UpdateCodeQualitySubscriptionSeatsPayload>;
  /** Upgrade the plan for code quality subscription */
  getUpgradeCodeQualitySubscriptionPlanInfo?: Maybe<GetUpgradeCodeQualitySubscriptionPlanInfoPayload>;
  /** Change codequality subscription */
  subscriptionPlanSwitch?: Maybe<SubscriptionPlanSwitchPayload>;
  /** Upgrade the plan for code quality subscription */
  revertSubscriptionCancellation?: Maybe<RevertSubscriptionCancellationPayload>;
  /** Apply credits to an owner */
  applyCreditsToOwner?: Maybe<ApplyCreditsToOwnerPayload>;
  /** Invite a new member to a team. */
  inviteTeamMember?: Maybe<InviteTeamMemberPayload>;
  /** Invite members to a team. */
  inviteTeamMembers?: Maybe<InviteTeamMembersPayload>;
  /** Remove a member from a team. */
  removeTeamMember?: Maybe<RemoveTeamMemberPayload>;
  /** Update team member role */
  updateTeamMemberRole?: Maybe<UpdateTeamMemberRolePayload>;
  /** Transfer ownership of the given team to another user. */
  transferTeamOwnership?: Maybe<TransferTeamOwnershipPayload>;
  /** Sync given repository for the owner (with member permissions) from VCS provider. */
  syncRepositoryForOwner?: Maybe<SyncRepositoryForOwnerPayload>;
  /** Sync all accessible repositories for the given owner from VCS provider. */
  syncRepositoriesForOwner?: Maybe<SyncRepositoriesForOwnerPayload>;
  /** Create new autofix run */
  createAutofixRun?: Maybe<CreateAutofixRunPayload>;
  /** Create PR with patches */
  createdPullRequest?: Maybe<CreatePullRequestPayload>;
  /** Commit config to VCS */
  commitConfigToVcs?: Maybe<CommitConfigToVcsPayload>;
  /** Save config to DB */
  saveRepositoryConfig?: Maybe<SaveRepositoryConfigPayload>;
  /** Update repository metric threshold */
  updateRepoMetricThreshold?: Maybe<UpdateRepoMetricThresholdPayload>;
  /** Suppress a metric's value for a check */
  ignoreCheckMetric?: Maybe<IgnoreCheckMetricPayload>;
  /** Create autofix run for pull request */
  createAutofixRunForPullRequest?: Maybe<CreateAutofixRunForPullRequestPayload>;
  /** Create autofix run for issues raised by an analyzer. */
  createAutofixRunForAnalyzer?: Maybe<CreateAutofixRunForAnalyzerPayload>;
  /** Create commit on PR */
  commitChangesToPr?: Maybe<CommitChangesToPrPayload>;
  /** Commit the same config which was used for running the latest adhoc run. */
  commitAdhocConfig?: Maybe<CommitAdhocConfigPayload>;
  /** Reset the invitation url */
  resetInvitationLink?: Maybe<ResetTeamInvitationLinkPayload>;
  /** Update base permissions for a team */
  updateTeamBasePermissions?: Maybe<UpdateTeamBasePermissionsPayload>;
  /** Add transformer feedback */
  addTransformerFeedback?: Maybe<AddTransformerFeedbackPayload>;
  /** Update access control settings of the team */
  updateAccessControlSettings?: Maybe<UpdateAccessControlSettingsPayload>;
  /** Manual synchronize permission from VCS */
  syncVcsPermissions?: Maybe<SyncVcsPermissionsPayload>;
  /** Mutation to update or create a repository collaborator */
  updateOrCreateRepositoryCollaborator?: Maybe<UpdateOrCreateRepositoryCollaboratorPayload>;
  /** Remove repository collaborator */
  removeRepositoryCollaborator?: Maybe<RemoveRepositoryCollaboratorPayload>;
  /** Run analysis on repository */
  triggerAnalysisForRepository?: Maybe<TriggerAnalysisForRepositoryPayload>;
  /** Trigger analysis run for a specific pull request */
  triggerPullRequestRun?: Maybe<TriggerPullRequestRunPayload>;
  /** Trigger adhoc run */
  triggerAdhocRun?: Maybe<TriggerAdHocRunPayload>;
  /** Activate a GSR repository */
  activateGsrRepository?: Maybe<ActivateGsrRepositoryPayload>;
  /** Trigger config generation for a repository */
  generateRepositoryConfig?: Maybe<GenerateRepositoryConfigPayload>;
  /** Install an integration */
  installIntegration?: Maybe<InstallIntegrationPayload>;
  /** Get the integration installation URL */
  getIntegrationInstallationUrl?: Maybe<GetIntegrationInstallationUrlPayload>;
  /** installation landing */
  installation?: Maybe<GithubInstallationLandingPayload>;
  /** GitHub Enterprise installation landing */
  gheInstallationLanding?: Maybe<GithubEnterpriseInstallationLandingPayload>;
  /** Bitbucket add-on installation landing */
  bitbucketInstallationLanding?: Maybe<BitbucketInstallationLandingPayload>;
  /** Once user has installed Gitlab app, create owner on DeepSource. */
  gitlabInstallationLanding?: Maybe<GitlabInstallationLandingPayload>;
  /** Create owner on DeepSource once user has installed the Google OAuth App. */
  gsrInstallationLanding?: Maybe<GsrInstallationLandingPayload>;
  /** Create an owner on Azure Devops Services. */
  adsInstallationLanding?: Maybe<AdsInstallationLandingPayload>;
  /** Create an owner for a project on Bitbucket Data Center. */
  bitbucketDatacenterInstallationLanding?: Maybe<BitbucketDataCenterInstallationLandingPayload>;
  /** Update starred repository for a user */
  updateStarredRepository?: Maybe<UpdateStarredRepositoryPayload>;
  /** Update watched repository for a user */
  updateWatchedRepository?: Maybe<UpdateWatchedRepositoryPayload>;
  /** Update personal details for a user */
  updateUserDetails?: Maybe<UpdateUserDetailsPayload>;
  /** Delete user and associated data from DeepSource */
  deleteRequestingUser?: Maybe<DeleteRequestingUserPayload>;
  /** Delete a team from DeepSource */
  deleteTeam?: Maybe<DeleteTeamPayload>;
  /** Mutation to view invitation info or accept the invite */
  confirmInvitation?: Maybe<ConfirmInvitationPayload>;
  /** Send request to join a team */
  sendTeamMemberAdditionRequest?: Maybe<SendTeamMemberAdditionRequestPayload>;
  /** Accept user's request to join a team */
  acceptTeamMemberAdditionRequest?: Maybe<AcceptTeamMemberAdditionRequestPayload>;
  /** Reject user's request to join a team */
  rejectTeamMemberAdditionRequest?: Maybe<RejectTeamMemberAdditionRequestPayload>;
  /** Verify a CLI login attempt. */
  verifyDevice?: Maybe<VerifyDevicePayload>;
  /** Submit a support ticket to Plain */
  submitSupportTicket?: Maybe<SubmitSupportTicketPayload>;
  /** Create access token for a user. */
  createAccessToken?: Maybe<CreateAccessTokenPayload>;
  /** Update attributes of an access token. */
  updateAccessToken?: Maybe<UpdateAccessTokenPayload>;
  /** Rotate the value of token. */
  rotateAccessToken?: Maybe<RotateAccessTokenPayload>;
  /** Delete access token from it's ID. */
  deleteAccessToken?: Maybe<DeleteAccessTokenPayload>;
  /** Delete all access tokens for the currently logged in user. */
  deleteAllAccessTokens?: Maybe<DeleteAllAccessTokensPayload>;
  /**
   * For the given gsr owner, verify that the primary user's oauth tokens have
   * all the necessary permissions.
   */
  verifyGsrPermissions?: Maybe<VerifyGsrPermissionsPayload>;
  /** Verify that webhooks are enabled for the given GSR project. */
  verifyGsrWebhooks?: Maybe<VerifyGsrWebhooksPayload>;
  /**
   * Trigger a SSHVerifyRun. This run checks whether the public key for the
   * given owner is registered with the VCS or not.
   */
  triggerVerifyGsrSsh?: Maybe<TriggerVerifyGsrsshPayload>;
  /**
   * Check whether all setup steps have been completed for integrating with
   * GSR. If so, the flag gsr_setup_pending is unset and onboarding is allowed.
   */
  verifyGsrSetup?: Maybe<VerifyGsrSetupPayload>;
  /** Mutation to set issue priority for an issue */
  updateIssuePriority?: Maybe<UpdateIssuePriorityPayload>;
  /** Mutation to unset issue priority on an issue */
  unsetIssuePriority?: Maybe<UnsetIssuePriorityPayload>;
  /** Mutation to clear repository level settings */
  clearIntegrationRepositorySettings?: Maybe<ClearIntegrationRepositorySettingsPayload>;
  /** Create an issue on an integration. */
  createIssueOnIntegration?: Maybe<CreateIssueOnIntegrationPayload>;
  /** Mutation to update the settings for an integration */
  updateIntegrationSettings?: Maybe<UpdateIntegrationSettingsPayload>;
  /** Mutation to uninstall an integration */
  uninstallIntegration?: Maybe<UninstallIntegrationPayload>;
  /** Create a Slack Connect channel for a trial team. */
  requestSlackConnect?: Maybe<RequestSlackConnectPayload>;
  /** Resend the Slack Connect invite for a team. */
  resendSlackConnectInvite?: Maybe<ResendSlackConnectInvitePayload>;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateCheckoutSessionForUnifiedSubscriptionArgs = {
  input: CreateCheckoutSessionForUnifiedSubscriptionInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCancelUnifiedSubscriptionArgs = {
  input: CancelUnifiedSubscriptionInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationResumeUnifiedSubscriptionArgs = {
  input: ResumeUnifiedSubscriptionInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDowngradeToFreePlanArgs = {
  input: DowngradeToFreePlanInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateAutoTopupArgs = {
  input: UpdateAutoTopupInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDetachSavedCardArgs = {
  input: DetachSavedCardInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationSetDefaultCardArgs = {
  input: SetDefaultCardInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateSetupCheckoutSessionArgs = {
  input: CreateSetupCheckoutSessionInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateManualTopupArgs = {
  input: CreateManualTopupInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateBillingPortalSessionArgs = {
  input: CreateBillingPortalSessionInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationMigrateToUnifiedBillingArgs = {
  input: MigrateToUnifiedBillingInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationExportVulnerabilityOccurrencesArgs = {
  input: ExportVulnerabilityOccurrencesInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateRepositoryTargetArgs = {
  input: CreateRepositoryTargetInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationSyncRepositoryTargetsArgs = {
  input: SyncRepositoryTargetsInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationActivateRepositoryTargetArgs = {
  input: ActivateRepositoryTargetInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeactivateRepositoryTargetArgs = {
  input: DeactivateRepositoryTargetInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteRepositoryTargetArgs = {
  input: DeleteRepositoryTargetInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateRepositoryTargetArgs = {
  input: UpdateRepositoryTargetInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationExportRepositoryTargetSbomArgs = {
  input: ExportRepositoryTargetSbomInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateRepositoryGroupArgs = {
  input: CreateRepositoryGroupInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationGenerateKeyPairForRepositoryGroupArgs = {
  input: GenerateKeyPairForRepositoryGroupInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRemoveKeyPairForRepositoryGroupArgs = {
  input: RemoveKeyPairForRepositoryGroupInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateRepositoryGroupVcsReportingOptionsEnabledArgs = {
  input: UpdateRepositoryGroupVcsReportingOptionsEnabledInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateRepositoryGroupPinnedReportsArgs = {
  input: UpdateRepositoryGroupPinnedReportsInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateRepositoryGroupSettingsArgs = {
  input: UpdateRepositoryGroupSettingsInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateRepositoryGroupLeadArgs = {
  input: UpdateRepositoryGroupLeadInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAddRepositoriesToRepositoryGroupArgs = {
  input: AddRepositoriesToRepositoryGroupInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRemoveRepositoriesFromRepositoryGroupArgs = {
  input: RemoveRepositoriesFromRepositoryGroupInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteRepositoryGroupArgs = {
  input: DeleteRepositoryGroupInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreatePublicReportArgs = {
  input: CreatePublicReportInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeletePublicReportArgs = {
  input: DeletePublicReportInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdatePublicReportSourcedRepositoriesArgs = {
  input: UpdatePublicReportSourcedRepositoriesInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdatePublicReportArgs = {
  input: UpdatePublicReportInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationVerifyPasswordForPublicReportArgs = {
  input: VerifyPasswordForPublicReportInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationGetAuthTokenForPublicReportArgs = {
  input: GetAuthTokenForPublicReportInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateRemediationPatchForVulnerabilityOccurrenceArgs = {
  input: CreateRemediationPatchForVulnerabilityOccurrenceInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationTriggerRemediationRunArgs = {
  input: TriggerRemediationRunInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationGeneratePackageUpgradeSummaryArgs = {
  input: GeneratePackageUpgradeSummaryInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationGetSubscriptionCheckoutUrlForIdeArgs = {
  input: GetSubscriptionCheckoutUrlForIdeInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationGetSubscriptionCheckoutUrlForScaArgs = {
  input: GetSubscriptionCheckoutUrlForScaInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationGetSubscriptionManagementUrlForScaArgs = {
  input: GetSubscriptionManagementUrlForScaInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateOwnerScaPolicyArgs = {
  input: UpdateOwnerScaPolicyInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateOwnerLicensePolicyArgs = {
  input: UpdateOwnerLicenseScaPolicyInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateOwnerAiPolicyArgs = {
  input: UpdateOwnerAiPolicyInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAddAnalyzerFeedbackArgs = {
  input: AddAnalyzerFeedbackInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateCustomAnalyzerArgs = {
  input: CreateCustomAnalyzerInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationSyncCustomAnalyzerArgs = {
  input: SyncCustomAnalyzerInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationArchiveCustomAnalyzerArgs = {
  input: ArchiveCustomAnalyzerInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUnarchiveCustomAnalyzerArgs = {
  input: UnarchiveCustomAnalyzerInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationEnableMonorepoModeArgs = {
  input: EnableMonorepoModeInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDisableMonorepoModeArgs = {
  input: DisableMonorepoModeInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAddSubRepoArgs = {
  input: AddSubRepoInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteSubRepoArgs = {
  input: DeleteSubRepoInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateWebhookArgs = {
  input: CreateWebhookInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationTestWebhookArgs = {
  input: TestWebhookInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateWebhookArgs = {
  input: UpdateWebhookInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDisableWebhookArgs = {
  input: DisableWebhookInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteWebhookArgs = {
  input: DeleteWebhookInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationExportAuditLogsArgs = {
  input: ExportAuditLogsInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateConfigTemplateArgs = {
  input: CreateConfigTemplateInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateConfigTemplateArgs = {
  input: UpdateConfigTemplateInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteConfigTemplateArgs = {
  input: DeleteConfigTemplateInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAutoOnboardArgs = {
  input: AutoOnboardInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAddIdentityProviderArgs = {
  input: AddIdentityProviderInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteIdentityProviderArgs = {
  input: DeleteIdentityProviderInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateIdentityProviderArgs = {
  input: UpdateIdentityProviderInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateDynamicRiskConfigArgs = {
  input: UpdateDynamicRiskConfigInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRetryChecksInRunArgs = {
  input: RetryChecksInRunInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateEnterpriseInstallationArgs = {
  input: UpdateEnterpriseInstallationInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateGroupArgs = {
  input: UpdateGroupInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteGroupArgs = {
  input: DeleteGroupInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationResetGroupInvitationLinkArgs = {
  input: ResetGroupInvitationLinkInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAddUserToGroupArgs = {
  input: AddUserToGroupInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRemoveUserFromGroupArgs = {
  input: RemoveUserFromGroupInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAddTeamToGroupArgs = {
  input: AddTeamToGroupInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRemoveTeamFromGroupArgs = {
  input: RemoveTeamFromGroupInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateGroupTeamRoleArgs = {
  input: UpdateGroupTeamRoleInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationToggleUserActiveArgs = {
  input: ToggleUserActiveInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAcceptGroupInviteArgs = {
  input: AcceptGroupInviteInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRequestEnterprisePilotLicenseArgs = {
  input: RequestEnterprisePilotLicenseInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationSocialAuthArgs = {
  appId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  provider: Scalars['String'];
};


/** The root query for implementing GraphQL mutations. */
export type MutationRevokeTokenArgs = {
  refreshToken?: Maybe<Scalars['String']>;
};


/** The root query for implementing GraphQL mutations. */
export type MutationLogoutArgs = {
  input: LogOutInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationVerifyTokenArgs = {
  token?: Maybe<Scalars['String']>;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRefreshTokenArgs = {
  refreshToken?: Maybe<Scalars['String']>;
};


/** The root query for implementing GraphQL mutations. */
export type MutationToggleRepositoryActivationArgs = {
  input: ToggleRepositoryActivationInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateRepositorySettingsArgs = {
  input: UpdateRepositorySettingsInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateOwnerSettingsArgs = {
  input: UpdateOwnerSettingsInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateOwnerProfileArgs = {
  input: UpdateOwnerProfileInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateUserProfileArgs = {
  input: UpdateUserProfileInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationGetBillingInfoArgs = {
  input: GetBillingInfoInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationIgnoreIssueForRepositoryArgs = {
  input: IgnoreIssueForRepositoryInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationIgnoreIssueForFilePatternInRepositoryArgs = {
  input: IgnoreIssueForFilePatternInRepositoryInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationIgnoreIssueForTestPatternsInRepositoryArgs = {
  input: IgnoreIssueForTestPatternsInRepositoryInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationReportIssueFalsePositiveArgs = {
  input: ReportIssueFalsePositiveInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationIgnoreCheckIssueArgs = {
  input: IgnoreCheckIssueInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationIgnoreAiReviewIssueArgs = {
  input: IgnoreAiReviewIssueInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationReportAiReviewIssueFalsePositiveArgs = {
  input: ReportAiReviewIssueFalsePositiveInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateCheckIssueValidityArgs = {
  input: UpdateCheckIssueValidityInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationGenerateKeyPairForRepositoryArgs = {
  input: GenerateKeyPairForRepositoryInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRemoveKeyPairForRepositoryArgs = {
  input: RemoveKeyPairForRepositoryInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationGenerateKeyPairForOwnerArgs = {
  input: GenerateKeyPairForOwnerInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRemoveKeyPairForOwnerArgs = {
  input: RemoveKeyPairForOwnerInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateTimeoutSettingArgs = {
  input: UpdateTimeoutSettingInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateOwnerPinnedReportsArgs = {
  input: UpdateOwnerPinnedReportsInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateVulnerabilityNotificationSettingsArgs = {
  input: UpdateVulnerabilityNotificationSettingsInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateRepositoryPinnedReportsArgs = {
  input: UpdateRepositoryPinnedReportsInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateRepositoryWidgetsArgs = {
  input: UpdateRepositoryWidgetsInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateRepositoryVcsReportingOptionsEnabledArgs = {
  input: UpdateRepositoryVcsReportingOptionsEnabledInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRegenerateRepositoryDsnArgs = {
  input: RegenerateRepositoryDsnInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteSilenceRuleArgs = {
  input: DeleteSilenceRuleInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateDefaultDashboardContextForUserArgs = {
  input: UpdateDefaultDashboardContextForUserInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateBillingInfoArgs = {
  input: UpdateBillingInfoInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationSubscriptionCheckoutArgs = {
  input: SubscriptionCheckoutInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateDefaultPaymentSourceArgs = {
  input: UpdateDefaultPaymentSourceInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCancelCodeQualitySubscriptionArgs = {
  input: CancelCodeQualitySubscriptionInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateCodeQualitySubscriptionSeatsArgs = {
  input: UpdateCodeQualitySubscriptionSeatsInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationGetUpgradeCodeQualitySubscriptionPlanInfoArgs = {
  input: GetUpgradeCodeQualitySubscriptionPlanInfoInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationSubscriptionPlanSwitchArgs = {
  input: SubscriptionPlanSwitchInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRevertSubscriptionCancellationArgs = {
  input: RevertSubscriptionCancellationInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationApplyCreditsToOwnerArgs = {
  input: ApplyCreditsToOwnerInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationInviteTeamMemberArgs = {
  input: InviteTeamMemberInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationInviteTeamMembersArgs = {
  input: InviteTeamMembersInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRemoveTeamMemberArgs = {
  input: RemoveTeamMemberInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateTeamMemberRoleArgs = {
  input: UpdateTeamMemberRoleInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationTransferTeamOwnershipArgs = {
  input: TransferTeamOwnershipInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationSyncRepositoryForOwnerArgs = {
  input: SyncRepositoryForOwnerInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationSyncRepositoriesForOwnerArgs = {
  input: SyncRepositoriesForOwnerInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateAutofixRunArgs = {
  input: CreateAutofixRunInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreatedPullRequestArgs = {
  input: CreatePullRequestInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCommitConfigToVcsArgs = {
  input: CommitConfigToVcsInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationSaveRepositoryConfigArgs = {
  input: SaveRepositoryConfigInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateRepoMetricThresholdArgs = {
  input: UpdateRepoMetricThresholdInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationIgnoreCheckMetricArgs = {
  input: IgnoreCheckMetricInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateAutofixRunForPullRequestArgs = {
  input: CreateAutofixRunForPullRequestInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateAutofixRunForAnalyzerArgs = {
  input: CreateAutofixRunForAnalyzerInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCommitChangesToPrArgs = {
  input: CommitChangesToPrInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCommitAdhocConfigArgs = {
  input: CommitAdhocConfigInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationResetInvitationLinkArgs = {
  input: ResetTeamInvitationLinkInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateTeamBasePermissionsArgs = {
  input: UpdateTeamBasePermissionsInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAddTransformerFeedbackArgs = {
  input: AddTransformerFeedbackInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateAccessControlSettingsArgs = {
  input: UpdateAccessControlSettingsInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationSyncVcsPermissionsArgs = {
  input: SyncVcsPermissionsInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateOrCreateRepositoryCollaboratorArgs = {
  input: UpdateOrCreateRepositoryCollaboratorInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRemoveRepositoryCollaboratorArgs = {
  input: RemoveRepositoryCollaboratorInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationTriggerAnalysisForRepositoryArgs = {
  input: TriggerAnalysisForRepositoryInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationTriggerPullRequestRunArgs = {
  input: TriggerPullRequestRunInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationTriggerAdhocRunArgs = {
  input: TriggerAdHocRunInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationActivateGsrRepositoryArgs = {
  input: ActivateGsrRepositoryInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationGenerateRepositoryConfigArgs = {
  input: GenerateRepositoryConfigInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationInstallIntegrationArgs = {
  input: InstallIntegrationInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationGetIntegrationInstallationUrlArgs = {
  input: GetIntegrationInstallationUrlInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationInstallationArgs = {
  input: GithubInstallationLandingInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationGheInstallationLandingArgs = {
  input: GithubEnterpriseInstallationLandingInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationBitbucketInstallationLandingArgs = {
  input: BitbucketInstallationLandingInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationGitlabInstallationLandingArgs = {
  input: GitlabInstallationLandingInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationGsrInstallationLandingArgs = {
  input: GsrInstallationLandingInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAdsInstallationLandingArgs = {
  input: AdsInstallationLandingInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationBitbucketDatacenterInstallationLandingArgs = {
  input: BitbucketDataCenterInstallationLandingInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateStarredRepositoryArgs = {
  input: UpdateStarredRepositoryInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateWatchedRepositoryArgs = {
  input: UpdateWatchedRepositoryInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateUserDetailsArgs = {
  input: UpdateUserDetailsInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteRequestingUserArgs = {
  input: DeleteRequestingUserInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteTeamArgs = {
  input: DeleteTeamInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationConfirmInvitationArgs = {
  input: ConfirmInvitationInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationSendTeamMemberAdditionRequestArgs = {
  input: SendTeamMemberAdditionRequestInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAcceptTeamMemberAdditionRequestArgs = {
  input: AcceptTeamMemberAdditionRequestInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRejectTeamMemberAdditionRequestArgs = {
  input: RejectTeamMemberAdditionRequestInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationVerifyDeviceArgs = {
  input: VerifyDeviceInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationSubmitSupportTicketArgs = {
  input: SubmitSupportTicketInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateAccessTokenArgs = {
  input: CreateAccessTokenInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateAccessTokenArgs = {
  input: UpdateAccessTokenInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRotateAccessTokenArgs = {
  input: RotateAccessTokenInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteAccessTokenArgs = {
  input: DeleteAccessTokenInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteAllAccessTokensArgs = {
  input: DeleteAllAccessTokensInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationVerifyGsrPermissionsArgs = {
  input: VerifyGsrPermissionsInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationVerifyGsrWebhooksArgs = {
  input: VerifyGsrWebhooksInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationTriggerVerifyGsrSshArgs = {
  input: TriggerVerifyGsrsshInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationVerifyGsrSetupArgs = {
  input: VerifyGsrSetupInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateIssuePriorityArgs = {
  input: UpdateIssuePriorityInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUnsetIssuePriorityArgs = {
  input: UnsetIssuePriorityInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationClearIntegrationRepositorySettingsArgs = {
  input: ClearIntegrationRepositorySettingsInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateIssueOnIntegrationArgs = {
  input: CreateIssueOnIntegrationInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateIntegrationSettingsArgs = {
  input: UpdateIntegrationSettingsInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUninstallIntegrationArgs = {
  input: UninstallIntegrationInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRequestSlackConnectArgs = {
  input: RequestSlackConnectInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationResendSlackConnectInviteArgs = {
  input: ResendSlackConnectInviteInput;
};

export enum NextActionChoice {
  GithubLogin = 'GITHUB_LOGIN',
  Dashboard = 'DASHBOARD',
  Onboard = 'ONBOARD',
  Login = 'LOGIN'
}

/** An enumeration. */
export enum OccurrenceValidityStatusChoices {
  Indeterminate = 'INDETERMINATE',
  Valid = 'VALID',
  Invalid = 'INVALID'
}

/** An Owner object. */
export type Owner = MaskPrimaryKeyNode & {
  __typename?: 'Owner';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  /** The unique identifier (or username) of the account. */
  login: Scalars['String'];
  /** Owner's avatar URL. */
  avatar?: Maybe<Scalars['String']>;
  /** VCS provider of this owner's origin. */
  vcsProvider: OwnerVcsProvider;
  /** Unique identity of this owner in the VCS, if available. */
  vcsAccountUid: Scalars['String'];
  /** Pricing plan which this owner is subscribed to. */
  plan?: Maybe<OwnerPlan>;
  customerId?: Maybe<Scalars['String']>;
  primaryUser?: Maybe<User>;
  gsrSetupPending: Scalars['Boolean'];
  resourceSelector?: Maybe<OwnerResourceSelector>;
  /** The runner associated with this owner. */
  runner?: Maybe<Runner>;
  /** The runner app associated with this owner. */
  runnerApp?: Maybe<RunnerApp>;
  IsBetaTester?: Maybe<Scalars['Boolean']>;
  billingVersion?: Maybe<OwnerBillingVersion>;
  features?: Maybe<Scalars['GenericScalar']>;
  analyzers: AnalyzerConnection;
  /** List of product subscriptions for the owner. */
  productSubscriptions?: Maybe<ProductSubscriptionConnection>;
  team?: Maybe<EnterpriseTeam>;
  /** List repositories for an owner. */
  repositories?: Maybe<RepositoryConnection>;
  /** Repositories on this owner that are not yet activated and that the viewer has permission to activate. Use this in place of `repositories` when listing candidates in an activation UI — the schema-level filter prevents surfacing repos that would 403 on the activation mutation. */
  activatableRepositories?: Maybe<RepositoryConnection>;
  issuePriorities: IssuePriorityConnection;
  userSet: UserConnection;
  configTemplates?: Maybe<ConfigTemplateConnection>;
  onboardingEvents: AutoOnboardEventConnection;
  /** List repository groups for an owner. */
  repositoryGroups?: Maybe<RepositoryGroupConnection>;
  ownerSetting?: Maybe<OwnerSetting>;
  /** Onboarding profile for the owner. */
  profile?: Maybe<OwnerProfile>;
  publicReports?: Maybe<PublicReportConnection>;
  /** Webhooks for the owner. */
  webhooks?: Maybe<WebhookConnection>;
  isAutofixEnabled: Scalars['Boolean'];
  autofixInstallationUrl?: Maybe<Scalars['String']>;
  isTeam?: Maybe<Scalars['Boolean']>;
  cacheKeys?: Maybe<OwnerCacheKeys>;
  numMembersTotal?: Maybe<Scalars['Int']>;
  billingInfo?: Maybe<BillingInfo>;
  hasPremiumPlan?: Maybe<Scalars['Boolean']>;
  hasSubscribedToPlan?: Maybe<Scalars['Boolean']>;
  isViewerPrimaryUser?: Maybe<Scalars['Boolean']>;
  setting?: Maybe<OwnerSetting>;
  hasGrantedAllRepoAccess?: Maybe<Scalars['Boolean']>;
  appConfigurationUrl?: Maybe<Scalars['String']>;
  featureConfig?: Maybe<Array<Maybe<FeatureInfo>>>;
  accountSetupStatus?: Maybe<Scalars['GenericScalar']>;
  subscribedPlanInfo?: Maybe<Scalars['GenericScalar']>;
  vcsUrl?: Maybe<Scalars['String']>;
  vcsInstallationId?: Maybe<Scalars['String']>;
  canOnboard?: Maybe<Scalars['Boolean']>;
  configTemplate?: Maybe<ConfigTemplate>;
  isAutoonboardAllowed?: Maybe<Scalars['Boolean']>;
  autoonboardableRepositories?: Maybe<RepositoryConnection>;
  autoonboardingEvents?: Maybe<AutoOnboardEventConnection>;
  accessTokens?: Maybe<AccessTokenConnection>;
  maxUsagePercentage?: Maybe<Scalars['Float']>;
  featureUsage?: Maybe<Scalars['GenericScalar']>;
  isGsrSshRegistered?: Maybe<Scalars['Boolean']>;
  installedIntegrations?: Maybe<Array<Maybe<IntegrationProvider>>>;
  repositoriesCoverageReport?: Maybe<RepositoryCoverageReportItemConnection>;
  mostRecentScaTargets?: Maybe<RepositoryScaTargetReportItemConnection>;
  /** List of repositories containing the given compliance issue. */
  repositoriesWithComplianceIssue?: Maybe<RepositoryComplianceReportItemConnection>;
  activeRepositoryCount?: Maybe<Scalars['Int']>;
  supportTier: SupportTierChoices;
  /** Custom analyzers created by the owner. */
  customAnalyzers?: Maybe<AnalyzerConnection>;
  /** Monthly statistics for the owner. */
  monthlyStats: OwnerMonthlyStats;
  /** The product subscription for the owner. */
  productSubscription?: Maybe<ProductSubscription>;
  /** List of pull requests across all repositories for this owner. */
  pullRequests?: Maybe<PrConnection>;
  /** Usage metrics for the owner. */
  usage: Usage;
  /** Summary of usage and credits for the owner. */
  usageSummary: UsageSummary;
};


/** An Owner object. */
export type OwnerAnalyzersArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  categoryIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  q?: Maybe<Scalars['String']>;
  exclude?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** An Owner object. */
export type OwnerProductSubscriptionsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  productType?: Maybe<ProductChoice>;
};


/** An Owner object. */
export type OwnerRepositoriesArgs = {
  kindIn?: Maybe<Array<Maybe<RepositoryKindChoices>>>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  vcsProvider?: Maybe<VcsProviderChoices>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  isActivated?: Maybe<Scalars['Boolean']>;
  errorCode?: Maybe<Scalars['Int']>;
  name_Icontains?: Maybe<Scalars['String']>;
  nameFuzzy?: Maybe<Scalars['String']>;
};


/** An Owner object. */
export type OwnerActivatableRepositoriesArgs = {
  kindIn?: Maybe<Array<Maybe<RepositoryKindChoices>>>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  vcsProvider?: Maybe<VcsProviderChoices>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  isActivated?: Maybe<Scalars['Boolean']>;
  errorCode?: Maybe<Scalars['Int']>;
  name_Icontains?: Maybe<Scalars['String']>;
  nameFuzzy?: Maybe<Scalars['String']>;
};


/** An Owner object. */
export type OwnerIssuePrioritiesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** An Owner object. */
export type OwnerUserSetArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** An Owner object. */
export type OwnerConfigTemplatesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  shortcode?: Maybe<Scalars['String']>;
  title_Icontains?: Maybe<Scalars['String']>;
};


/** An Owner object. */
export type OwnerOnboardingEventsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  owner?: Maybe<Scalars['ID']>;
};


/** An Owner object. */
export type OwnerRepositoryGroupsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_Icontains?: Maybe<Scalars['String']>;
};


/** An Owner object. */
export type OwnerPublicReportsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  q?: Maybe<Scalars['String']>;
};


/** An Owner object. */
export type OwnerWebhooksArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** An Owner object. */
export type OwnerConfigTemplateArgs = {
  shortcode: Scalars['String'];
};


/** An Owner object. */
export type OwnerAutoonboardableRepositoriesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  vcsProvider?: Maybe<VcsProviderChoices>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  isActivated?: Maybe<Scalars['Boolean']>;
  errorCode?: Maybe<Scalars['Int']>;
  name_Icontains?: Maybe<Scalars['String']>;
  nameFuzzy?: Maybe<Scalars['String']>;
};


/** An Owner object. */
export type OwnerAutoonboardingEventsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  owner?: Maybe<Scalars['ID']>;
};


/** An Owner object. */
export type OwnerAccessTokensArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** An Owner object. */
export type OwnerInstalledIntegrationsArgs = {
  feature?: Maybe<IntegrationFeature>;
};


/** An Owner object. */
export type OwnerRepositoriesCoverageReportArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
};


/** An Owner object. */
export type OwnerMostRecentScaTargetsArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
};


/** An Owner object. */
export type OwnerRepositoriesWithComplianceIssueArgs = {
  tag: Scalars['String'];
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  vcsProvider?: Maybe<VcsProviderChoices>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  isActivated?: Maybe<Scalars['Boolean']>;
  errorCode?: Maybe<Scalars['Int']>;
  name_Icontains?: Maybe<Scalars['String']>;
  nameFuzzy?: Maybe<Scalars['String']>;
};


/** An Owner object. */
export type OwnerCustomAnalyzersArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  categoryIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  q?: Maybe<Scalars['String']>;
  exclude?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** An Owner object. */
export type OwnerProductSubscriptionArgs = {
  productType: ProductChoice;
};


/** An Owner object. */
export type OwnerPullRequestsArgs = {
  author?: Maybe<Scalars['ID']>;
  isAuthorViewer?: Maybe<Scalars['Boolean']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** Owner level AI policy configuration. */
export type OwnerAiPolicy = MaskPrimaryKeyNode & {
  __typename?: 'OwnerAIPolicy';
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  /** The ID of the object */
  id: Scalars['ID'];
  /** Enable AI agents for code generation and review. */
  isAiAgentsEnabled: Scalars['Boolean'];
  /** Enable AI-based secrets detection in the codebase. */
  useAiSecretsDetection: Scalars['Boolean'];
  /** Enable AI-based autofix suggestions for vulnerabilities. */
  useAiAutofix: Scalars['Boolean'];
  /** Automatically trigger AI review on every PR. When False/None, AI review only triggers via @mention. */
  autoTriggerAiReview?: Maybe<Scalars['Boolean']>;
  /** Enable commit suggestions from Autofix in PR reviews. */
  isAutofixCommitSuggestionsEnabled?: Maybe<Scalars['Boolean']>;
};

/** Input for AI policy configuration. */
export type OwnerAiPolicyInput = {
  /** Enable AI agents for code generation and review. */
  isAiAgentsEnabled?: Maybe<Scalars['Boolean']>;
  /** Enable AI-based secrets detection in the codebase. */
  useAiSecretsDetection?: Maybe<Scalars['Boolean']>;
  /** Enable AI-based autofix suggestions for vulnerabilities. */
  useAiAutofix?: Maybe<Scalars['Boolean']>;
  /** Enable commit suggestions from Autofix in PR reviews. */
  isAutofixCommitSuggestionsEnabled?: Maybe<Scalars['Boolean']>;
  /** Automatically trigger AI review on every PR. When false, AI review only triggers via @mention. */
  autoTriggerAiReview?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum OwnerBillingVersion {
  /** Legacy */
  V1 = 'V1',
  /** Unified */
  V2 = 'V2'
}

export type OwnerCacheKeys = {
  __typename?: 'OwnerCacheKeys';
  repositories: Scalars['String'];
  team: Scalars['String'];
  settings: Scalars['String'];
};

export type OwnerConnection = {
  __typename?: 'OwnerConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OwnerEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A dynamic risk configuration. */
export type OwnerDynamicRiskConfig = MaskPrimaryKeyNode & {
  __typename?: 'OwnerDynamicRiskConfig';
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  /** The ID of the object */
  id: Scalars['ID'];
  /** Weight for CVSS score in the base score calculation */
  cvssWeight: Scalars['Float'];
  /** Weight for EPSS score in the base score calculation */
  epssWeight: Scalars['Float'];
  percentileStrategy: PercentileStrategy;
  /** Weight for reachable vulnerabilities */
  reachableWeight: Scalars['Float'];
  /** Weight for unreachable vulnerabilities */
  unreachableWeight: Scalars['Float'];
  /** Weight for vulnerabilities with unknown reachability */
  unknownWeight: Scalars['Float'];
};

/** A Relay edge containing a `Owner` and its cursor. */
export type OwnerEdge = {
  __typename?: 'OwnerEdge';
  /** The item at the end of the edge */
  node?: Maybe<Owner>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Owner level license policy configuration. */
export type OwnerLicensePolicy = MaskPrimaryKeyNode & {
  __typename?: 'OwnerLicensePolicy';
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  /** The ID of the object */
  id: Scalars['ID'];
  /** Block PRs with license violations. */
  blockPrs: Scalars['Boolean'];
  /** Mark non-OSI approved licenses as safe. */
  isNonOsiApprovedSafe: Scalars['Boolean'];
  /** Mark non-FSF free/libre licenses as safe. */
  isNonFsfFreeLibreSafe: Scalars['Boolean'];
  /** Mark deprecated licenses as safe. */
  isDeprecatedSafe: Scalars['Boolean'];
  /** List of custom safe licenses identifiers. */
  customSafeLicenseIdentifiers: Array<Scalars['String']>;
  /** List of custom unsafe licenses identifiers. */
  customUnsafeLicenseIdentifiers: Array<Scalars['String']>;
};

/** Input for license policy configuration. */
export type OwnerLicensePolicyInput = {
  /** Block PRs with licenses that are not allowed. */
  blockPrs?: Maybe<Scalars['Boolean']>;
  /** Mark non-OSI approved licenses as safe. */
  isNonOsiApprovedSafe?: Maybe<Scalars['Boolean']>;
  /** Mark non-FSF free/libre licenses as safe. */
  isNonFsfFreeLibreSafe?: Maybe<Scalars['Boolean']>;
  /** Mark deprecated licenses as safe. */
  isDeprecatedSafe?: Maybe<Scalars['Boolean']>;
  /** List of custom safe licenses identifiers. */
  customSafeLicenseIdentifiers?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** List of custom unsafe licenses identifiers. */
  customUnsafeLicenseIdentifiers?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type OwnerMonthlyStats = {
  __typename?: 'OwnerMonthlyStats';
  commitsAnalyzed: Scalars['Int'];
  issuesPrevented: Scalars['Int'];
  dependenciesUpdated: Scalars['Int'];
  vulnerabilitiesDetected: Scalars['Int'];
};

/** An enumeration. */
export enum OwnerPlan {
  /** Free */
  Free = 'FREE',
  /** Developer */
  Developer = 'DEVELOPER',
  /** Team */
  Team = 'TEAM'
}

/** GraphQL type for OwnerProfile model. */
export type OwnerProfile = MaskPrimaryKeyNode & {
  __typename?: 'OwnerProfile';
  /** The ID of the object */
  id: Scalars['ID'];
  /** List of products the owner is interested in */
  productInterests: Array<Scalars['String']>;
};

/** An enumeration. */
export enum OwnerResourceSelector {
  /** Plan */
  Plan = 'PLAN',
  /** Owner */
  Ownr = 'OWNR'
}

/** A SCA policy configuration. */
export type OwnerScaPolicy = MaskPrimaryKeyNode & {
  __typename?: 'OwnerSCAPolicy';
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  /** The ID of the object */
  id: Scalars['ID'];
  /** Block PRs with vulnerabilities. */
  blockPrs: Scalars['Boolean'];
  /** List of package types to be blocked. */
  packageTypes: Array<Maybe<PackageType>>;
  /** List of package groups to be blocked. */
  packageGroups: Array<Maybe<PackageGroup>>;
  /** List of severity levels to be blocked. */
  severity: Array<Maybe<VulnerabilitySeverity>>;
  /** List of reachability levels to be blocked. */
  reachability: Array<Maybe<VulnerabilityOccurrenceReachability>>;
  /** List of fixability levels to be blocked. */
  fixability: Array<Maybe<VulnerabilityOccurrenceFixability>>;
  /** List of dynamic risk levels to be blocked. */
  dynamicRisk: Array<Maybe<DynamicRiskLevel>>;
  /** Minimum CVSS v4 score threshold to be used for blocking. */
  cvssV4Min: Scalars['Float'];
  /** Maximum CVSS v4 score threshold to be used for blocking. */
  cvssV4Max: Scalars['Float'];
  /** Minimum CVSS v3 score threshold to be used for blocking. */
  cvssV3Min: Scalars['Float'];
  /** Maximum CVSS v3 score threshold to be used for blocking. */
  cvssV3Max: Scalars['Float'];
  /** Minimum CVSS v2 score threshold to be used for blocking. */
  cvssV2Min: Scalars['Float'];
  /** Maximum CVSS v2 score threshold to be used for blocking. */
  cvssV2Max: Scalars['Float'];
  /** Minimum EPSS score threshold to be used for blocking. */
  epssScoreMin: Scalars['Float'];
  /** Maximum EPSS score threshold to be used for blocking. */
  epssScoreMax: Scalars['Float'];
  /** Minimum EPSS percentile threshold to be used for blocking. */
  epssPercentileMin: Scalars['Float'];
  /** Maximum EPSS percentile threshold to be used for blocking. */
  epssPercentileMax: Scalars['Float'];
};

/** Input for SCA policy configuration. */
export type OwnerScaPolicyInput = {
  /** Block PRs with vulnerabilities. */
  blockPrs?: Maybe<Scalars['Boolean']>;
  /** List of package types to be blocked. */
  packageTypes?: Maybe<Array<Maybe<PackageType>>>;
  /** List of package groups to be blocked. */
  packageGroups?: Maybe<Array<Maybe<PackageGroup>>>;
  /** List of severity levels to be blocked. */
  severity?: Maybe<Array<Maybe<VulnerabilitySeverity>>>;
  /** List of reachability levels to be blocked. */
  reachability?: Maybe<Array<Maybe<VulnerabilityOccurrenceReachability>>>;
  /** List of fixability levels to be blocked. */
  fixability?: Maybe<Array<Maybe<VulnerabilityOccurrenceFixability>>>;
  /** List of dynamic risk levels to be blocked. */
  dynamicRisk?: Maybe<Array<Maybe<DynamicRiskLevel>>>;
  /** Minimum CVSS v4 score to be blocked. */
  cvssV4Min?: Maybe<Scalars['Float']>;
  /** Maximum CVSS v4 score to be blocked. */
  cvssV4Max?: Maybe<Scalars['Float']>;
  /** Minimum CVSS v3 score to be blocked. */
  cvssV3Min?: Maybe<Scalars['Float']>;
  /** Maximum CVSS v3 score to be blocked. */
  cvssV3Max?: Maybe<Scalars['Float']>;
  /** Minimum CVSS v2 score to be blocked. */
  cvssV2Min?: Maybe<Scalars['Float']>;
  /** Maximum CVSS v2 score to be blocked. */
  cvssV2Max?: Maybe<Scalars['Float']>;
  /** Minimum EPSS score to be blocked. */
  epssScoreMin?: Maybe<Scalars['Float']>;
  /** Maximum EPSS score to be blocked. */
  epssScoreMax?: Maybe<Scalars['Float']>;
};

export type OwnerSetting = MaskPrimaryKeyNode & {
  __typename?: 'OwnerSetting';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  owner: Owner;
  publicKey?: Maybe<Scalars['String']>;
  /** If true, all test-coverage checks initiate as soon as the run is created and marked as 'failed' if an artifact isn't reported within the specified period. */
  shouldTimeoutDataTrigger?: Maybe<Scalars['Boolean']>;
  /** List of report keys (with metadata) to pin on the owner dashboard. */
  pinnedReports?: Maybe<Array<Maybe<PinnedReport>>>;
  /** If true, admins/members of the team will be subscribed to a sponsored pro plan on IDE. */
  sponsorIdeSubscriptions?: Maybe<Scalars['Boolean']>;
  /** Whether to allow users from running Autofix AI on private repositories. */
  allowAutofixAi?: Maybe<Scalars['Boolean']>;
  /** List of analyzer shortcodes to be enabled for AI */
  aiEnabledAnalyzers?: Maybe<Array<Scalars['String']>>;
  /** If true, Asgard will commit the deepsource.toml file to the repository on behalf of the owner. */
  ShouldCommitConfig?: Maybe<Scalars['Boolean']>;
  suppressedIssues: IssueConnection;
  /** Additional email addresses for vulnerability notifications. Always included as recipients. Admin emails are added separately via alert_all_admins. */
  vulnerabilityNotificationEmails: Array<Scalars['String']>;
  /** Minimum severity level for vulnerability notifications. */
  vulnerabilityNotificationThreshold: OwnerSettingVulnerabilityNotificationThreshold;
  /** Whether to include all org administrators in vulnerability notification recipients. When enabled, all admin emails are added to the notification recipients. When disabled, only the configured emails list is used. */
  vulnerabilityNotificationAlertAllAdmins?: Maybe<Scalars['Boolean']>;
  /** Dynamic risk configuration for the owner. */
  dynamicRiskConfig?: Maybe<OwnerDynamicRiskConfig>;
  issueTypeSettings?: Maybe<Array<Maybe<IssueTypeSetting>>>;
  /** A SCA policy configuration for the owner. */
  scaPolicy?: Maybe<OwnerScaPolicy>;
  /** A license policy configuration for the owner. */
  licensePolicy?: Maybe<OwnerLicensePolicy>;
  /** An AI policy configuration for the owner. */
  aiPolicy?: Maybe<OwnerAiPolicy>;
  /**
   * Whether to use the legacy autofix engine for all Autofix runs.
   * @deprecated Use ai_policy.useAiAutofix instead.
   */
  useLegacyAutofix?: Maybe<Scalars['Boolean']>;
  /** Whether to use the legacy secret analyzer for secret scanning. */
  useLegacySecretAnalyzer?: Maybe<Scalars['Boolean']>;
  /** Whether to commit config to the repository. */
  shouldCommitConfig?: Maybe<Scalars['Boolean']>;
};


export type OwnerSettingSuppressedIssuesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  issueType?: Maybe<Scalars['String']>;
  autofixAvailable?: Maybe<Scalars['Boolean']>;
  autofixAiAvailable?: Maybe<Scalars['Boolean']>;
  auditRequired?: Maybe<Scalars['Boolean']>;
  severity?: Maybe<Scalars['String']>;
  severityIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  sort?: Maybe<Scalars['String']>;
};

export type OwnerSettingConnection = {
  __typename?: 'OwnerSettingConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OwnerSettingEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `OwnerSetting` and its cursor. */
export type OwnerSettingEdge = {
  __typename?: 'OwnerSettingEdge';
  /** The item at the end of the edge */
  node?: Maybe<OwnerSetting>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** An enumeration. */
export enum OwnerSettingVulnerabilityNotificationThreshold {
  /** None */
  Non = 'NON',
  /** Low */
  Low = 'LOW',
  /** Medium */
  Med = 'MED',
  /** High */
  Hig = 'HIG',
  /** Critical */
  Cri = 'CRI'
}

/** An enumeration. */
export enum OwnerVcsProvider {
  /** GitHub */
  Gh = 'GH',
  /** GitLab */
  Gl = 'GL',
  /** Bitbucket */
  Bb = 'BB',
  /** Bitbucket Data Center */
  Bbd = 'BBD',
  /** GitHub Enterprise */
  Ghe = 'GHE',
  /** Google Cloud Source */
  Gsr = 'GSR',
  /** Azure DevOps Services */
  Ads = 'ADS'
}

/** A Pull Request on DeepSource.. */
export type Pr = MaskPrimaryKeyNode & {
  __typename?: 'PR';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  /** Base branch against which this pull request is raised. */
  baseBranch?: Maybe<Scalars['String']>;
  /** Branch on which this pull request is raised. */
  branch?: Maybe<Scalars['String']>;
  /** Pull Request number. */
  number?: Maybe<Scalars['Int']>;
  /** Issues raised by this pull request. */
  raisedCount?: Maybe<Scalars['Int']>;
  /** Issues resolved by this pull request. */
  resolvedCount?: Maybe<Scalars['Int']>;
  status: PrStatus;
  /** Current state of this pull request. */
  state?: Maybe<PrStateChoices>;
  /** Title of this pull request. */
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  /** Merge commit sha of the PR if and when it was merged. */
  mergeCommitOid?: Maybe<Scalars['String']>;
  /** Latest analysis run on this pull request. */
  latestAnalysisRun?: Maybe<Run>;
  /** Repository this PR belongs to. */
  repository?: Maybe<Repository>;
  /** Author of this pull request. */
  author?: Maybe<PrAuthor>;
  /** List of analysis runs for this pull request. */
  runs?: Maybe<RunConnection>;
  /** Issues that were raised then suppressed in this pull request. */
  suppressedCount?: Maybe<Scalars['Int']>;
  /** Total count of runs associated with this pull request. */
  runCount?: Maybe<Scalars['Int']>;
  /** URL of the PR on the VCS provider's website. */
  vcsUrl?: Maybe<Scalars['String']>;
  /** Aggregate grade from the latest analysis run's report card. */
  grade?: Maybe<Scalars['String']>;
};


/** A Pull Request on DeepSource.. */
export type PrRunsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  statusIn?: Maybe<Array<Maybe<RunStatusChoice>>>;
  q?: Maybe<Scalars['String']>;
};

/** The author of a Pull Request. */
export type PrAuthor = MaskPrimaryKeyNode & {
  __typename?: 'PRAuthor';
  /** The ID of the object */
  id: Scalars['ID'];
  /** Username/login on VCS provider */
  login?: Maybe<Scalars['String']>;
  /** Display name on VCS provider */
  displayName?: Maybe<Scalars['String']>;
  /** Avatar URL on VCS provider */
  avatarUrl?: Maybe<Scalars['String']>;
  /** VCS provider where this author exists. */
  vcsProvider?: Maybe<VcsProviderChoices>;
};

export type PrAuthorConnection = {
  __typename?: 'PRAuthorConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PrAuthorEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `PRAuthor` and its cursor. */
export type PrAuthorEdge = {
  __typename?: 'PRAuthorEdge';
  /** The item at the end of the edge */
  node?: Maybe<PrAuthor>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type PrConnection = {
  __typename?: 'PRConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PrEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `PR` and its cursor. */
export type PrEdge = {
  __typename?: 'PREdge';
  /** The item at the end of the edge */
  node?: Maybe<Pr>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export enum PrStateChoices {
  Open = 'OPEN',
  Closed = 'CLOSED'
}

/** An enumeration. */
export enum PrStatus {
  /** Draft */
  Draft = 'DRAFT',
  /** Open */
  Open = 'OPEN',
  /** Merged */
  Merged = 'MERGED',
  /** Closed */
  Closed = 'CLOSED'
}

export type Package = MaskPrimaryKeyNode & {
  __typename?: 'Package';
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  /** The ID of the object */
  id: Scalars['ID'];
  ecosystem: Ecosystem;
  /** Name of the package */
  name: Scalars['String'];
  /** The package URL */
  purl?: Maybe<Scalars['String']>;
  vulnerabilities: VulnerabilityConnection;
  /** Package */
  versions: PackageVersionConnection;
  repositoryPackages: RepositoryPackageConnection;
  checkPackages: CheckPackageConnection;
};


export type PackageVulnerabilitiesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type PackageVersionsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type PackageRepositoryPackagesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  packageType?: Maybe<PackageType>;
  q?: Maybe<Scalars['String']>;
  targetId?: Maybe<Scalars['ID']>;
  severityIn?: Maybe<Array<Maybe<VulnerabilitySeverity>>>;
  licenseSafetyIn?: Maybe<Array<Maybe<LicenseSafetyFilter>>>;
};


export type PackageCheckPackagesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type PackageConnection = {
  __typename?: 'PackageConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PackageEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Package` and its cursor. */
export type PackageEdge = {
  __typename?: 'PackageEdge';
  /** The item at the end of the edge */
  node?: Maybe<Package>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** The group of dependencies the package belongs to. */
export enum PackageGroup {
  Dev = 'DEV',
  Prod = 'PROD',
  Test = 'TEST',
  Documentation = 'DOCUMENTATION',
  Unknown = 'UNKNOWN'
}

/** Package managers supported by DeepSource */
export enum PackageManager {
  RequirementsTxt = 'REQUIREMENTS_TXT',
  Poetry = 'POETRY',
  Pipfile = 'PIPFILE',
  Pdm = 'PDM',
  Uv = 'UV',
  Npm = 'NPM',
  Yarn = 'YARN',
  Pnpm = 'PNPM',
  Bun = 'BUN',
  Gradle = 'GRADLE',
  Maven = 'MAVEN',
  GoMod = 'GO_MOD',
  RubyGems = 'RUBY_GEMS',
  Nuget = 'NUGET',
  Packagist = 'PACKAGIST',
  Cargo = 'CARGO'
}

/** The type of the package (direct/transitive, etc.). */
export enum PackageType {
  Direct = 'DIRECT',
  Transitive = 'TRANSITIVE',
  Unknown = 'UNKNOWN'
}

/** A summary of changes between two package versions. */
export type PackageUpgradeSummary = MaskPrimaryKeyNode & {
  __typename?: 'PackageUpgradeSummary';
  /** The package ecosystem. */
  ecosystem: Ecosystem;
  /** Name of the package */
  packageName: Scalars['String'];
  /** From version of the package */
  fromVersion: Scalars['String'];
  /** To version of the package */
  toVersion: Scalars['String'];
  /** The breakage risk of the upgrade */
  breakageRisk: PackageUpgradeSummaryBreakageRisk;
  /** The ID of the object */
  id: Scalars['ID'];
  /** A list of breaking changes. */
  breakingChanges: Array<Maybe<Scalars['String']>>;
  /** A list of non-breaking changes. */
  otherChanges: Array<Maybe<Scalars['String']>>;
  /** A list of reference URLs. */
  urls: Array<Maybe<Scalars['String']>>;
};

/** An enumeration. */
export enum PackageUpgradeSummaryBreakageRisk {
  /** very low */
  VeryLow = 'VERY_LOW',
  /** low */
  Low = 'LOW',
  /** moderate */
  Moderate = 'MODERATE',
  /** high */
  High = 'HIGH',
  /** very high */
  VeryHigh = 'VERY_HIGH'
}

export type PackageVersion = MaskPrimaryKeyNode & {
  __typename?: 'PackageVersion';
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  /** The ID of the object */
  id: Scalars['ID'];
  /** Package */
  package: Package;
  /** License of the package */
  licenses: LicenseConnection;
  /** License expressions of the package */
  licenseExpressions?: Maybe<Array<Scalars['String']>>;
  /** Description of the package */
  description?: Maybe<Scalars['String']>;
  /** Version of the package */
  version: Scalars['String'];
  /** Type of the version */
  versionType: PackageVersionVersionType;
  /** Major version of the package */
  versionMajor?: Maybe<Scalars['Int']>;
  /** Minor version of the package */
  versionMinor?: Maybe<Scalars['Int']>;
  /** Patch version of the package */
  versionPatch?: Maybe<Scalars['Int']>;
  vulnerabilities: VulnerabilityConnection;
  repositoryPackages: RepositoryPackageConnection;
  checkPackages: CheckPackageConnection;
};


export type PackageVersionLicensesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
};


export type PackageVersionVulnerabilitiesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type PackageVersionRepositoryPackagesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  packageType?: Maybe<PackageType>;
  q?: Maybe<Scalars['String']>;
  targetId?: Maybe<Scalars['ID']>;
  severityIn?: Maybe<Array<Maybe<VulnerabilitySeverity>>>;
  licenseSafetyIn?: Maybe<Array<Maybe<LicenseSafetyFilter>>>;
};


export type PackageVersionCheckPackagesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type PackageVersionConnection = {
  __typename?: 'PackageVersionConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PackageVersionEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `PackageVersion` and its cursor. */
export type PackageVersionEdge = {
  __typename?: 'PackageVersionEdge';
  /** The item at the end of the edge */
  node?: Maybe<PackageVersion>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** An enumeration. */
export enum PackageVersionVersionType {
  /** Semantic Versioning */
  Semver = 'SEMVER',
  /** Ecosystem Versioning */
  Ecosystem = 'ECOSYSTEM',
  /** Git Commit */
  Git = 'GIT'
}

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum PercentileStrategy {
  Linear = 'LINEAR',
  Quadratic = 'QUADRATIC',
  Cubic = 'CUBIC'
}

export type PinnedReport = {
  __typename?: 'PinnedReport';
  key: Scalars['String'];
  metadata?: Maybe<Scalars['GenericScalar']>;
};

export type PinnedReportInput = {
  key: Scalars['String'];
  metadata?: Maybe<Scalars['GenericScalar']>;
};

export enum PlatformStatus {
  Operational = 'OPERATIONAL',
  Degraded = 'DEGRADED',
  Downtime = 'DOWNTIME'
}

export type Product = AgentsProduct | CodeQualityProduct | IdeProduct | ScaProduct | UnifiedProduct;

export enum ProductChoice {
  Agents = 'AGENTS',
  CodeQuality = 'CODE_QUALITY',
  Ide = 'IDE',
  Sca = 'SCA',
  Unified = 'UNIFIED'
}

export enum ProductInterestChoices {
  AiCodeReview = 'AI_CODE_REVIEW',
  SecurityScanning = 'SECURITY_SCANNING',
  DependencyScanning = 'DEPENDENCY_SCANNING',
  CodeCoverage = 'CODE_COVERAGE',
  ComplianceReporting = 'COMPLIANCE_REPORTING'
}

export type ProductSubscription = MaskPrimaryKeyNode & {
  __typename?: 'ProductSubscription';
  owner?: Maybe<Owner>;
  user?: Maybe<User>;
  status: ProductSubscriptionStatus;
  /** The ID of the object */
  id: Scalars['ID'];
  product: Product;
  billingDetails: BillingDetails;
  billingBackend: BillingBackend;
  /** The subscription's sponsor. */
  sponsoredBy?: Maybe<SubscriptionSponsor>;
};

export type ProductSubscriptionConnection = {
  __typename?: 'ProductSubscriptionConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProductSubscriptionEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ProductSubscription` and its cursor. */
export type ProductSubscriptionEdge = {
  __typename?: 'ProductSubscriptionEdge';
  /** The item at the end of the edge */
  node?: Maybe<ProductSubscription>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** An enumeration. */
export enum ProductSubscriptionStatus {
  /** Active */
  Active = 'ACTIVE',
  /** Inactive */
  Inactive = 'INACTIVE',
  /** Trial */
  Trial = 'TRIAL',
  /** Past Due */
  PastDue = 'PAST_DUE',
  /** SCA Required */
  Sca = 'SCA'
}

/** An enumeration. */
export enum ProductType {
  StaticAnalysis = 'STATIC_ANALYSIS',
  Secrets = 'SECRETS',
  Sast = 'SAST',
  Coverage = 'COVERAGE',
  IacAnalysis = 'IAC_ANALYSIS'
}

export type PublicReport = MaskPrimaryKeyNode & {
  __typename?: 'PublicReport';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  /** An id that uniquely identifies the report. */
  reportId: Scalars['UUID'];
  /** A human readable label for the report. */
  label: Scalars['String'];
  /** Whether or not the report is password protected. */
  isRestricted: Scalars['Boolean'];
  /** Whether or not the report includes historical data. */
  shareHistoricalData: Scalars['Boolean'];
  reportKeys?: Maybe<Array<Maybe<Scalars['String']>>>;
  source?: Maybe<ReportSource>;
  sourcedRepositories?: Maybe<RepositoryConnection>;
  /** The owner for which this report was created. Corresponds to owner level reports. */
  owner?: Maybe<Owner>;
  /** The repository group for which this report was created. Corresponds to repository group level reports */
  repositoryGroup?: Maybe<RepositoryGroup>;
  /** The repository for which this report was created. Corresponds to repository level reports */
  repository?: Maybe<Repository>;
  /** The view count for this report. */
  views: Scalars['Int'];
  level?: Maybe<ReportLevel>;
  report?: Maybe<Report>;
  complianceIssues?: Maybe<Array<Maybe<ComplianceIssue>>>;
  /** A map of the severity count of compliance issues */
  complianceIssuesSeverityMap?: Maybe<ComplianceIssueOccurrence>;
  issueDistributionByAnalyzer?: Maybe<Array<Maybe<IssueDistribution>>>;
  issueDistributionByCategory?: Maybe<Array<Maybe<IssueDistribution>>>;
  repositoriesCoverageReport?: Maybe<RepositoryCoverageReportItemConnection>;
  scaTargetsReport?: Maybe<RepositoryScaTargetReportItemConnection>;
  activeThirdPartyVulnerabilitiesBySeverity?: Maybe<Array<Maybe<ActiveThirdPartyVulnerabilitiesReportItem>>>;
  activeThirdPartyVulnerabilitiesByReachability?: Maybe<Array<Maybe<ActiveThirdPartyVulnerabilitiesReportItem>>>;
};


export type PublicReportSourcedRepositoriesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  vcsProvider?: Maybe<VcsProviderChoices>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  isActivated?: Maybe<Scalars['Boolean']>;
  errorCode?: Maybe<Scalars['Int']>;
  name_Icontains?: Maybe<Scalars['String']>;
  nameFuzzy?: Maybe<Scalars['String']>;
};


export type PublicReportReportArgs = {
  key: Scalars['String'];
};


export type PublicReportComplianceIssuesArgs = {
  key: Scalars['String'];
};


export type PublicReportComplianceIssuesSeverityMapArgs = {
  key: Scalars['String'];
};


export type PublicReportIssueDistributionByAnalyzerArgs = {
  key: Scalars['String'];
  sortKey?: Maybe<IssueDistributionSortKey>;
};


export type PublicReportIssueDistributionByCategoryArgs = {
  key: Scalars['String'];
  sortKey?: Maybe<IssueDistributionSortKey>;
};


export type PublicReportRepositoriesCoverageReportArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
};


export type PublicReportScaTargetsReportArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
};


export type PublicReportActiveThirdPartyVulnerabilitiesBySeverityArgs = {
  key: Scalars['String'];
};


export type PublicReportActiveThirdPartyVulnerabilitiesByReachabilityArgs = {
  key: Scalars['String'];
};

export type PublicReportConnection = {
  __typename?: 'PublicReportConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PublicReportEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `PublicReport` and its cursor. */
export type PublicReportEdge = {
  __typename?: 'PublicReportEdge';
  /** The item at the end of the edge */
  node?: Maybe<PublicReport>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** The query root of DeepSource's GraphQL interface. */
export type Query = {
  __typename?: 'Query';
  /** Export run analysis results as markdown. Use run_id (UUID) and optional analyzer_shortcode instead of internal IDs. */
  exportRunAsMarkdown?: Maybe<Scalars['String']>;
  configGenerationRun: ConfigGenerationRun;
  /** Look up a repository group by slug. */
  repositoryGroup?: Maybe<RepositoryGroup>;
  /** Get SAML2 SSO login URL for an email. Returns URL if exactly 1 IDP exists for the domain, null otherwise. */
  saml2LoginUrl?: Maybe<Scalars['String']>;
  /** Get all available IDPs for an email domain, with login URLs. */
  identityProvidersForEmail?: Maybe<SsoIdentityProviderConnection>;
  isViewerSuperadmin?: Maybe<Scalars['Boolean']>;
  getGroupInviteInfo?: Maybe<GroupInviteInfo>;
  enterprise?: Maybe<EnterpriseInstallationRoot>;
  /** Get an Access Token */
  accessToken?: Maybe<AccessToken>;
  /** Get all webhook events */
  webhookEventTypes?: Maybe<WebhookEventTypesConnection>;
  /** Get all webhook event deliveries for an owner */
  webhookEventDeliveries?: Maybe<WebhookEventDeliveryConnection>;
  /** Get a single webhook event delivery */
  webhookEventDelivery?: Maybe<WebhookEventDelivery>;
  /** Get a webhook */
  webhook?: Maybe<Webhook>;
  /** Lookup a transformer by it's shortcode. */
  transformer?: Maybe<TransformerTool>;
  /** Lookup a transformer by it's shortcode. */
  transformers?: Maybe<TransformerToolConnection>;
  transformerRun: TransformerRun;
  autofixRun: AutofixRun;
  oauth?: Maybe<SocialAuthUrl>;
  repositoryTarget: RepositoryTarget;
  /** Get a license by ID. */
  license?: Maybe<License>;
  /** List of licenses. */
  licenses?: Maybe<LicenseConnection>;
  /** Get a summary of changes between two package versions if available. */
  packageUpgradeSummary?: Maybe<PackageUpgradeSummary>;
  /** Return all available issue priority types */
  issuePriorityType?: Maybe<IssuePriorityTypeConnection>;
  /** An issue raised by an analyzer, identified by it's shortcode. */
  issue?: Maybe<Issue>;
  /** Return issues based on the filters passed */
  issuesWithPriority?: Maybe<IssueConnection>;
  integrations?: Maybe<Array<Maybe<IntegrationProvider>>>;
  integration?: Maybe<IntegrationProvider>;
  /** List of transactions of a user */
  transactions?: Maybe<TransactionConnection>;
  /** Lookup one owner by login and VCS provider. */
  owner?: Maybe<Owner>;
  /** Lookup one team by login and VCS provider. */
  team?: Maybe<Team>;
  /** Lookup if the given invite code is valid and return team info if valid. */
  getTeamInviteInfo?: Maybe<TeamInviteInfo>;
  /** Get join request status for a given (user, team) */
  getTeamMemberAdditionRequests?: Maybe<GetTeamMemberRequestStatus>;
  /** List of RepositoryIssues raised for 'filepath' in the given repository. */
  fileIssues?: Maybe<RepositoryIssueConnection>;
  /** Lookup one check with it's check id */
  scaCheck: ScaCheck;
  /** List of issues raised in a check. */
  checkIssues?: Maybe<CheckIssueConnection>;
  /** Lookup one check with it's check id */
  check: Check;
  /** Lookup an analyzer by it's shortcode. */
  analyzer?: Maybe<Analyzer>;
  /** Lookup an analyzer by it's shortcode. */
  analyzers?: Maybe<AnalyzerConnection>;
  /** The currently authenticated user. */
  viewer?: Maybe<User>;
  /** Lookup one repository by name and owner's login. */
  repository?: Maybe<Repository>;
  report?: Maybe<Report>;
  reports?: Maybe<Array<Maybe<Report>>>;
  complianceIssues?: Maybe<Array<Maybe<ComplianceIssue>>>;
  /** A map of the severity count of compliance issues */
  complianceIssuesSeverityMap?: Maybe<ComplianceIssueOccurrence>;
  issueDistributionByAnalyzer?: Maybe<Array<Maybe<IssueDistribution>>>;
  issueDistributionByCategory?: Maybe<Array<Maybe<IssueDistribution>>>;
  activeThirdPartyVulnerabilitiesBySeverity?: Maybe<Array<Maybe<ActiveThirdPartyVulnerabilitiesReportItem>>>;
  activeThirdPartyVulnerabilitiesByReachability?: Maybe<Array<Maybe<ActiveThirdPartyVulnerabilitiesReportItem>>>;
  publicReport?: Maybe<PublicReport>;
  /** The list of sourceable repositories in a public report for an owner. */
  publicReportSourceableRepositories?: Maybe<SourceableRepositoryConnection>;
  context?: Maybe<Context>;
  node?: Maybe<MaskPrimaryKeyNode>;
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryExportRunAsMarkdownArgs = {
  runId: Scalars['String'];
  analyzerShortcode?: Maybe<Scalars['String']>;
  targetId?: Maybe<Scalars['String']>;
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryConfigGenerationRunArgs = {
  runId: Scalars['String'];
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryRepositoryGroupArgs = {
  slug: Scalars['String'];
};


/** The query root of DeepSource's GraphQL interface. */
export type QuerySaml2LoginUrlArgs = {
  email: Scalars['String'];
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryIdentityProvidersForEmailArgs = {
  email: Scalars['String'];
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryGetGroupInviteInfoArgs = {
  invitationCode: Scalars['String'];
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryAccessTokenArgs = {
  tokenId: Scalars['ID'];
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryWebhookEventTypesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryWebhookEventDeliveriesArgs = {
  ownerId: Scalars['ID'];
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryWebhookEventDeliveryArgs = {
  ownerId: Scalars['ID'];
  deliveryId: Scalars['ID'];
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryWebhookArgs = {
  webhookId: Scalars['ID'];
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryTransformerArgs = {
  shortcode: Scalars['String'];
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryTransformersArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  language?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryTransformerRunArgs = {
  runId: Scalars['String'];
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryAutofixRunArgs = {
  runId: Scalars['String'];
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryRepositoryTargetArgs = {
  targetId: Scalars['ID'];
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryLicenseArgs = {
  identifier: Scalars['ID'];
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryLicensesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryPackageUpgradeSummaryArgs = {
  ecosystem: Ecosystem;
  packageName: Scalars['String'];
  fromVersion: Scalars['String'];
  toVersion: Scalars['String'];
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryIssuePriorityTypeArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Int']>;
  verboseName?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryIssueArgs = {
  shortcode: Scalars['String'];
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryIssuesWithPriorityArgs = {
  isIssuePrioritySet?: Maybe<Scalars['Boolean']>;
  objectId: Scalars['ID'];
  level: IssuePriorityLevel;
  analyzerShortcode?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  issueType?: Maybe<Scalars['String']>;
  autofixAvailable?: Maybe<Scalars['Boolean']>;
  autofixAiAvailable?: Maybe<Scalars['Boolean']>;
  auditRequired?: Maybe<Scalars['Boolean']>;
  severity?: Maybe<Scalars['String']>;
  severityIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  sort?: Maybe<Scalars['String']>;
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryIntegrationsArgs = {
  level?: Maybe<IntegrationSettingsLevel>;
  ownerId?: Maybe<Scalars['ID']>;
  repositoryId?: Maybe<Scalars['ID']>;
  onlyInstalled?: Maybe<Scalars['Boolean']>;
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryIntegrationArgs = {
  shortcode: Scalars['String'];
  level?: Maybe<IntegrationSettingsLevel>;
  ownerId?: Maybe<Scalars['ID']>;
  repositoryId?: Maybe<Scalars['ID']>;
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryTransactionsArgs = {
  userId: Scalars['Int'];
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  transactionType?: Maybe<TransactionTransactionType>;
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryOwnerArgs = {
  login: Scalars['String'];
  provider: VcsProviderChoices;
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryTeamArgs = {
  login: Scalars['String'];
  provider: VcsProviderChoices;
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryGetTeamInviteInfoArgs = {
  invitationCode: Scalars['String'];
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryGetTeamMemberAdditionRequestsArgs = {
  teamId: Scalars['ID'];
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryFileIssuesArgs = {
  repoId: Scalars['ID'];
  filepath: Scalars['String'];
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  recommended?: Maybe<Scalars['Boolean']>;
  issueType?: Maybe<Scalars['String']>;
  analyzer?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['String']>;
  severityIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  autofixAvailable?: Maybe<Scalars['Boolean']>;
  auditRequired?: Maybe<Scalars['Boolean']>;
  q?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryScaCheckArgs = {
  id?: Maybe<Scalars['ID']>;
  runId?: Maybe<Scalars['UUID']>;
  targetId?: Maybe<Scalars['ID']>;
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryCheckIssuesArgs = {
  checkId: Scalars['ID'];
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  shortcode?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryCheckArgs = {
  checkId: Scalars['ID'];
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryAnalyzerArgs = {
  shortcode: Scalars['String'];
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryAnalyzersArgs = {
  analyzerType?: Maybe<AnalyzerTypeChoices>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  categoryIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  q?: Maybe<Scalars['String']>;
  exclude?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryRepositoryArgs = {
  name: Scalars['String'];
  owner: Scalars['String'];
  provider: VcsProviderChoices;
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryReportArgs = {
  level?: Maybe<ReportLevel>;
  key?: Maybe<Scalars['String']>;
  objectId?: Maybe<Scalars['ID']>;
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryReportsArgs = {
  level?: Maybe<ReportLevel>;
  objectId?: Maybe<Scalars['ID']>;
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryComplianceIssuesArgs = {
  level?: Maybe<ReportLevel>;
  reportKey?: Maybe<Scalars['String']>;
  objectId?: Maybe<Scalars['ID']>;
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryComplianceIssuesSeverityMapArgs = {
  level?: Maybe<ReportLevel>;
  reportKey?: Maybe<Scalars['String']>;
  objectId?: Maybe<Scalars['ID']>;
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryIssueDistributionByAnalyzerArgs = {
  level?: Maybe<ReportLevel>;
  reportKey: Scalars['String'];
  objectId?: Maybe<Scalars['ID']>;
  sortKey?: Maybe<IssueDistributionSortKey>;
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryIssueDistributionByCategoryArgs = {
  level?: Maybe<ReportLevel>;
  reportKey: Scalars['String'];
  objectId?: Maybe<Scalars['ID']>;
  sortKey?: Maybe<IssueDistributionSortKey>;
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryActiveThirdPartyVulnerabilitiesBySeverityArgs = {
  level?: Maybe<ReportLevel>;
  reportKey: Scalars['String'];
  objectId?: Maybe<Scalars['ID']>;
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryActiveThirdPartyVulnerabilitiesByReachabilityArgs = {
  level?: Maybe<ReportLevel>;
  reportKey: Scalars['String'];
  objectId?: Maybe<Scalars['ID']>;
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryPublicReportArgs = {
  reportId?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryPublicReportSourceableRepositoriesArgs = {
  ownerLogin: Scalars['String'];
  vcsProvider: VcsProviderChoices;
  q?: Maybe<Scalars['String']>;
  publicReportId?: Maybe<Scalars['ID']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** The query root of DeepSource's GraphQL interface. */
export type QueryNodeArgs = {
  id: Scalars['ID'];
};

/** Representation of the recent stats for a report. */
export type RecentStat = {
  __typename?: 'RecentStat';
  statLabel?: Maybe<Scalars['String']>;
  statValue?: Maybe<Scalars['Int']>;
  trendValue?: Maybe<Scalars['Int']>;
  trendDirection?: Maybe<TrendDirection>;
  trendPositive?: Maybe<Scalars['Boolean']>;
};

export enum ReferralSourceChoices {
  XTwitter = 'X_TWITTER',
  Linkedin = 'LINKEDIN',
  Google = 'GOOGLE',
  AiSearch = 'AI_SEARCH',
  ColleagueFriend = 'COLLEAGUE_FRIEND',
  HackerNews = 'HACKER_NEWS',
  Other = 'OTHER',
  PreferNotShare = 'PREFER_NOT_SHARE'
}

export type RefreshToken = {
  __typename?: 'RefreshToken';
  payload: Scalars['GenericScalar'];
  refreshExpiresIn: Scalars['Int'];
  token: Scalars['String'];
  refreshToken: Scalars['String'];
};

export type RegenerateRepositoryDsnInput = {
  /** GraphQL node ID of the repository. */
  repositoryId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type RegenerateRepositoryDsnPayload = {
  __typename?: 'RegenerateRepositoryDSNPayload';
  /** The new DSN for the repository. */
  dsn: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type RejectTeamMemberAdditionRequestInput = {
  additionRequestId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type RejectTeamMemberAdditionRequestPayload = {
  __typename?: 'RejectTeamMemberAdditionRequestPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type RemoveKeyPairForOwnerInput = {
  /** GraphQL node ID of the owner. */
  ownerId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Remove RSA key pair for the owner. */
export type RemoveKeyPairForOwnerPayload = {
  __typename?: 'RemoveKeyPairForOwnerPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type RemoveKeyPairForRepositoryGroupInput = {
  /** GraphQL node ID of the repository group. */
  repositoryGroupId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Remove RSA key pair for the repository group. */
export type RemoveKeyPairForRepositoryGroupPayload = {
  __typename?: 'RemoveKeyPairForRepositoryGroupPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type RemoveKeyPairForRepositoryInput = {
  /** GraphQL node ID of the repository. */
  repositoryId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Remove RSA key pair for the repository. */
export type RemoveKeyPairForRepositoryPayload = {
  __typename?: 'RemoveKeyPairForRepositoryPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type RemoveRepositoriesFromRepositoryGroupInput = {
  /** GraphQL node ID of the repository group. */
  repositoryGroupId: Scalars['ID'];
  /** List of GraphQL node IDs of the repositories to remove. */
  repositoryIds: Array<Scalars['ID']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Remove repositories from a repository group. */
export type RemoveRepositoriesFromRepositoryGroupPayload = {
  __typename?: 'RemoveRepositoriesFromRepositoryGroupPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type RemoveRepositoryCollaboratorInput = {
  repositoryCollaboratorId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type RemoveRepositoryCollaboratorPayload = {
  __typename?: 'RemoveRepositoryCollaboratorPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type RemoveTeamFromGroupInput = {
  groupId: Scalars['ID'];
  teamId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type RemoveTeamFromGroupPayload = {
  __typename?: 'RemoveTeamFromGroupPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type RemoveTeamMemberInput = {
  ownerId?: Maybe<Scalars['Int']>;
  ownerPk?: Maybe<Scalars['ID']>;
  memberEmail: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type RemoveTeamMemberPayload = {
  __typename?: 'RemoveTeamMemberPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type RemoveUserFromGroupInput = {
  groupId: Scalars['ID'];
  userId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type RemoveUserFromGroupPayload = {
  __typename?: 'RemoveUserFromGroupPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type Report = {
  __typename?: 'Report';
  key?: Maybe<Scalars['String']>;
  type?: Maybe<ReportType>;
  title?: Maybe<Scalars['String']>;
  status?: Maybe<ReportStatus>;
  currentValue?: Maybe<Scalars['Int']>;
  historicalValues?: Maybe<Scalars['GenericScalar']>;
  recentStats?: Maybe<Array<Maybe<RecentStat>>>;
};


export type ReportHistoricalValuesArgs = {
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
};

export type ReportAiReviewIssueFalsePositiveInput = {
  /** ID of the AI Review Issue. */
  aiReviewIssueId: Scalars['ID'];
  /** Comment by the user explaining this report. */
  comment?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Report an AI review issue as a false-positive. */
export type ReportAiReviewIssueFalsePositivePayload = {
  __typename?: 'ReportAIReviewIssueFalsePositivePayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type ReportIssueFalsePositiveInput = {
  /** ID of the CheckIssue. */
  checkIssueId: Scalars['ID'];
  action?: Maybe<IgnoreCheckIssueActionChoice>;
  /** Comment by the user explaining this report. */
  comment?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Report an issue as a false-positive. */
export type ReportIssueFalsePositivePayload = {
  __typename?: 'ReportIssueFalsePositivePayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** The level of the report. */
export enum ReportLevel {
  Repository = 'REPOSITORY',
  RepositoryGroup = 'REPOSITORY_GROUP',
  Owner = 'OWNER',
  Enterprise = 'ENTERPRISE'
}

/** The source of the report. */
export enum ReportSource {
  SourceAll = 'SOURCE_ALL',
  SourceSelected = 'SOURCE_SELECTED'
}

/** The status of the report. */
export enum ReportStatus {
  Passing = 'PASSING',
  Failing = 'FAILING',
  Noop = 'NOOP'
}

/** The type of the report. */
export enum ReportType {
  Compliance = 'COMPLIANCE',
  Insight = 'INSIGHT'
}

/** A repository on DeepSource. */
export type Repository = MaskPrimaryKeyNode & {
  __typename?: 'Repository';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  /** The name of this repository. */
  name: Scalars['String'];
  /** Description of the repository from the VCS provider. */
  description?: Maybe<Scalars['String']>;
  /** VCS used by this repository. */
  vcsType: RepositoryVcsType;
  vcsProvider: VcsProviderChoices;
  vcsUrl: Scalars['String'];
  /** Unique identity of the repository in the VCS, if available. */
  vcsRepoUid: Scalars['String'];
  /** repository collaborators */
  collaborators?: Maybe<RepositoryCollaboratorConnection>;
  vcsCreatedAt?: Maybe<Scalars['DateTime']>;
  /** The SSH URL to clone this repository. */
  sshUrl: Scalars['String'];
  /** Default branch for analysis of this repository. */
  defaultBranchName?: Maybe<Scalars['String']>;
  /** Object ID of the latest commit on the default branch. */
  latestCommitOid?: Maybe<Scalars['String']>;
  latestAnalysisRun?: Maybe<Run>;
  isFork: Scalars['Boolean'];
  isMirror: Scalars['Boolean'];
  isPrivate: Scalars['Boolean'];
  showInDiscover: Scalars['Boolean'];
  languages: Scalars['GenericScalar'];
  isActivated: Scalars['Boolean'];
  errorCode: Scalars['Int'];
  errorMessage?: Maybe<Scalars['String']>;
  /** Text to show on CTA button alongwith error message on dashboard. */
  errorCtaButtonText?: Maybe<Scalars['String']>;
  /** Redirect the user from error message to this HTTP URL */
  errorCtaButtonUrl?: Maybe<Scalars['String']>;
  /** Public SSH key */
  encPublicKey?: Maybe<Scalars['String']>;
  isSubmoduleEnabled: Scalars['Boolean'];
  analyzeChangesetOnly?: Maybe<Scalars['Boolean']>;
  /** List of issues on the default of this repository. */
  issues?: Maybe<RepositoryIssueConnection>;
  config: Scalars['GenericScalar'];
  owner: Owner;
  widgets?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** List of supported analyzers, inferred from languages info on VCS. Use case - we can recommend analyzers in repo config editor. */
  supportedAnalyzers?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Primitive authentication for serving badge requests */
  token: Scalars['String'];
  extraData: Scalars['JSONString'];
  weightCutoff: Scalars['Int'];
  tree: Scalars['JSONString'];
  latestTrainedRun?: Maybe<Run>;
  /** Analyzer corresponding to the most used language and is enabled in the config */
  primaryAnalyzer?: Maybe<Analyzer>;
  /** The analyzer representing the majority language */
  majorityAnalyzer?: Maybe<Analyzer>;
  kind: RepositoryKindChoices;
  /** Repository group this repository belongs to. */
  repositoryGroup?: Maybe<RepositoryGroup>;
  analyzer?: Maybe<Analyzer>;
  checks: CheckConnection;
  /** List of packages for this repository. */
  packages: RepositoryPackageConnection;
  issuePriorities: IssuePriorityConnection;
  repositorySetting?: Maybe<RepositorySetting>;
  /** List of targets for this repository. */
  targets: RepositoryTargetConnection;
  billedrepositorytargets: BilledRepositoryTargetConnection;
  watchedBy: UserPreferenceConnection;
  /** List of autofix runs for this repository. */
  autofixRuns?: Maybe<AutofixRunConnection>;
  onboardingEvents: AutoOnboardEventConnection;
  configGenerationRuns: ConfigGenerationRunConnection;
  /** List of PRs for this repository */
  prs?: Maybe<PrConnection>;
  scaChecks: ScaCheckConnection;
  /** List of transformer runs for this repository. */
  transformerRuns?: Maybe<TransformerRunConnection>;
  /** List of analysis runs for this repository. */
  runs?: Maybe<RunConnection>;
  remediationPatchRuns: VulnerabilityRemediationPatchRunConnection;
  /** A list of repositories from which the report data should be sourced. */
  sourcedInPublicReports: PublicReportConnection;
  publicReports?: Maybe<PublicReportConnection>;
  /** List of silence rules that exist for this repository. */
  silenceRules?: Maybe<SilenceRuleConnection>;
  ownerLogin?: Maybe<Scalars['String']>;
  canBeActivated?: Maybe<Scalars['Boolean']>;
  lastAnalyzedAt?: Maybe<Scalars['DateTime']>;
  blobUrlRoot?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  displayFullName: Scalars['String'];
  renderedErrorMessage?: Maybe<Scalars['String']>;
  issueTypeSettings?: Maybe<Array<Maybe<IssueTypeSetting>>>;
  issuePrioritySettings?: Maybe<Array<Maybe<IssuePrioritySetting>>>;
  issueSeveritySettings?: Maybe<Array<Maybe<IssueSeveritySetting>>>;
  metricSettings?: Maybe<Array<Maybe<MetricSetting>>>;
  widgetsDisplay?: Maybe<Scalars['GenericScalar']>;
  allWidgets?: Maybe<Scalars['GenericScalar']>;
  widgetsAvailable?: Maybe<Array<Maybe<Scalars['String']>>>;
  isAutofixEnabled: Scalars['Boolean'];
  useLegacyAutofix?: Maybe<Scalars['Boolean']>;
  /** Denotes whether any SCA target is activated for this repository. */
  isScaEnabled: Scalars['Boolean'];
  /** The status of the autofix installation app. */
  autofixInstallationStatus: AutofixInstallationStatus;
  /** The status of the code analysis. */
  codeAnalysisStatus: CodeAnalysisStatus;
  /** The status of the SCA analysis. */
  scaStatus: ScaStatus;
  /** The status of the coverage analysis. */
  coverageStatus: CoverageStatus;
  /** All analyzers that have issues in this repository */
  availableAnalyzers?: Maybe<AnalyzerConnection>;
  /** List of metrics captured for the default branch of this repository. */
  metricsCaptured?: Maybe<Array<Maybe<Metric>>>;
  uniqueNamespaceKeys?: Maybe<Array<Maybe<Scalars['String']>>>;
  isCommitPossible?: Maybe<Scalars['Boolean']>;
  vcsHost?: Maybe<Scalars['String']>;
  configGenerationRoute?: Maybe<Scalars['String']>;
  activeIssueCount?: Maybe<Scalars['Int']>;
  vcsDefaultBranchUrl?: Maybe<Scalars['String']>;
  /** An issue that has been raised for this repository. */
  issue?: Maybe<RepositoryIssue>;
  /** Last triggered run */
  lastRun?: Maybe<Run>;
  /**
   * List of analysis runs for this repository grouped by branch name
   * @deprecated Removed in favour of `prs`
   */
  groupedRuns?: Maybe<RunConnection>;
  /** Pull Request with specified pr# on this repository */
  pr?: Maybe<Pr>;
  /** Most recently analyzed PR on this repository. */
  latestPr?: Maybe<Pr>;
  /** Open pull request count on this repository. */
  openPrCount?: Maybe<Scalars['Int']>;
  /** Closed pull request count on this repository. */
  closedPrCount?: Maybe<Scalars['Int']>;
  /** Get a autofix run from it's run id. */
  autofixRun?: Maybe<AutofixRun>;
  /** List of transformer runs for this repository grouped by branch name */
  groupedTransformerRuns?: Maybe<TransformerRunConnection>;
  /** List of transformer runs for this repository for given branch name */
  transformerBranchRuns?: Maybe<TransformerRunConnection>;
  /** Get a transformer run from it's run id. */
  transformerRun?: Maybe<TransformerRun>;
  /** Get a run from it's run id. */
  run?: Maybe<Run>;
  /** List of analysis runs for this repository for given branch name */
  branchRuns?: Maybe<RunConnection>;
  /** Does the viewer have some kind of edit access on this repo? */
  hasViewerEditAccess?: Maybe<Scalars['Boolean']>;
  viewerPermission?: Maybe<RepositoryPermissionChoices>;
  /** URL to install the Autofix installation. */
  autofixInstallationUrl?: Maybe<Scalars['String']>;
  /**
   * GitHub Autofix app installation URL
   * @deprecated Use autofixInstallationUrl instead
   */
  autofixGithubAppInstallationUrl?: Maybe<Scalars['String']>;
  /**
   * Bitbucket Autofix Addon installation URL
   * @deprecated Use autofixInstallationUrl instead
   */
  autofixBitbucketAddonInstallationUrl?: Maybe<Scalars['String']>;
  /** List of team members which can be added as repo collaborator */
  addableMembers?: Maybe<TeamMemberConnection>;
  /** The general DSN for this repository. */
  dsn?: Maybe<Scalars['String']>;
  /** If repository has test-coverage analyzer enabled */
  hasTestCoverage?: Maybe<Scalars['Boolean']>;
  badge: Scalars['GenericScalar'];
  /** List of audit logs */
  logs?: Maybe<AuditLogConnection>;
  /** List of details of autofixable issues per analyzer. */
  autofixableIssuesPerAnalyzer?: Maybe<Array<Maybe<AnalyzerAutofixableIssues>>>;
  /** List of details of autofixable issues per analyzer. */
  aiAutofixableIssuesPerAnalyzer?: Maybe<Array<Maybe<AnalyzerAutofixableIssues>>>;
  /** Info on autofixable issues on default analysis branch. */
  autofixableIssuesMetadata?: Maybe<AutofixableIssuesMetadata>;
  /** Info on AI-autofixable issues on default analysis branch. */
  aiAutofixableIssuesMetadata?: Maybe<AutofixableIssuesMetadata>;
  userPermissionMeta?: Maybe<Scalars['GenericScalar']>;
  issueOccurrenceDistributionByProduct: Array<IssueOccurrenceFrequency>;
  issueOccurrenceDistributionByIssueType: Array<IssueOccurrenceFrequency>;
  recommendedIssueCount?: Maybe<Scalars['Int']>;
  totalIssueCount?: Maybe<Scalars['Int']>;
  isStarred?: Maybe<Scalars['Boolean']>;
  isWatched?: Maybe<Scalars['Boolean']>;
  hasAdhocRuns?: Maybe<Scalars['Boolean']>;
  gitlabIntegrationUseStatus?: Maybe<Scalars['Boolean']>;
  setting?: Maybe<RepositorySetting>;
  /** Relevance score from fuzzy search (0-1). Only present when using fuzzy search. */
  similarityScore?: Maybe<Scalars['Float']>;
  path?: Maybe<Scalars['String']>;
  parentMonorepo?: Maybe<Repository>;
  /** List sub-repositories for a monorepo. */
  subRepos?: Maybe<RepositoryConnection>;
  /** Get a specific target. */
  target?: Maybe<RepositoryTarget>;
  /** Get a vulnerability occurrence by its ID. */
  vulnerabilityOccurrence: VulnerabilityOccurrence;
  /** List of vulnerability occurrences for this repository. */
  vulnerabilityOccurrences: VulnerabilityOccurrenceConnection;
  /** Open pull requests fetched directly from the VCS provider. */
  vcsPullRequests: VcsPullRequestConnection;
};


/** A repository on DeepSource. */
export type RepositoryCollaboratorsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  permission?: Maybe<Scalars['String']>;
  isAddedFromVcs?: Maybe<Scalars['Boolean']>;
  isPermFromVcs?: Maybe<Scalars['Boolean']>;
};


/** A repository on DeepSource. */
export type RepositoryIssuesArgs = {
  all?: Maybe<Scalars['Boolean']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  recommended?: Maybe<Scalars['Boolean']>;
  issueType?: Maybe<Scalars['String']>;
  analyzer?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['String']>;
  severityIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  autofixAvailable?: Maybe<Scalars['Boolean']>;
  auditRequired?: Maybe<Scalars['Boolean']>;
  q?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
};


/** A repository on DeepSource. */
export type RepositoryChecksArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A repository on DeepSource. */
export type RepositoryPackagesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  packageType?: Maybe<PackageType>;
  q?: Maybe<Scalars['String']>;
  targetId?: Maybe<Scalars['ID']>;
  severityIn?: Maybe<Array<Maybe<VulnerabilitySeverity>>>;
  licenseSafetyIn?: Maybe<Array<Maybe<LicenseSafetyFilter>>>;
};


/** A repository on DeepSource. */
export type RepositoryIssuePrioritiesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A repository on DeepSource. */
export type RepositoryTargetsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  isActivated?: Maybe<Scalars['Boolean']>;
};


/** A repository on DeepSource. */
export type RepositoryBilledrepositorytargetsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A repository on DeepSource. */
export type RepositoryWatchedByArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A repository on DeepSource. */
export type RepositoryAutofixRunsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  status_In?: Maybe<Array<Maybe<Scalars['String']>>>;
  pullRequestStatus_In?: Maybe<Array<Maybe<Scalars['String']>>>;
  q?: Maybe<Scalars['String']>;
};


/** A repository on DeepSource. */
export type RepositoryOnboardingEventsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  owner?: Maybe<Scalars['ID']>;
};


/** A repository on DeepSource. */
export type RepositoryConfigGenerationRunsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A repository on DeepSource. */
export type RepositoryPrsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  number?: Maybe<Scalars['Int']>;
  state?: Maybe<PrStateChoices>;
  runStatus?: Maybe<RunStatusChoice>;
  runStatusIn?: Maybe<Array<Maybe<RunStatusChoice>>>;
  branch?: Maybe<Scalars['String']>;
  q?: Maybe<Scalars['String']>;
};


/** A repository on DeepSource. */
export type RepositoryScaChecksArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A repository on DeepSource. */
export type RepositoryTransformerRunsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
};


/** A repository on DeepSource. */
export type RepositoryRunsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  statusIn?: Maybe<Array<Maybe<RunStatusChoice>>>;
  q?: Maybe<Scalars['String']>;
};


/** A repository on DeepSource. */
export type RepositoryRemediationPatchRunsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A repository on DeepSource. */
export type RepositorySourcedInPublicReportsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  q?: Maybe<Scalars['String']>;
};


/** A repository on DeepSource. */
export type RepositoryPublicReportsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  q?: Maybe<Scalars['String']>;
};


/** A repository on DeepSource. */
export type RepositorySilenceRulesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  creator?: Maybe<Scalars['ID']>;
  issueTitle?: Maybe<Scalars['String']>;
  issueCode?: Maybe<Scalars['String']>;
  filePath?: Maybe<Scalars['String']>;
  silenceLevel?: Maybe<SilenceRuleSilenceLevel>;
};


/** A repository on DeepSource. */
export type RepositoryAvailableAnalyzersArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  categoryIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  q?: Maybe<Scalars['String']>;
  exclude?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** A repository on DeepSource. */
export type RepositoryMetricsCapturedArgs = {
  shortcode?: Maybe<Scalars['String']>;
  metricType?: Maybe<MetricTypeChoices>;
};


/** A repository on DeepSource. */
export type RepositoryIssueArgs = {
  shortcode: Scalars['String'];
};


/** A repository on DeepSource. */
export type RepositoryGroupedRunsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  statusIn?: Maybe<Array<Maybe<RunStatusChoice>>>;
  q?: Maybe<Scalars['String']>;
};


/** A repository on DeepSource. */
export type RepositoryPrArgs = {
  number: Scalars['Int'];
};


/** A repository on DeepSource. */
export type RepositoryAutofixRunArgs = {
  runId: Scalars['String'];
};


/** A repository on DeepSource. */
export type RepositoryGroupedTransformerRunsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
};


/** A repository on DeepSource. */
export type RepositoryTransformerBranchRunsArgs = {
  branchName: Scalars['String'];
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
};


/** A repository on DeepSource. */
export type RepositoryTransformerRunArgs = {
  runId: Scalars['String'];
};


/** A repository on DeepSource. */
export type RepositoryRunArgs = {
  runId: Scalars['String'];
};


/** A repository on DeepSource. */
export type RepositoryBranchRunsArgs = {
  branchName: Scalars['String'];
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  statusIn?: Maybe<Array<Maybe<RunStatusChoice>>>;
  q?: Maybe<Scalars['String']>;
};


/** A repository on DeepSource. */
export type RepositoryAddableMembersArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  role?: Maybe<Array<Maybe<Scalars['String']>>>;
  isAddedFromVcs?: Maybe<Scalars['Boolean']>;
  isRoleFromVcs?: Maybe<Scalars['Boolean']>;
};


/** A repository on DeepSource. */
export type RepositoryLogsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  actorIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  eventIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  ipAddressIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdAtGte?: Maybe<Scalars['Date']>;
  createdAtLte?: Maybe<Scalars['Date']>;
  q?: Maybe<Scalars['String']>;
};


/** A repository on DeepSource. */
export type RepositoryIssueOccurrenceDistributionByProductArgs = {
  recommended?: Maybe<Scalars['Boolean']>;
  issueType?: Maybe<Scalars['String']>;
  analyzer?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['String']>;
  severityIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  autofixAvailable?: Maybe<Scalars['Boolean']>;
  auditRequired?: Maybe<Scalars['Boolean']>;
  q?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
};


/** A repository on DeepSource. */
export type RepositoryIssueOccurrenceDistributionByIssueTypeArgs = {
  recommended?: Maybe<Scalars['Boolean']>;
  issueType?: Maybe<Scalars['String']>;
  analyzer?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['String']>;
  severityIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  autofixAvailable?: Maybe<Scalars['Boolean']>;
  auditRequired?: Maybe<Scalars['Boolean']>;
  q?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
};


/** A repository on DeepSource. */
export type RepositorySubReposArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  vcsProvider?: Maybe<VcsProviderChoices>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  isActivated?: Maybe<Scalars['Boolean']>;
  errorCode?: Maybe<Scalars['Int']>;
  name_Icontains?: Maybe<Scalars['String']>;
  nameFuzzy?: Maybe<Scalars['String']>;
};


/** A repository on DeepSource. */
export type RepositoryTargetArgs = {
  lockfilePath: Scalars['String'];
  manifestPath: Scalars['String'];
};


/** A repository on DeepSource. */
export type RepositoryVulnerabilityOccurrenceArgs = {
  id: Scalars['ID'];
};


/** A repository on DeepSource. */
export type RepositoryVulnerabilityOccurrencesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  targetId?: Maybe<Scalars['ID']>;
  packageType?: Maybe<PackageType>;
  severityIn?: Maybe<Array<Maybe<VulnerabilitySeverity>>>;
  reachabilityIn?: Maybe<Array<Maybe<VulnerabilityOccurrenceReachability>>>;
  fixabilityIn?: Maybe<Array<Maybe<VulnerabilityOccurrenceFixability>>>;
  dynamicRiskLevelIn?: Maybe<Array<Maybe<DynamicRiskLevel>>>;
  cvssScoreMin?: Maybe<Scalars['Float']>;
  cvssScoreMax?: Maybe<Scalars['Float']>;
  epssScoreMin?: Maybe<Scalars['Float']>;
  epssScoreMax?: Maybe<Scalars['Float']>;
  epssPercentileMin?: Maybe<Scalars['Float']>;
  epssPercentileMax?: Maybe<Scalars['Float']>;
  q?: Maybe<Scalars['String']>;
};


/** A repository on DeepSource. */
export type RepositoryVcsPullRequestsArgs = {
  q?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type RepositoryCollaborator = MaskPrimaryKeyNode & {
  __typename?: 'RepositoryCollaborator';
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  /** The ID of the object */
  id: Scalars['ID'];
  repository: Repository;
  user: User;
  permission: RepositoryCollaboratorPermission;
  /** Whether fetched from VCS (sync) or added on DeepSource. */
  isAddedFromVcs: Scalars['Boolean'];
  /** Whether the permissiom fetched from VCS (sync) or changed on DeepSource. */
  isPermFromVcs: Scalars['Boolean'];
};

export type RepositoryCollaboratorConnection = {
  __typename?: 'RepositoryCollaboratorConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RepositoryCollaboratorEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `RepositoryCollaborator` and its cursor. */
export type RepositoryCollaboratorEdge = {
  __typename?: 'RepositoryCollaboratorEdge';
  /** The item at the end of the edge */
  node?: Maybe<RepositoryCollaborator>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** An enumeration. */
export enum RepositoryCollaboratorPermission {
  /** Read */
  Read = 'READ',
  /** Write */
  Write = 'WRITE',
  /** Admin */
  Admin = 'ADMIN'
}

export type RepositoryComplianceReportItem = MaskPrimaryKeyNode & {
  __typename?: 'RepositoryComplianceReportItem';
  /** The name of this repository. */
  name: Scalars['String'];
  isPrivate: Scalars['Boolean'];
  /** The type of the repository. */
  kind: RepositoryKindChoices;
  /** The ID of the object */
  id: Scalars['ID'];
  /** The display name of the repository. */
  displayName: Scalars['String'];
  /** All analyzers that have issues in this repository. */
  availableAnalyzers?: Maybe<AnalyzerConnection>;
  /** The count of issues with a minor severity. */
  minorCount?: Maybe<Scalars['Int']>;
  /** The count of issues with a major severity. */
  majorCount?: Maybe<Scalars['Int']>;
  /** The count of issues with a critical severity. */
  criticalCount?: Maybe<Scalars['Int']>;
  /** The total count of issues. */
  totalCount?: Maybe<Scalars['Int']>;
};


export type RepositoryComplianceReportItemAvailableAnalyzersArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  categoryIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  q?: Maybe<Scalars['String']>;
  exclude?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type RepositoryComplianceReportItemConnection = {
  __typename?: 'RepositoryComplianceReportItemConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RepositoryComplianceReportItemEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `RepositoryComplianceReportItem` and its cursor. */
export type RepositoryComplianceReportItemEdge = {
  __typename?: 'RepositoryComplianceReportItemEdge';
  /** The item at the end of the edge */
  node?: Maybe<RepositoryComplianceReportItem>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type RepositoryConnection = {
  __typename?: 'RepositoryConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RepositoryEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type RepositoryCoverageReportItem = MaskPrimaryKeyNode & {
  __typename?: 'RepositoryCoverageReportItem';
  /** The name of this repository. */
  name: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  lcvValue?: Maybe<Scalars['Float']>;
  bcvValue?: Maybe<Scalars['Float']>;
  ccvValue?: Maybe<Scalars['Float']>;
  cpcvValue?: Maybe<Scalars['Float']>;
  lcvIsPassing?: Maybe<Scalars['Boolean']>;
  bcvIsPassing?: Maybe<Scalars['Boolean']>;
  ccvIsPassing?: Maybe<Scalars['Boolean']>;
  cpcvIsPassing?: Maybe<Scalars['Boolean']>;
};

export type RepositoryCoverageReportItemConnection = {
  __typename?: 'RepositoryCoverageReportItemConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RepositoryCoverageReportItemEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `RepositoryCoverageReportItem` and its cursor. */
export type RepositoryCoverageReportItemEdge = {
  __typename?: 'RepositoryCoverageReportItemEdge';
  /** The item at the end of the edge */
  node?: Maybe<RepositoryCoverageReportItem>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** A Relay edge containing a `Repository` and its cursor. */
export type RepositoryEdge = {
  __typename?: 'RepositoryEdge';
  /** The item at the end of the edge */
  node?: Maybe<Repository>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type RepositoryGroup = MaskPrimaryKeyNode & {
  __typename?: 'RepositoryGroup';
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  /** The ID of the object */
  id: Scalars['ID'];
  name: Scalars['String'];
  isDefaultGroup: Scalars['Boolean'];
  vcsProvider: RepositoryGroupVcsProvider;
  /** Owner of the repository group. */
  owner?: Maybe<Owner>;
  overrideRepoSetting: Scalars['Boolean'];
  /** Primary user of the repository group. */
  primaryUser?: Maybe<User>;
  /** List of repositories in the repository group. */
  repositories?: Maybe<RepositoryConnection>;
  repoGroupSetting?: Maybe<RepositoryGroupSetting>;
  /** The repository group for which this report was created. Corresponds to repository group level reports */
  publicReports: PublicReportConnection;
  /** Number of repositories in the repository group. */
  repositoryCount?: Maybe<Scalars['Int']>;
  /** Identifier of the repository group. */
  slug?: Maybe<Scalars['String']>;
  /** List of repositories containing the given compliance issue. */
  repositoriesWithComplianceIssue?: Maybe<RepositoryComplianceReportItemConnection>;
  repositoriesCoverageReport?: Maybe<RepositoryCoverageReportItemConnection>;
  /** Settings for the repository group. */
  repositoryGroupSetting?: Maybe<RepositoryGroupSetting>;
  issueTypeSettings?: Maybe<Array<Maybe<IssueTypeSetting>>>;
  issueSeveritySettings?: Maybe<Array<Maybe<IssueSeveritySetting>>>;
  metricSettings?: Maybe<Array<Maybe<RepositoryGroupMetricSetting>>>;
};


export type RepositoryGroupRepositoriesArgs = {
  name?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  vcsProvider?: Maybe<VcsProviderChoices>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  isActivated?: Maybe<Scalars['Boolean']>;
  errorCode?: Maybe<Scalars['Int']>;
  name_Icontains?: Maybe<Scalars['String']>;
  nameFuzzy?: Maybe<Scalars['String']>;
};


export type RepositoryGroupPublicReportsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  q?: Maybe<Scalars['String']>;
};


export type RepositoryGroupRepositoriesWithComplianceIssueArgs = {
  tag: Scalars['String'];
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  vcsProvider?: Maybe<VcsProviderChoices>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  isActivated?: Maybe<Scalars['Boolean']>;
  errorCode?: Maybe<Scalars['Int']>;
  name_Icontains?: Maybe<Scalars['String']>;
  nameFuzzy?: Maybe<Scalars['String']>;
};


export type RepositoryGroupRepositoriesCoverageReportArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
};

export type RepositoryGroupConnection = {
  __typename?: 'RepositoryGroupConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RepositoryGroupEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `RepositoryGroup` and its cursor. */
export type RepositoryGroupEdge = {
  __typename?: 'RepositoryGroupEdge';
  /** The item at the end of the edge */
  node?: Maybe<RepositoryGroup>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Repository group metric setting type. */
export type RepositoryGroupMetricSetting = {
  __typename?: 'RepositoryGroupMetricSetting';
  shortcode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  isIgnoredInCheckStatus?: Maybe<Scalars['Boolean']>;
  isIgnoredToDisplay?: Maybe<Scalars['Boolean']>;
  /** Threshold value for this metric. */
  threshold?: Maybe<Scalars['Int']>;
};

/** Input type for repository group metric settings. */
export type RepositoryGroupMetricSettingsInput = {
  shortcode: Scalars['String'];
  isIgnoredInCheckStatus: Scalars['Boolean'];
  isIgnoredToDisplay: Scalars['Boolean'];
  /** Threshold value for this metric. */
  threshold?: Maybe<Scalars['Int']>;
};

/** Repository group setting type. */
export type RepositoryGroupSetting = MaskPrimaryKeyNode & {
  __typename?: 'RepositoryGroupSetting';
  /** Whether to infer code coverage artifacts from PR to merge commit on default branch. */
  inferDefaultBranchCoverage?: Maybe<Scalars['Boolean']>;
  /** Whether to infer community analyzers artifacts from PR to merge commit on default branch. */
  inferDefaultBranchCommunity?: Maybe<Scalars['Boolean']>;
  /** List of VCS reporting options enabled for the repository group. */
  vcsReportingOptionsEnabled?: Maybe<Array<Maybe<VcsReportingChoices>>>;
  analyzeChangesetOnly: Scalars['Boolean'];
  /** If true, all test-coverage checks initiate as soon as the run is created and marked as 'failed' if an artifact isn't reported within the specified period. */
  shouldTimeoutDataTrigger?: Maybe<Scalars['Boolean']>;
  /** The ID of the object */
  id: Scalars['ID'];
  /** Encrypted public key for the repository group. */
  encPublicKey?: Maybe<Scalars['String']>;
  /** List of report keys (with metadata) to pin on the owner dashboard. */
  pinnedReports?: Maybe<Array<Maybe<PinnedReport>>>;
  /** Reporting Configuration for GitLab */
  gitlabIntegrationUseStatus?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum RepositoryGroupVcsProvider {
  /** GitHub */
  Gh = 'GH',
  /** GitLab */
  Gl = 'GL',
  /** Bitbucket */
  Bb = 'BB',
  /** Bitbucket Data Center */
  Bbd = 'BBD',
  /** GitHub Enterprise */
  Ghe = 'GHE',
  /** Google Cloud Source */
  Gsr = 'GSR',
  /** Azure DevOps Services */
  Ads = 'ADS'
}

/** A repository issue. */
export type RepositoryIssue = MaskPrimaryKeyNode & {
  __typename?: 'RepositoryIssue';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  repositoryInstance: Repository;
  issue?: Maybe<Issue>;
  checkIssues: CheckIssueConnection;
  shouldIgnore: Scalars['Boolean'];
  severity: RepositoryIssueSeverityChoices;
  lastSeen?: Maybe<Scalars['DateTime']>;
  weight: Scalars['Int'];
  checkSet: CheckConnection;
  userSet: UserConnection;
  issueType?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  shortcode?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  descriptionRendered?: Maybe<Scalars['String']>;
  occurrenceCount?: Maybe<Scalars['Int']>;
  /** Change in issue count since last week or commit. No trend if null. */
  trend?: Maybe<IssueTrend>;
  firstSeen?: Maybe<Scalars['DateTime']>;
  analyzerName?: Maybe<Scalars['String']>;
  analyzerShortcode?: Maybe<Scalars['String']>;
  analyzerLogo?: Maybe<Scalars['String']>;
  analyzerType: AnalyzerTypeChoices;
  seenIn?: Maybe<Scalars['String']>;
  autofixAvailable?: Maybe<Scalars['Boolean']>;
  auditRequired: Scalars['Boolean'];
  raisedInFiles?: Maybe<Array<Maybe<Scalars['String']>>>;
  silenceRules?: Maybe<Array<Maybe<SilenceRule>>>;
  newVcsIssueUrl?: Maybe<Scalars['String']>;
  lastActivity?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** A repository issue. */
export type RepositoryIssueCheckIssuesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  shortcode?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
};


/** A repository issue. */
export type RepositoryIssueCheckSetArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A repository issue. */
export type RepositoryIssueUserSetArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type RepositoryIssueConnection = {
  __typename?: 'RepositoryIssueConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RepositoryIssueEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `RepositoryIssue` and its cursor. */
export type RepositoryIssueEdge = {
  __typename?: 'RepositoryIssueEdge';
  /** The item at the end of the edge */
  node?: Maybe<RepositoryIssue>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type RepositoryIssuePrioritySettingsInput = {
  slug?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Int']>;
  verboseName?: Maybe<Scalars['String']>;
  isIgnoredInCheckStatus?: Maybe<Scalars['Boolean']>;
  isIgnoredToDisplay?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum RepositoryIssueSeverityChoices {
  Critical = 'CRITICAL',
  Major = 'MAJOR',
  Minor = 'MINOR'
}

/** An enumeration. */
export enum RepositoryKindChoices {
  Repo = 'REPO',
  Monorepo = 'MONOREPO',
  Subrepo = 'SUBREPO'
}

/** A RepositoryMetricValue instance. */
export type RepositoryMetricValue = MaskPrimaryKeyNode & {
  __typename?: 'RepositoryMetricValue';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
  /** Threshold for this metric when this value was recorded */
  threshold?: Maybe<Scalars['Int']>;
  extraData: Scalars['JSONString'];
  commitOid: Scalars['String'];
  checkInstance: Check;
  branchName?: Maybe<Scalars['String']>;
  /** True if this metric value was manually suppressed by user else False. */
  isSuppressed?: Maybe<Scalars['Boolean']>;
  /** Name of the metric. */
  name?: Maybe<Scalars['String']>;
  /** Shortcode of the metric. */
  shortcode?: Maybe<Scalars['String']>;
  /** Human-readable representation of the metric's value. */
  valueDisplay?: Maybe<Scalars['String']>;
  /** Boolean to show if repository metric value passes the threshold, None if threshold is not set. */
  isPassing?: Maybe<Scalars['Boolean']>;
  namespace?: Maybe<Scalars['GenericScalar']>;
  valueTrendDisplay?: Maybe<Scalars['String']>;
  trendPositive: Scalars['Boolean'];
};

export type RepositoryPackage = MaskPrimaryKeyNode & {
  __typename?: 'RepositoryPackage';
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  /** The ID of the object */
  id: Scalars['ID'];
  packageGroup: PackageGroup;
  packageType: PackageType;
  /** Whether the dependency version is pinned in the user's target. */
  isPinned?: Maybe<Scalars['Boolean']>;
  repository: Repository;
  target: RepositoryTarget;
  package: Package;
  packageVersion: PackageVersion;
  /** List of vulnerability occurrences. */
  vulnerabilityOccurrences: VulnerabilityOccurrenceConnection;
  /** The number of low severity vulnerabilities. */
  lowSeverityVulnerabilityCount: Scalars['Int'];
  /** The number of medium severity vulnerabilities. */
  mediumSeverityVulnerabilityCount: Scalars['Int'];
  /** The number of high severity vulnerabilities. */
  highSeverityVulnerabilityCount: Scalars['Int'];
  /** The number of critical severity vulnerabilities. */
  criticalSeverityVulnerabilityCount: Scalars['Int'];
};


export type RepositoryPackageVulnerabilityOccurrencesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  targetId?: Maybe<Scalars['ID']>;
  packageType?: Maybe<PackageType>;
  severityIn?: Maybe<Array<Maybe<VulnerabilitySeverity>>>;
  reachabilityIn?: Maybe<Array<Maybe<VulnerabilityOccurrenceReachability>>>;
  fixabilityIn?: Maybe<Array<Maybe<VulnerabilityOccurrenceFixability>>>;
  dynamicRiskLevelIn?: Maybe<Array<Maybe<DynamicRiskLevel>>>;
  cvssScoreMin?: Maybe<Scalars['Float']>;
  cvssScoreMax?: Maybe<Scalars['Float']>;
  epssScoreMin?: Maybe<Scalars['Float']>;
  epssScoreMax?: Maybe<Scalars['Float']>;
  epssPercentileMin?: Maybe<Scalars['Float']>;
  epssPercentileMax?: Maybe<Scalars['Float']>;
  q?: Maybe<Scalars['String']>;
};

export type RepositoryPackageConnection = {
  __typename?: 'RepositoryPackageConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RepositoryPackageEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `RepositoryPackage` and its cursor. */
export type RepositoryPackageEdge = {
  __typename?: 'RepositoryPackageEdge';
  /** The item at the end of the edge */
  node?: Maybe<RepositoryPackage>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** An enumeration. */
export enum RepositoryPermissionChoices {
  Read = 'READ',
  Write = 'WRITE',
  Admin = 'ADMIN'
}

export type RepositoryScaTargetReportItem = MaskPrimaryKeyNode & {
  __typename?: 'RepositoryScaTargetReportItem';
  /** The ID of the object */
  id: Scalars['ID'];
  repository: Repository;
  manifestPath?: Maybe<Scalars['String']>;
  lockfilePath: Scalars['String'];
  isActivated: Scalars['Boolean'];
  packageManager: PackageManager;
  /** The number of low severity vulnerabilities. */
  lowSeverityVulnerabilityCount: Scalars['Int'];
  /** The number of medium severity vulnerabilities. */
  mediumSeverityVulnerabilityCount: Scalars['Int'];
  /** The number of high severity vulnerabilities. */
  highSeverityVulnerabilityCount: Scalars['Int'];
  /** The number of critical severity vulnerabilities. */
  criticalSeverityVulnerabilityCount: Scalars['Int'];
  /** The total number of vulnerabilities. */
  totalVulnerabilityCount: Scalars['Int'];
};

export type RepositoryScaTargetReportItemConnection = {
  __typename?: 'RepositoryScaTargetReportItemConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RepositoryScaTargetReportItemEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `RepositoryScaTargetReportItem` and its cursor. */
export type RepositoryScaTargetReportItemEdge = {
  __typename?: 'RepositoryScaTargetReportItemEdge';
  /** The item at the end of the edge */
  node?: Maybe<RepositoryScaTargetReportItem>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type RepositorySetting = MaskPrimaryKeyNode & {
  __typename?: 'RepositorySetting';
  /** Whether to infer code coverage artifacts from PR to merge commit on default branch. */
  inferDefaultBranchCoverage?: Maybe<Scalars['Boolean']>;
  /** Whether to infer community analyzers artifacts from PR to merge commit on default branch. */
  inferDefaultBranchCommunity?: Maybe<Scalars['Boolean']>;
  /** Whether code analysis is enabled. Only applies when using DB config. */
  enableCodeAnalysis?: Maybe<Scalars['Boolean']>;
  /** Whether code formatting is enabled. Only applies when using DB config. */
  enableCodeFormatting?: Maybe<Scalars['Boolean']>;
  /** List of report keys (with metadata) to pin on the repository dashboard. */
  pinnedReports?: Maybe<Array<Maybe<PinnedReport>>>;
  /** List of VCS reporting options enabled for the repository. */
  vcsReportingOptionsEnabled?: Maybe<Array<Maybe<VcsReportingChoices>>>;
  /** The ID of the object */
  id: Scalars['ID'];
};

/** A SCA target in a repository. */
export type RepositoryTarget = MaskPrimaryKeyNode & {
  __typename?: 'RepositoryTarget';
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  /** The ID of the object */
  id: Scalars['ID'];
  ecosystem: Ecosystem;
  packageManager: PackageManager;
  repository: Repository;
  manifestPath?: Maybe<Scalars['String']>;
  lockfilePath: Scalars['String'];
  source: RepositoryTargetSource;
  status: RepositoryTargetStatus;
  spdxSbom?: Maybe<Scalars['String']>;
  isActivated: Scalars['Boolean'];
  /** List of errors encountered during a default branch run for this target. */
  errors: Array<Maybe<AnalysisError>>;
  /** List of vulnerability occurrences. */
  vulnerabilityOccurrences: VulnerabilityOccurrenceConnection;
  repositoryPackages: RepositoryPackageConnection;
  billedrepositorytarget?: Maybe<BilledRepositoryTarget>;
  scaChecks: ScaCheckConnection;
  checkPackages: CheckPackageConnection;
  remediationPatchRuns: VulnerabilityRemediationPatchRunConnection;
  /** The number of direct dependencies for this target. */
  directDependencyCount: Scalars['Int'];
  /** The number of transitive dependencies for this target. */
  transitiveDependencyCount: Scalars['Int'];
  /** The number of low severity vulnerabilities. */
  lowSeverityVulnerabilityCount: Scalars['Int'];
  /** The number of medium severity vulnerabilities. */
  mediumSeverityVulnerabilityCount: Scalars['Int'];
  /** The number of high severity vulnerabilities. */
  highSeverityVulnerabilityCount: Scalars['Int'];
  /** The number of critical severity vulnerabilities. */
  criticalSeverityVulnerabilityCount: Scalars['Int'];
  /** The latest SCA check for this target. */
  latestScaCheck?: Maybe<ScaCheck>;
  /** True if the target has an SBOM report. */
  hasSpdxSbom: Scalars['Boolean'];
};


/** A SCA target in a repository. */
export type RepositoryTargetVulnerabilityOccurrencesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  targetId?: Maybe<Scalars['ID']>;
  packageType?: Maybe<PackageType>;
  severityIn?: Maybe<Array<Maybe<VulnerabilitySeverity>>>;
  reachabilityIn?: Maybe<Array<Maybe<VulnerabilityOccurrenceReachability>>>;
  fixabilityIn?: Maybe<Array<Maybe<VulnerabilityOccurrenceFixability>>>;
  dynamicRiskLevelIn?: Maybe<Array<Maybe<DynamicRiskLevel>>>;
  cvssScoreMin?: Maybe<Scalars['Float']>;
  cvssScoreMax?: Maybe<Scalars['Float']>;
  epssScoreMin?: Maybe<Scalars['Float']>;
  epssScoreMax?: Maybe<Scalars['Float']>;
  epssPercentileMin?: Maybe<Scalars['Float']>;
  epssPercentileMax?: Maybe<Scalars['Float']>;
  q?: Maybe<Scalars['String']>;
};


/** A SCA target in a repository. */
export type RepositoryTargetRepositoryPackagesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  packageType?: Maybe<PackageType>;
  q?: Maybe<Scalars['String']>;
  targetId?: Maybe<Scalars['ID']>;
  severityIn?: Maybe<Array<Maybe<VulnerabilitySeverity>>>;
  licenseSafetyIn?: Maybe<Array<Maybe<LicenseSafetyFilter>>>;
};


/** A SCA target in a repository. */
export type RepositoryTargetScaChecksArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A SCA target in a repository. */
export type RepositoryTargetCheckPackagesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A SCA target in a repository. */
export type RepositoryTargetRemediationPatchRunsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type RepositoryTargetConnection = {
  __typename?: 'RepositoryTargetConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RepositoryTargetEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `RepositoryTarget` and its cursor. */
export type RepositoryTargetEdge = {
  __typename?: 'RepositoryTargetEdge';
  /** The item at the end of the edge */
  node?: Maybe<RepositoryTarget>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** The source of the target. */
export enum RepositoryTargetSource {
  Auto = 'AUTO',
  Custom = 'CUSTOM'
}

/** The status of the target. */
export enum RepositoryTargetStatus {
  Ready = 'READY',
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** An enumeration. */
export enum RepositoryVcsType {
  /** Git */
  Git = 'GIT',
  /** Subversion */
  Svn = 'SVN',
  /** Mercurial */
  Hg = 'HG'
}

export type RequestEnterprisePilotLicenseInput = {
  /** The name of the requester. */
  name: Scalars['String'];
  /** The email of the requester. */
  email: Scalars['String'];
  /** The job title of the requester. */
  jobTitle: Scalars['String'];
  /** The name of the requester's company. */
  companyName: Scalars['String'];
  /** The seat count. */
  seats: EnterprisePilotLicenseSeatChoices;
  /** The VCS of the requester. */
  vcs: EnterprisePilotLicenseVcsChoices;
  /** The purpose of requesting the pilot license. */
  purpose: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Mutation to request an enterprise pilot license */
export type RequestEnterprisePilotLicensePayload = {
  __typename?: 'RequestEnterprisePilotLicensePayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type RequestSlackConnectInput = {
  /** Global ID of the owner. */
  ownerId: Scalars['ID'];
  /** Customer's Slack workspace email for the invite. */
  email: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/**
 * Create a Slack Connect channel for a trial team and send an invite
 * to the customer's email.
 */
export type RequestSlackConnectPayload = {
  __typename?: 'RequestSlackConnectPayload';
  ok?: Maybe<Scalars['Boolean']>;
  slackConnectChannel?: Maybe<SlackConnectChannelType>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type ResendSlackConnectInviteInput = {
  /** Global ID of the owner. */
  ownerId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Resend the Slack Connect invite for an existing channel. */
export type ResendSlackConnectInvitePayload = {
  __typename?: 'ResendSlackConnectInvitePayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type ResetGroupInvitationLinkInput = {
  groupId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type ResetGroupInvitationLinkPayload = {
  __typename?: 'ResetGroupInvitationLinkPayload';
  invitationUrl?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type ResetTeamInvitationLinkInput = {
  ownerId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type ResetTeamInvitationLinkPayload = {
  __typename?: 'ResetTeamInvitationLinkPayload';
  invitationUrl?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type ResumeUnifiedSubscriptionInput = {
  /** The owner's node ID */
  ownerId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Resume a unified subscription that is pending cancellation. */
export type ResumeUnifiedSubscriptionPayload = {
  __typename?: 'ResumeUnifiedSubscriptionPayload';
  subscription?: Maybe<ProductSubscription>;
  ok?: Maybe<Scalars['Boolean']>;
  error?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type RetryChecksInRunInput = {
  runId: Scalars['String'];
  analyzers: Array<Maybe<Scalars['String']>>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/**
 * Retry analysis for the given checks in a run.
 * This operation is only allowed for the latest run on a PR and if checks' statuses are errored or timed-out.
 */
export type RetryChecksInRunPayload = {
  __typename?: 'RetryChecksInRunPayload';
  ok: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type RevertSubscriptionCancellationInput = {
  /** Owner's gql ID */
  id?: Maybe<Scalars['ID']>;
  ownerId?: Maybe<Scalars['Int']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type RevertSubscriptionCancellationPayload = {
  __typename?: 'RevertSubscriptionCancellationPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type Revoke = {
  __typename?: 'Revoke';
  revoked: Scalars['Int'];
};

export enum RoleChoices {
  FounderLeadership = 'FOUNDER_LEADERSHIP',
  EngineeringManager = 'ENGINEERING_MANAGER',
  SecurityLeader = 'SECURITY_LEADER',
  SoftwareEngineer = 'SOFTWARE_ENGINEER',
  Agency = 'AGENCY',
  Other = 'OTHER',
  PreferNotShare = 'PREFER_NOT_SHARE'
}

export type RotateAccessTokenInput = {
  /** ID of the token to rotate. */
  tokenId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Rotate the value of the token. */
export type RotateAccessTokenPayload = {
  __typename?: 'RotateAccessTokenPayload';
  /** Value of the new token. */
  token?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** An analysis run. */
export type Run = MaskPrimaryKeyNode & {
  __typename?: 'Run';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  runId: Scalars['UUID'];
  status: RunStatus;
  branchName?: Maybe<Scalars['String']>;
  baseOid?: Maybe<Scalars['String']>;
  commitOid?: Maybe<Scalars['String']>;
  commitMessage?: Maybe<Scalars['String']>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  errorMeta?: Maybe<Scalars['JSONString']>;
  config?: Maybe<Scalars['GenericScalar']>;
  extraData: Scalars['JSONString'];
  pullRequest?: Maybe<Pr>;
  checks: CheckConnection;
  /** Report Card for the Run with quality dimension grades and scores */
  reportCard?: Maybe<RunReport>;
  scaChecks: ScaCheckConnection;
  finishedIn?: Maybe<Scalars['Int']>;
  vcsCommitUrl?: Maybe<Scalars['String']>;
  gitCompareDisplay?: Maybe<Scalars['String']>;
  pullRequestNumberDisplay?: Maybe<Scalars['String']>;
  issuesRaisedCount: Scalars['Int'];
  issuesResolvedCount: Scalars['Int'];
  issuesSuppressedCount: Scalars['Int'];
  /** @deprecated Deprecated in favor of `issuesResolvedCount`. */
  issuesResolvedNum?: Maybe<Scalars['Int']>;
  isForDefaultBranch?: Maybe<Scalars['Boolean']>;
  isForCrossRepoPr?: Maybe<Scalars['Boolean']>;
  branchRunCount?: Maybe<Scalars['Int']>;
  vcsPrUrl?: Maybe<Scalars['String']>;
  blobUrlRoot?: Maybe<Scalars['String']>;
};


/** An analysis run. */
export type RunChecksArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** An analysis run. */
export type RunScaChecksArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type RunConnection = {
  __typename?: 'RunConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RunEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Run` and its cursor. */
export type RunEdge = {
  __typename?: 'RunEdge';
  /** The item at the end of the edge */
  node?: Maybe<Run>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** GraphQL type for RunReport model - thin layer over dataclass properties */
export type RunReport = MaskPrimaryKeyNode & {
  __typename?: 'RunReport';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  /** Insights and feedback on root causes and systemic improvements based on detected issues */
  insights?: Maybe<Scalars['String']>;
  status: RunReportStatus;
  insightsRendered?: Maybe<Scalars['String']>;
  insightsSkipReason?: Maybe<RunReportInsightsSkipReason>;
  security?: Maybe<RunReportDimension>;
  reliability?: Maybe<RunReportDimension>;
  complexity?: Maybe<RunReportDimension>;
  hygiene?: Maybe<RunReportDimension>;
  coverage?: Maybe<RunReportCoverage>;
  aggregate?: Maybe<RunReportAggregate>;
  meta?: Maybe<RunReportMetadata>;
  focusArea?: Maybe<RunReportFocusArea>;
};

/** GraphQL type for RunReportAggregateData dataclass */
export type RunReportAggregate = {
  __typename?: 'RunReportAggregate';
  grade: RunReportGrade;
  score: Scalars['Int'];
};

/** GraphQL type for RunReportCoverageData dataclass */
export type RunReportCoverage = {
  __typename?: 'RunReportCoverage';
  grade?: Maybe<RunReportGrade>;
  score?: Maybe<Scalars['Int']>;
  lineCoverage?: Maybe<Scalars['Float']>;
  branchCoverage?: Maybe<Scalars['Float']>;
};

/** GraphQL type for RunReportDimensionData dataclass */
export type RunReportDimension = {
  __typename?: 'RunReportDimension';
  grade: RunReportGrade;
  score: Scalars['Int'];
  issuesCount: Scalars['Int'];
  summary?: Maybe<Scalars['String']>;
};

/** GraphQL type for RunReportFocusArea dataclass */
export type RunReportFocusArea = {
  __typename?: 'RunReportFocusArea';
  dimension?: Maybe<Scalars['String']>;
  action?: Maybe<Scalars['String']>;
};

/** Letter grade for a report dimension */
export enum RunReportGrade {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D'
}

/** Reason why insights and summaries were not generated */
export enum RunReportInsightsSkipReason {
  AiPolicyDisabled = 'AI_POLICY_DISABLED',
  FeatureNotEnabled = 'FEATURE_NOT_ENABLED'
}

/** GraphQL type for RunReportMetadata dataclass */
export type RunReportMetadata = {
  __typename?: 'RunReportMetadata';
  linesChanged: Scalars['Int'];
  filesChanged: Scalars['Int'];
  capped: Scalars['Boolean'];
  capReason?: Maybe<Scalars['String']>;
};

/** Status of the Run Report */
export enum RunReportStatus {
  InProgress = 'IN_PROGRESS',
  Recompute = 'RECOMPUTE',
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  Skipped = 'SKIPPED'
}

/** An enumeration. */
export enum RunStatus {
  /** Pending */
  Pend = 'PEND',
  /** Success */
  Pass = 'PASS',
  /** Failure */
  Fail = 'FAIL',
  /** Timed out */
  Timo = 'TIMO',
  /** Cancelled */
  Cncl = 'CNCL',
  /** Ready */
  Read = 'READ',
  /** Skipped */
  Skip = 'SKIP'
}

/** An enumeration. */
export enum RunStatusChoice {
  StatusPending = 'STATUS_PENDING',
  StatusSuccess = 'STATUS_SUCCESS',
  StatusFailure = 'STATUS_FAILURE',
  StatusTimeout = 'STATUS_TIMEOUT',
  StatusCancel = 'STATUS_CANCEL',
  StatusReady = 'STATUS_READY',
  StatusSkipped = 'STATUS_SKIPPED'
}

/** A Runner object. */
export type Runner = MaskPrimaryKeyNode & {
  __typename?: 'Runner';
  /** The base URL of the runner. */
  baseUrl: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
};

/** A Runner App object. */
export type RunnerApp = MaskPrimaryKeyNode & {
  __typename?: 'RunnerApp';
  /** The app ID to identify the app on the runner. */
  appId: Scalars['String'];
  /** The VCS providers associated with this app. */
  vcsProvider: VcsProviderChoices;
  /** Display name for the app. */
  name: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  /** The runner API endpoint to fetch check issue snippets from. */
  codeSnippetUrl: Scalars['String'];
  /** The runner API endpoint to fetch autofix patch snippets from. */
  patchSnippetUrl: Scalars['String'];
};

export type RuntimeLog = MaskPrimaryKeyNode & {
  __typename?: 'RuntimeLog';
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  /** The ID of the object */
  id: Scalars['ID'];
  objectId: Scalars['BigInt'];
  /** Unique stream key for this log stream */
  streamKey: Scalars['UUID'];
  /** List of log entries. */
  entries: Array<Maybe<RuntimeLogEntry>>;
  /** Total number of entries */
  entriesCount: Scalars['Int'];
  lastLogLevel?: Maybe<RuntimeLogLastLogLevel>;
  lastMessage?: Maybe<Scalars['String']>;
  lastTimestamp?: Maybe<Scalars['DateTime']>;
};

export type RuntimeLogEntry = {
  __typename?: 'RuntimeLogEntry';
  /** ID of the log entry. */
  id?: Maybe<Scalars['ID']>;
  /** Log level of the entry. */
  level?: Maybe<RuntimeLogLevel>;
  /** Log message. */
  message?: Maybe<Scalars['String']>;
  /** Timestamp of the log entry. */
  timestamp?: Maybe<Scalars['DateTime']>;
};

/** An enumeration. */
export enum RuntimeLogLastLogLevel {
  /** Info */
  Info = 'INFO',
  /** Warning */
  Warning = 'WARNING',
  /** Error */
  Error = 'ERROR',
  /** Debug */
  Debug = 'DEBUG'
}

/** Log levels for runtime logs. */
export enum RuntimeLogLevel {
  Info = 'INFO',
  Warning = 'WARNING',
  Error = 'ERROR',
  Debug = 'DEBUG'
}

/** Export formats for SBOM report exports. */
export enum SbomExportFormat {
  Spdxjson = 'SPDXJSON'
}

/** A SCA check. */
export type ScaCheck = MaskPrimaryKeyNode & {
  __typename?: 'SCACheck';
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  /** The ID of the object */
  id: Scalars['ID'];
  sequence: Scalars['Int'];
  status: ScaCheckStatus;
  run: Run;
  target?: Maybe<RepositoryTarget>;
  triggeredAt?: Maybe<Scalars['DateTime']>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  /** List of errors encountered during the check. */
  errors: Array<Maybe<AnalysisError>>;
  extraData: Scalars['JSONString'];
  triggerSource?: Maybe<ScaCheckTriggerSource>;
  scannedVulnVersion?: Maybe<Scalars['BigInt']>;
  /** List of vulnerability occurrences. */
  vulnerabilityOccurrences: VulnerabilityOccurrenceConnection;
  packages: CheckPackageConnection;
  /** Time taken for this check to finish. */
  finishedIn?: Maybe<Scalars['Int']>;
  /** Get a vulnerability occurrence in a check. */
  vulnerabilityOccurrence: VulnerabilityOccurrence;
  /** Number of vulnerabilities raised in this check. */
  vulnerabilityRaisedCount: Scalars['Int'];
  /** Number of vulnerabilities resolved in this check. */
  vulnerabilityResolvedCount: Scalars['Int'];
  /** Number of vulnerabilities suppressed in this check. */
  vulnerabilitySuppressedCount: Scalars['Int'];
  /** List of errors encountered during the check. */
  errorsRendered: Array<Maybe<AnalysisError>>;
  /** Runtime log for this check. */
  runtimeLog?: Maybe<RuntimeLog>;
};


/** A SCA check. */
export type ScaCheckVulnerabilityOccurrencesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  targetId?: Maybe<Scalars['ID']>;
  packageType?: Maybe<PackageType>;
  severityIn?: Maybe<Array<Maybe<VulnerabilitySeverity>>>;
  reachabilityIn?: Maybe<Array<Maybe<VulnerabilityOccurrenceReachability>>>;
  fixabilityIn?: Maybe<Array<Maybe<VulnerabilityOccurrenceFixability>>>;
  dynamicRiskLevelIn?: Maybe<Array<Maybe<DynamicRiskLevel>>>;
  cvssScoreMin?: Maybe<Scalars['Float']>;
  cvssScoreMax?: Maybe<Scalars['Float']>;
  epssScoreMin?: Maybe<Scalars['Float']>;
  epssScoreMax?: Maybe<Scalars['Float']>;
  epssPercentileMin?: Maybe<Scalars['Float']>;
  epssPercentileMax?: Maybe<Scalars['Float']>;
  q?: Maybe<Scalars['String']>;
};


/** A SCA check. */
export type ScaCheckPackagesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A SCA check. */
export type ScaCheckVulnerabilityOccurrenceArgs = {
  id: Scalars['ID'];
};

export type ScaCheckConnection = {
  __typename?: 'SCACheckConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ScaCheckEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `SCACheck` and its cursor. */
export type ScaCheckEdge = {
  __typename?: 'SCACheckEdge';
  /** The item at the end of the edge */
  node?: Maybe<ScaCheck>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** An enumeration. */
export enum ScaCheckStatus {
  /** Waiting */
  Wait = 'WAIT',
  /** Pending */
  Pend = 'PEND',
  /** Success */
  Pass = 'PASS',
  /** Failure */
  Fail = 'FAIL',
  /** Timed out */
  Timo = 'TIMO',
  /** Cancelled */
  Cncl = 'CNCL',
  /** Ready */
  Read = 'READ',
  /** Neutral */
  Neut = 'NEUT',
  /** Artifact not reported */
  Atmo = 'ATMO',
  /** Skipped */
  Skip = 'SKIP'
}

/** An enumeration. */
export enum ScaCheckTriggerSource {
  /** Periodic Scan */
  PeriodicScan = 'PERIODIC_SCAN'
}

export type ScaProduct = MaskPrimaryKeyNode & {
  __typename?: 'SCAProduct';
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  /** The ID of the object */
  id: Scalars['ID'];
  plan: ScaProductPlan;
  targetQuantity: Scalars['Int'];
  lastReconciledAt: Scalars['DateTime'];
  billedTargets?: Maybe<BilledRepositoryTargetConnection>;
};


export type ScaProductBilledTargetsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum ScaProductPlan {
  PlanFree = 'PLAN_FREE',
  PlanStarter = 'PLAN_STARTER'
}

/** Status of the SCA. */
export enum ScaStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/**
 * Represents an IDP available for a given email domain.
 * Used when multiple teams share the same domain for SSO login.
 */
export type SsoIdentityProvider = MaskPrimaryKeyNode & {
  __typename?: 'SSOIdentityProvider';
  /** The ID of the object */
  id: Scalars['ID'];
  teamName: Scalars['String'];
  teamLogin: Scalars['String'];
  teamLogo?: Maybe<Scalars['String']>;
  vcsProvider: VcsProviderChoices;
  loginUrl: Scalars['String'];
};

export type SsoIdentityProviderConnection = {
  __typename?: 'SSOIdentityProviderConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SsoIdentityProviderEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `SSOIdentityProvider` and its cursor. */
export type SsoIdentityProviderEdge = {
  __typename?: 'SSOIdentityProviderEdge';
  /** The item at the end of the edge */
  node?: Maybe<SsoIdentityProvider>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type SaveRepositoryConfigInput = {
  config: Scalars['String'];
  /** GraphQL node ID of the repository. */
  repositoryId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Save the generated config to the database. */
export type SaveRepositoryConfigPayload = {
  __typename?: 'SaveRepositoryConfigPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type SendTeamMemberAdditionRequestInput = {
  teamId: Scalars['ID'];
  email: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type SendTeamMemberAdditionRequestPayload = {
  __typename?: 'SendTeamMemberAdditionRequestPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type SetDefaultCardInput = {
  /** The owner's node ID */
  ownerId: Scalars['ID'];
  /** Stripe payment method ID to set as default */
  paymentMethodId: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Set a saved payment method (card) as the default for the owner's Stripe customer. */
export type SetDefaultCardPayload = {
  __typename?: 'SetDefaultCardPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** A silence rule created for a repository. */
export type SilenceRule = MaskPrimaryKeyNode & {
  __typename?: 'SilenceRule';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  silenceLevel: SilenceRuleSilenceLevel;
  filePath?: Maybe<Scalars['String']>;
  repository: Repository;
  issue: Issue;
  creator?: Maybe<User>;
  metadata?: Maybe<Scalars['GenericScalar']>;
};

export type SilenceRuleConnection = {
  __typename?: 'SilenceRuleConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SilenceRuleEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `SilenceRule` and its cursor. */
export type SilenceRuleEdge = {
  __typename?: 'SilenceRuleEdge';
  /** The item at the end of the edge */
  node?: Maybe<SilenceRule>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** An enumeration. */
export enum SilenceRuleSilenceLevel {
  /** File Level */
  Fl = 'FL',
  /** Repository Level */
  Rl = 'RL'
}

/** An enumeration. */
export enum SlackConnectChannelStatus {
  NotStarted = 'NOT_STARTED',
  InviteSent = 'INVITE_SENT',
  Connected = 'CONNECTED',
  Failed = 'FAILED',
  Archived = 'ARCHIVED'
}

/** Represents the Slack Connect channel state for a team. */
export type SlackConnectChannelType = {
  __typename?: 'SlackConnectChannelType';
  /** Current status of the Slack Connect channel. */
  status?: Maybe<SlackConnectChannelStatus>;
  /** Email the invite was sent to. */
  email?: Maybe<Scalars['String']>;
  /** Name of the Slack channel. */
  channelName?: Maybe<Scalars['String']>;
  /** When the record was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** When the customer accepted the invite. */
  acceptedAt?: Maybe<Scalars['DateTime']>;
};

export type SocialAuthJwt = {
  __typename?: 'SocialAuthJWT';
  social?: Maybe<SocialType>;
  token?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  tokenExpiresIn?: Maybe<Scalars['Int']>;
  refreshExpiresIn?: Maybe<Scalars['Int']>;
};

export type SocialAuthUrl = {
  __typename?: 'SocialAuthURL';
  /** A list of authorization URLs. */
  socialUrls?: Maybe<Array<Maybe<AuthUrl>>>;
};


export type SocialType = {
  __typename?: 'SocialType';
  id: Scalars['ID'];
  provider: Scalars['String'];
  uid: Scalars['String'];
  extraData?: Maybe<Scalars['SocialCamelJSON']>;
  created: Scalars['DateTime'];
  modified: Scalars['DateTime'];
};

/** A representation of a repository that is sourceable in a public report. */
export type SourceableRepository = MaskPrimaryKeyNode & {
  __typename?: 'SourceableRepository';
  /** The name of this repository. */
  name: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  /** The display name of the repository */
  displayName: Scalars['String'];
  /** The repository owner's login. */
  ownerLogin: Scalars['String'];
  /** Whether or not this repository is sourced in the public report. */
  isSourced: Scalars['Boolean'];
};

export type SourceableRepositoryConnection = {
  __typename?: 'SourceableRepositoryConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SourceableRepositoryEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `SourceableRepository` and its cursor. */
export type SourceableRepositoryEdge = {
  __typename?: 'SourceableRepositoryEdge';
  /** The item at the end of the edge */
  node?: Maybe<SourceableRepository>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** A static analysis issue from a check (CheckIssue). */
export type StaticAnalysisIssue = {
  __typename?: 'StaticAnalysisIssue';
  id: Scalars['ID'];
  shortcode: Scalars['String'];
  path: Scalars['String'];
  severity: IssueSeverity;
  category: IssueType;
  text?: Maybe<Scalars['String']>;
  explanation?: Maybe<Scalars['String']>;
  shortExplanation?: Maybe<Scalars['String']>;
  isSuppressed: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  beginLine: Scalars['Int'];
  beginColumn: Scalars['Int'];
  endLine: Scalars['Int'];
  endColumn: Scalars['Int'];
  sourceCodeRendered?: Maybe<Scalars['String']>;
};

export type SubmitSupportTicketInput = {
  ownerLogin?: Maybe<Scalars['String']>;
  vcsProvider?: Maybe<VcsProviderChoices>;
  fromEmail: Scalars['String'];
  ccEmails?: Maybe<Scalars['String']>;
  subject: Scalars['String'];
  body: Scalars['String'];
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  attachments?: Maybe<Array<Maybe<Attachment>>>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Submit a support ticket to Plain. */
export type SubmitSupportTicketPayload = {
  __typename?: 'SubmitSupportTicketPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type SubscriptionCheckoutInput = {
  email: Scalars['String'];
  name: Scalars['String'];
  token: Scalars['String'];
  coupon: Scalars['String'];
  seats: Scalars['Int'];
  installationId: Scalars['String'];
  planSlug: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type SubscriptionCheckoutPayload = {
  __typename?: 'SubscriptionCheckoutPayload';
  nextAction?: Maybe<Scalars['String']>;
  /** The secret to use when performing SCA */
  clientSecret?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type SubscriptionPlanSwitchInput = {
  /** Owner's gql ID */
  id?: Maybe<Scalars['ID']>;
  planSlug: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type SubscriptionPlanSwitchPayload = {
  __typename?: 'SubscriptionPlanSwitchPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type SubscriptionSponsor = Owner;

/** An enumeration. */
export enum SubscriptionStatusChoice {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Trial = 'TRIAL',
  PastDue = 'PAST_DUE',
  ScaRequired = 'SCA_REQUIRED'
}

/** An enumeration. */
export enum SupportTierChoices {
  Enterprise = 'ENTERPRISE',
  Community = 'COMMUNITY',
  Standard = 'STANDARD'
}

export type SyncCustomAnalyzerInput = {
  analyzerId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Trigger sync for a custom analyzer. */
export type SyncCustomAnalyzerPayload = {
  __typename?: 'SyncCustomAnalyzerPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type SyncRepositoriesForOwnerInput = {
  ownerId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Sync all accessible repositories for the given owner from VCS provider. */
export type SyncRepositoriesForOwnerPayload = {
  __typename?: 'SyncRepositoriesForOwnerPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type SyncRepositoryForOwnerInput = {
  ownerId: Scalars['ID'];
  /** Name of the repository to sync. */
  repositoryName: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Sync given repository for the owner (with member permissions) from VCS provider. */
export type SyncRepositoryForOwnerPayload = {
  __typename?: 'SyncRepositoryForOwnerPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type SyncRepositoryTargetsInput = {
  repositoryId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Auto sync repository targets. */
export type SyncRepositoryTargetsPayload = {
  __typename?: 'SyncRepositoryTargetsPayload';
  ok: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type SyncVcsPermissionsInput = {
  teamId: Scalars['ID'];
  overrideChangesMadeOnDeepsource?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type SyncVcsPermissionsPayload = {
  __typename?: 'SyncVcsPermissionsPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** A team object. */
export type Team = MaskPrimaryKeyNode & {
  __typename?: 'Team';
  ownerPtr: Owner;
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  /** The unique identifier (or username) of the account. */
  login: Scalars['String'];
  avatar?: Maybe<Scalars['String']>;
  /** VCS provider of this owner's origin. */
  vcsProvider: OwnerVcsProvider;
  /** Unique identity of this owner in the VCS, if available. */
  vcsAccountUid: Scalars['String'];
  /** Pricing plan which this owner is subscribed to. */
  plan?: Maybe<OwnerPlan>;
  customerId?: Maybe<Scalars['String']>;
  primaryUser?: Maybe<User>;
  gsrSetupPending: Scalars['Boolean'];
  resourceSelector?: Maybe<OwnerResourceSelector>;
  runner?: Maybe<Runner>;
  runnerApp?: Maybe<RunnerApp>;
  IsBetaTester?: Maybe<Scalars['Boolean']>;
  billingVersion?: Maybe<OwnerBillingVersion>;
  /** The team's public name. */
  name: Scalars['String'];
  members: UserConnection;
  invitationCode?: Maybe<Scalars['String']>;
  syncPermissionsWithVcs: Scalars['Boolean'];
  features: FeatureDefinitionConnection;
  memberAdditionRequests: TeamMemberAdditionRequestConnection;
  verifiableDomains: VerifiableDomainConnection;
  /** Get IdentityProvider for the team. */
  identityProvider?: Maybe<IdentityProvider>;
  basePermissionSet?: Maybe<TeamBasePermissionSet>;
  /** Slack Connect channel for this team (trial customers). */
  slackConnectChannel?: Maybe<SlackConnectChannelType>;
  analyzers: AnalyzerConnection;
  productSubscriptions: ProductSubscriptionConnection;
  team?: Maybe<EnterpriseTeam>;
  repositories: RepositoryConnection;
  issuePriorities: IssuePriorityConnection;
  userSet: UserConnection;
  configTemplates: ConfigTemplateConnection;
  onboardingEvents: AutoOnboardEventConnection;
  repositoryGroups: RepositoryGroupConnection;
  ownerSetting?: Maybe<OwnerSetting>;
  profile?: Maybe<OwnerProfile>;
  /** The owner for which this report was created. Corresponds to owner level reports. */
  publicReports: PublicReportConnection;
  webhooks: WebhookConnection;
  numMembersTotal?: Maybe<Scalars['Int']>;
  isViewerPrimaryUser?: Maybe<Scalars['Boolean']>;
  /** Members of this team. */
  teamMembers: TeamMemberConnection;
  /** Team invites that are pending in this team. */
  invites?: Maybe<TeamMemberInvitationConnection>;
  /** Sharable invitation link for the team */
  invitationUrl?: Maybe<Scalars['String']>;
  /** Requests to join the team */
  additionRequests?: Maybe<TeamMemberAdditionRequestConnection>;
  /** List of audit logs */
  logs?: Maybe<AuditLogConnection>;
  accountSetupStatus?: Maybe<Scalars['GenericScalar']>;
  roleInGroup?: Maybe<TeamMemberRoleChoices>;
  isDirectMember?: Maybe<Scalars['Boolean']>;
  /** Repository collaborators in all repositories of this team. */
  repositoryCollaborators: RepositoryCollaboratorConnection;
  activeRepositoryCount?: Maybe<Scalars['Int']>;
  /** Get VerifiableDomain for the team. */
  verifiableDomain?: Maybe<VerifiableDomain>;
};


/** A team object. */
export type TeamMembersArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A team object. */
export type TeamFeaturesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A team object. */
export type TeamMemberAdditionRequestsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  status?: Maybe<TeamMemberAdditionRequestStatus>;
};


/** A team object. */
export type TeamVerifiableDomainsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A team object. */
export type TeamAnalyzersArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  categoryIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  q?: Maybe<Scalars['String']>;
  exclude?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** A team object. */
export type TeamProductSubscriptionsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  productType?: Maybe<ProductChoice>;
};


/** A team object. */
export type TeamRepositoriesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  vcsProvider?: Maybe<VcsProviderChoices>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  isActivated?: Maybe<Scalars['Boolean']>;
  errorCode?: Maybe<Scalars['Int']>;
  name_Icontains?: Maybe<Scalars['String']>;
  nameFuzzy?: Maybe<Scalars['String']>;
};


/** A team object. */
export type TeamIssuePrioritiesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A team object. */
export type TeamUserSetArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A team object. */
export type TeamConfigTemplatesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  shortcode?: Maybe<Scalars['String']>;
  title_Icontains?: Maybe<Scalars['String']>;
};


/** A team object. */
export type TeamOnboardingEventsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  owner?: Maybe<Scalars['ID']>;
};


/** A team object. */
export type TeamRepositoryGroupsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_Icontains?: Maybe<Scalars['String']>;
};


/** A team object. */
export type TeamPublicReportsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  q?: Maybe<Scalars['String']>;
};


/** A team object. */
export type TeamWebhooksArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A team object. */
export type TeamTeamMembersArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  role?: Maybe<Array<Maybe<Scalars['String']>>>;
  isAddedFromVcs?: Maybe<Scalars['Boolean']>;
  isRoleFromVcs?: Maybe<Scalars['Boolean']>;
};


/** A team object. */
export type TeamInvitesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};


/** A team object. */
export type TeamAdditionRequestsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  status?: Maybe<TeamMemberAdditionRequestStatus>;
};


/** A team object. */
export type TeamLogsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  actorIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  eventIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  ipAddressIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdAtGte?: Maybe<Scalars['Date']>;
  createdAtLte?: Maybe<Scalars['Date']>;
  q?: Maybe<Scalars['String']>;
};


/** A team object. */
export type TeamRepositoryCollaboratorsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  permission?: Maybe<Scalars['String']>;
  isAddedFromVcs?: Maybe<Scalars['Boolean']>;
  isPermFromVcs?: Maybe<Scalars['Boolean']>;
};

export type TeamBasePermissionSet = MaskPrimaryKeyNode & {
  __typename?: 'TeamBasePermissionSet';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  team: EnterpriseTeam;
  defaultRepositoryPermission?: Maybe<DefaultRepositoryPermissionChoices>;
  canMembersIgnoreIssues: Scalars['Boolean'];
  canMembersModifyMetricThresholds: Scalars['Boolean'];
  canMembersIgnoreFailingMetrics: Scalars['Boolean'];
  canContributorsIgnoreIssues: Scalars['Boolean'];
  canContributorsModifyMetricThresholds: Scalars['Boolean'];
  canContributorsIgnoreFailingMetrics: Scalars['Boolean'];
};

export type TeamConnection = {
  __typename?: 'TeamConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TeamEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Team` and its cursor. */
export type TeamEdge = {
  __typename?: 'TeamEdge';
  /** The item at the end of the edge */
  node?: Maybe<Team>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type TeamInviteInfo = {
  __typename?: 'TeamInviteInfo';
  teamName?: Maybe<Scalars['String']>;
  teamLogin?: Maybe<Scalars['String']>;
  teamLogo?: Maybe<Scalars['String']>;
  vcsProvider?: Maybe<Scalars['String']>;
  role?: Maybe<TeamMemberRoleChoices>;
  message?: Maybe<Scalars['String']>;
  joined?: Maybe<Scalars['Boolean']>;
};

/** A team member object. */
export type TeamMember = MaskPrimaryKeyNode & {
  __typename?: 'TeamMember';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  role?: Maybe<TeamMemberRoleChoices>;
  team: EnterpriseTeam;
  user: User;
  /** Whether fetched from VCS (sync) or added on DeepSource. */
  isAddedFromVcs: Scalars['Boolean'];
  /** Whether the role fetched from VCS (sync) or changed on DeepSource. */
  isRoleFromVcs: Scalars['Boolean'];
  isPrimaryUser?: Maybe<Scalars['Boolean']>;
};

/** A team member add request object */
export type TeamMemberAdditionRequest = MaskPrimaryKeyNode & {
  __typename?: 'TeamMemberAdditionRequest';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  team: EnterpriseTeam;
  user: User;
  status?: Maybe<TeamMemberAdditionRequestStatus>;
};

export type TeamMemberAdditionRequestConnection = {
  __typename?: 'TeamMemberAdditionRequestConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TeamMemberAdditionRequestEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `TeamMemberAdditionRequest` and its cursor. */
export type TeamMemberAdditionRequestEdge = {
  __typename?: 'TeamMemberAdditionRequestEdge';
  /** The item at the end of the edge */
  node?: Maybe<TeamMemberAdditionRequest>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** An enumeration. */
export enum TeamMemberAdditionRequestStatus {
  StatusNoRqst = 'STATUS_NO_RQST',
  StatusPending = 'STATUS_PENDING',
  StatusAccepted = 'STATUS_ACCEPTED',
  StatusRejected = 'STATUS_REJECTED',
  StatusAlreadyMember = 'STATUS_ALREADY_MEMBER'
}

export type TeamMemberConnection = {
  __typename?: 'TeamMemberConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TeamMemberEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `TeamMember` and its cursor. */
export type TeamMemberEdge = {
  __typename?: 'TeamMemberEdge';
  /** The item at the end of the edge */
  node?: Maybe<TeamMember>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** A team member invite object. */
export type TeamMemberInvitation = MaskPrimaryKeyNode & {
  __typename?: 'TeamMemberInvitation';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  role?: Maybe<TeamMemberRoleChoices>;
  team: EnterpriseTeam;
  invitationCode: Scalars['String'];
  email: Scalars['String'];
  status: TeamMemberInvitationStatus;
};

export type TeamMemberInvitationConnection = {
  __typename?: 'TeamMemberInvitationConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TeamMemberInvitationEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `TeamMemberInvitation` and its cursor. */
export type TeamMemberInvitationEdge = {
  __typename?: 'TeamMemberInvitationEdge';
  /** The item at the end of the edge */
  node?: Maybe<TeamMemberInvitation>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** An enumeration. */
export enum TeamMemberInvitationStatus {
  /** Pending */
  Pend = 'PEND',
  /** Accepted */
  Actd = 'ACTD'
}

/** An enumeration. */
export enum TeamMemberRoleChoices {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  Contributor = 'CONTRIBUTOR'
}

export type TestWebhookInput = {
  webhookId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Mutation to test a webhook */
export type TestWebhookPayload = {
  __typename?: 'TestWebhookPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type ToggleRepositoryActivationInput = {
  /** New activation state. */
  isActivated: Scalars['Boolean'];
  /** Global ID of the repository. */
  id: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Toggle analysis activation of a repository. */
export type ToggleRepositoryActivationPayload = {
  __typename?: 'ToggleRepositoryActivationPayload';
  repository?: Maybe<Repository>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type ToggleUserActiveInput = {
  userId: Scalars['ID'];
  isActive: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type ToggleUserActivePayload = {
  __typename?: 'ToggleUserActivePayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type Transaction = MaskPrimaryKeyNode & {
  __typename?: 'Transaction';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  transactionType: TransactionTransactionType;
  amount: Scalars['Int'];
  user: User;
  reason: TransactionReason;
  objectId?: Maybe<Scalars['Int']>;
  through?: Maybe<Scalars['String']>;
};

export type TransactionConnection = {
  __typename?: 'TransactionConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TransactionEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Transaction` and its cursor. */
export type TransactionEdge = {
  __typename?: 'TransactionEdge';
  /** The item at the end of the edge */
  node?: Maybe<Transaction>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** An enumeration. */
export enum TransactionReason {
  /** For referring a new user */
  Refer = 'REFER',
  /** For signing up via referral code */
  Signup = 'SIGNUP',
  /** For applying credit on an account */
  Credit = 'CREDIT'
}

/** An enumeration. */
export enum TransactionTransactionType {
  /** credit */
  Crd = 'CRD',
  /** debit */
  Dbt = 'DBT'
}

export type TransferTeamOwnershipInput = {
  /** ID of the team of which the ownership is being transferred. */
  teamId: Scalars['ID'];
  /** ID of the owner of the team. */
  newPrimaryUserId: Scalars['ID'];
  /** If True, use new owner's email for all billing related comm. */
  updateBillingEmail?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type TransferTeamOwnershipPayload = {
  __typename?: 'TransferTeamOwnershipPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** An Transformer review on DeepSource. */
export type TransformerReview = MaskPrimaryKeyNode & {
  __typename?: 'TransformerReview';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  transformerTool: TransformerTool;
  name: Scalars['String'];
  avatar: Scalars['String'];
  comment: Scalars['String'];
};

export type TransformerReviewConnection = {
  __typename?: 'TransformerReviewConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TransformerReviewEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `TransformerReview` and its cursor. */
export type TransformerReviewEdge = {
  __typename?: 'TransformerReviewEdge';
  /** The item at the end of the edge */
  node?: Maybe<TransformerReview>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type TransformerRun = MaskPrimaryKeyNode & {
  __typename?: 'TransformerRun';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  runId: Scalars['UUID'];
  commitOid: Scalars['String'];
  baseOid?: Maybe<Scalars['String']>;
  branchName?: Maybe<Scalars['String']>;
  status: TransformerRunStatus;
  finishedAt?: Maybe<Scalars['DateTime']>;
  errors?: Maybe<Scalars['JSONString']>;
  config?: Maybe<Scalars['JSONString']>;
  pullRequestNumber?: Maybe<Scalars['Int']>;
  pullRequestStatus: TransformerRunPullRequestStatus;
  committedToBranchStatus: TransformerRunCommittedToBranchStatus;
  createdCommitOid?: Maybe<Scalars['String']>;
  extraData: Scalars['JSONString'];
  analyzer: Analyzer;
  changedFiles: Array<Scalars['String']>;
  tools?: Maybe<Scalars['GenericScalar']>;
  githubCheckRunId?: Maybe<Scalars['BigInt']>;
  githubCheckSuiteId?: Maybe<Scalars['BigInt']>;
  changedFilesCount?: Maybe<Scalars['Int']>;
  changeset?: Maybe<Scalars['GenericScalar']>;
  finishedIn?: Maybe<Scalars['Int']>;
  vcsPrUrl?: Maybe<Scalars['String']>;
  vcsCommitUrl?: Maybe<Scalars['String']>;
  pullRequestNumberDisplay?: Maybe<Scalars['String']>;
  commitMessage?: Maybe<Scalars['String']>;
  commitOidShort?: Maybe<Scalars['String']>;
  gitCompareDisplay?: Maybe<Scalars['String']>;
  gitCompareUrl?: Maybe<Scalars['String']>;
  staleRedirectUrl?: Maybe<Scalars['String']>;
  errorsRendered?: Maybe<Scalars['GenericScalar']>;
};

/** An enumeration. */
export enum TransformerRunCommittedToBranchStatus {
  /** Not committed to branch */
  Ncb = 'NCB',
  /** Committed to branch */
  Ctb = 'CTB',
  /** Failed to commit */
  Ctf = 'CTF'
}

export type TransformerRunConnection = {
  __typename?: 'TransformerRunConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TransformerRunEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `TransformerRun` and its cursor. */
export type TransformerRunEdge = {
  __typename?: 'TransformerRunEdge';
  /** The item at the end of the edge */
  node?: Maybe<TransformerRun>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** An enumeration. */
export enum TransformerRunPullRequestStatus {
  /** Pull-Request not created */
  Pnc = 'PNC',
  /** Pull-Request opened */
  Pro = 'PRO',
  /** Pull-Request closed */
  Prc = 'PRC',
  /** Pull-Request merged */
  Prm = 'PRM',
  /** Failed to create Pull-Request */
  Prf = 'PRF'
}

/** An enumeration. */
export enum TransformerRunStatus {
  /** Pending */
  Pend = 'PEND',
  /** Success */
  Pass = 'PASS',
  /** Empty */
  Empt = 'EMPT',
  /** Timed out */
  Timo = 'TIMO',
  /** Failure */
  Fail = 'FAIL',
  /** Stale */
  Stal = 'STAL',
  /** Skipped */
  Skip = 'SKIP',
  /** Error */
  Erro = 'ERRO'
}

/** A transformer on DeepSource. */
export type TransformerTool = MaskPrimaryKeyNode & {
  __typename?: 'TransformerTool';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  analyzer?: Maybe<Analyzer>;
  documentationUrl?: Maybe<Scalars['String']>;
  discussUrl?: Maybe<Scalars['String']>;
  exampleConfig?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
  /** Name of the tool. */
  name: Scalars['String'];
  /** Unique identifier for this tool globally. */
  shortcode: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  /** Verbose description, written in Markdown. */
  description: Scalars['String'];
  transformerRuns: TransformerRunConnection;
  reviews: TransformerReviewConnection;
  descriptionRendered?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  publishedOn?: Maybe<Scalars['Date']>;
  updatedOn?: Maybe<Scalars['Date']>;
  owner?: Maybe<Scalars['String']>;
};


/** A transformer on DeepSource. */
export type TransformerToolTransformerRunsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
};


/** A transformer on DeepSource. */
export type TransformerToolReviewsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type TransformerToolConnection = {
  __typename?: 'TransformerToolConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TransformerToolEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `TransformerTool` and its cursor. */
export type TransformerToolEdge = {
  __typename?: 'TransformerToolEdge';
  /** The item at the end of the edge */
  node?: Maybe<TransformerTool>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export enum TrendDirection {
  Up = 'UP',
  Down = 'DOWN'
}

/** An enumeration. */
export enum TrendType {
  Yearly = 'YEARLY',
  Monthly = 'MONTHLY'
}

export type TriggerAdHocRunInput = {
  config: Scalars['String'];
  /** GraphQL node ID of the repository. */
  repositoryId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Trigger analysis run with the given config. */
export type TriggerAdHocRunPayload = {
  __typename?: 'TriggerAdHocRunPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type TriggerAnalysisForRepositoryInput = {
  repoId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Trigger a run for the given repository. */
export type TriggerAnalysisForRepositoryPayload = {
  __typename?: 'TriggerAnalysisForRepositoryPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type TriggerPullRequestRunInput = {
  /** GraphQL node ID of the repository. */
  repositoryId: Scalars['ID'];
  /** Pull request number on VCS. */
  prNumber: Scalars['Int'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/**
 * Trigger an analysis run for a specific pull request.
 *
 * Fetches PR details from VCS, creates/updates the PR record in the database,
 * and triggers an analysis run for the latest commit on the PR branch.
 */
export type TriggerPullRequestRunPayload = {
  __typename?: 'TriggerPullRequestRunPayload';
  ok?: Maybe<Scalars['Boolean']>;
  errorMessage?: Maybe<Scalars['String']>;
  pr?: Maybe<Pr>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type TriggerRemediationRunInput = {
  vulnerabilityOccurrenceId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type TriggerRemediationRunPayload = {
  __typename?: 'TriggerRemediationRunPayload';
  ok: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type TriggerVerifyGsrsshInput = {
  ownerId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/**
 * Trigger a SSHVerifyRun. This run checks whether the public key for the
 * given owner is registered with the VCS or not.
 */
export type TriggerVerifyGsrsshPayload = {
  __typename?: 'TriggerVerifyGSRSSHPayload';
  /** Status of the verify run for the given owner. */
  status?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};


export type UnarchiveCustomAnalyzerInput = {
  analyzerId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Unarchive a custom analyzer. */
export type UnarchiveCustomAnalyzerPayload = {
  __typename?: 'UnarchiveCustomAnalyzerPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UnifiedProduct = MaskPrimaryKeyNode & {
  __typename?: 'UnifiedProduct';
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  /** The ID of the object */
  id: Scalars['ID'];
  plan: UnifiedProductPlan;
  seatQuantity: Scalars['Int'];
  scaTargetQuantity: Scalars['Int'];
  isAutoTopupEnabled: Scalars['Boolean'];
  autoTopupThreshold: Scalars['Int'];
  autoTopupAmount: Scalars['Int'];
  autoTopupMax?: Maybe<Scalars['Int']>;
  /** Stripe ID of the currently active usage credit grant */
  activeCreditGrantId?: Maybe<Scalars['String']>;
  /** Stripe pricing plan version ID this subscription was created with */
  pricingPlanVersionId?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum UnifiedProductPlan {
  PlanIndividual = 'PLAN_INDIVIDUAL',
  PlanOpenSource = 'PLAN_OPEN_SOURCE',
  PlanTrial = 'PLAN_TRIAL',
  PlanTeam = 'PLAN_TEAM',
  PlanEnterprise = 'PLAN_ENTERPRISE'
}

export type UninstallIntegrationInput = {
  shortcode: Scalars['String'];
  ownerId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UninstallIntegrationPayload = {
  __typename?: 'UninstallIntegrationPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UnsetIssuePriorityInput = {
  /** Shortcode of issue for which to set the issue priority */
  issueShortcode: Scalars['String'];
  /** Level on which to set the priority (repository/owner/enterprise) */
  level: IssuePriorityLevel;
  /** ID of the object to set/update the issue priority for */
  objectId: Scalars['ID'];
  /** The slug for the priority to set for this issue */
  issuePriorityType?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Unset issue priority on an issue */
export type UnsetIssuePriorityPayload = {
  __typename?: 'UnsetIssuePriorityPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateAccessControlSettingsInput = {
  teamId: Scalars['ID'];
  syncPermissionsWithVcs?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateAccessControlSettingsPayload = {
  __typename?: 'UpdateAccessControlSettingsPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateAccessTokenInput = {
  /** Access token's GQL ID. */
  tokenId: Scalars['ID'];
  /** A note on why this token was created. */
  description?: Maybe<Scalars['String']>;
  /** Number of days from today this token should expire. */
  expireInDays?: Maybe<Scalars['Int']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Mutation to update an access token for owner */
export type UpdateAccessTokenPayload = {
  __typename?: 'UpdateAccessTokenPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** The action to perform in an update. */
export enum UpdateAction {
  Add = 'ADD',
  Remove = 'REMOVE'
}

export type UpdateAutoTopupInput = {
  /** The owner's node ID */
  ownerId: Scalars['ID'];
  /** Whether auto top-up is enabled */
  isAutoTopupEnabled?: Maybe<Scalars['Boolean']>;
  /** Credit threshold (in cents) to trigger auto top-up */
  autoTopupThreshold?: Maybe<Scalars['Int']>;
  /** Amount (in cents) to top-up when triggered */
  autoTopupAmount?: Maybe<Scalars['Int']>;
  /** Maximum balance (in cents) allowed for auto top-up */
  autoTopupMax?: Maybe<Scalars['Int']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Update auto top-up settings for a unified subscription. */
export type UpdateAutoTopupPayload = {
  __typename?: 'UpdateAutoTopupPayload';
  unifiedProduct?: Maybe<UnifiedProduct>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateBillingInfoInput = {
  /** Owner's gql ID */
  id?: Maybe<Scalars['ID']>;
  ownerId?: Maybe<Scalars['Int']>;
  billingEmail?: Maybe<Scalars['String']>;
  billingAddress?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateBillingInfoPayload = {
  __typename?: 'UpdateBillingInfoPayload';
  billingEmail?: Maybe<Scalars['String']>;
  billingAddress?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateCheckIssueValidityInput = {
  checkIssueId: Scalars['ID'];
  validityStatus: OccurrenceValidityStatusChoices;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Update the `validity_status` for a `CheckIssue`. */
export type UpdateCheckIssueValidityPayload = {
  __typename?: 'UpdateCheckIssueValidityPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateCodeQualitySubscriptionSeatsInput = {
  /** Owner's gql ID */
  id?: Maybe<Scalars['ID']>;
  ownerId?: Maybe<Scalars['Int']>;
  seats: Scalars['Int'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateCodeQualitySubscriptionSeatsPayload = {
  __typename?: 'UpdateCodeQualitySubscriptionSeatsPayload';
  ok?: Maybe<Scalars['Boolean']>;
  totalSeats?: Maybe<Scalars['Int']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateConfigTemplateInput = {
  shortcode: Scalars['String'];
  config?: Maybe<Scalars['JSONString']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateConfigTemplatePayload = {
  __typename?: 'UpdateConfigTemplatePayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateDefaultDashboardContextForUserInput = {
  /** Database ID of the context owner. */
  contextOwnerId: Scalars['Int'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Update the default dashboard context for a user. */
export type UpdateDefaultDashboardContextForUserPayload = {
  __typename?: 'UpdateDefaultDashboardContextForUserPayload';
  contexts?: Maybe<Scalars['GenericScalar']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateDefaultPaymentSourceInput = {
  /** Owner's gql ID */
  id?: Maybe<Scalars['ID']>;
  ownerId?: Maybe<Scalars['Int']>;
  token?: Maybe<Scalars['String']>;
  action: UpdatePaymentActionChoice;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateDefaultPaymentSourcePayload = {
  __typename?: 'UpdateDefaultPaymentSourcePayload';
  card?: Maybe<Card>;
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateDynamicRiskConfigInput = {
  /** Global ID of the owner. */
  ownerId: Scalars['ID'];
  /** Dynamic risk configuration. */
  config: DynamicRiskConfigInput;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateDynamicRiskConfigPayload = {
  __typename?: 'UpdateDynamicRiskConfigPayload';
  ok?: Maybe<Scalars['Boolean']>;
  dynamicRiskConfig?: Maybe<OwnerDynamicRiskConfig>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateEnterpriseInstallationInput = {
  name?: Maybe<Scalars['String']>;
  logo?: Maybe<Attachment>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateEnterpriseInstallationPayload = {
  __typename?: 'UpdateEnterpriseInstallationPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateGroupInput = {
  groupId: Scalars['ID'];
  name: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateGroupPayload = {
  __typename?: 'UpdateGroupPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateGroupTeamRoleInput = {
  groupId: Scalars['ID'];
  teamId: Scalars['ID'];
  role?: Maybe<TeamMemberRoleChoices>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateGroupTeamRolePayload = {
  __typename?: 'UpdateGroupTeamRolePayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateIdentityProviderInput = {
  teamId: Scalars['ID'];
  isScimEnabled?: Maybe<Scalars['Boolean']>;
  scimAuthToken?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateIdentityProviderPayload = {
  __typename?: 'UpdateIdentityProviderPayload';
  ok: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateIntegrationSettingsInput = {
  shortcode: Scalars['String'];
  level: IntegrationSettingsLevel;
  ownerId?: Maybe<Scalars['ID']>;
  repositoryId?: Maybe<Scalars['ID']>;
  settings: Scalars['GenericScalar'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateIntegrationSettingsPayload = {
  __typename?: 'UpdateIntegrationSettingsPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateIssuePriorityInput = {
  /** Shortcode of issue for which to set the issue priority */
  issueShortcode: Scalars['String'];
  /** Level on which to set the priority (repository/owner/enterprise) */
  level: IssuePriorityLevel;
  /** ID of the object to set/update the issue priority for */
  objectId: Scalars['ID'];
  /** The slug for the priority to set for this issue */
  issuePriorityType?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateIssuePriorityPayload = {
  __typename?: 'UpdateIssuePriorityPayload';
  issue?: Maybe<Issue>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateOrCreateRepositoryCollaboratorInput = {
  userId: Scalars['ID'];
  repositoryId: Scalars['ID'];
  permission?: Maybe<RepositoryPermissionChoices>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateOrCreateRepositoryCollaboratorPayload = {
  __typename?: 'UpdateOrCreateRepositoryCollaboratorPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateOwnerAiPolicyInput = {
  /** Global ID of the owner. */
  ownerId: Scalars['ID'];
  /** AI policy configuration. */
  policy: OwnerAiPolicyInput;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Update AI policy for a owner. */
export type UpdateOwnerAiPolicyPayload = {
  __typename?: 'UpdateOwnerAIPolicyPayload';
  ok: Scalars['Boolean'];
  aiPolicy: OwnerAiPolicy;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateOwnerLicenseScaPolicyInput = {
  /** Global ID of the owner. */
  ownerId: Scalars['ID'];
  /** License policy configuration. */
  policy: OwnerLicensePolicyInput;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Update license policy for a owner. */
export type UpdateOwnerLicenseScaPolicyPayload = {
  __typename?: 'UpdateOwnerLicenseSCAPolicyPayload';
  ok?: Maybe<Scalars['Boolean']>;
  licensePolicy?: Maybe<OwnerLicensePolicy>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateOwnerPinnedReportsInput = {
  /** GraphQL node ID of the owner. */
  ownerId: Scalars['ID'];
  /** List of report keys (with metadata) to pin on the owner dashboard. */
  pinnedReports: Array<Maybe<PinnedReportInput>>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Update an owner's `OwnerSetting.pinned_reports` field. */
export type UpdateOwnerPinnedReportsPayload = {
  __typename?: 'UpdateOwnerPinnedReportsPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateOwnerProfileInput = {
  /** Global ID of the owner. */
  ownerId: Scalars['ID'];
  /** List of product interests selected by the owner. */
  productInterests?: Maybe<Array<Maybe<ProductInterestChoices>>>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Update owner profile for product interests. */
export type UpdateOwnerProfilePayload = {
  __typename?: 'UpdateOwnerProfilePayload';
  ok?: Maybe<Scalars['Boolean']>;
  ownerProfile?: Maybe<OwnerProfile>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateOwnerScaPolicyInput = {
  /** Global ID of the owner. */
  ownerId: Scalars['ID'];
  /** SCA policy configuration. */
  policy: OwnerScaPolicyInput;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Update SCA policy for a owner. */
export type UpdateOwnerScaPolicyPayload = {
  __typename?: 'UpdateOwnerSCAPolicyPayload';
  ok?: Maybe<Scalars['Boolean']>;
  scaPolicy?: Maybe<OwnerScaPolicy>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateOwnerSettingsInput = {
  /** Global ID of the owner. */
  ownerId: Scalars['ID'];
  /** Issue type configuration. */
  issueTypeSettings?: Maybe<Array<Maybe<IssueTypeSettingInput>>>;
  /** Whether to sponsor IDE team subscriptions for team admin/members. */
  sponsorIdeSubscriptions?: Maybe<Scalars['Boolean']>;
  /** Whether to allow users from running Autofix AI on private repositories. */
  allowAutofixAi?: Maybe<Scalars['Boolean']>;
  /** Whether to use the legacy autofix engine for all Autofix runs. */
  useLegacyAutofix?: Maybe<Scalars['Boolean']>;
  /** Whether to use the legacy secret analyzer for secret scanning. */
  useLegacySecretAnalyzer?: Maybe<Scalars['Boolean']>;
  /** Whether to commit config to the repository. */
  shouldCommitConfig?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Update settings of a owner. */
export type UpdateOwnerSettingsPayload = {
  __typename?: 'UpdateOwnerSettingsPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export enum UpdatePaymentActionChoice {
  Update = 'UPDATE',
  Remove = 'REMOVE'
}

export type UpdatePublicReportInput = {
  /** The `reportId` of the public report to update */
  reportId: Scalars['String'];
  /** The label of the report */
  label?: Maybe<Scalars['String']>;
  /** Whether the report is restricted */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** The password to access the report */
  password?: Maybe<Scalars['String']>;
  /** Whether the report's historical data is shared or not */
  shareHistoricalData?: Maybe<Scalars['Boolean']>;
  /** The list of reports to be shown in the public report. */
  reportKeys?: Maybe<Array<Maybe<Scalars['String']>>>;
  source?: Maybe<ReportSource>;
  /** The list of repositories to be included in the results. */
  sourcedRepositories?: Maybe<Array<Maybe<Scalars['ID']>>>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Update a public report details */
export type UpdatePublicReportPayload = {
  __typename?: 'UpdatePublicReportPayload';
  publicReport?: Maybe<PublicReport>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdatePublicReportSourcedRepositoriesInput = {
  /** The `reportId` of the public report. */
  reportId: Scalars['UUID'];
  /** The action to perform. */
  action: UpdateAction;
  /** List of repository IDs to add or remove. */
  repositoryIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Add or remove sourced repositories from a public report. */
export type UpdatePublicReportSourcedRepositoriesPayload = {
  __typename?: 'UpdatePublicReportSourcedRepositoriesPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateRepoMetricThresholdInput = {
  /** Metric shortcode */
  metricShortcode: Scalars['String'];
  /** GraphQL node ID of the repository. */
  repositoryId: Scalars['ID'];
  /** Threshold value of Metric for a repository */
  thresholdValue?: Maybe<Scalars['Int']>;
  /** Namespace key identifying the analyzer */
  key: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Update threshold for a metric namespace, creating the namespace if doesn't exist. */
export type UpdateRepoMetricThresholdPayload = {
  __typename?: 'UpdateRepoMetricThresholdPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateRepositoryGroupLeadInput = {
  /** ID of the repository group. */
  repositoryGroupId: Scalars['ID'];
  /** ID of the new lead user. */
  leadUserId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Update the lead user of a repository group. */
export type UpdateRepositoryGroupLeadPayload = {
  __typename?: 'UpdateRepositoryGroupLeadPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateRepositoryGroupPinnedReportsInput = {
  /** GraphQL node ID of the repository group. */
  repositoryGroupId: Scalars['ID'];
  /** List of report keys (with metadata) to pin on the repository group dashboard. */
  pinnedReports: Array<Maybe<PinnedReportInput>>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Update a repository group's `RepositoryGroupSetting.pinned_reports` field. */
export type UpdateRepositoryGroupPinnedReportsPayload = {
  __typename?: 'UpdateRepositoryGroupPinnedReportsPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateRepositoryGroupSettingsInput = {
  /** GraphQL node ID of the repository group. */
  repositoryGroupId: Scalars['ID'];
  /** Name of the repository group. Only non-default groups can be renamed. */
  name?: Maybe<Scalars['String']>;
  /** Analyze changeset and report only new issues introduced or report all issues on modified files */
  analyzeChangesetOnly?: Maybe<Scalars['Boolean']>;
  /** Set True to fail checks if no artifact is reported. */
  shouldTimeoutDataTrigger?: Maybe<Scalars['Boolean']>;
  /** Issue type configuration. */
  issueTypeSettings?: Maybe<Array<Maybe<IssueTypeSettingInput>>>;
  /** Issue severity configuration. */
  issueSeveritySettings?: Maybe<Array<Maybe<IssueSeveritySettingInput>>>;
  /** Metrics reporting configuration */
  metricSettings?: Maybe<Array<Maybe<RepositoryGroupMetricSettingsInput>>>;
  /** Override repository settings. */
  overrideRepoSetting?: Maybe<Scalars['Boolean']>;
  /** Reporting Configuration for GitLab */
  gitlabIntegrationUseStatus?: Maybe<Scalars['Boolean']>;
  /** Whether to infer code coverage artifacts from PR to merge commit on default branch. */
  inferDefaultBranchCoverage?: Maybe<Scalars['Boolean']>;
  /** Whether to infer community analyzers artifacts from PR to merge commit on default branch. */
  inferDefaultBranchCommunity?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Update a repository group's settings. */
export type UpdateRepositoryGroupSettingsPayload = {
  __typename?: 'UpdateRepositoryGroupSettingsPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateRepositoryGroupVcsReportingOptionsEnabledInput = {
  /** GraphQL node ID of the repository group. */
  repositoryGroupId: Scalars['ID'];
  /** List of VCS reporting options to enable for the repository group. */
  vcsReportingOptions: Array<VcsReportingChoices>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Update a repository's `RepositorySetting.vcs_reporting_options_enabled` field. */
export type UpdateRepositoryGroupVcsReportingOptionsEnabledPayload = {
  __typename?: 'UpdateRepositoryGroupVCSReportingOptionsEnabledPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateRepositoryPinnedReportsInput = {
  /** GraphQL node ID of the repository. */
  repositoryId: Scalars['ID'];
  /** List of report keys (with metadata) to pin on the repository dashboard. */
  pinnedReports: Array<Maybe<PinnedReportInput>>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Update a repository's `RepositorySetting.pinned_reports` field. */
export type UpdateRepositoryPinnedReportsPayload = {
  __typename?: 'UpdateRepositoryPinnedReportsPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateRepositorySettingsInput = {
  /** Default branch for analysis on this repository. */
  defaultBranchName?: Maybe<Scalars['String']>;
  /** Is fetching git submodule enabled for this repository? */
  isSubmoduleEnabled?: Maybe<Scalars['Boolean']>;
  /** Analyze changeset and report only new issues introduced or report all issues on modified files */
  analyzeChangesetOnly?: Maybe<Scalars['Boolean']>;
  keepExistingIssues?: Maybe<Scalars['Boolean']>;
  /** Issue type configuration. */
  issueTypeSettings?: Maybe<Array<Maybe<IssueTypeSettingInput>>>;
  /** Issue priority configuration */
  issuePrioritySettings?: Maybe<Array<Maybe<RepositoryIssuePrioritySettingsInput>>>;
  /** Issue severity configuration */
  issueSeveritySettings?: Maybe<Array<Maybe<IssueSeveritySettingInput>>>;
  /** Metrics reporting configuration */
  metricSettings?: Maybe<Array<Maybe<MetricSettingsInput>>>;
  /** Reporting Configuration for GitLab */
  gitlabIntegrationUseStatus?: Maybe<Scalars['Boolean']>;
  /** Whether to infer code coverage artifacts from PR to merge commit on default branch. */
  inferDefaultBranchCoverage?: Maybe<Scalars['Boolean']>;
  /** Whether to infer community analyzers artifacts from PR to merge commit on default branch. */
  inferDefaultBranchCommunity?: Maybe<Scalars['Boolean']>;
  /** Whether code analysis is enabled. Only applies when using DB config. */
  enableCodeAnalysis?: Maybe<Scalars['Boolean']>;
  /** Whether code formatting is enabled. Only applies when using DB config. */
  enableCodeFormatting?: Maybe<Scalars['Boolean']>;
  /** Global ID of the repository. */
  id: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Update settings of a repository. */
export type UpdateRepositorySettingsPayload = {
  __typename?: 'UpdateRepositorySettingsPayload';
  repository?: Maybe<Repository>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateRepositoryTargetInput = {
  targetId: Scalars['ID'];
  packageManager: PackageManager;
  lockfilePath: Scalars['String'];
  manifestPath?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Update a repository target. */
export type UpdateRepositoryTargetPayload = {
  __typename?: 'UpdateRepositoryTargetPayload';
  ok: Scalars['Boolean'];
  target: RepositoryTarget;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateRepositoryVcsReportingOptionsEnabledInput = {
  /** GraphQL node ID of the repository. */
  repositoryId: Scalars['ID'];
  /** List of VCS reporting options to enable for the repository. */
  vcsReportingOptions: Array<VcsReportingChoices>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Update a repository's `RepositorySetting.vcs_reporting_options_enabled` field. */
export type UpdateRepositoryVcsReportingOptionsEnabledPayload = {
  __typename?: 'UpdateRepositoryVCSReportingOptionsEnabledPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateRepositoryWidgetsInput = {
  widgetCodes: Array<Maybe<Scalars['String']>>;
  /** GraphQL node ID of the repository. */
  repositoryId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Update the order of default widgets. */
export type UpdateRepositoryWidgetsPayload = {
  __typename?: 'UpdateRepositoryWidgetsPayload';
  widgetCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateStarredRepositoryInput = {
  repoId: Scalars['ID'];
  action: ActionChoice;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateStarredRepositoryPayload = {
  __typename?: 'UpdateStarredRepositoryPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateTeamBasePermissionsInput = {
  teamId: Scalars['ID'];
  /** default repository permission for team members */
  defaultRepositoryPermission?: Maybe<DefaultRepositoryPermissionChoices>;
  canMembersIgnoreIssues?: Maybe<Scalars['Boolean']>;
  canMembersModifyMetricThresholds?: Maybe<Scalars['Boolean']>;
  canMembersIgnoreFailingMetrics?: Maybe<Scalars['Boolean']>;
  canContributorsIgnoreIssues?: Maybe<Scalars['Boolean']>;
  canContributorsModifyMetricThresholds?: Maybe<Scalars['Boolean']>;
  canContributorsIgnoreFailingMetrics?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateTeamBasePermissionsPayload = {
  __typename?: 'UpdateTeamBasePermissionsPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateTeamMemberRoleInput = {
  ownerId?: Maybe<Scalars['Int']>;
  ownerPk?: Maybe<Scalars['ID']>;
  email: Scalars['String'];
  role: TeamMemberRoleChoices;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateTeamMemberRolePayload = {
  __typename?: 'UpdateTeamMemberRolePayload';
  role?: Maybe<TeamMemberRoleChoices>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateTimeoutSettingInput = {
  /** Set True to fail checks if no artifact is reported. */
  shouldTimeoutDataTrigger: Scalars['Boolean'];
  /** GraphQL node Id of the owner */
  ownerId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/**
 * Toggle whether data-triggered checks should be marked as timed out if no
 * artifacts are reported within the specified period.
 */
export type UpdateTimeoutSettingPayload = {
  __typename?: 'UpdateTimeoutSettingPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateUserDetailsInput = {
  /** Display name to update for the user. */
  displayName?: Maybe<Scalars['String']>;
  /** Avatar token to update for the user. */
  avatarToken?: Maybe<Scalars['UUID']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateUserDetailsPayload = {
  __typename?: 'UpdateUserDetailsPayload';
  ok?: Maybe<Scalars['Boolean']>;
  viewer?: Maybe<User>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateUserProfileInput = {
  /** First name of the user. */
  firstName?: Maybe<Scalars['String']>;
  /** Last name of the user. */
  lastName?: Maybe<Scalars['String']>;
  /** Company or organization name. */
  company?: Maybe<Scalars['String']>;
  /** Size of the company. */
  companySize?: Maybe<CompanySizeChoices>;
  /** Role of the user. */
  role?: Maybe<RoleChoices>;
  /** How the user heard about DeepSource. */
  referralSource?: Maybe<ReferralSourceChoices>;
  /** Mark the onboarding as completed. */
  markCompleted?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Update user profile for onboarding or profile edits. */
export type UpdateUserProfilePayload = {
  __typename?: 'UpdateUserProfilePayload';
  ok?: Maybe<Scalars['Boolean']>;
  userProfile?: Maybe<UserProfile>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateVulnerabilityNotificationSettingsInput = {
  /** GraphQL node ID of the owner. */
  ownerId: Scalars['ID'];
  /** When True, org admin emails (or primary user email for personal accounts) are additionally included as recipients alongside the emails list. */
  alertAllAdmins?: Maybe<Scalars['Boolean']>;
  /** Email addresses to receive vulnerability notifications. Always included as recipients regardless of the alert_all_admins flag. */
  emails?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Minimum severity level for vulnerability notifications. Only vulnerabilities at or above this level will trigger emails. */
  threshold?: Maybe<VulnerabilityNotificationThreshold>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/**
 * Update vulnerability notification settings for an owner.
 *
 * Configure email addresses and severity threshold for periodic scan
 * vulnerability notifications.
 */
export type UpdateVulnerabilityNotificationSettingsPayload = {
  __typename?: 'UpdateVulnerabilityNotificationSettingsPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateWatchedRepositoryInput = {
  repoId: Scalars['ID'];
  action: ActionChoice;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateWatchedRepositoryPayload = {
  __typename?: 'UpdateWatchedRepositoryPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateWebhookInput = {
  webhookId: Scalars['ID'];
  url?: Maybe<Scalars['String']>;
  secret?: Maybe<Scalars['String']>;
  apiSigning?: Maybe<Scalars['Boolean']>;
  eventsSubscribed?: Maybe<Array<Maybe<Scalars['String']>>>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Mutation to update the webhook */
export type UpdateWebhookPayload = {
  __typename?: 'UpdateWebhookPayload';
  webhook?: Maybe<Webhook>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type Usage = {
  __typename?: 'Usage';
  /** @deprecated Use totalSpend instead. */
  aiReview?: Maybe<UsageMetric>;
  /** @deprecated Use locProcessedCodeReview and locProcessedSecrets instead. */
  locAnalyzed?: Maybe<UsageMetric>;
  /** @deprecated Use locProcessedCodeReview and locProcessedSecrets instead. */
  locFixed?: Maybe<UsageMetric>;
  locProcessedCodeReview?: Maybe<GroupedUsageMetric>;
  locProcessedSecrets?: Maybe<GroupedUsageMetric>;
  commitsReviewed?: Maybe<GroupedUsageMetric>;
  prsReviewed?: Maybe<GroupedUsageMetric>;
  totalSpend?: Maybe<GroupedUsageMetric>;
  activatedTargets?: Maybe<RepositoryTargetConnection>;
};


export type UsageAiReviewArgs = {
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
};


export type UsageLocAnalyzedArgs = {
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
};


export type UsageLocFixedArgs = {
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
};


export type UsageLocProcessedCodeReviewArgs = {
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
};


export type UsageLocProcessedSecretsArgs = {
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
};


export type UsageCommitsReviewedArgs = {
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
};


export type UsagePrsReviewedArgs = {
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
};


export type UsageTotalSpendArgs = {
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
};


export type UsageActivatedTargetsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  isActivated?: Maybe<Scalars['Boolean']>;
};

export type UsageMetric = {
  __typename?: 'UsageMetric';
  total?: Maybe<Scalars['Float']>;
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  values?: Maybe<Array<Maybe<Scalars['Float']>>>;
};

export type UsageMetricSeries = {
  __typename?: 'UsageMetricSeries';
  name: Scalars['String'];
  total: Scalars['Float'];
  values: Array<Scalars['Float']>;
};

export type UsageSummary = {
  __typename?: 'UsageSummary';
  id: Scalars['ID'];
  creditsAvailable: Scalars['Int'];
  creditsUsed: Scalars['Int'];
  creditsAllocated: Scalars['Int'];
  prReviewedCount: Scalars['Int'];
  commitReviewedCount: Scalars['Int'];
  ossTargetsCount: Scalars['Int'];
};

/** A user on DeepSource. */
export type User = MaskPrimaryKeyNode & {
  __typename?: 'User';
  /** The ID of the object */
  id: Scalars['ID'];
  lastLogin?: Maybe<Scalars['DateTime']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  /** Designates whether the user can log into this admin site. */
  isStaff: Scalars['Boolean'];
  /** Designates whether this user should be treated as active. Unselect this instead of deleting accounts. */
  isActive: Scalars['Boolean'];
  dateJoined: Scalars['DateTime'];
  /** A unique identifier for a SCIM resource as defined by the service provider. */
  scimId?: Maybe<Scalars['String']>;
  /** A string that is an identifier for the resource as defined by the provisioning client. */
  scimExternalId?: Maybe<Scalars['String']>;
  /** A service provider's unique identifier for the user */
  scimUsername?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  primaryOwner?: Maybe<Owner>;
  /** Avatar URL. */
  avatar?: Maybe<Scalars['String']>;
  preferredTechnologies: AnalyzerConnection;
  bookmarkedIssues: RepositoryIssueConnection;
  preference?: Maybe<UserPreference>;
  customerId?: Maybe<Scalars['String']>;
  IsBetaTester: Scalars['Boolean'];
  deleted?: Maybe<Scalars['DateTime']>;
  /** Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only. */
  username: Scalars['String'];
  socialAuth: UserSocialConnectionConnection;
  /** Get all Access Tokens for a user */
  accessTokens?: Maybe<AccessTokenConnection>;
  productSubscriptions: ProductSubscriptionConnection;
  teams: EnterpriseTeamConnection;
  teamMemberships: TeamMemberConnection;
  teamAdditionRequests: TeamMemberAdditionRequestConnection;
  transactions: TransactionConnection;
  scimGroups: EnterpriseGroupConnection;
  onboardingEvents: AutoOnboardEventConnection;
  /** Linked DeepSource user (if they have an account) */
  prAuthorships: PrAuthorConnection;
  repoGroups: RepositoryGroupConnection;
  /** Onboarding profile for the user. */
  profile?: Maybe<UserProfile>;
  vulnerabilityremediationpatchrunSet: VulnerabilityRemediationPatchRunConnection;
  silenceRulesCreated: SilenceRuleConnection;
  /** Full name of the user. */
  fullName?: Maybe<Scalars['String']>;
  /** Credits available to the user */
  availableCredits?: Maybe<Scalars['Float']>;
  /** Referral URL for this user. */
  referralUrl?: Maybe<Scalars['String']>;
  repositories?: Maybe<RepositoryConnection>;
  dashboardContext?: Maybe<Scalars['GenericScalar']>;
  recommendedIssues?: Maybe<RepositoryIssueConnection>;
  gitlabAccounts?: Maybe<Array<Maybe<Scalars['GenericScalar']>>>;
  gsrProjects?: Maybe<Array<Maybe<GsrProject>>>;
  /** Fetch the Azure DevOps organization for the given login */
  adsOrganization?: Maybe<AdsOrganization>;
  adsOrganizations?: Maybe<Array<Maybe<AdsOrganization>>>;
  bitbucketDatacenterProjects?: Maybe<Array<Maybe<BitbucketDataCenterProject>>>;
  /** Anonymous ID used for analytics and tracking. */
  analyticsId: Scalars['String'];
  isAsgardian?: Maybe<Scalars['Boolean']>;
  isBetaTester?: Maybe<Scalars['Boolean']>;
  /** Whether the user is subscribed to and IDE plan. */
  isIdeUser: Scalars['Boolean'];
  /** List of VCS providers the user has used to sign into DeepSource */
  connectedVcsProviders?: Maybe<Array<Maybe<VcsProviderChoices>>>;
  /** Social login connections for a user */
  socialConnections: Array<UserSocialConnection>;
  /** Ownerships associated with the user. */
  personalAccounts?: Maybe<OwnerConnection>;
  /** Teams associated with the user. */
  teamAccounts?: Maybe<TeamConnection>;
};


/** A user on DeepSource. */
export type UserPreferredTechnologiesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  categoryIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  q?: Maybe<Scalars['String']>;
  exclude?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** A user on DeepSource. */
export type UserBookmarkedIssuesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  recommended?: Maybe<Scalars['Boolean']>;
  issueType?: Maybe<Scalars['String']>;
  analyzer?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['String']>;
  severityIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  autofixAvailable?: Maybe<Scalars['Boolean']>;
  auditRequired?: Maybe<Scalars['Boolean']>;
  q?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
};


/** A user on DeepSource. */
export type UserSocialAuthArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A user on DeepSource. */
export type UserAccessTokensArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A user on DeepSource. */
export type UserProductSubscriptionsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  productType?: Maybe<ProductChoice>;
};


/** A user on DeepSource. */
export type UserTeamsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
};


/** A user on DeepSource. */
export type UserTeamMembershipsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  role?: Maybe<Array<Maybe<Scalars['String']>>>;
  isAddedFromVcs?: Maybe<Scalars['Boolean']>;
  isRoleFromVcs?: Maybe<Scalars['Boolean']>;
};


/** A user on DeepSource. */
export type UserTeamAdditionRequestsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  status?: Maybe<TeamMemberAdditionRequestStatus>;
};


/** A user on DeepSource. */
export type UserTransactionsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  transactionType?: Maybe<TransactionTransactionType>;
};


/** A user on DeepSource. */
export type UserScimGroupsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
};


/** A user on DeepSource. */
export type UserOnboardingEventsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  owner?: Maybe<Scalars['ID']>;
};


/** A user on DeepSource. */
export type UserPrAuthorshipsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A user on DeepSource. */
export type UserRepoGroupsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_Icontains?: Maybe<Scalars['String']>;
};


/** A user on DeepSource. */
export type UserVulnerabilityremediationpatchrunSetArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A user on DeepSource. */
export type UserSilenceRulesCreatedArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  creator?: Maybe<Scalars['ID']>;
  issueTitle?: Maybe<Scalars['String']>;
  issueCode?: Maybe<Scalars['String']>;
  filePath?: Maybe<Scalars['String']>;
  silenceLevel?: Maybe<SilenceRuleSilenceLevel>;
};


/** A user on DeepSource. */
export type UserRepositoriesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  vcsProvider?: Maybe<VcsProviderChoices>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  isActivated?: Maybe<Scalars['Boolean']>;
  errorCode?: Maybe<Scalars['Int']>;
  name_Icontains?: Maybe<Scalars['String']>;
  nameFuzzy?: Maybe<Scalars['String']>;
};


/** A user on DeepSource. */
export type UserRecommendedIssuesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  recommended?: Maybe<Scalars['Boolean']>;
  issueType?: Maybe<Scalars['String']>;
  analyzer?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['String']>;
  severityIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  autofixAvailable?: Maybe<Scalars['Boolean']>;
  auditRequired?: Maybe<Scalars['Boolean']>;
  q?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
};


/** A user on DeepSource. */
export type UserAdsOrganizationArgs = {
  login: Scalars['String'];
};


/** A user on DeepSource. */
export type UserPersonalAccountsArgs = {
  login?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A user on DeepSource. */
export type UserTeamAccountsArgs = {
  login?: Maybe<Scalars['String']>;
  isViewerPrimaryUser?: Maybe<Scalars['Boolean']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `User` and its cursor. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** The item at the end of the edge */
  node?: Maybe<User>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type UserPreference = MaskPrimaryKeyNode & {
  __typename?: 'UserPreference';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  starredRepositories: RepositoryConnection;
  watchedRepositories: RepositoryConnection;
  user?: Maybe<User>;
};


export type UserPreferenceStarredRepositoriesArgs = {
  ownerLogin?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  vcsProvider?: Maybe<VcsProviderChoices>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  isActivated?: Maybe<Scalars['Boolean']>;
  errorCode?: Maybe<Scalars['Int']>;
  name_Icontains?: Maybe<Scalars['String']>;
  nameFuzzy?: Maybe<Scalars['String']>;
};


export type UserPreferenceWatchedRepositoriesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  vcsProvider?: Maybe<VcsProviderChoices>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  isActivated?: Maybe<Scalars['Boolean']>;
  errorCode?: Maybe<Scalars['Int']>;
  name_Icontains?: Maybe<Scalars['String']>;
  nameFuzzy?: Maybe<Scalars['String']>;
};

export type UserPreferenceConnection = {
  __typename?: 'UserPreferenceConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserPreferenceEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `UserPreference` and its cursor. */
export type UserPreferenceEdge = {
  __typename?: 'UserPreferenceEdge';
  /** The item at the end of the edge */
  node?: Maybe<UserPreference>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** GraphQL type for UserProfile model. */
export type UserProfile = MaskPrimaryKeyNode & {
  __typename?: 'UserProfile';
  /** The ID of the object */
  id: Scalars['ID'];
  /** First name of the user */
  firstName: Scalars['String'];
  /** Last name of the user */
  lastName: Scalars['String'];
  /** Company or organization name */
  company: Scalars['String'];
  companySize?: Maybe<CompanySizeChoices>;
  role?: Maybe<RoleChoices>;
  referralSource?: Maybe<ReferralSourceChoices>;
  /** When the user onboarding was completed */
  completedAt?: Maybe<Scalars['DateTime']>;
};

export type UserSocialConnection = MaskPrimaryKeyNode & {
  __typename?: 'UserSocialConnection';
  /** The ID of the object */
  id: Scalars['ID'];
  /** Created date of the login connection. */
  enabledOn: Scalars['DateTime'];
  /** Provider for the login connection. */
  provider: UserSocialConnectionChoices;
  /** UID of the user on the provider's system. */
  uid?: Maybe<Scalars['String']>;
};

export enum UserSocialConnectionChoices {
  Github = 'GITHUB',
  Gitlab = 'GITLAB',
  Bitbucket = 'BITBUCKET',
  BitbucketDatacenter = 'BITBUCKET_DATACENTER',
  GithubEnterprise = 'GITHUB_ENTERPRISE',
  Gsr = 'GSR',
  Ads = 'ADS',
  Runner = 'RUNNER'
}

export type UserSocialConnectionConnection = {
  __typename?: 'UserSocialConnectionConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserSocialConnectionEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `UserSocialConnection` and its cursor. */
export type UserSocialConnectionEdge = {
  __typename?: 'UserSocialConnectionEdge';
  /** The item at the end of the edge */
  node?: Maybe<UserSocialConnection>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** An enumeration. */
export enum VcsProviderChoices {
  Github = 'GITHUB',
  Gitlab = 'GITLAB',
  Bitbucket = 'BITBUCKET',
  BitbucketDatacenter = 'BITBUCKET_DATACENTER',
  GithubEnterprise = 'GITHUB_ENTERPRISE',
  Gsr = 'GSR',
  Ads = 'ADS'
}

/** A pull request fetched directly from the VCS provider. */
export type VcsPullRequest = {
  __typename?: 'VCSPullRequest';
  /** Pull request number. */
  number: Scalars['Int'];
  /** Title of the pull request. */
  title: Scalars['String'];
  /** Source/head branch name. */
  branch: Scalars['String'];
  /** Target/base branch name. */
  baseBranch: Scalars['String'];
  /** URL on the VCS provider. */
  url: Scalars['String'];
  /** State of the pull request (e.g., open, closed, merged, draft). */
  state: Scalars['String'];
};

/** A connection to a list of VCS pull requests. */
export type VcsPullRequestConnection = {
  __typename?: 'VCSPullRequestConnection';
  edges: Array<VcsPullRequestEdge>;
  pageInfo: PageInfo;
  /** Total count of results. Only available when using search. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a VCSPullRequest connection. */
export type VcsPullRequestEdge = {
  __typename?: 'VCSPullRequestEdge';
  node: VcsPullRequest;
  cursor: Scalars['String'];
};

/** An enumeration. */
export enum VcsReportingChoices {
  PrComment = 'PR_COMMENT',
  InlineComments = 'INLINE_COMMENTS'
}

export type VerifiableDomain = MaskPrimaryKeyNode & {
  __typename?: 'VerifiableDomain';
  domainName: Scalars['String'];
  verified: Scalars['Boolean'];
  /** The ID of the object */
  id: Scalars['ID'];
};

export type VerifiableDomainConnection = {
  __typename?: 'VerifiableDomainConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VerifiableDomainEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `VerifiableDomain` and its cursor. */
export type VerifiableDomainEdge = {
  __typename?: 'VerifiableDomainEdge';
  /** The item at the end of the edge */
  node?: Maybe<VerifiableDomain>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type Verify = {
  __typename?: 'Verify';
  payload: Scalars['GenericScalar'];
};

export type VerifyDeviceInput = {
  /** The user_code entered by the user. */
  userCode: Scalars['String'];
  /** True if user has accepted the request. */
  accepted: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/**
 * Validates the user code provided by the user, and and accepts or declines
 * the request according to the accepted parameter.
 */
export type VerifyDevicePayload = {
  __typename?: 'VerifyDevicePayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type VerifyGsrPermissionsInput = {
  ownerId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/**
 * For the given gsr owner, verify that the primary user's oauth tokens have
 * all the necessary permissions.
 */
export type VerifyGsrPermissionsPayload = {
  __typename?: 'VerifyGSRPermissionsPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type VerifyGsrSetupInput = {
  ownerId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/**
 * Check whether all setup steps have been completed for integrating with
 * GSR. If so, the flag gsr_setup_pending is unset and onboarding is allowed.
 */
export type VerifyGsrSetupPayload = {
  __typename?: 'VerifyGSRSetupPayload';
  ok: Scalars['Boolean'];
  clientMutationId?: Maybe<Scalars['String']>;
};

export type VerifyGsrWebhooksInput = {
  ownerId: Scalars['ID'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Verify that webhooks are enabled for the given GSR project. */
export type VerifyGsrWebhooksPayload = {
  __typename?: 'VerifyGSRWebhooksPayload';
  ok?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type VerifyPasswordForPublicReportInput = {
  /** The public report ID. */
  reportId: Scalars['String'];
  /** The password to verify. */
  password: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Verify the password for a public report & get a token in return. */
export type VerifyPasswordForPublicReportPayload = {
  __typename?: 'VerifyPasswordForPublicReportPayload';
  token?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** A vulnerability. */
export type Vulnerability = MaskPrimaryKeyNode & {
  __typename?: 'Vulnerability';
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  /** The ID of the object */
  id: Scalars['ID'];
  /** CVSS v2 vector */
  cvssV2Vector?: Maybe<Scalars['String']>;
  /** CVSS v2 base score */
  cvssV2BaseScore?: Maybe<Scalars['Float']>;
  cvssV2Severity?: Maybe<VulnerabilitySeverity>;
  /** CVSS v3 vector */
  cvssV3Vector?: Maybe<Scalars['String']>;
  /** CVSS v3 base score */
  cvssV3BaseScore?: Maybe<Scalars['Float']>;
  cvssV3Severity?: Maybe<VulnerabilitySeverity>;
  /** CVSS v4 vector */
  cvssV4Vector?: Maybe<Scalars['String']>;
  /** CVSS v4 base score */
  cvssV4BaseScore?: Maybe<Scalars['Float']>;
  cvssV4Severity?: Maybe<VulnerabilitySeverity>;
  severity: VulnerabilitySeverity;
  /** The identifier of the vulnerability */
  identifier: Scalars['String'];
  /** The CVE identifier of the vulnerability */
  cve?: Maybe<Scalars['String']>;
  /** The aliases of the vulnerability */
  aliases: Array<Scalars['String']>;
  /** The summary of the vulnerability */
  summary?: Maybe<Scalars['String']>;
  /** The details of the vulnerability */
  details?: Maybe<Scalars['String']>;
  /** The time when the vulnerability was published */
  publishedAt: Scalars['DateTime'];
  /** The time when the vulnerability was updated */
  updatedAt: Scalars['DateTime'];
  /** The time when the vulnerability was withdrawn */
  withdrawnAt?: Maybe<Scalars['DateTime']>;
  /** The EPSS score of the vulnerability */
  epssScore?: Maybe<Scalars['Float']>;
  /** The EPSS percentile of the vulnerability */
  epssPercentile?: Maybe<Scalars['Float']>;
  packages: PackageConnection;
  packageVersions: PackageVersionConnection;
  /** The introduced versions of the vulnerability */
  introducedVersions: Array<Scalars['String']>;
  /** The fixed versions of the vulnerability */
  fixedVersions: Array<Scalars['String']>;
  referenceUrls: Array<Maybe<VulnerabilityReferenceUrl>>;
  /** The database specific information of the vulnerability */
  databaseSpecific: Scalars['String'];
  /** The ecosystem specific information of the vulnerability */
  ecosystemSpecific: Scalars['String'];
  /** The vulnerability associated with this occurrence */
  occurrences: VulnerabilityOccurrenceConnection;
  /** Details rendered as HTML. */
  detailsRendered?: Maybe<Scalars['String']>;
  fixPaths: VulnerabilityRemediationFixPathConnection;
};


/** A vulnerability. */
export type VulnerabilityPackagesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A vulnerability. */
export type VulnerabilityPackageVersionsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A vulnerability. */
export type VulnerabilityOccurrencesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  targetId?: Maybe<Scalars['ID']>;
  packageType?: Maybe<PackageType>;
  severityIn?: Maybe<Array<Maybe<VulnerabilitySeverity>>>;
  reachabilityIn?: Maybe<Array<Maybe<VulnerabilityOccurrenceReachability>>>;
  fixabilityIn?: Maybe<Array<Maybe<VulnerabilityOccurrenceFixability>>>;
  dynamicRiskLevelIn?: Maybe<Array<Maybe<DynamicRiskLevel>>>;
  cvssScoreMin?: Maybe<Scalars['Float']>;
  cvssScoreMax?: Maybe<Scalars['Float']>;
  epssScoreMin?: Maybe<Scalars['Float']>;
  epssScoreMax?: Maybe<Scalars['Float']>;
  epssPercentileMin?: Maybe<Scalars['Float']>;
  epssPercentileMax?: Maybe<Scalars['Float']>;
  q?: Maybe<Scalars['String']>;
};


/** A vulnerability. */
export type VulnerabilityFixPathsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** A vulnerability call stack. */
export type VulnerabilityCallStack = MaskPrimaryKeyNode & {
  __typename?: 'VulnerabilityCallStack';
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  /** The ID of the object */
  id: Scalars['ID'];
  /** The vulnerability occurrence associated with this call stack */
  vulnerabilityOccurrence: VulnerabilityOccurrence;
  frames: CallStackFrameConnection;
};


/** A vulnerability call stack. */
export type VulnerabilityCallStackFramesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type VulnerabilityCallStackConnection = {
  __typename?: 'VulnerabilityCallStackConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VulnerabilityCallStackEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `VulnerabilityCallStack` and its cursor. */
export type VulnerabilityCallStackEdge = {
  __typename?: 'VulnerabilityCallStackEdge';
  /** The item at the end of the edge */
  node?: Maybe<VulnerabilityCallStack>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type VulnerabilityConnection = {
  __typename?: 'VulnerabilityConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VulnerabilityEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Vulnerability` and its cursor. */
export type VulnerabilityEdge = {
  __typename?: 'VulnerabilityEdge';
  /** The item at the end of the edge */
  node?: Maybe<Vulnerability>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** An enumeration. */
export enum VulnerabilityNotificationThreshold {
  Low = 'LOW',
  Medium = 'MEDIUM',
  High = 'HIGH',
  Critical = 'CRITICAL'
}

/** A vulnerability occurrence. */
export type VulnerabilityOccurrence = MaskPrimaryKeyNode & {
  __typename?: 'VulnerabilityOccurrence';
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  /** The ID of the object */
  id: Scalars['ID'];
  /** Whether the vulnerability is suppressed */
  isSuppressed: Scalars['Boolean'];
  /** The reason why the vulnerability is suppressed */
  suppressionReason?: Maybe<Scalars['String']>;
  /** The reachability of the vulnerability occurrence */
  reachability: VulnerabilityOccurrenceReachability;
  /** The fixability of the vulnerability occurrence */
  fixability: VulnerabilityOccurrenceFixability;
  /**
   * Overridden severity of the vulnerability occurrence
   * @deprecated Use `implied_severity` instead.
   */
  severity?: Maybe<VulnerabilitySeverity>;
  /** The SCA check associated with this vulnerability occurrence */
  scaCheck: ScaCheck;
  /** The check package associated with this vulnerability occurrence */
  checkPackage: CheckPackage;
  /** The repository target associated with this vulnerability occurrence */
  target: RepositoryTarget;
  /** The vulnerability associated with this occurrence */
  vulnerability: Vulnerability;
  callStacks: VulnerabilityCallStackConnection;
  repositoryPackages: RepositoryPackageConnection;
  /** The associated vulnerability occurrence */
  fixPaths: VulnerabilityRemediationFixPathConnection;
  package: Package;
  packageVersion: PackageVersion;
  latestRemediationPatchRun?: Maybe<VulnerabilityRemediationPatchRun>;
  dynamicRiskLevel?: Maybe<DynamicRiskLevel>;
  /** The dynamic risk score. */
  dynamicRiskScore?: Maybe<Scalars['Float']>;
  /** The implied severity of the vulnerability occurrence. */
  impliedSeverity: VulnerabilitySeverity;
  /** Whether the severity of the vulnerability occurrence is overridden. */
  isSeverityOverridden: Scalars['Boolean'];
};


/** A vulnerability occurrence. */
export type VulnerabilityOccurrenceCallStacksArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A vulnerability occurrence. */
export type VulnerabilityOccurrenceRepositoryPackagesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  packageType?: Maybe<PackageType>;
  q?: Maybe<Scalars['String']>;
  targetId?: Maybe<Scalars['ID']>;
  severityIn?: Maybe<Array<Maybe<VulnerabilitySeverity>>>;
  licenseSafetyIn?: Maybe<Array<Maybe<LicenseSafetyFilter>>>;
};


/** A vulnerability occurrence. */
export type VulnerabilityOccurrenceFixPathsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type VulnerabilityOccurrenceConnection = {
  __typename?: 'VulnerabilityOccurrenceConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VulnerabilityOccurrenceEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `VulnerabilityOccurrence` and its cursor. */
export type VulnerabilityOccurrenceEdge = {
  __typename?: 'VulnerabilityOccurrenceEdge';
  /** The item at the end of the edge */
  node?: Maybe<VulnerabilityOccurrence>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** The fixability type of the vulnerability occurrence */
export enum VulnerabilityOccurrenceFixability {
  Error = 'ERROR',
  Unfixable = 'UNFIXABLE',
  GeneratingFix = 'GENERATING_FIX',
  PossiblyFixable = 'POSSIBLY_FIXABLE',
  ManuallyFixable = 'MANUALLY_FIXABLE',
  AutoFixable = 'AUTO_FIXABLE'
}

/** The reachability type of the vulnerability occurrence */
export enum VulnerabilityOccurrenceReachability {
  Reachable = 'REACHABLE',
  Unreachable = 'UNREACHABLE',
  Unknown = 'UNKNOWN'
}

/** A reference URL for a vulnerability. */
export type VulnerabilityReferenceUrl = {
  __typename?: 'VulnerabilityReferenceUrl';
  category: Scalars['String'];
  url: Scalars['String'];
};

export type VulnerabilityRemediationFixPath = MaskPrimaryKeyNode & {
  __typename?: 'VulnerabilityRemediationFixPath';
  /** The ID of the object */
  id: Scalars['ID'];
  /** Whether this fix path is recommended for remediation */
  isRecommended: Scalars['Boolean'];
  /** The associated vulnerability occurrence */
  occurrence: VulnerabilityOccurrence;
  /** The associated fix path */
  packageUpdates: VulnerabilityRemediationFixPathUpdateConnection;
  latestRemediationPatchRun?: Maybe<VulnerabilityRemediationPatchRun>;
};


export type VulnerabilityRemediationFixPathPackageUpdatesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type VulnerabilityRemediationFixPathConnection = {
  __typename?: 'VulnerabilityRemediationFixPathConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VulnerabilityRemediationFixPathEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `VulnerabilityRemediationFixPath` and its cursor. */
export type VulnerabilityRemediationFixPathEdge = {
  __typename?: 'VulnerabilityRemediationFixPathEdge';
  /** The item at the end of the edge */
  node?: Maybe<VulnerabilityRemediationFixPath>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type VulnerabilityRemediationFixPathUpdate = MaskPrimaryKeyNode & {
  __typename?: 'VulnerabilityRemediationFixPathUpdate';
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  /** The ID of the object */
  id: Scalars['ID'];
  ecosystem: Ecosystem;
  /** The package to update */
  package: Scalars['String'];
  /** The version to update from */
  versionFrom: Scalars['String'];
  /** The version to update to */
  versionTo: Scalars['String'];
  /** The risk score of the version update */
  versionRiskScore: Scalars['Int'];
  /** The risk score of the dependency update */
  dependencyRiskScore: Scalars['Int'];
  /** The risk score of the compatibility update */
  compatibilityRiskScore: Scalars['Int'];
  /** The overall risk score of the update */
  overallRiskScore: Scalars['Int'];
  /** Whether AI overview is supported for this package upgrade. */
  isAiOverviewSupported: Scalars['Boolean'];
};

export type VulnerabilityRemediationFixPathUpdateConnection = {
  __typename?: 'VulnerabilityRemediationFixPathUpdateConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VulnerabilityRemediationFixPathUpdateEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `VulnerabilityRemediationFixPathUpdate` and its cursor. */
export type VulnerabilityRemediationFixPathUpdateEdge = {
  __typename?: 'VulnerabilityRemediationFixPathUpdateEdge';
  /** The item at the end of the edge */
  node?: Maybe<VulnerabilityRemediationFixPathUpdate>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type VulnerabilityRemediationPatchRun = MaskPrimaryKeyNode & {
  __typename?: 'VulnerabilityRemediationPatchRun';
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  /** The ID of the object */
  id: Scalars['ID'];
  runId: Scalars['UUID'];
  commitOid: Scalars['String'];
  createdCommitOid?: Maybe<Scalars['String']>;
  branchName?: Maybe<Scalars['String']>;
  branchToCommit?: Maybe<Scalars['String']>;
  status: VulnerabilityRemediationPatchRunStatus;
  finishedAt?: Maybe<Scalars['DateTime']>;
  errors?: Maybe<Scalars['JSONString']>;
  pullRequestNumber?: Maybe<Scalars['Int']>;
  pullRequestStatus: VulnerabilityRemediationPatchRunPullRequestStatus;
  committedToBranchStatus: VulnerabilityRemediationPatchRunCommittedToBranchStatus;
  extraData: Scalars['JSONString'];
  createdBy: User;
  repository: Repository;
  target: RepositoryTarget;
  /** The fix paths to apply */
  fixPaths: VulnerabilityRemediationFixPathConnection;
  /** Time in seconds to finish the run. */
  finishedIn?: Maybe<Scalars['Int']>;
  /** URL of the commit created by the run. */
  vcsCommitUrl?: Maybe<Scalars['String']>;
  /** URL of the PR created by the run. */
  vcsPrUrl?: Maybe<Scalars['String']>;
};


export type VulnerabilityRemediationPatchRunFixPathsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum VulnerabilityRemediationPatchRunCommittedToBranchStatus {
  /** Not committed */
  Ncm = 'NCM',
  /** Commit in progress */
  Cip = 'CIP',
  /** Committed */
  Ctd = 'CTD',
  /** Failed to commit */
  Ctf = 'CTF'
}

export type VulnerabilityRemediationPatchRunConnection = {
  __typename?: 'VulnerabilityRemediationPatchRunConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VulnerabilityRemediationPatchRunEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `VulnerabilityRemediationPatchRun` and its cursor. */
export type VulnerabilityRemediationPatchRunEdge = {
  __typename?: 'VulnerabilityRemediationPatchRunEdge';
  /** The item at the end of the edge */
  node?: Maybe<VulnerabilityRemediationPatchRun>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** An enumeration. */
export enum VulnerabilityRemediationPatchRunPullRequestStatus {
  /** Pull Request not created */
  Pnc = 'PNC',
  /** Pull Request in progress */
  Prp = 'PRP',
  /** Pull Request opened */
  Pro = 'PRO',
  /** Pull Request merged */
  Prm = 'PRM',
  /** Pull Request closed */
  Prc = 'PRC',
  /** Failed to create Pull Request */
  Prf = 'PRF'
}

/** An enumeration. */
export enum VulnerabilityRemediationPatchRunStatus {
  /** Pending */
  Pend = 'PEND',
  /** Success */
  Pass = 'PASS',
  /** Timed out */
  Timo = 'TIMO',
  /** Cancelled */
  Cncl = 'CNCL',
  /** Failure */
  Fail = 'FAIL',
  /** Stale */
  Stal = 'STAL'
}

/** The severity of the vulnerability. */
export enum VulnerabilitySeverity {
  None = 'NONE',
  Low = 'LOW',
  Medium = 'MEDIUM',
  High = 'HIGH',
  Critical = 'CRITICAL'
}

export type Webhook = MaskPrimaryKeyNode & {
  __typename?: 'Webhook';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  owner: Owner;
  url: Scalars['String'];
  secret: Scalars['String'];
  apiSigning: Scalars['Boolean'];
  eventsSubscribed: WebhookEventTypesConnection;
  version: Scalars['String'];
  active?: Maybe<Scalars['DateTime']>;
  deliveries: WebhookEventDeliveryConnection;
};


export type WebhookEventsSubscribedArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type WebhookDeliveriesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type WebhookConnection = {
  __typename?: 'WebhookConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WebhookEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Webhook` and its cursor. */
export type WebhookEdge = {
  __typename?: 'WebhookEdge';
  /** The item at the end of the edge */
  node?: Maybe<Webhook>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type WebhookEventDelivery = MaskPrimaryKeyNode & {
  __typename?: 'WebhookEventDelivery';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  deliveryId?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  httpStatusCode?: Maybe<Scalars['Int']>;
  retryCount?: Maybe<Scalars['Int']>;
  webhook: Webhook;
  eventType: WebhookEventTypes;
  payload?: Maybe<Scalars['GenericScalar']>;
  finishedIn?: Maybe<Scalars['Float']>;
};

export type WebhookEventDeliveryConnection = {
  __typename?: 'WebhookEventDeliveryConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WebhookEventDeliveryEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `WebhookEventDelivery` and its cursor. */
export type WebhookEventDeliveryEdge = {
  __typename?: 'WebhookEventDeliveryEdge';
  /** The item at the end of the edge */
  node?: Maybe<WebhookEventDelivery>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type WebhookEventTypes = MaskPrimaryKeyNode & {
  __typename?: 'WebhookEventTypes';
  /** The ID of the object */
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  alive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  shortcode: Scalars['String'];
  shortDescription: Scalars['String'];
  isPrivate: Scalars['Boolean'];
  webhooks: WebhookConnection;
  deliveries: WebhookEventDeliveryConnection;
};


export type WebhookEventTypesWebhooksArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type WebhookEventTypesDeliveriesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type WebhookEventTypesConnection = {
  __typename?: 'WebhookEventTypesConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WebhookEventTypesEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `WebhookEventTypes` and its cursor. */
export type WebhookEventTypesEdge = {
  __typename?: 'WebhookEventTypesEdge';
  /** The item at the end of the edge */
  node?: Maybe<WebhookEventTypes>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type ExportAuditLogsMutationVariables = Exact<{
  input: ExportAuditLogsInput;
}>;


export type ExportAuditLogsMutation = (
  { __typename?: 'Mutation' }
  & { exportAuditLogs?: Maybe<(
    { __typename?: 'ExportAuditLogsPayload' }
    & Pick<ExportAuditLogsPayload, 'ok'>
  )> }
);

export type DeleteRefreshTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteRefreshTokenMutation = (
  { __typename?: 'Mutation' }
  & { deleteRefreshTokenCookie?: Maybe<(
    { __typename?: 'DeleteRefreshTokenCookie' }
    & Pick<DeleteRefreshTokenCookie, 'deleted'>
  )> }
);

export type DeleteTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteTokenMutation = (
  { __typename?: 'Mutation' }
  & { deleteTokenCookie?: Maybe<(
    { __typename?: 'DeleteJSONWebTokenCookie' }
    & Pick<DeleteJsonWebTokenCookie, 'deleted'>
  )> }
);

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = (
  { __typename?: 'Mutation' }
  & { logout?: Maybe<(
    { __typename?: 'LogOutPayload' }
    & Pick<LogOutPayload, 'ok'>
  )> }
);

export type RefreshTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshTokenMutation = (
  { __typename?: 'Mutation' }
  & { refreshToken?: Maybe<(
    { __typename?: 'RefreshToken' }
    & Pick<RefreshToken, 'token'>
  )> }
);

export type SocialAuthMutationVariables = Exact<{
  code: Scalars['String'];
  provider: Scalars['String'];
  appId?: Maybe<Scalars['String']>;
}>;


export type SocialAuthMutation = (
  { __typename?: 'Mutation' }
  & { socialAuth?: Maybe<(
    { __typename?: 'SocialAuthJWT' }
    & Pick<SocialAuthJwt, 'token' | 'tokenExpiresIn' | 'refreshToken' | 'refreshExpiresIn'>
  )> }
);

export type CommitFixToPullRequestMutationVariables = Exact<{
  input: CommitChangesToPrInput;
}>;


export type CommitFixToPullRequestMutation = (
  { __typename?: 'Mutation' }
  & { commitChangesToPr?: Maybe<(
    { __typename?: 'CommitChangesToPRPayload' }
    & Pick<CommitChangesToPrPayload, 'ok'>
  )> }
);

export type CreateAutofixRunForPullRequestMutationVariables = Exact<{
  input: CreateAutofixRunForPullRequestInput;
}>;


export type CreateAutofixRunForPullRequestMutation = (
  { __typename?: 'Mutation' }
  & { createAutofixRunForPullRequest?: Maybe<(
    { __typename?: 'CreateAutofixRunForPullRequestPayload' }
    & Pick<CreateAutofixRunForPullRequestPayload, 'autofixRunId'>
  )> }
);

export type CreatePullRequestMutationVariables = Exact<{
  input: CreatePullRequestInput;
}>;


export type CreatePullRequestMutation = (
  { __typename?: 'Mutation' }
  & { createdPullRequest?: Maybe<(
    { __typename?: 'CreatePullRequestPayload' }
    & Pick<CreatePullRequestPayload, 'ok'>
  )> }
);

export type VerifyDeviceMutationVariables = Exact<{
  input: VerifyDeviceInput;
}>;


export type VerifyDeviceMutation = (
  { __typename?: 'Mutation' }
  & { verifyDevice?: Maybe<(
    { __typename?: 'VerifyDevicePayload' }
    & Pick<VerifyDevicePayload, 'ok'>
  )> }
);

export type AcceptGroupInviteMutationVariables = Exact<{
  invitationCode: Scalars['String'];
}>;


export type AcceptGroupInviteMutation = (
  { __typename?: 'Mutation' }
  & { acceptGroupInvite?: Maybe<(
    { __typename?: 'AcceptGroupInvitePayload' }
    & Pick<AcceptGroupInvitePayload, 'ok'>
  )> }
);

export type AddTeamToGroupMutationVariables = Exact<{
  groupId: Scalars['ID'];
  teamId: Scalars['ID'];
  role?: Maybe<TeamMemberRoleChoices>;
}>;


export type AddTeamToGroupMutation = (
  { __typename?: 'Mutation' }
  & { addTeamToGroup?: Maybe<(
    { __typename?: 'AddTeamToGroupPayload' }
    & Pick<AddTeamToGroupPayload, 'ok'>
  )> }
);

export type CreateGroupMutationVariables = Exact<{
  groupName: Scalars['String'];
}>;


export type CreateGroupMutation = (
  { __typename?: 'Mutation' }
  & { createGroup?: Maybe<(
    { __typename?: 'CreateGroupPayload' }
    & { group?: Maybe<(
      { __typename?: 'EnterpriseGroup' }
      & Pick<EnterpriseGroup, 'id'>
    )> }
  )> }
);

export type DeleteGroupMutationVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type DeleteGroupMutation = (
  { __typename?: 'Mutation' }
  & { deleteGroup?: Maybe<(
    { __typename?: 'DeleteGroupPayload' }
    & Pick<DeleteGroupPayload, 'ok'>
  )> }
);

export type DeleteUserMutationVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type DeleteUserMutation = (
  { __typename?: 'Mutation' }
  & { deleteUser?: Maybe<(
    { __typename?: 'DeleteUserPayload' }
    & Pick<DeleteUserPayload, 'ok'>
  )> }
);

export type RemoveTeamFromGroupMutationVariables = Exact<{
  groupId: Scalars['ID'];
  teamId: Scalars['ID'];
}>;


export type RemoveTeamFromGroupMutation = (
  { __typename?: 'Mutation' }
  & { removeTeamFromGroup?: Maybe<(
    { __typename?: 'RemoveTeamFromGroupPayload' }
    & Pick<RemoveTeamFromGroupPayload, 'ok'>
  )> }
);

export type RemoveUserFromGroupMutationVariables = Exact<{
  groupId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type RemoveUserFromGroupMutation = (
  { __typename?: 'Mutation' }
  & { removeUserFromGroup?: Maybe<(
    { __typename?: 'RemoveUserFromGroupPayload' }
    & Pick<RemoveUserFromGroupPayload, 'ok'>
  )> }
);

export type ResetGroupInviteMutationVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type ResetGroupInviteMutation = (
  { __typename?: 'Mutation' }
  & { resetGroupInvitationLink?: Maybe<(
    { __typename?: 'ResetGroupInvitationLinkPayload' }
    & Pick<ResetGroupInvitationLinkPayload, 'invitationUrl'>
  )> }
);

export type ToggleUserActiveMutationVariables = Exact<{
  userId: Scalars['ID'];
  isActive: Scalars['Boolean'];
}>;


export type ToggleUserActiveMutation = (
  { __typename?: 'Mutation' }
  & { toggleUserActive?: Maybe<(
    { __typename?: 'ToggleUserActivePayload' }
    & Pick<ToggleUserActivePayload, 'ok'>
  )> }
);

export type UpdateGroupMutationVariables = Exact<{
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
}>;


export type UpdateGroupMutation = (
  { __typename?: 'Mutation' }
  & { updateGroup?: Maybe<(
    { __typename?: 'UpdateGroupPayload' }
    & Pick<UpdateGroupPayload, 'ok'>
  )> }
);

export type UpdateGroupTeamRoleMutationVariables = Exact<{
  groupId: Scalars['ID'];
  teamId: Scalars['ID'];
  role?: Maybe<TeamMemberRoleChoices>;
}>;


export type UpdateGroupTeamRoleMutation = (
  { __typename?: 'Mutation' }
  & { updateGroupTeamRole?: Maybe<(
    { __typename?: 'UpdateGroupTeamRolePayload' }
    & Pick<UpdateGroupTeamRolePayload, 'ok'>
  )> }
);

export type ExportSbomForTargetMutationVariables = Exact<{
  targetId: Scalars['ID'];
}>;


export type ExportSbomForTargetMutation = (
  { __typename?: 'Mutation' }
  & { exportRepositoryTargetSbom?: Maybe<(
    { __typename?: 'ExportRepositoryTargetSBOMPayload' }
    & Pick<ExportRepositoryTargetSbomPayload, 'ok' | 'clientMutationId'>
  )> }
);

export type ExportVulnerabilitiesMutationVariables = Exact<{
  objectId: Scalars['ID'];
  format: ExportFormat;
}>;


export type ExportVulnerabilitiesMutation = (
  { __typename?: 'Mutation' }
  & { exportVulnerabilityOccurrences?: Maybe<(
    { __typename?: 'ExportVulnerabilityOccurrencesPayload' }
    & Pick<ExportVulnerabilityOccurrencesPayload, 'ok' | 'clientMutationId'>
  )> }
);

export type ActivateRepositoryTargetMutationVariables = Exact<{
  input: ActivateRepositoryTargetInput;
}>;


export type ActivateRepositoryTargetMutation = (
  { __typename?: 'Mutation' }
  & { activateRepositoryTarget?: Maybe<(
    { __typename?: 'ActivateRepositoryTargetPayload' }
    & Pick<ActivateRepositoryTargetPayload, 'ok'>
  )> }
);

export type CreateRemediationPatchMutationVariables = Exact<{
  fixPathId: Scalars['ID'];
}>;


export type CreateRemediationPatchMutation = (
  { __typename?: 'Mutation' }
  & { createRemediationPatchForVulnerabilityOccurrence?: Maybe<(
    { __typename?: 'CreateRemediationPatchForVulnerabilityOccurrencePayload' }
    & Pick<CreateRemediationPatchForVulnerabilityOccurrencePayload, 'ok'>
  )> }
);

export type CreateRepositoryTargetMutationVariables = Exact<{
  input: CreateRepositoryTargetInput;
}>;


export type CreateRepositoryTargetMutation = (
  { __typename?: 'Mutation' }
  & { createRepositoryTarget?: Maybe<(
    { __typename?: 'CreateRepositoryTargetPayload' }
    & { repositoryTarget?: Maybe<(
      { __typename?: 'RepositoryTarget' }
      & Pick<RepositoryTarget, 'packageManager' | 'manifestPath' | 'lockfilePath' | 'ecosystem'>
    )> }
  )> }
);

export type DeactivateRepositoryTargetMutationVariables = Exact<{
  input: DeactivateRepositoryTargetInput;
}>;


export type DeactivateRepositoryTargetMutation = (
  { __typename?: 'Mutation' }
  & { deactivateRepositoryTarget?: Maybe<(
    { __typename?: 'DeactivateRepositoryTargetPayload' }
    & Pick<DeactivateRepositoryTargetPayload, 'ok'>
  )> }
);

export type DeleteRepositoryTargetMutationVariables = Exact<{
  input: DeleteRepositoryTargetInput;
}>;


export type DeleteRepositoryTargetMutation = (
  { __typename?: 'Mutation' }
  & { deleteRepositoryTarget?: Maybe<(
    { __typename?: 'DeleteRepositoryTargetPayload' }
    & Pick<DeleteRepositoryTargetPayload, 'ok'>
  )> }
);

export type GeneratePackageUpgradeSummaryMutationVariables = Exact<{
  ecosystem: Ecosystem;
  packageName: Scalars['String'];
  fromVersion: Scalars['String'];
  toVersion: Scalars['String'];
  ownerId: Scalars['ID'];
}>;


export type GeneratePackageUpgradeSummaryMutation = (
  { __typename?: 'Mutation' }
  & { generatePackageUpgradeSummary?: Maybe<(
    { __typename?: 'GeneratePackageUpgradeSummaryPayload' }
    & Pick<GeneratePackageUpgradeSummaryPayload, 'isGenerated'>
    & { summary?: Maybe<(
      { __typename?: 'PackageUpgradeSummary' }
      & Pick<PackageUpgradeSummary, 'id' | 'ecosystem' | 'packageName' | 'fromVersion' | 'toVersion' | 'breakageRisk' | 'breakingChanges' | 'otherChanges' | 'urls'>
    )> }
  )> }
);

export type SyncRepositoryTargetsMutationVariables = Exact<{
  input: SyncRepositoryTargetsInput;
}>;


export type SyncRepositoryTargetsMutation = (
  { __typename?: 'Mutation' }
  & { syncRepositoryTargets?: Maybe<(
    { __typename?: 'SyncRepositoryTargetsPayload' }
    & Pick<SyncRepositoryTargetsPayload, 'ok'>
  )> }
);

export type TriggerRemediationRunMutationVariables = Exact<{
  occurrenceId: Scalars['ID'];
}>;


export type TriggerRemediationRunMutation = (
  { __typename?: 'Mutation' }
  & { triggerRemediationRun?: Maybe<(
    { __typename?: 'TriggerRemediationRunPayload' }
    & Pick<TriggerRemediationRunPayload, 'ok'>
  )> }
);

export type UpdateRepositoryTargetMutationVariables = Exact<{
  input: UpdateRepositoryTargetInput;
}>;


export type UpdateRepositoryTargetMutation = (
  { __typename?: 'Mutation' }
  & { updateRepositoryTarget?: Maybe<(
    { __typename?: 'UpdateRepositoryTargetPayload' }
    & Pick<UpdateRepositoryTargetPayload, 'ok'>
    & { target: (
      { __typename?: 'RepositoryTarget' }
      & Pick<RepositoryTarget, 'id' | 'packageManager' | 'manifestPath' | 'lockfilePath'>
    ) }
  )> }
);

export type AddRepositoriesToGroupMutationVariables = Exact<{
  input: AddRepositoriesToRepositoryGroupInput;
}>;


export type AddRepositoriesToGroupMutation = (
  { __typename?: 'Mutation' }
  & { addRepositoriesToRepositoryGroup?: Maybe<(
    { __typename?: 'AddRepositoriesToRepositoryGroupPayload' }
    & Pick<AddRepositoriesToRepositoryGroupPayload, 'ok' | 'clientMutationId'>
  )> }
);

export type CreateRepositoryGroupMutationVariables = Exact<{
  name: Scalars['String'];
  ownerId: Scalars['ID'];
}>;


export type CreateRepositoryGroupMutation = (
  { __typename?: 'Mutation' }
  & { createRepositoryGroup?: Maybe<(
    { __typename?: 'CreateRepositoryGroupPayload' }
    & Pick<CreateRepositoryGroupPayload, 'ok'>
  )> }
);

export type DeleteRepositoryGroupMutationVariables = Exact<{
  repositoryGroupId: Scalars['ID'];
}>;


export type DeleteRepositoryGroupMutation = (
  { __typename?: 'Mutation' }
  & { deleteRepositoryGroup?: Maybe<(
    { __typename?: 'DeleteRepositoryGroupPayload' }
    & Pick<DeleteRepositoryGroupPayload, 'ok'>
  )> }
);

export type GenerateRepositoryGroupSshKeyMutationVariables = Exact<{
  input: GenerateKeyPairForRepositoryGroupInput;
}>;


export type GenerateRepositoryGroupSshKeyMutation = (
  { __typename?: 'Mutation' }
  & { generateKeyPairForRepositoryGroup?: Maybe<(
    { __typename?: 'GenerateKeyPairForRepositoryGroupPayload' }
    & Pick<GenerateKeyPairForRepositoryGroupPayload, 'ok' | 'clientMutationId'>
  )> }
);

export type RemoveKeyPairForRepositoryGroupMutationVariables = Exact<{
  input: RemoveKeyPairForRepositoryGroupInput;
}>;


export type RemoveKeyPairForRepositoryGroupMutation = (
  { __typename?: 'Mutation' }
  & { removeKeyPairForRepositoryGroup?: Maybe<(
    { __typename?: 'RemoveKeyPairForRepositoryGroupPayload' }
    & Pick<RemoveKeyPairForRepositoryGroupPayload, 'ok' | 'clientMutationId'>
  )> }
);

export type RemoveRepositoriesFromGroupMutationVariables = Exact<{
  repositoryGroupId: Scalars['ID'];
  repositoryIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RemoveRepositoriesFromGroupMutation = (
  { __typename?: 'Mutation' }
  & { removeRepositoriesFromRepositoryGroup?: Maybe<(
    { __typename?: 'RemoveRepositoriesFromRepositoryGroupPayload' }
    & Pick<RemoveRepositoriesFromRepositoryGroupPayload, 'ok'>
  )> }
);

export type UpdateGroupNameAndLeadMutationVariables = Exact<{
  repositoryGroupId: Scalars['ID'];
  name: Scalars['String'];
  leadUserId: Scalars['ID'];
}>;


export type UpdateGroupNameAndLeadMutation = (
  { __typename?: 'Mutation' }
  & { updateName?: Maybe<(
    { __typename?: 'UpdateRepositoryGroupSettingsPayload' }
    & Pick<UpdateRepositoryGroupSettingsPayload, 'ok'>
  )>, updateLead?: Maybe<(
    { __typename?: 'UpdateRepositoryGroupLeadPayload' }
    & Pick<UpdateRepositoryGroupLeadPayload, 'ok'>
  )> }
);

export type UpdateRepositoryGroupSettingsMutationVariables = Exact<{
  input: UpdateRepositoryGroupSettingsInput;
}>;


export type UpdateRepositoryGroupSettingsMutation = (
  { __typename?: 'Mutation' }
  & { updateRepositoryGroupSettings?: Maybe<(
    { __typename?: 'UpdateRepositoryGroupSettingsPayload' }
    & Pick<UpdateRepositoryGroupSettingsPayload, 'ok' | 'clientMutationId'>
  )> }
);

export type UpdateRepositoryGroupOverrideSettingMutationVariables = Exact<{
  repositoryGroupId: Scalars['ID'];
  overrideRepoSetting: Scalars['Boolean'];
}>;


export type UpdateRepositoryGroupOverrideSettingMutation = (
  { __typename?: 'Mutation' }
  & { updateRepositoryGroupSettings?: Maybe<(
    { __typename?: 'UpdateRepositoryGroupSettingsPayload' }
    & Pick<UpdateRepositoryGroupSettingsPayload, 'ok' | 'clientMutationId'>
  )> }
);

export type UpdateRepositoryGroupQualityGatesSettingsMutationVariables = Exact<{
  repositoryGroupId: Scalars['ID'];
  issueTypeSettings?: Maybe<Array<Maybe<IssueTypeSettingInput>> | Maybe<IssueTypeSettingInput>>;
  issueSeveritySettings?: Maybe<Array<Maybe<IssueSeveritySettingInput>> | Maybe<IssueSeveritySettingInput>>;
  metricSettings?: Maybe<Array<Maybe<RepositoryGroupMetricSettingsInput>> | Maybe<RepositoryGroupMetricSettingsInput>>;
  gitlabIntegrationUseStatus?: Maybe<Scalars['Boolean']>;
}>;


export type UpdateRepositoryGroupQualityGatesSettingsMutation = (
  { __typename?: 'Mutation' }
  & { updateRepositoryGroupSettings?: Maybe<(
    { __typename?: 'UpdateRepositoryGroupSettingsPayload' }
    & Pick<UpdateRepositoryGroupSettingsPayload, 'ok'>
  )> }
);

export type UpdateRepositoryGroupVcsReportingOptionsMutationVariables = Exact<{
  repositoryGroupId: Scalars['ID'];
  vcsReportingOptions: Array<VcsReportingChoices> | VcsReportingChoices;
}>;


export type UpdateRepositoryGroupVcsReportingOptionsMutation = (
  { __typename?: 'Mutation' }
  & { updateRepositoryGroupVcsReportingOptionsEnabled?: Maybe<(
    { __typename?: 'UpdateRepositoryGroupVCSReportingOptionsEnabledPayload' }
    & Pick<UpdateRepositoryGroupVcsReportingOptionsEnabledPayload, 'ok'>
  )> }
);

export type UpdateGroupPinnedReportsMutationVariables = Exact<{
  input: UpdateRepositoryGroupPinnedReportsInput;
}>;


export type UpdateGroupPinnedReportsMutation = (
  { __typename?: 'Mutation' }
  & { updateRepositoryGroupPinnedReports?: Maybe<(
    { __typename?: 'UpdateRepositoryGroupPinnedReportsPayload' }
    & Pick<UpdateRepositoryGroupPinnedReportsPayload, 'ok'>
  )> }
);

export type AdsInstallationLandingMutationVariables = Exact<{
  input: AdsInstallationLandingInput;
}>;


export type AdsInstallationLandingMutation = (
  { __typename?: 'Mutation' }
  & { adsInstallationLanding?: Maybe<(
    { __typename?: 'ADSInstallationLandingPayload' }
    & Pick<AdsInstallationLandingPayload, 'ok'>
  )> }
);

export type BitbucketDatacenterInstallationLandingMutationVariables = Exact<{
  input: BitbucketDataCenterInstallationLandingInput;
}>;


export type BitbucketDatacenterInstallationLandingMutation = (
  { __typename?: 'Mutation' }
  & { bitbucketDatacenterInstallationLanding?: Maybe<(
    { __typename?: 'BitbucketDataCenterInstallationLandingPayload' }
    & Pick<BitbucketDataCenterInstallationLandingPayload, 'ok'>
  )> }
);

export type BitbucketInstallationLandingMutationVariables = Exact<{
  input: BitbucketInstallationLandingInput;
}>;


export type BitbucketInstallationLandingMutation = (
  { __typename?: 'Mutation' }
  & { bitbucketInstallationLanding?: Maybe<(
    { __typename?: 'BitbucketInstallationLandingPayload' }
    & Pick<BitbucketInstallationLandingPayload, 'nextAction' | 'message' | 'vcsProvider' | 'login'>
  )> }
);

export type GithubEnterpriseInstallationLandingMutationVariables = Exact<{
  input: GithubEnterpriseInstallationLandingInput;
}>;


export type GithubEnterpriseInstallationLandingMutation = (
  { __typename?: 'Mutation' }
  & { gheInstallationLanding?: Maybe<(
    { __typename?: 'GithubEnterpriseInstallationLandingPayload' }
    & Pick<GithubEnterpriseInstallationLandingPayload, 'nextAction' | 'message' | 'vcsProvider' | 'login'>
  )> }
);

export type GithubInstallationLandingMutationVariables = Exact<{
  input: GithubInstallationLandingInput;
}>;


export type GithubInstallationLandingMutation = (
  { __typename?: 'Mutation' }
  & { installation?: Maybe<(
    { __typename?: 'GithubInstallationLandingPayload' }
    & Pick<GithubInstallationLandingPayload, 'nextAction' | 'message' | 'vcsProvider' | 'login'>
  )> }
);

export type GitlabInstallationLandingMutationVariables = Exact<{
  input: GitlabInstallationLandingInput;
}>;


export type GitlabInstallationLandingMutation = (
  { __typename?: 'Mutation' }
  & { gitlabInstallationLanding?: Maybe<(
    { __typename?: 'GitlabInstallationLandingPayload' }
    & Pick<GitlabInstallationLandingPayload, 'ok'>
  )> }
);

export type CreateIssueOnIntegrationMutationVariables = Exact<{
  input: CreateIssueOnIntegrationInput;
}>;


export type CreateIssueOnIntegrationMutation = (
  { __typename?: 'Mutation' }
  & { createIssueOnIntegration?: Maybe<(
    { __typename?: 'CreateIssueOnIntegrationPayload' }
    & Pick<CreateIssueOnIntegrationPayload, 'ok' | 'issueCode' | 'issueUrl'>
  )> }
);

export type GetIntegrationInstallationUrlMutationVariables = Exact<{
  input: GetIntegrationInstallationUrlInput;
}>;


export type GetIntegrationInstallationUrlMutation = (
  { __typename?: 'Mutation' }
  & { getIntegrationInstallationUrl?: Maybe<(
    { __typename?: 'GetIntegrationInstallationURLPayload' }
    & Pick<GetIntegrationInstallationUrlPayload, 'url'>
  )> }
);

export type InstallIntegrationMutationVariables = Exact<{
  input: InstallIntegrationInput;
}>;


export type InstallIntegrationMutation = (
  { __typename?: 'Mutation' }
  & { installIntegration?: Maybe<(
    { __typename?: 'InstallIntegrationPayload' }
    & Pick<InstallIntegrationPayload, 'nextStep' | 'options' | 'installingOn'>
  )> }
);

export type UninstallIntegrationMutationVariables = Exact<{
  input: UninstallIntegrationInput;
}>;


export type UninstallIntegrationMutation = (
  { __typename?: 'Mutation' }
  & { uninstallIntegration?: Maybe<(
    { __typename?: 'UninstallIntegrationPayload' }
    & Pick<UninstallIntegrationPayload, 'ok'>
  )> }
);

export type UpdateIntegrationSettingsMutationVariables = Exact<{
  input: UpdateIntegrationSettingsInput;
}>;


export type UpdateIntegrationSettingsMutation = (
  { __typename?: 'Mutation' }
  & { updateIntegrationSettings?: Maybe<(
    { __typename?: 'UpdateIntegrationSettingsPayload' }
    & Pick<UpdateIntegrationSettingsPayload, 'ok'>
  )> }
);

export type ConfirmInvitationMutationVariables = Exact<{
  invitationCode: Scalars['String'];
}>;


export type ConfirmInvitationMutation = (
  { __typename?: 'Mutation' }
  & { confirmInvitation?: Maybe<(
    { __typename?: 'ConfirmInvitationPayload' }
    & Pick<ConfirmInvitationPayload, 'ok' | 'message' | 'joined'>
  )> }
);

export type CreateAutofixRunMutationVariables = Exact<{
  input: CreateAutofixRunInput;
}>;


export type CreateAutofixRunMutation = (
  { __typename?: 'Mutation' }
  & { createAutofixRun?: Maybe<(
    { __typename?: 'CreateAutofixRunPayload' }
    & Pick<CreateAutofixRunPayload, 'runId'>
  )> }
);

export type IgnoreAiReviewIssueMutationVariables = Exact<{
  input: IgnoreAiReviewIssueInput;
}>;


export type IgnoreAiReviewIssueMutation = (
  { __typename?: 'Mutation' }
  & { ignoreAiReviewIssue?: Maybe<(
    { __typename?: 'IgnoreAIReviewIssuePayload' }
    & Pick<IgnoreAiReviewIssuePayload, 'ok'>
  )> }
);

export type IgnoreCheckIssueMutationVariables = Exact<{
  input: IgnoreCheckIssueInput;
}>;


export type IgnoreCheckIssueMutation = (
  { __typename?: 'Mutation' }
  & { ignoreCheckIssue?: Maybe<(
    { __typename?: 'IgnoreCheckIssuePayload' }
    & Pick<IgnoreCheckIssuePayload, 'ok'>
  )> }
);

export type ReportFalsePositiveMutationVariables = Exact<{
  input: ReportIssueFalsePositiveInput;
}>;


export type ReportFalsePositiveMutation = (
  { __typename?: 'Mutation' }
  & { reportIssueFalsePositive?: Maybe<(
    { __typename?: 'ReportIssueFalsePositivePayload' }
    & Pick<ReportIssueFalsePositivePayload, 'ok'>
  )> }
);

export type IgnoreIssueFilePatternMutationVariables = Exact<{
  repositoryId?: Maybe<Scalars['ID']>;
  checkId?: Maybe<Scalars['ID']>;
  pattern: Scalars['String'];
  issueShortcode?: Maybe<Scalars['String']>;
  alsoCreateRule?: Maybe<Scalars['Boolean']>;
}>;


export type IgnoreIssueFilePatternMutation = (
  { __typename?: 'Mutation' }
  & { ignoreIssueForFilePatternInRepository?: Maybe<(
    { __typename?: 'IgnoreIssueForFilePatternInRepositoryPayload' }
    & Pick<IgnoreIssueForFilePatternInRepositoryPayload, 'ok' | 'checkIssueIds' | 'ruleAlreadyExisted'>
  )> }
);

export type IgnoreIssueForFileMutationVariables = Exact<{
  repositoryId?: Maybe<Scalars['ID']>;
  checkId?: Maybe<Scalars['ID']>;
  filePath?: Maybe<Scalars['String']>;
  issueShortcode?: Maybe<Scalars['String']>;
  alsoCreateRule?: Maybe<Scalars['Boolean']>;
}>;


export type IgnoreIssueForFileMutation = (
  { __typename?: 'Mutation' }
  & { ignoreIssueForRepository?: Maybe<(
    { __typename?: 'IgnoreIssueForRepositoryPayload' }
    & Pick<IgnoreIssueForRepositoryPayload, 'ok' | 'checkIssueIds' | 'ruleAlreadyExisted'>
  )> }
);

export type IgnoreIssueRepositoryMutationVariables = Exact<{
  repositoryId?: Maybe<Scalars['ID']>;
  checkId?: Maybe<Scalars['ID']>;
  issueShortcode?: Maybe<Scalars['String']>;
  alsoCreateRule?: Maybe<Scalars['Boolean']>;
}>;


export type IgnoreIssueRepositoryMutation = (
  { __typename?: 'Mutation' }
  & { ignoreIssueForRepository?: Maybe<(
    { __typename?: 'IgnoreIssueForRepositoryPayload' }
    & Pick<IgnoreIssueForRepositoryPayload, 'ok' | 'checkIssueIds' | 'ruleAlreadyExisted'>
  )> }
);

export type IgnoreIssueTestPatternMutationVariables = Exact<{
  repositoryId?: Maybe<Scalars['ID']>;
  checkId?: Maybe<Scalars['ID']>;
  issueShortcode?: Maybe<Scalars['String']>;
  alsoCreateRule?: Maybe<Scalars['Boolean']>;
}>;


export type IgnoreIssueTestPatternMutation = (
  { __typename?: 'Mutation' }
  & { ignoreIssueForTestPatternsInRepository?: Maybe<(
    { __typename?: 'IgnoreIssueForTestPatternsInRepositoryPayload' }
    & Pick<IgnoreIssueForTestPatternsInRepositoryPayload, 'ok' | 'checkIssueIds' | 'ruleAlreadyExisted'>
  )> }
);

export type ReportAiReviewIssueFalsePositiveMutationVariables = Exact<{
  input: ReportAiReviewIssueFalsePositiveInput;
}>;


export type ReportAiReviewIssueFalsePositiveMutation = (
  { __typename?: 'Mutation' }
  & { reportAiReviewIssueFalsePositive?: Maybe<(
    { __typename?: 'ReportAIReviewIssueFalsePositivePayload' }
    & Pick<ReportAiReviewIssueFalsePositivePayload, 'ok'>
  )> }
);

export type GenerateRepositoryConfigMutationVariables = Exact<{
  repositoryId: Scalars['ID'];
}>;


export type GenerateRepositoryConfigMutation = (
  { __typename?: 'Mutation' }
  & { generateRepositoryConfig?: Maybe<(
    { __typename?: 'GenerateRepositoryConfigPayload' }
    & Pick<GenerateRepositoryConfigPayload, 'runId'>
  )> }
);

export type TriggerPullRequestRunMutationVariables = Exact<{
  repositoryId: Scalars['ID'];
  prNumber: Scalars['Int'];
}>;


export type TriggerPullRequestRunMutation = (
  { __typename?: 'Mutation' }
  & { triggerPullRequestRun?: Maybe<(
    { __typename?: 'TriggerPullRequestRunPayload' }
    & Pick<TriggerPullRequestRunPayload, 'ok' | 'errorMessage'>
    & { pr?: Maybe<(
      { __typename?: 'PR' }
      & Pick<Pr, 'id'>
    )> }
  )> }
);

export type UpdateOwnerProfileMutationVariables = Exact<{
  ownerId: Scalars['ID'];
  productInterests?: Maybe<Array<ProductInterestChoices> | ProductInterestChoices>;
}>;


export type UpdateOwnerProfileMutation = (
  { __typename?: 'Mutation' }
  & { updateOwnerProfile?: Maybe<(
    { __typename?: 'UpdateOwnerProfilePayload' }
    & Pick<UpdateOwnerProfilePayload, 'ok'>
    & { ownerProfile?: Maybe<(
      { __typename?: 'OwnerProfile' }
      & Pick<OwnerProfile, 'id' | 'productInterests'>
    )> }
  )> }
);

export type UpdateUserProfileMutationVariables = Exact<{
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  companySize?: Maybe<CompanySizeChoices>;
  role?: Maybe<RoleChoices>;
  referralSource?: Maybe<ReferralSourceChoices>;
  markCompleted?: Maybe<Scalars['Boolean']>;
}>;


export type UpdateUserProfileMutation = (
  { __typename?: 'Mutation' }
  & { updateUserProfile?: Maybe<(
    { __typename?: 'UpdateUserProfilePayload' }
    & Pick<UpdateUserProfilePayload, 'ok'>
    & { userProfile?: Maybe<(
      { __typename?: 'UserProfile' }
      & Pick<UserProfile, 'id' | 'firstName' | 'lastName' | 'company' | 'companySize' | 'role' | 'referralSource' | 'completedAt'>
    )> }
  )> }
);

export type ApplyCreditsToOwnerMutationVariables = Exact<{
  ownerId: Scalars['ID'];
  amount: Scalars['Int'];
}>;


export type ApplyCreditsToOwnerMutation = (
  { __typename?: 'Mutation' }
  & { applyCreditsToOwner?: Maybe<(
    { __typename?: 'ApplyCreditsToOwnerPayload' }
    & Pick<ApplyCreditsToOwnerPayload, 'ok' | 'availableCredits'>
  )> }
);

export type CancelPlanMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CancelPlanMutation = (
  { __typename?: 'Mutation' }
  & { cancelCodeQualitySubscription?: Maybe<(
    { __typename?: 'CancelCodeQualitySubscriptionPayload' }
    & Pick<CancelCodeQualitySubscriptionPayload, 'ok'>
  )> }
);

export type CancelUnifiedSubscriptionMutationVariables = Exact<{
  ownerId: Scalars['ID'];
}>;


export type CancelUnifiedSubscriptionMutation = (
  { __typename?: 'Mutation' }
  & { cancelUnifiedSubscription?: Maybe<(
    { __typename?: 'CancelUnifiedSubscriptionPayload' }
    & Pick<CancelUnifiedSubscriptionPayload, 'ok' | 'error'>
  )> }
);

export type ChangePlanMutationVariables = Exact<{
  id: Scalars['ID'];
  planSlug: Scalars['String'];
}>;


export type ChangePlanMutation = (
  { __typename?: 'Mutation' }
  & { subscriptionPlanSwitch?: Maybe<(
    { __typename?: 'SubscriptionPlanSwitchPayload' }
    & Pick<SubscriptionPlanSwitchPayload, 'ok'>
  )> }
);

export type CheckoutMutationVariables = Exact<{
  email: Scalars['String'];
  name: Scalars['String'];
  token: Scalars['String'];
  planSlug: Scalars['String'];
  seats: Scalars['Int'];
  coupon: Scalars['String'];
  installationId: Scalars['String'];
}>;


export type CheckoutMutation = (
  { __typename?: 'Mutation' }
  & { subscriptionCheckout?: Maybe<(
    { __typename?: 'SubscriptionCheckoutPayload' }
    & Pick<SubscriptionCheckoutPayload, 'nextAction' | 'clientSecret'>
  )> }
);

export type CreateBillingPortalSessionMutationVariables = Exact<{
  ownerId: Scalars['ID'];
}>;


export type CreateBillingPortalSessionMutation = (
  { __typename?: 'Mutation' }
  & { createBillingPortalSession?: Maybe<(
    { __typename?: 'CreateBillingPortalSessionPayload' }
    & Pick<CreateBillingPortalSessionPayload, 'url'>
  )> }
);

export type CreateCheckoutSessionForUnifiedSubscriptionMutationVariables = Exact<{
  ownerId: Scalars['ID'];
  pricingPlan: UnifiedProductPlan;
  uiMode?: Maybe<Scalars['String']>;
  billingInterval?: Maybe<BillingInterval>;
}>;


export type CreateCheckoutSessionForUnifiedSubscriptionMutation = (
  { __typename?: 'Mutation' }
  & { createCheckoutSessionForUnifiedSubscription?: Maybe<(
    { __typename?: 'CreateCheckoutSessionForUnifiedSubscriptionPayload' }
    & Pick<CreateCheckoutSessionForUnifiedSubscriptionPayload, 'seats' | 'targetQuantity' | 'additionalTargetQuantity' | 'aiCredits' | 'checkoutSessionUrl' | 'checkoutSessionSecret'>
  )> }
);

export type CreateManualTopupMutationVariables = Exact<{
  ownerId: Scalars['ID'];
  amountCents: Scalars['Int'];
  paymentMethodId?: Maybe<Scalars['String']>;
}>;


export type CreateManualTopupMutation = (
  { __typename?: 'Mutation' }
  & { createManualTopup?: Maybe<(
    { __typename?: 'CreateManualTopupPayload' }
    & Pick<CreateManualTopupPayload, 'invoiceId' | 'amountCents' | 'status'>
  )> }
);

export type CreateSetupCheckoutSessionMutationVariables = Exact<{
  ownerId: Scalars['ID'];
}>;


export type CreateSetupCheckoutSessionMutation = (
  { __typename?: 'Mutation' }
  & { createSetupCheckoutSession?: Maybe<(
    { __typename?: 'CreateSetupCheckoutSessionPayload' }
    & Pick<CreateSetupCheckoutSessionPayload, 'clientSecret'>
  )> }
);

export type DetachSavedCardMutationVariables = Exact<{
  ownerId: Scalars['ID'];
  paymentMethodId: Scalars['String'];
}>;


export type DetachSavedCardMutation = (
  { __typename?: 'Mutation' }
  & { detachSavedCard?: Maybe<(
    { __typename?: 'DetachSavedCardPayload' }
    & Pick<DetachSavedCardPayload, 'ok'>
  )> }
);

export type DowngradeToFreePlanMutationVariables = Exact<{
  ownerId: Scalars['ID'];
}>;


export type DowngradeToFreePlanMutation = (
  { __typename?: 'Mutation' }
  & { downgradeToFreePlan?: Maybe<(
    { __typename?: 'DowngradeToFreePlanPayload' }
    & Pick<DowngradeToFreePlanPayload, 'ok' | 'error'>
  )> }
);

export type GenerateScaCheckoutUrlMutationVariables = Exact<{
  ownerId: Scalars['ID'];
  plan: ScaProductPlan;
  interval: BillingInterval;
}>;


export type GenerateScaCheckoutUrlMutation = (
  { __typename?: 'Mutation' }
  & { getSubscriptionCheckoutUrlForSca?: Maybe<(
    { __typename?: 'GetSubscriptionCheckoutURLForSCAPayload' }
    & Pick<GetSubscriptionCheckoutUrlForScaPayload, 'url'>
  )> }
);

export type GetSubscriptionManagementUrlForScaMutationVariables = Exact<{
  subscriptionId: Scalars['ID'];
  flow: BillingManagementFlow;
}>;


export type GetSubscriptionManagementUrlForScaMutation = (
  { __typename?: 'Mutation' }
  & { getSubscriptionManagementUrlForSca?: Maybe<(
    { __typename?: 'GetSubscriptionManagementURLForSCAPayload' }
    & Pick<GetSubscriptionManagementUrlForScaPayload, 'url'>
  )> }
);

export type GetBillingInfoMutationVariables = Exact<{
  productSlug: Scalars['String'];
  planSlug: Scalars['String'];
  quantity: Scalars['Int'];
  couponCode?: Maybe<Scalars['String']>;
  ownerId: Scalars['ID'];
  isTrial: Scalars['Boolean'];
}>;


export type GetBillingInfoMutation = (
  { __typename?: 'Mutation' }
  & { getBillingInfo?: Maybe<(
    { __typename?: 'GetBillingInfoPayload' }
    & Pick<GetBillingInfoPayload, 'amountPayableThisCycle' | 'amountPayableNextCycle' | 'nextBillingCycle' | 'netPayableThisCycle' | 'netPayableNextCycle'>
    & { discounts: (
      { __typename?: 'Discount' }
      & { credits?: Maybe<(
        { __typename?: 'CreditsInfo' }
        & Pick<CreditsInfo, 'isApplied' | 'currentCycleDiscount' | 'nextCycleDiscount'>
      )>, coupon?: Maybe<(
        { __typename?: 'CouponInfo' }
        & Pick<CouponInfo, 'isApplied' | 'currentCycleDiscount' | 'nextCycleDiscount' | 'description'>
      )> }
    ) }
  )> }
);

export type GetUpgradePlanInfoMutationVariables = Exact<{
  id: Scalars['ID'];
  planSlug: Scalars['String'];
}>;


export type GetUpgradePlanInfoMutation = (
  { __typename?: 'Mutation' }
  & { planInfo?: Maybe<(
    { __typename?: 'GetUpgradeCodeQualitySubscriptionPlanInfoPayload' }
    & Pick<GetUpgradeCodeQualitySubscriptionPlanInfoPayload, 'endingBalance' | 'upcomingBillAmount' | 'upcomingBillDate' | 'prorationAmount' | 'proratedForDays' | 'billedImmediately' | 'quantity'>
  )> }
);

export type MigrateToUnifiedBillingMutationVariables = Exact<{
  ownerId: Scalars['ID'];
  confirm: Scalars['Boolean'];
}>;


export type MigrateToUnifiedBillingMutation = (
  { __typename?: 'Mutation' }
  & { migrateToUnifiedBilling?: Maybe<(
    { __typename?: 'MigrateToUnifiedBillingPayload' }
    & Pick<MigrateToUnifiedBillingPayload, 'ok' | 'error'>
  )> }
);

export type RequestSlackConnectMutationVariables = Exact<{
  input: RequestSlackConnectInput;
}>;


export type RequestSlackConnectMutation = (
  { __typename?: 'Mutation' }
  & { requestSlackConnect?: Maybe<(
    { __typename?: 'RequestSlackConnectPayload' }
    & Pick<RequestSlackConnectPayload, 'ok'>
    & { slackConnectChannel?: Maybe<(
      { __typename?: 'SlackConnectChannelType' }
      & Pick<SlackConnectChannelType, 'status' | 'email'>
    )> }
  )> }
);

export type ResendSlackConnectInviteMutationVariables = Exact<{
  input: ResendSlackConnectInviteInput;
}>;


export type ResendSlackConnectInviteMutation = (
  { __typename?: 'Mutation' }
  & { resendSlackConnectInvite?: Maybe<(
    { __typename?: 'ResendSlackConnectInvitePayload' }
    & Pick<ResendSlackConnectInvitePayload, 'ok'>
  )> }
);

export type ResumePlanMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ResumePlanMutation = (
  { __typename?: 'Mutation' }
  & { revertSubscriptionCancellation?: Maybe<(
    { __typename?: 'RevertSubscriptionCancellationPayload' }
    & Pick<RevertSubscriptionCancellationPayload, 'ok'>
  )> }
);

export type ResumeUnifiedSubscriptionMutationVariables = Exact<{
  ownerId: Scalars['ID'];
}>;


export type ResumeUnifiedSubscriptionMutation = (
  { __typename?: 'Mutation' }
  & { resumeUnifiedSubscription?: Maybe<(
    { __typename?: 'ResumeUnifiedSubscriptionPayload' }
    & Pick<ResumeUnifiedSubscriptionPayload, 'ok' | 'error'>
  )> }
);

export type SetDefaultCardMutationVariables = Exact<{
  ownerId: Scalars['ID'];
  paymentMethodId: Scalars['String'];
}>;


export type SetDefaultCardMutation = (
  { __typename?: 'Mutation' }
  & { setDefaultCard?: Maybe<(
    { __typename?: 'SetDefaultCardPayload' }
    & Pick<SetDefaultCardPayload, 'ok'>
  )> }
);

export type UpdateAiPolicyMutationVariables = Exact<{
  ownerId: Scalars['ID'];
  policyInput: OwnerAiPolicyInput;
}>;


export type UpdateAiPolicyMutation = (
  { __typename?: 'Mutation' }
  & { updateOwnerAiPolicy?: Maybe<(
    { __typename?: 'UpdateOwnerAIPolicyPayload' }
    & Pick<UpdateOwnerAiPolicyPayload, 'ok'>
    & { aiPolicy: (
      { __typename?: 'OwnerAIPolicy' }
      & Pick<OwnerAiPolicy, 'id' | 'isAiAgentsEnabled' | 'useAiSecretsDetection' | 'useAiAutofix' | 'autoTriggerAiReview' | 'isAutofixCommitSuggestionsEnabled'>
    ) }
  )> }
);

export type UpdateLicensePolicyMutationVariables = Exact<{
  ownerId: Scalars['ID'];
  policyInput: OwnerLicensePolicyInput;
}>;


export type UpdateLicensePolicyMutation = (
  { __typename?: 'Mutation' }
  & { updateOwnerLicensePolicy?: Maybe<(
    { __typename?: 'UpdateOwnerLicenseSCAPolicyPayload' }
    & Pick<UpdateOwnerLicenseScaPolicyPayload, 'ok' | 'clientMutationId'>
    & { licensePolicy?: Maybe<(
      { __typename?: 'OwnerLicensePolicy' }
      & Pick<OwnerLicensePolicy, 'id' | 'isNonOsiApprovedSafe' | 'isNonFsfFreeLibreSafe' | 'isDeprecatedSafe' | 'customSafeLicenseIdentifiers' | 'customUnsafeLicenseIdentifiers'>
    )> }
  )> }
);

export type UpdateScaPolicyMutationVariables = Exact<{
  ownerId: Scalars['ID'];
  policyInput: OwnerScaPolicyInput;
}>;


export type UpdateScaPolicyMutation = (
  { __typename?: 'Mutation' }
  & { updateOwnerScaPolicy?: Maybe<(
    { __typename?: 'UpdateOwnerSCAPolicyPayload' }
    & Pick<UpdateOwnerScaPolicyPayload, 'ok'>
    & { scaPolicy?: Maybe<(
      { __typename?: 'OwnerSCAPolicy' }
      & Pick<OwnerScaPolicy, 'id' | 'blockPrs' | 'packageTypes' | 'packageGroups' | 'severity' | 'reachability' | 'fixability' | 'dynamicRisk' | 'cvssV4Min' | 'cvssV4Max' | 'cvssV3Min' | 'cvssV3Max' | 'cvssV2Min' | 'cvssV2Max' | 'epssScoreMin' | 'epssScoreMax'>
    )> }
  )> }
);

export type UpdateVulnerabilityNotificationSettingsMutationVariables = Exact<{
  ownerId: Scalars['ID'];
  alertAllAdmins?: Maybe<Scalars['Boolean']>;
  emails?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  threshold?: Maybe<VulnerabilityNotificationThreshold>;
}>;


export type UpdateVulnerabilityNotificationSettingsMutation = (
  { __typename?: 'Mutation' }
  & { updateVulnerabilityNotificationSettings?: Maybe<(
    { __typename?: 'UpdateVulnerabilityNotificationSettingsPayload' }
    & Pick<UpdateVulnerabilityNotificationSettingsPayload, 'ok'>
  )> }
);

export type AddIdentityProviderMutationVariables = Exact<{
  input: AddIdentityProviderInput;
}>;


export type AddIdentityProviderMutation = (
  { __typename?: 'Mutation' }
  & { addIdentityProvider?: Maybe<(
    { __typename?: 'AddIdentityProviderPayload' }
    & Pick<AddIdentityProviderPayload, 'ok'>
  )> }
);

export type DeleteIdentityProviderMutationVariables = Exact<{
  input: DeleteIdentityProviderInput;
}>;


export type DeleteIdentityProviderMutation = (
  { __typename?: 'Mutation' }
  & { deleteIdentityProvider?: Maybe<(
    { __typename?: 'DeleteIdentityProviderPayload' }
    & Pick<DeleteIdentityProviderPayload, 'ok'>
  )> }
);

export type GenerateKeyPairForOwnerMutationVariables = Exact<{
  ownerId: Scalars['ID'];
}>;


export type GenerateKeyPairForOwnerMutation = (
  { __typename?: 'Mutation' }
  & { generateKeyPairForOwner?: Maybe<(
    { __typename?: 'GenerateKeyPairForOwnerPayload' }
    & Pick<GenerateKeyPairForOwnerPayload, 'publicKey'>
  )> }
);

export type RemoveKeyPairForOwnerMutationVariables = Exact<{
  ownerId: Scalars['ID'];
}>;


export type RemoveKeyPairForOwnerMutation = (
  { __typename?: 'Mutation' }
  & { removeKeyPairForOwner?: Maybe<(
    { __typename?: 'RemoveKeyPairForOwnerPayload' }
    & Pick<RemoveKeyPairForOwnerPayload, 'ok'>
  )> }
);

export type ToggleDataTriggerTimeoutMutationVariables = Exact<{
  ownerId: Scalars['ID'];
  shouldTimeoutDataTrigger: Scalars['Boolean'];
}>;


export type ToggleDataTriggerTimeoutMutation = (
  { __typename?: 'Mutation' }
  & { updateTimeoutSetting?: Maybe<(
    { __typename?: 'UpdateTimeoutSettingPayload' }
    & Pick<UpdateTimeoutSettingPayload, 'ok'>
  )> }
);

export type ToggleLegacySecretAnalyzerMutationVariables = Exact<{
  ownerId: Scalars['ID'];
  useLegacySecretAnalyzer: Scalars['Boolean'];
}>;


export type ToggleLegacySecretAnalyzerMutation = (
  { __typename?: 'Mutation' }
  & { updateOwnerSettings?: Maybe<(
    { __typename?: 'UpdateOwnerSettingsPayload' }
    & Pick<UpdateOwnerSettingsPayload, 'ok'>
  )> }
);

export type UpdateOwnerRiskConfigMutationVariables = Exact<{
  input: UpdateDynamicRiskConfigInput;
}>;


export type UpdateOwnerRiskConfigMutation = (
  { __typename?: 'Mutation' }
  & { updateDynamicRiskConfig?: Maybe<(
    { __typename?: 'UpdateDynamicRiskConfigPayload' }
    & Pick<UpdateDynamicRiskConfigPayload, 'ok' | 'clientMutationId'>
    & { dynamicRiskConfig?: Maybe<(
      { __typename?: 'OwnerDynamicRiskConfig' }
      & Pick<OwnerDynamicRiskConfig, 'id' | 'cvssWeight' | 'epssWeight' | 'percentileStrategy' | 'reachableWeight' | 'unreachableWeight' | 'unknownWeight'>
    )> }
  )> }
);

export type UpdateIdentityProviderMutationVariables = Exact<{
  input: UpdateIdentityProviderInput;
}>;


export type UpdateIdentityProviderMutation = (
  { __typename?: 'Mutation' }
  & { updateIdentityProvider?: Maybe<(
    { __typename?: 'UpdateIdentityProviderPayload' }
    & Pick<UpdateIdentityProviderPayload, 'ok'>
  )> }
);

export type UpdateOwnerSettingsMutationVariables = Exact<{
  input: UpdateOwnerSettingsInput;
}>;


export type UpdateOwnerSettingsMutation = (
  { __typename?: 'Mutation' }
  & { updateOwnerSettings?: Maybe<(
    { __typename?: 'UpdateOwnerSettingsPayload' }
    & Pick<UpdateOwnerSettingsPayload, 'ok'>
  )> }
);

export type SyncRepositoriesMutationVariables = Exact<{
  ownerId: Scalars['ID'];
}>;


export type SyncRepositoriesMutation = (
  { __typename?: 'Mutation' }
  & { syncRepositoriesForOwner?: Maybe<(
    { __typename?: 'SyncRepositoriesForOwnerPayload' }
    & Pick<SyncRepositoriesForOwnerPayload, 'ok'>
  )> }
);

export type SyncRepositoryForOwnerMutationVariables = Exact<{
  input: SyncRepositoryForOwnerInput;
}>;


export type SyncRepositoryForOwnerMutation = (
  { __typename?: 'Mutation' }
  & { syncRepositoryForOwner?: Maybe<(
    { __typename?: 'SyncRepositoryForOwnerPayload' }
    & Pick<SyncRepositoryForOwnerPayload, 'ok'>
  )> }
);

export type UpdateAutoTopupMutationVariables = Exact<{
  ownerId: Scalars['ID'];
  isAutoTopupEnabled?: Maybe<Scalars['Boolean']>;
  autoTopupThreshold?: Maybe<Scalars['Int']>;
  autoTopupAmount?: Maybe<Scalars['Int']>;
  autoTopupMax?: Maybe<Scalars['Int']>;
}>;


export type UpdateAutoTopupMutation = (
  { __typename?: 'Mutation' }
  & { updateAutoTopup?: Maybe<(
    { __typename?: 'UpdateAutoTopupPayload' }
    & { unifiedProduct?: Maybe<(
      { __typename?: 'UnifiedProduct' }
      & Pick<UnifiedProduct, 'id' | 'isAutoTopupEnabled' | 'autoTopupThreshold' | 'autoTopupAmount' | 'autoTopupMax'>
    )> }
  )> }
);

export type UpdateBillingInfoMutationVariables = Exact<{
  ownerId: Scalars['ID'];
  billingEmail?: Maybe<Scalars['String']>;
  billingAddress?: Maybe<Scalars['String']>;
}>;


export type UpdateBillingInfoMutation = (
  { __typename?: 'Mutation' }
  & { updateBillingInfo?: Maybe<(
    { __typename?: 'UpdateBillingInfoPayload' }
    & Pick<UpdateBillingInfoPayload, 'billingEmail' | 'billingAddress'>
  )> }
);

export type UpdateOwnerPinnedReportsMutationVariables = Exact<{
  input: UpdateOwnerPinnedReportsInput;
}>;


export type UpdateOwnerPinnedReportsMutation = (
  { __typename?: 'Mutation' }
  & { updateOwnerPinnedReports?: Maybe<(
    { __typename?: 'UpdateOwnerPinnedReportsPayload' }
    & Pick<UpdateOwnerPinnedReportsPayload, 'ok'>
  )> }
);

export type UpdatePaymentSourceMutationVariables = Exact<{
  id: Scalars['ID'];
  token: Scalars['String'];
  action: UpdatePaymentActionChoice;
}>;


export type UpdatePaymentSourceMutation = (
  { __typename?: 'Mutation' }
  & { updateDefaultPaymentSource?: Maybe<(
    { __typename?: 'UpdateDefaultPaymentSourcePayload' }
    & Pick<UpdateDefaultPaymentSourcePayload, 'ok'>
  )> }
);

export type UpdateSeatsMutationVariables = Exact<{
  id: Scalars['ID'];
  seats: Scalars['Int'];
}>;


export type UpdateSeatsMutation = (
  { __typename?: 'Mutation' }
  & { updateCodeQualitySubscriptionSeats?: Maybe<(
    { __typename?: 'UpdateCodeQualitySubscriptionSeatsPayload' }
    & Pick<UpdateCodeQualitySubscriptionSeatsPayload, 'ok' | 'totalSeats'>
  )> }
);

export type CreateWebhookMutationVariables = Exact<{
  url: Scalars['String'];
  secret: Scalars['String'];
  apiSigning: Scalars['Boolean'];
  ownerId: Scalars['ID'];
  eventsSubscribed: Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>;
}>;


export type CreateWebhookMutation = (
  { __typename?: 'Mutation' }
  & { createWebhook?: Maybe<(
    { __typename?: 'CreateWebhookPayload' }
    & { webhook?: Maybe<(
      { __typename?: 'Webhook' }
      & Pick<Webhook, 'id'>
    )> }
  )> }
);

export type DeletewebhookMutationVariables = Exact<{
  webhookId: Scalars['ID'];
}>;


export type DeletewebhookMutation = (
  { __typename?: 'Mutation' }
  & { deleteWebhook?: Maybe<(
    { __typename?: 'DeleteWebhookPayload' }
    & Pick<DeleteWebhookPayload, 'ok'>
  )> }
);

export type DisablewebhookMutationVariables = Exact<{
  webhookId: Scalars['ID'];
}>;


export type DisablewebhookMutation = (
  { __typename?: 'Mutation' }
  & { disableWebhook?: Maybe<(
    { __typename?: 'DisableWebhookPayload' }
    & Pick<DisableWebhookPayload, 'ok'>
  )> }
);

export type TestWebhookMutationVariables = Exact<{
  webhookId: Scalars['ID'];
}>;


export type TestWebhookMutation = (
  { __typename?: 'Mutation' }
  & { testWebhook?: Maybe<(
    { __typename?: 'TestWebhookPayload' }
    & Pick<TestWebhookPayload, 'ok'>
  )> }
);

export type UpdateWebhookMutationVariables = Exact<{
  webhookId: Scalars['ID'];
  url?: Maybe<Scalars['String']>;
  secret?: Maybe<Scalars['String']>;
  apiSigning?: Maybe<Scalars['Boolean']>;
  eventsSubscribed?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
}>;


export type UpdateWebhookMutation = (
  { __typename?: 'Mutation' }
  & { updateWebhook?: Maybe<(
    { __typename?: 'UpdateWebhookPayload' }
    & { webhook?: Maybe<(
      { __typename?: 'Webhook' }
      & Pick<Webhook, 'id'>
    )> }
  )> }
);

export type CreateAccessTokenMutationVariables = Exact<{
  description: Scalars['String'];
  expiryDays?: Maybe<Scalars['Int']>;
}>;


export type CreateAccessTokenMutation = (
  { __typename?: 'Mutation' }
  & { createAccessToken?: Maybe<(
    { __typename?: 'CreateAccessTokenPayload' }
    & Pick<CreateAccessTokenPayload, 'token'>
    & { accessToken?: Maybe<(
      { __typename?: 'AccessToken' }
      & Pick<AccessToken, 'id' | 'description' | 'expirationStatus' | 'expiresAt' | 'lastUsedAt'>
    )> }
  )> }
);

export type DeleteAccessTokenMutationVariables = Exact<{
  tokenId: Scalars['ID'];
}>;


export type DeleteAccessTokenMutation = (
  { __typename?: 'Mutation' }
  & { deleteAccessToken?: Maybe<(
    { __typename?: 'DeleteAccessTokenPayload' }
    & Pick<DeleteAccessTokenPayload, 'ok'>
  )> }
);

export type DeleteAllAccessTokensMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteAllAccessTokensMutation = (
  { __typename?: 'Mutation' }
  & { deleteAllAccessTokens?: Maybe<(
    { __typename?: 'DeleteAllAccessTokensPayload' }
    & Pick<DeleteAllAccessTokensPayload, 'ok'>
  )> }
);

export type CreatePublicReportMutationVariables = Exact<{
  input: CreatePublicReportInput;
}>;


export type CreatePublicReportMutation = (
  { __typename?: 'Mutation' }
  & { createPublicReport?: Maybe<(
    { __typename?: 'CreatePublicReportPayload' }
    & { report?: Maybe<(
      { __typename?: 'PublicReport' }
      & Pick<PublicReport, 'id' | 'reportId' | 'label' | 'views' | 'createdAt' | 'isRestricted' | 'shareHistoricalData' | 'reportKeys'>
    )> }
  )> }
);

export type DeletePublicReportMutationVariables = Exact<{
  input: DeletePublicReportInput;
}>;


export type DeletePublicReportMutation = (
  { __typename?: 'Mutation' }
  & { deletePublicReport?: Maybe<(
    { __typename?: 'DeletePublicReportPayload' }
    & Pick<DeletePublicReportPayload, 'ok'>
  )> }
);

export type FetchReportTokenMutationVariables = Exact<{
  input: GetAuthTokenForPublicReportInput;
}>;


export type FetchReportTokenMutation = (
  { __typename?: 'Mutation' }
  & { getAuthTokenForPublicReport?: Maybe<(
    { __typename?: 'GetAuthTokenForPublicReportPayload' }
    & Pick<GetAuthTokenForPublicReportPayload, 'token'>
  )> }
);

export type UpdateOwnerPublicReportMutationVariables = Exact<{
  updateInput: UpdatePublicReportInput;
  addReposInput: UpdatePublicReportSourcedRepositoriesInput;
  removeReposInput: UpdatePublicReportSourcedRepositoriesInput;
}>;


export type UpdateOwnerPublicReportMutation = (
  { __typename?: 'Mutation' }
  & { updatePublicReport?: Maybe<(
    { __typename?: 'UpdatePublicReportPayload' }
    & { publicReport?: Maybe<(
      { __typename?: 'PublicReport' }
      & Pick<PublicReport, 'id' | 'reportId' | 'label' | 'reportKeys' | 'isRestricted' | 'shareHistoricalData' | 'source'>
    )> }
  )>, addRepos?: Maybe<(
    { __typename?: 'UpdatePublicReportSourcedRepositoriesPayload' }
    & Pick<UpdatePublicReportSourcedRepositoriesPayload, 'ok'>
  )>, removeRepos?: Maybe<(
    { __typename?: 'UpdatePublicReportSourcedRepositoriesPayload' }
    & Pick<UpdatePublicReportSourcedRepositoriesPayload, 'ok'>
  )> }
);

export type UpdateRepoPublicReportMutationVariables = Exact<{
  updateInput: UpdatePublicReportInput;
}>;


export type UpdateRepoPublicReportMutation = (
  { __typename?: 'Mutation' }
  & { updatePublicReport?: Maybe<(
    { __typename?: 'UpdatePublicReportPayload' }
    & { publicReport?: Maybe<(
      { __typename?: 'PublicReport' }
      & Pick<PublicReport, 'id' | 'reportId' | 'label' | 'reportKeys' | 'isRestricted' | 'shareHistoricalData'>
    )> }
  )> }
);

export type VerifyPasswordForPublicReportMutationVariables = Exact<{
  input: VerifyPasswordForPublicReportInput;
}>;


export type VerifyPasswordForPublicReportMutation = (
  { __typename?: 'Mutation' }
  & { verifyPasswordForPublicReport?: Maybe<(
    { __typename?: 'VerifyPasswordForPublicReportPayload' }
    & Pick<VerifyPasswordForPublicReportPayload, 'token'>
  )> }
);

export type AddSubRepoMutationVariables = Exact<{
  input: AddSubRepoInput;
}>;


export type AddSubRepoMutation = (
  { __typename?: 'Mutation' }
  & { addSubRepo?: Maybe<(
    { __typename?: 'AddSubRepoPayload' }
    & Pick<AddSubRepoPayload, 'ok'>
    & { repository?: Maybe<(
      { __typename?: 'Repository' }
      & Pick<Repository, 'id' | 'name'>
    )> }
  )> }
);

export type CommitConfigToVcsMutationVariables = Exact<{
  input: CommitConfigToVcsInput;
}>;


export type CommitConfigToVcsMutation = (
  { __typename?: 'Mutation' }
  & { commitConfigToVcs?: Maybe<(
    { __typename?: 'CommitConfigToVCSPayload' }
    & Pick<CommitConfigToVcsPayload, 'ok'>
  )> }
);

export type DeleteSubRepoMutationVariables = Exact<{
  input: DeleteSubRepoInput;
}>;


export type DeleteSubRepoMutation = (
  { __typename?: 'Mutation' }
  & { deleteSubRepo?: Maybe<(
    { __typename?: 'DeleteSubRepoPayload' }
    & Pick<DeleteSubRepoPayload, 'ok'>
  )> }
);

export type IgnoreCheckMetricMutationVariables = Exact<{
  checkId: Scalars['ID'];
  metricShortcode: Scalars['String'];
  key: Scalars['String'];
}>;


export type IgnoreCheckMetricMutation = (
  { __typename?: 'Mutation' }
  & { ignoreCheckMetric?: Maybe<(
    { __typename?: 'IgnoreCheckMetricPayload' }
    & Pick<IgnoreCheckMetricPayload, 'ok'>
  )> }
);

export type RetryChecksMutationVariables = Exact<{
  input: RetryChecksInRunInput;
}>;


export type RetryChecksMutation = (
  { __typename?: 'Mutation' }
  & { retryChecksInRun?: Maybe<(
    { __typename?: 'RetryChecksInRunPayload' }
    & Pick<RetryChecksInRunPayload, 'ok'>
  )> }
);

export type SaveRepositoryConfigMutationVariables = Exact<{
  input: SaveRepositoryConfigInput;
}>;


export type SaveRepositoryConfigMutation = (
  { __typename?: 'Mutation' }
  & { saveRepositoryConfig?: Maybe<(
    { __typename?: 'SaveRepositoryConfigPayload' }
    & Pick<SaveRepositoryConfigPayload, 'ok' | 'clientMutationId'>
  )> }
);

export type ConvertToMonorepoMutationVariables = Exact<{
  input: EnableMonorepoModeInput;
}>;


export type ConvertToMonorepoMutation = (
  { __typename?: 'Mutation' }
  & { enableMonorepoMode?: Maybe<(
    { __typename?: 'EnableMonorepoModePayload' }
    & Pick<EnableMonorepoModePayload, 'ok'>
  )> }
);

export type DeleteIgnoredRuleMutationVariables = Exact<{
  silenceRuleId: Scalars['ID'];
}>;


export type DeleteIgnoredRuleMutation = (
  { __typename?: 'Mutation' }
  & { deleteSilenceRule?: Maybe<(
    { __typename?: 'DeleteSilenceRulePayload' }
    & Pick<DeleteSilenceRulePayload, 'ok'>
  )> }
);

export type DeleteSshKeyMutationVariables = Exact<{
  repositoryId: Scalars['ID'];
}>;


export type DeleteSshKeyMutation = (
  { __typename?: 'Mutation' }
  & { removeKeyPairForRepository?: Maybe<(
    { __typename?: 'RemoveKeyPairForRepositoryPayload' }
    & Pick<RemoveKeyPairForRepositoryPayload, 'ok'>
  )> }
);

export type GenerateSshKeyMutationVariables = Exact<{
  repositoryId: Scalars['ID'];
}>;


export type GenerateSshKeyMutation = (
  { __typename?: 'Mutation' }
  & { generateKeyPairForRepository?: Maybe<(
    { __typename?: 'GenerateKeyPairForRepositoryPayload' }
    & { repository?: Maybe<(
      { __typename?: 'Repository' }
      & Pick<Repository, 'id' | 'encPublicKey'>
    )> }
  )> }
);

export type RegenerateRepositoryDsnMutationVariables = Exact<{
  input: RegenerateRepositoryDsnInput;
}>;


export type RegenerateRepositoryDsnMutation = (
  { __typename?: 'Mutation' }
  & { regenerateRepositoryDSN?: Maybe<(
    { __typename?: 'RegenerateRepositoryDSNPayload' }
    & Pick<RegenerateRepositoryDsnPayload, 'dsn'>
  )> }
);

export type RemoveCollaboratorMutationVariables = Exact<{
  input: RemoveRepositoryCollaboratorInput;
}>;


export type RemoveCollaboratorMutation = (
  { __typename?: 'Mutation' }
  & { removeRepositoryCollaborator?: Maybe<(
    { __typename?: 'RemoveRepositoryCollaboratorPayload' }
    & Pick<RemoveRepositoryCollaboratorPayload, 'ok'>
  )> }
);

export type RevertMonorepoMutationVariables = Exact<{
  input: DisableMonorepoModeInput;
}>;


export type RevertMonorepoMutation = (
  { __typename?: 'Mutation' }
  & { disableMonorepoMode?: Maybe<(
    { __typename?: 'DisableMonorepoModePayload' }
    & Pick<DisableMonorepoModePayload, 'ok'>
  )> }
);

export type UpdateInferDefaultBranchCoverageMutationVariables = Exact<{
  input: UpdateRepositorySettingsInput;
}>;


export type UpdateInferDefaultBranchCoverageMutation = (
  { __typename?: 'Mutation' }
  & { updateRepositorySettings?: Maybe<(
    { __typename?: 'UpdateRepositorySettingsPayload' }
    & { repository?: Maybe<(
      { __typename?: 'Repository' }
      & Pick<Repository, 'id'>
      & { repositorySetting?: Maybe<(
        { __typename?: 'RepositorySetting' }
        & Pick<RepositorySetting, 'id' | 'inferDefaultBranchCoverage'>
      )> }
    )> }
  )> }
);

export type UpdatePermissionMutationVariables = Exact<{
  input: UpdateOrCreateRepositoryCollaboratorInput;
}>;


export type UpdatePermissionMutation = (
  { __typename?: 'Mutation' }
  & { updateOrCreateRepositoryCollaborator?: Maybe<(
    { __typename?: 'UpdateOrCreateRepositoryCollaboratorPayload' }
    & Pick<UpdateOrCreateRepositoryCollaboratorPayload, 'ok'>
  )> }
);

export type UpdateRepositorySettingsMutationVariables = Exact<{
  input: UpdateRepositorySettingsInput;
}>;


export type UpdateRepositorySettingsMutation = (
  { __typename?: 'Mutation' }
  & { updateRepositorySettings?: Maybe<(
    { __typename?: 'UpdateRepositorySettingsPayload' }
    & { repository?: Maybe<(
      { __typename?: 'Repository' }
      & Pick<Repository, 'id' | 'analyzeChangesetOnly' | 'defaultBranchName' | 'isSubmoduleEnabled' | 'config' | 'isActivated' | 'gitlabIntegrationUseStatus'>
      & { repositorySetting?: Maybe<(
        { __typename?: 'RepositorySetting' }
        & Pick<RepositorySetting, 'id' | 'inferDefaultBranchCommunity'>
      )> }
    )> }
  )> }
);

export type UpdateRepositoryVcsReportingOptionsEnabledMutationVariables = Exact<{
  input: UpdateRepositoryVcsReportingOptionsEnabledInput;
}>;


export type UpdateRepositoryVcsReportingOptionsEnabledMutation = (
  { __typename?: 'Mutation' }
  & { updateRepositoryVcsReportingOptionsEnabled?: Maybe<(
    { __typename?: 'UpdateRepositoryVCSReportingOptionsEnabledPayload' }
    & Pick<UpdateRepositoryVcsReportingOptionsEnabledPayload, 'ok'>
  )> }
);

export type ToggleRepositoryActivationMutationVariables = Exact<{
  input: ToggleRepositoryActivationInput;
}>;


export type ToggleRepositoryActivationMutation = (
  { __typename?: 'Mutation' }
  & { toggleRepositoryActivation?: Maybe<(
    { __typename?: 'ToggleRepositoryActivationPayload' }
    & { repository?: Maybe<(
      { __typename?: 'Repository' }
      & Pick<Repository, 'id' | 'name' | 'displayName' | 'isActivated'>
    )> }
  )> }
);

export type UpdateRepoMetricThresholdMutationVariables = Exact<{
  input: UpdateRepoMetricThresholdInput;
}>;


export type UpdateRepoMetricThresholdMutation = (
  { __typename?: 'Mutation' }
  & { updateRepoMetricThreshold?: Maybe<(
    { __typename?: 'UpdateRepoMetricThresholdPayload' }
    & Pick<UpdateRepoMetricThresholdPayload, 'ok'>
  )> }
);

export type UpdateRepositoryPinnedReportsMutationVariables = Exact<{
  input: UpdateRepositoryPinnedReportsInput;
}>;


export type UpdateRepositoryPinnedReportsMutation = (
  { __typename?: 'Mutation' }
  & { updateRepositoryPinnedReports?: Maybe<(
    { __typename?: 'UpdateRepositoryPinnedReportsPayload' }
    & Pick<UpdateRepositoryPinnedReportsPayload, 'ok'>
  )> }
);

export type UpdateRepositoryWidgetsMutationVariables = Exact<{
  input: UpdateRepositoryWidgetsInput;
}>;


export type UpdateRepositoryWidgetsMutation = (
  { __typename?: 'Mutation' }
  & { updateRepositoryWidgets?: Maybe<(
    { __typename?: 'UpdateRepositoryWidgetsPayload' }
    & Pick<UpdateRepositoryWidgetsPayload, 'widgetCodes'>
  )> }
);

export type SubmitSupportTicketMutationVariables = Exact<{
  input: SubmitSupportTicketInput;
}>;


export type SubmitSupportTicketMutation = (
  { __typename?: 'Mutation' }
  & { submitSupportTicket?: Maybe<(
    { __typename?: 'SubmitSupportTicketPayload' }
    & Pick<SubmitSupportTicketPayload, 'ok'>
  )> }
);

export type AcceptTeamMemberAdditionRequestMutationVariables = Exact<{
  additionRequestId: Scalars['ID'];
  role: TeamMemberRoleChoices;
}>;


export type AcceptTeamMemberAdditionRequestMutation = (
  { __typename?: 'Mutation' }
  & { acceptTeamMemberAdditionRequest?: Maybe<(
    { __typename?: 'AcceptTeamMemberAdditionRequestPayload' }
    & Pick<AcceptTeamMemberAdditionRequestPayload, 'ok'>
  )> }
);

export type DeleteTeamMutationVariables = Exact<{
  input: DeleteTeamInput;
}>;


export type DeleteTeamMutation = (
  { __typename?: 'Mutation' }
  & { deleteTeam?: Maybe<(
    { __typename?: 'DeleteTeamPayload' }
    & Pick<DeleteTeamPayload, 'ok'>
  )> }
);

export type InviteMembersMutationVariables = Exact<{
  input: InviteTeamMembersInput;
}>;


export type InviteMembersMutation = (
  { __typename?: 'Mutation' }
  & { inviteTeamMembers?: Maybe<(
    { __typename?: 'InviteTeamMembersPayload' }
    & Pick<InviteTeamMembersPayload, 'ok'>
  )> }
);

export type InviteSingleMutationVariables = Exact<{
  ownerId: Scalars['ID'];
  email: Scalars['String'];
  action: InviteTeamMemberActionChoice;
  role: TeamMemberRoleChoices;
}>;


export type InviteSingleMutation = (
  { __typename?: 'Mutation' }
  & { inviteTeamMember?: Maybe<(
    { __typename?: 'InviteTeamMemberPayload' }
    & Pick<InviteTeamMemberPayload, 'invitationUrl'>
  )> }
);

export type RejectTeamMemberAdditionRequestMutationVariables = Exact<{
  additionRequestId: Scalars['ID'];
}>;


export type RejectTeamMemberAdditionRequestMutation = (
  { __typename?: 'Mutation' }
  & { rejectTeamMemberAdditionRequest?: Maybe<(
    { __typename?: 'RejectTeamMemberAdditionRequestPayload' }
    & Pick<RejectTeamMemberAdditionRequestPayload, 'ok'>
  )> }
);

export type RemoveMemberMutationVariables = Exact<{
  ownerPk: Scalars['ID'];
  email: Scalars['String'];
}>;


export type RemoveMemberMutation = (
  { __typename?: 'Mutation' }
  & { removeTeamMember?: Maybe<(
    { __typename?: 'RemoveTeamMemberPayload' }
    & Pick<RemoveTeamMemberPayload, 'ok'>
  )> }
);

export type ResetTeamInviteLinkMutationVariables = Exact<{
  input: ResetTeamInvitationLinkInput;
}>;


export type ResetTeamInviteLinkMutation = (
  { __typename?: 'Mutation' }
  & { resetInvitationLink?: Maybe<(
    { __typename?: 'ResetTeamInvitationLinkPayload' }
    & Pick<ResetTeamInvitationLinkPayload, 'invitationUrl'>
  )> }
);

export type SendTeamMemberAdditionRequestMutationVariables = Exact<{
  teamId: Scalars['ID'];
  email: Scalars['String'];
}>;


export type SendTeamMemberAdditionRequestMutation = (
  { __typename?: 'Mutation' }
  & { sendTeamMemberAdditionRequest?: Maybe<(
    { __typename?: 'SendTeamMemberAdditionRequestPayload' }
    & Pick<SendTeamMemberAdditionRequestPayload, 'ok'>
  )> }
);

export type SyncVcsPermissionsMutationVariables = Exact<{
  teamId: Scalars['ID'];
  overrideChangesMadeOnDeepsource: Scalars['Boolean'];
}>;


export type SyncVcsPermissionsMutation = (
  { __typename?: 'Mutation' }
  & { syncVcsPermissions?: Maybe<(
    { __typename?: 'SyncVcsPermissionsPayload' }
    & Pick<SyncVcsPermissionsPayload, 'ok'>
  )> }
);

export type TransferTeamOwnershipMutationVariables = Exact<{
  input: TransferTeamOwnershipInput;
}>;


export type TransferTeamOwnershipMutation = (
  { __typename?: 'Mutation' }
  & { transferTeamOwnership?: Maybe<(
    { __typename?: 'TransferTeamOwnershipPayload' }
    & Pick<TransferTeamOwnershipPayload, 'ok'>
  )> }
);

export type UpdateAccessControlSettingsMutationVariables = Exact<{
  teamId: Scalars['ID'];
  syncPermissionsWithVcs?: Maybe<Scalars['Boolean']>;
}>;


export type UpdateAccessControlSettingsMutation = (
  { __typename?: 'Mutation' }
  & { updateAccessControlSettings?: Maybe<(
    { __typename?: 'UpdateAccessControlSettingsPayload' }
    & Pick<UpdateAccessControlSettingsPayload, 'ok'>
  )> }
);

export type UpdateAutofixAiSettingsMutationVariables = Exact<{
  ownerId: Scalars['ID'];
  allowAutofixAi?: Maybe<Scalars['Boolean']>;
  useLegacyAutofix?: Maybe<Scalars['Boolean']>;
}>;


export type UpdateAutofixAiSettingsMutation = (
  { __typename?: 'Mutation' }
  & { updateOwnerSettings?: Maybe<(
    { __typename?: 'UpdateOwnerSettingsPayload' }
    & Pick<UpdateOwnerSettingsPayload, 'ok'>
  )> }
);

export type UpdateRoleMutationVariables = Exact<{
  ownerPk: Scalars['ID'];
  email: Scalars['String'];
  role: TeamMemberRoleChoices;
}>;


export type UpdateRoleMutation = (
  { __typename?: 'Mutation' }
  & { updateTeamMemberRole?: Maybe<(
    { __typename?: 'UpdateTeamMemberRolePayload' }
    & Pick<UpdateTeamMemberRolePayload, 'role'>
  )> }
);

export type UpdateTeamBasePermissionsMutationVariables = Exact<{
  input: UpdateTeamBasePermissionsInput;
}>;


export type UpdateTeamBasePermissionsMutation = (
  { __typename?: 'Mutation' }
  & { updateTeamBasePermissions?: Maybe<(
    { __typename?: 'UpdateTeamBasePermissionsPayload' }
    & Pick<UpdateTeamBasePermissionsPayload, 'ok'>
  )> }
);

export type UpdateCodeAnalysisStatusMutationVariables = Exact<{
  input: UpdateRepositorySettingsInput;
}>;


export type UpdateCodeAnalysisStatusMutation = (
  { __typename?: 'Mutation' }
  & { updateRepositorySettings?: Maybe<(
    { __typename?: 'UpdateRepositorySettingsPayload' }
    & { repository?: Maybe<(
      { __typename?: 'Repository' }
      & Pick<Repository, 'id'>
      & { repositorySetting?: Maybe<(
        { __typename?: 'RepositorySetting' }
        & Pick<RepositorySetting, 'id' | 'enableCodeAnalysis'>
      )> }
    )> }
  )> }
);

export type UpdateCodeFormattingStatusMutationVariables = Exact<{
  input: UpdateRepositorySettingsInput;
}>;


export type UpdateCodeFormattingStatusMutation = (
  { __typename?: 'Mutation' }
  & { updateRepositorySettings?: Maybe<(
    { __typename?: 'UpdateRepositorySettingsPayload' }
    & { repository?: Maybe<(
      { __typename?: 'Repository' }
      & Pick<Repository, 'id'>
      & { repositorySetting?: Maybe<(
        { __typename?: 'RepositorySetting' }
        & Pick<RepositorySetting, 'id' | 'enableCodeFormatting'>
      )> }
    )> }
  )> }
);

export type DeleteRequestingUserMutationVariables = Exact<{
  input: DeleteRequestingUserInput;
}>;


export type DeleteRequestingUserMutation = (
  { __typename?: 'Mutation' }
  & { deleteRequestingUser?: Maybe<(
    { __typename?: 'DeleteRequestingUserPayload' }
    & Pick<DeleteRequestingUserPayload, 'ok'>
  )> }
);

export type UpdateDefaultContextMutationVariables = Exact<{
  contextOwnerId: Scalars['Int'];
}>;


export type UpdateDefaultContextMutation = (
  { __typename?: 'Mutation' }
  & { updateDefaultDashboardContextForUser?: Maybe<(
    { __typename?: 'UpdateDefaultDashboardContextForUserPayload' }
    & Pick<UpdateDefaultDashboardContextForUserPayload, 'contexts'>
  )> }
);

export type UpdateStarredRepoMutationVariables = Exact<{
  repoId: Scalars['ID'];
  action: ActionChoice;
}>;


export type UpdateStarredRepoMutation = (
  { __typename?: 'Mutation' }
  & { updateStarredRepository?: Maybe<(
    { __typename?: 'UpdateStarredRepositoryPayload' }
    & Pick<UpdateStarredRepositoryPayload, 'ok'>
  )> }
);

export type UpdateUserDetailsMutationVariables = Exact<{
  input: UpdateUserDetailsInput;
}>;


export type UpdateUserDetailsMutation = (
  { __typename?: 'Mutation' }
  & { updateUserDetails?: Maybe<(
    { __typename?: 'UpdateUserDetailsPayload' }
    & { viewer?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'fullName' | 'firstName' | 'lastName' | 'email' | 'avatar'>
    )> }
  )> }
);

export type FetchCiSnippetQueryVariables = Exact<{
  shortcode: Scalars['String'];
}>;


export type FetchCiSnippetQuery = (
  { __typename?: 'Query' }
  & { analyzer?: Maybe<(
    { __typename?: 'Analyzer' }
    & Pick<Analyzer, 'id'>
    & { ciSnippets?: Maybe<(
      { __typename?: 'AnalyzerCISnippetConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'AnalyzerCISnippetEdge' }
        & { node?: Maybe<(
          { __typename?: 'AnalyzerCISnippet' }
          & Pick<AnalyzerCiSnippet, 'id' | 'provider' | 'snippet'>
        )> }
      )>> }
    )> }
  )> }
);

export type GetAnalyzersQueryVariables = Exact<{
  exclude?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
}>;


export type GetAnalyzersQuery = (
  { __typename?: 'Query' }
  & { analyzers?: Maybe<(
    { __typename?: 'AnalyzerConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'AnalyzerEdge' }
      & { node?: Maybe<(
        { __typename?: 'Analyzer' }
        & Pick<Analyzer, 'id' | 'name' | 'shortcode' | 'logo' | 'analyzerLogo' | 'analyzerType' | 'metaSchema'>
        & { transformertoolSet: (
          { __typename?: 'TransformerToolConnection' }
          & { edges: Array<Maybe<(
            { __typename?: 'TransformerToolEdge' }
            & { node?: Maybe<(
              { __typename?: 'TransformerTool' }
              & Pick<TransformerTool, 'id' | 'name' | 'shortcode' | 'logo' | 'description'>
            )> }
          )>> }
        ) }
      )> }
    )>> }
  )> }
);

export type AnalyzerNamesQueryVariables = Exact<{
  categories?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
}>;


export type AnalyzerNamesQuery = (
  { __typename?: 'Query' }
  & { analyzers?: Maybe<(
    { __typename?: 'AnalyzerConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'AnalyzerEdge' }
      & { node?: Maybe<(
        { __typename?: 'Analyzer' }
        & Pick<Analyzer, 'id' | 'name' | 'shortcode' | 'category'>
      )> }
    )>> }
  )> }
);

export type IdentityProvidersForEmailQueryVariables = Exact<{
  email: Scalars['String'];
  first?: Maybe<Scalars['Int']>;
}>;


export type IdentityProvidersForEmailQuery = (
  { __typename?: 'Query' }
  & { identityProvidersForEmail?: Maybe<(
    { __typename?: 'SSOIdentityProviderConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'SSOIdentityProviderEdge' }
      & { node?: Maybe<(
        { __typename?: 'SSOIdentityProvider' }
        & Pick<SsoIdentityProvider, 'id' | 'teamName' | 'teamLogin' | 'teamLogo' | 'loginUrl'>
      )> }
    )>> }
  )> }
);

export type SocialAuthUrlsQueryVariables = Exact<{ [key: string]: never; }>;


export type SocialAuthUrlsQuery = (
  { __typename?: 'Query' }
  & { oauth?: Maybe<(
    { __typename?: 'SocialAuthURL' }
    & { socialUrls?: Maybe<Array<Maybe<(
      { __typename?: 'AuthUrl' }
      & Pick<AuthUrl, 'name' | 'provider' | 'url'>
    )>>> }
  )> }
);

export type FetchContextQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchContextQuery = (
  { __typename?: 'Query' }
  & { context?: Maybe<(
    { __typename?: 'Context' }
    & Pick<Context, 'staticRoot' | 'apiRoot' | 'websocketUrl' | 'installationProvidersUrl' | 'installationUrls' | 'stripePublishableKey' | 'appEnv' | 'emptyAvatarUrl' | 'debug' | 'userGroupUrl' | 'onPrem' | 'deepsourceCloudProduction' | 'githubEnabled' | 'gitlabEnabled' | 'bitbucketEnabled' | 'supportEmail' | 'isTransformersLicensed' | 'toOnboard' | 'plans' | 'isRunner'>
  )> }
);

export type FetchDeepSourceStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchDeepSourceStatusQuery = (
  { __typename?: 'Query' }
  & { context?: Maybe<(
    { __typename?: 'Context' }
    & Pick<Context, 'platformStatus'>
  )> }
);

export type ToOboardQueryVariables = Exact<{ [key: string]: never; }>;


export type ToOboardQuery = (
  { __typename?: 'Query' }
  & { context?: Maybe<(
    { __typename?: 'Context' }
    & Pick<Context, 'toOnboard'>
  )> }
);

export type BaseOrgInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type BaseOrgInfoQuery = (
  { __typename?: 'Query' }
  & { enterprise?: Maybe<(
    { __typename?: 'EnterpriseInstallationRoot' }
    & Pick<EnterpriseInstallationRoot, 'managementConsoleUrl'>
    & { installation?: Maybe<(
      { __typename?: 'EnterpriseInstallationSetup' }
      & Pick<EnterpriseInstallationSetup, 'name' | 'logo'>
    )> }
  )> }
);

export type FetchBilledScaTargetsQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
}>;


export type FetchBilledScaTargetsQuery = (
  { __typename?: 'Query' }
  & { enterprise?: Maybe<(
    { __typename?: 'EnterpriseInstallationRoot' }
    & { billedTargets?: Maybe<(
      { __typename?: 'EnterpriseBilledRepositoryTargetConnection' }
      & Pick<EnterpriseBilledRepositoryTargetConnection, 'totalCount'>
      & { pageInfo: (
        { __typename?: 'PageInfo' }
        & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ), edges: Array<Maybe<(
        { __typename?: 'EnterpriseBilledRepositoryTargetEdge' }
        & { node?: Maybe<(
          { __typename?: 'EnterpriseBilledRepositoryTarget' }
          & Pick<EnterpriseBilledRepositoryTarget, 'id' | 'manifestPath' | 'lockfilePath'>
          & { repository: (
            { __typename?: 'Repository' }
            & Pick<Repository, 'id' | 'name' | 'displayFullName' | 'vcsProvider'>
            & { owner: (
              { __typename?: 'Owner' }
              & Pick<Owner, 'id' | 'login'>
            ) }
          ) }
        )> }
      )>> }
    )> }
  )> }
);

export type OrgLicenseInfoQueryVariables = Exact<{
  lastDays: Scalars['Int'];
  trendType: TrendType;
}>;


export type OrgLicenseInfoQuery = (
  { __typename?: 'Query' }
  & { enterprise?: Maybe<(
    { __typename?: 'EnterpriseInstallationRoot' }
    & { license?: Maybe<(
      { __typename?: 'EnterpriseLicense' }
      & Pick<EnterpriseLicense, 'seatsTotal' | 'seatsUsed' | 'targetsTotal' | 'targetsUsed' | 'licenseExpiry' | 'seatUsageTrend'>
    )> }
  )> }
);

export type AddTeamQueryQueryVariables = Exact<{
  groupId: Scalars['ID'];
  q?: Maybe<Scalars['String']>;
}>;


export type AddTeamQueryQuery = (
  { __typename?: 'Query' }
  & { enterprise?: Maybe<(
    { __typename?: 'EnterpriseInstallationRoot' }
    & { group?: Maybe<(
      { __typename?: 'EnterpriseGroup' }
      & Pick<EnterpriseGroup, 'id'>
      & { allTeams?: Maybe<(
        { __typename?: 'TeamConnection' }
        & { edges: Array<Maybe<(
          { __typename?: 'TeamEdge' }
          & { node?: Maybe<(
            { __typename?: 'Team' }
            & Pick<Team, 'id' | 'login' | 'name' | 'avatar' | 'numMembersTotal' | 'roleInGroup'>
          )> }
        )>> }
      )> }
    )> }
  )> }
);

export type GetGroupInviteInfoQueryVariables = Exact<{
  invitationCode: Scalars['String'];
}>;


export type GetGroupInviteInfoQuery = (
  { __typename?: 'Query' }
  & { getGroupInviteInfo?: Maybe<(
    { __typename?: 'GroupInviteInfo' }
    & Pick<GroupInviteInfo, 'name'>
  )> }
);

export type GroupAndTeamsQueryVariables = Exact<{
  id: Scalars['ID'];
  q?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type GroupAndTeamsQuery = (
  { __typename?: 'Query' }
  & { enterprise?: Maybe<(
    { __typename?: 'EnterpriseInstallationRoot' }
    & { group?: Maybe<(
      { __typename?: 'EnterpriseGroup' }
      & Pick<EnterpriseGroup, 'id' | 'name' | 'createdAt' | 'scimEnabled'>
      & { membersCount?: Maybe<(
        { __typename?: 'EnterpriseUserConnection' }
        & Pick<EnterpriseUserConnection, 'totalCount'>
      )>, teamsCount?: Maybe<(
        { __typename?: 'GroupTeamMembershipConnection' }
        & Pick<GroupTeamMembershipConnection, 'totalCount'>
      )>, groupTeams?: Maybe<(
        { __typename?: 'GroupTeamMembershipConnection' }
        & Pick<GroupTeamMembershipConnection, 'totalCount'>
        & { edges: Array<Maybe<(
          { __typename?: 'GroupTeamMembershipEdge' }
          & { node?: Maybe<(
            { __typename?: 'GroupTeamMembership' }
            & Pick<GroupTeamMembership, 'id' | 'role' | 'createdAt' | 'modifiedAt'>
            & { team: (
              { __typename?: 'EnterpriseTeam' }
              & Pick<EnterpriseTeam, 'id' | 'name' | 'avatar' | 'login' | 'vcsProvider'>
              & { members: (
                { __typename?: 'UserConnection' }
                & Pick<UserConnection, 'totalCount'>
              ) }
            ) }
          )> }
        )>> }
      )> }
    )> }
  )> }
);

export type GroupAndUsersQueryVariables = Exact<{
  id: Scalars['ID'];
  q?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type GroupAndUsersQuery = (
  { __typename?: 'Query' }
  & { enterprise?: Maybe<(
    { __typename?: 'EnterpriseInstallationRoot' }
    & { group?: Maybe<(
      { __typename?: 'EnterpriseGroup' }
      & Pick<EnterpriseGroup, 'id' | 'name' | 'createdAt' | 'scimEnabled'>
      & { membersCount?: Maybe<(
        { __typename?: 'EnterpriseUserConnection' }
        & Pick<EnterpriseUserConnection, 'totalCount'>
      )>, members?: Maybe<(
        { __typename?: 'EnterpriseUserConnection' }
        & Pick<EnterpriseUserConnection, 'totalCount'>
        & { edges: Array<Maybe<(
          { __typename?: 'EnterpriseUserEdge' }
          & { node?: Maybe<(
            { __typename?: 'EnterpriseUser' }
            & Pick<EnterpriseUser, 'id' | 'avatar' | 'fullName' | 'email' | 'isActive' | 'isSuperuser' | 'scimEnabled'>
            & { groupsCount: (
              { __typename?: 'EnterpriseGroupConnection' }
              & Pick<EnterpriseGroupConnection, 'totalCount'>
            ) }
          )> }
        )>> }
      )>, teamsCount?: Maybe<(
        { __typename?: 'GroupTeamMembershipConnection' }
        & Pick<GroupTeamMembershipConnection, 'totalCount'>
      )> }
    )> }
  )> }
);

export type GroupsQueryVariables = Exact<{
  q?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type GroupsQuery = (
  { __typename?: 'Query' }
  & { enterprise?: Maybe<(
    { __typename?: 'EnterpriseInstallationRoot' }
    & Pick<EnterpriseInstallationRoot, 'isScimEnabled'>
    & { groups?: Maybe<(
      { __typename?: 'EnterpriseGroupConnection' }
      & Pick<EnterpriseGroupConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'EnterpriseGroupEdge' }
        & { node?: Maybe<(
          { __typename?: 'EnterpriseGroup' }
          & Pick<EnterpriseGroup, 'id' | 'name' | 'createdAt' | 'scimEnabled'>
          & { members?: Maybe<(
            { __typename?: 'EnterpriseUserConnection' }
            & Pick<EnterpriseUserConnection, 'totalCount'>
          )>, teams: (
            { __typename?: 'EnterpriseTeamConnection' }
            & Pick<EnterpriseTeamConnection, 'totalCount'>
          ) }
        )> }
      )>> }
    )> }
  )> }
);

export type InvitesQueryVariables = Exact<{ [key: string]: never; }>;


export type InvitesQuery = (
  { __typename?: 'Query' }
  & { enterprise?: Maybe<(
    { __typename?: 'EnterpriseInstallationRoot' }
    & { groups?: Maybe<(
      { __typename?: 'EnterpriseGroupConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'EnterpriseGroupEdge' }
        & { node?: Maybe<(
          { __typename?: 'EnterpriseGroup' }
          & Pick<EnterpriseGroup, 'name' | 'id' | 'invitationUrl'>
        )> }
      )>> }
    )> }
  )> }
);

export type ListTeamsQueryVariables = Exact<{
  q?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type ListTeamsQuery = (
  { __typename?: 'Query' }
  & { enterprise?: Maybe<(
    { __typename?: 'EnterpriseInstallationRoot' }
    & { teams?: Maybe<(
      { __typename?: 'EnterpriseTeamConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'EnterpriseTeamEdge' }
        & { node?: Maybe<(
          { __typename?: 'EnterpriseTeam' }
          & Pick<EnterpriseTeam, 'id' | 'name' | 'login'>
        )> }
      )>> }
    )> }
  )> }
);

export type UserAndGroupsQueryVariables = Exact<{
  id: Scalars['ID'];
  q?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type UserAndGroupsQuery = (
  { __typename?: 'Query' }
  & { enterprise?: Maybe<(
    { __typename?: 'EnterpriseInstallationRoot' }
    & { user?: Maybe<(
      { __typename?: 'EnterpriseUser' }
      & Pick<EnterpriseUser, 'id' | 'fullName' | 'avatar' | 'email' | 'dateJoined' | 'isActive' | 'isSuperuser' | 'scimEnabled'>
      & { groupsCount: (
        { __typename?: 'EnterpriseGroupConnection' }
        & Pick<EnterpriseGroupConnection, 'totalCount'>
      ), scimGroups: (
        { __typename?: 'EnterpriseGroupConnection' }
        & Pick<EnterpriseGroupConnection, 'totalCount'>
        & { edges: Array<Maybe<(
          { __typename?: 'EnterpriseGroupEdge' }
          & { node?: Maybe<(
            { __typename?: 'EnterpriseGroup' }
            & Pick<EnterpriseGroup, 'id' | 'name' | 'scimEnabled'>
            & { members?: Maybe<(
              { __typename?: 'EnterpriseUserConnection' }
              & Pick<EnterpriseUserConnection, 'totalCount'>
            )>, teams: (
              { __typename?: 'EnterpriseTeamConnection' }
              & Pick<EnterpriseTeamConnection, 'totalCount'>
            ) }
          )> }
        )>> }
      ) }
    )> }
  )> }
);

export type UserAndTeamsQueryVariables = Exact<{
  id: Scalars['ID'];
  q?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type UserAndTeamsQuery = (
  { __typename?: 'Query' }
  & { enterprise?: Maybe<(
    { __typename?: 'EnterpriseInstallationRoot' }
    & { user?: Maybe<(
      { __typename?: 'EnterpriseUser' }
      & Pick<EnterpriseUser, 'id' | 'fullName' | 'avatar' | 'email' | 'dateJoined' | 'isActive' | 'isSuperuser' | 'scimEnabled'>
      & { groupsCount: (
        { __typename?: 'EnterpriseGroupConnection' }
        & Pick<EnterpriseGroupConnection, 'totalCount'>
      ), teams: (
        { __typename?: 'EnterpriseTeamConnection' }
        & Pick<EnterpriseTeamConnection, 'totalCount'>
        & { edges: Array<Maybe<(
          { __typename?: 'EnterpriseTeamEdge' }
          & { node?: Maybe<(
            { __typename?: 'EnterpriseTeam' }
            & Pick<EnterpriseTeam, 'id' | 'name' | 'login' | 'avatar' | 'vcsProvider' | 'isDirectMember'>
            & { members: (
              { __typename?: 'UserConnection' }
              & Pick<UserConnection, 'totalCount'>
            ) }
          )> }
        )>> }
      ) }
    )> }
  )> }
);

export type UsersQueryVariables = Exact<{
  q?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type UsersQuery = (
  { __typename?: 'Query' }
  & { enterprise?: Maybe<(
    { __typename?: 'EnterpriseInstallationRoot' }
    & { users?: Maybe<(
      { __typename?: 'EnterpriseUserConnection' }
      & Pick<EnterpriseUserConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'EnterpriseUserEdge' }
        & { node?: Maybe<(
          { __typename?: 'EnterpriseUser' }
          & Pick<EnterpriseUser, 'id' | 'avatar' | 'fullName' | 'email' | 'isActive' | 'isSuperuser' | 'scimEnabled'>
          & { teams: (
            { __typename?: 'EnterpriseTeamConnection' }
            & { edges: Array<Maybe<(
              { __typename?: 'EnterpriseTeamEdge' }
              & { node?: Maybe<(
                { __typename?: 'EnterpriseTeam' }
                & Pick<EnterpriseTeam, 'name'>
              )> }
            )>> }
          ), groupsCount: (
            { __typename?: 'EnterpriseGroupConnection' }
            & Pick<EnterpriseGroupConnection, 'totalCount'>
          ) }
        )> }
      )>> }
    )> }
  )> }
);

export type FixPathsQueryVariables = Exact<{
  name: Scalars['String'];
  owner: Scalars['String'];
  provider: VcsProviderChoices;
  occurrenceId: Scalars['ID'];
}>;


export type FixPathsQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id'>
    & { vulnerabilityOccurrence: (
      { __typename?: 'VulnerabilityOccurrence' }
      & Pick<VulnerabilityOccurrence, 'id'>
      & { fixPaths: (
        { __typename?: 'VulnerabilityRemediationFixPathConnection' }
        & { edges: Array<Maybe<(
          { __typename?: 'VulnerabilityRemediationFixPathEdge' }
          & { node?: Maybe<(
            { __typename?: 'VulnerabilityRemediationFixPath' }
            & Pick<VulnerabilityRemediationFixPath, 'id' | 'isRecommended'>
            & { latestRemediationPatchRun?: Maybe<(
              { __typename?: 'VulnerabilityRemediationPatchRun' }
              & Pick<VulnerabilityRemediationPatchRun, 'id' | 'status' | 'pullRequestStatus' | 'pullRequestNumber' | 'vcsPrUrl'>
            )>, packageUpdates: (
              { __typename?: 'VulnerabilityRemediationFixPathUpdateConnection' }
              & { edges: Array<Maybe<(
                { __typename?: 'VulnerabilityRemediationFixPathUpdateEdge' }
                & { node?: Maybe<(
                  { __typename?: 'VulnerabilityRemediationFixPathUpdate' }
                  & Pick<VulnerabilityRemediationFixPathUpdate, 'id' | 'isAiOverviewSupported' | 'ecosystem' | 'package' | 'versionFrom' | 'versionTo' | 'versionRiskScore' | 'dependencyRiskScore' | 'compatibilityRiskScore' | 'overallRiskScore'>
                )> }
              )>> }
            ) }
          )> }
        )>> }
      ) }
    ) }
  )> }
);

export type FetchVulnOccurrenceQueryVariables = Exact<{
  name: Scalars['String'];
  owner: Scalars['String'];
  provider: VcsProviderChoices;
  occurrenceId: Scalars['ID'];
}>;


export type FetchVulnOccurrenceQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id'>
    & { vulnerabilityOccurrence: (
      { __typename?: 'VulnerabilityOccurrence' }
      & Pick<VulnerabilityOccurrence, 'id' | 'reachability' | 'fixability' | 'impliedSeverity' | 'isSeverityOverridden' | 'dynamicRiskLevel'>
      & { vulnerability: (
        { __typename?: 'Vulnerability' }
        & Pick<Vulnerability, 'id' | 'identifier' | 'aliases' | 'summary' | 'detailsRendered' | 'publishedAt' | 'introducedVersions' | 'fixedVersions' | 'cvssV2Vector' | 'cvssV2BaseScore' | 'cvssV2Severity' | 'cvssV3Vector' | 'cvssV3BaseScore' | 'cvssV3Severity' | 'cvssV4Vector' | 'cvssV4BaseScore' | 'cvssV4Severity' | 'epssScore' | 'epssPercentile'>
        & { referenceUrls: Array<Maybe<(
          { __typename?: 'VulnerabilityReferenceUrl' }
          & Pick<VulnerabilityReferenceUrl, 'category' | 'url'>
        )>> }
      ), checkPackage: (
        { __typename?: 'CheckPackage' }
        & Pick<CheckPackage, 'id' | 'packageType' | 'packageGroup'>
      ), package: (
        { __typename?: 'Package' }
        & Pick<Package, 'id' | 'name'>
      ), packageVersion: (
        { __typename?: 'PackageVersion' }
        & Pick<PackageVersion, 'id' | 'version'>
      ), callStacks: (
        { __typename?: 'VulnerabilityCallStackConnection' }
        & Pick<VulnerabilityCallStackConnection, 'totalCount'>
        & { edges: Array<Maybe<(
          { __typename?: 'VulnerabilityCallStackEdge' }
          & { node?: Maybe<(
            { __typename?: 'VulnerabilityCallStack' }
            & Pick<VulnerabilityCallStack, 'id'>
            & { frames: (
              { __typename?: 'CallStackFrameConnection' }
              & Pick<CallStackFrameConnection, 'totalCount'>
              & { edges: Array<Maybe<(
                { __typename?: 'CallStackFrameEdge' }
                & { node?: Maybe<(
                  { __typename?: 'CallStackFrame' }
                  & Pick<CallStackFrame, 'id' | 'method' | 'filepath' | 'lineNumber' | 'code'>
                )> }
              )>> }
            ) }
          )> }
        )>> }
      ) }
    ) }
  )> }
);

export type FetchPackageUpgradeSummaryQueryVariables = Exact<{
  ecosystem: Ecosystem;
  packageName: Scalars['String'];
  fromVersion: Scalars['String'];
  toVersion: Scalars['String'];
}>;


export type FetchPackageUpgradeSummaryQuery = (
  { __typename?: 'Query' }
  & { packageUpgradeSummary?: Maybe<(
    { __typename?: 'PackageUpgradeSummary' }
    & Pick<PackageUpgradeSummary, 'id' | 'ecosystem' | 'packageName' | 'fromVersion' | 'toVersion' | 'breakingChanges' | 'otherChanges' | 'urls' | 'breakageRisk'>
  )> }
);

export type FetchPkgsListQueryVariables = Exact<{
  repo: Scalars['String'];
  owner: Scalars['String'];
  provider: VcsProviderChoices;
  targetId?: Maybe<Scalars['ID']>;
  packageType?: Maybe<PackageType>;
  severityIn?: Maybe<Array<Maybe<VulnerabilitySeverity>> | Maybe<VulnerabilitySeverity>>;
  licenseSafetyIn?: Maybe<Array<Maybe<LicenseSafetyFilter>> | Maybe<LicenseSafetyFilter>>;
  after?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
}>;


export type FetchPkgsListQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id'>
    & { packages: (
      { __typename?: 'RepositoryPackageConnection' }
      & Pick<RepositoryPackageConnection, 'totalCount'>
      & { pageInfo: (
        { __typename?: 'PageInfo' }
        & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage'>
      ), edges: Array<Maybe<(
        { __typename?: 'RepositoryPackageEdge' }
        & { node?: Maybe<(
          { __typename?: 'RepositoryPackage' }
          & Pick<RepositoryPackage, 'id' | 'packageGroup' | 'lowSeverityVulnerabilityCount' | 'mediumSeverityVulnerabilityCount' | 'highSeverityVulnerabilityCount' | 'criticalSeverityVulnerabilityCount'>
          & { package: (
            { __typename?: 'Package' }
            & Pick<Package, 'id' | 'name'>
          ), packageVersion: (
            { __typename?: 'PackageVersion' }
            & Pick<PackageVersion, 'id' | 'version'>
            & { licenses: (
              { __typename?: 'LicenseConnection' }
              & { edges: Array<Maybe<(
                { __typename?: 'LicenseEdge' }
                & { node?: Maybe<(
                  { __typename?: 'License' }
                  & Pick<License, 'identifier' | 'name' | 'isSafe'>
                )> }
              )>> }
            ) }
          ) }
        )> }
      )>> }
    ) }
  )> }
);

export type FetchRepositoryTargetQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchRepositoryTargetQuery = (
  { __typename?: 'Query' }
  & { repositoryTarget: (
    { __typename?: 'RepositoryTarget' }
    & Pick<RepositoryTarget, 'id' | 'ecosystem' | 'packageManager' | 'lockfilePath' | 'manifestPath' | 'isActivated' | 'hasSpdxSbom'>
    & { latestScaCheck?: Maybe<(
      { __typename?: 'SCACheck' }
      & Pick<ScaCheck, 'id' | 'createdAt'>
    )> }
  ) }
);

export type FetchTargetCountsQueryVariables = Exact<{
  name: Scalars['String'];
  owner: Scalars['String'];
  provider: VcsProviderChoices;
  targetId?: Maybe<Scalars['ID']>;
  q?: Maybe<Scalars['String']>;
  severityIn?: Maybe<Array<Maybe<VulnerabilitySeverity>> | Maybe<VulnerabilitySeverity>>;
  reachabilityIn?: Maybe<Array<Maybe<VulnerabilityOccurrenceReachability>> | Maybe<VulnerabilityOccurrenceReachability>>;
  fixabilityIn?: Maybe<Array<Maybe<VulnerabilityOccurrenceFixability>> | Maybe<VulnerabilityOccurrenceFixability>>;
}>;


export type FetchTargetCountsQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id'>
    & { directPackages: (
      { __typename?: 'RepositoryPackageConnection' }
      & Pick<RepositoryPackageConnection, 'totalCount'>
    ), transitivePackages: (
      { __typename?: 'RepositoryPackageConnection' }
      & Pick<RepositoryPackageConnection, 'totalCount'>
    ), unknownPackages: (
      { __typename?: 'RepositoryPackageConnection' }
      & Pick<RepositoryPackageConnection, 'totalCount'>
    ), directVulnerabilities: (
      { __typename?: 'VulnerabilityOccurrenceConnection' }
      & Pick<VulnerabilityOccurrenceConnection, 'totalCount'>
    ), transitiveVulnerabilities: (
      { __typename?: 'VulnerabilityOccurrenceConnection' }
      & Pick<VulnerabilityOccurrenceConnection, 'totalCount'>
    ), unknownVulnerabilities: (
      { __typename?: 'VulnerabilityOccurrenceConnection' }
      & Pick<VulnerabilityOccurrenceConnection, 'totalCount'>
    ) }
  )> }
);

export type FetchTargetsListQueryVariables = Exact<{
  repo: Scalars['String'];
  owner: Scalars['String'];
  provider: VcsProviderChoices;
  q?: Maybe<Scalars['String']>;
}>;


export type FetchTargetsListQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id'>
    & { targets: (
      { __typename?: 'RepositoryTargetConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'RepositoryTargetEdge' }
        & { node?: Maybe<(
          { __typename?: 'RepositoryTarget' }
          & Pick<RepositoryTarget, 'id' | 'ecosystem' | 'manifestPath' | 'lockfilePath' | 'isActivated' | 'source' | 'status' | 'packageManager' | 'createdAt' | 'directDependencyCount' | 'transitiveDependencyCount' | 'lowSeverityVulnerabilityCount' | 'mediumSeverityVulnerabilityCount' | 'highSeverityVulnerabilityCount' | 'criticalSeverityVulnerabilityCount'>
          & { errors: Array<Maybe<(
            { __typename?: 'AnalysisError' }
            & Pick<AnalysisError, 'level' | 'message'>
          )>>, latestScaCheck?: Maybe<(
            { __typename?: 'SCACheck' }
            & Pick<ScaCheck, 'id' | 'createdAt' | 'status'>
          )> }
        )> }
      )>> }
    ) }
  )> }
);

export type FetchTargetSettingsQueryVariables = Exact<{
  targetId: Scalars['ID'];
}>;


export type FetchTargetSettingsQuery = (
  { __typename?: 'Query' }
  & { repositoryTarget: (
    { __typename?: 'RepositoryTarget' }
    & Pick<RepositoryTarget, 'id' | 'isActivated' | 'ecosystem' | 'packageManager' | 'manifestPath' | 'lockfilePath'>
  ) }
);

export type FetchVulnsListQueryVariables = Exact<{
  repo: Scalars['String'];
  owner: Scalars['String'];
  provider: VcsProviderChoices;
  targetId?: Maybe<Scalars['ID']>;
  packageType?: Maybe<PackageType>;
  severityIn?: Maybe<Array<Maybe<VulnerabilitySeverity>> | Maybe<VulnerabilitySeverity>>;
  reachabilityIn?: Maybe<Array<Maybe<VulnerabilityOccurrenceReachability>> | Maybe<VulnerabilityOccurrenceReachability>>;
  fixabilityIn?: Maybe<Array<Maybe<VulnerabilityOccurrenceFixability>> | Maybe<VulnerabilityOccurrenceFixability>>;
  dynamicRiskLevelIn?: Maybe<Array<Maybe<DynamicRiskLevel>> | Maybe<DynamicRiskLevel>>;
  cvssScoreMin?: Maybe<Scalars['Float']>;
  cvssScoreMax?: Maybe<Scalars['Float']>;
  epssScoreMin?: Maybe<Scalars['Float']>;
  after?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
}>;


export type FetchVulnsListQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id'>
    & { vulnerabilityOccurrences: (
      { __typename?: 'VulnerabilityOccurrenceConnection' }
      & Pick<VulnerabilityOccurrenceConnection, 'totalCount'>
      & { pageInfo: (
        { __typename?: 'PageInfo' }
        & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage'>
      ), edges: Array<Maybe<(
        { __typename?: 'VulnerabilityOccurrenceEdge' }
        & { node?: Maybe<(
          { __typename?: 'VulnerabilityOccurrence' }
          & Pick<VulnerabilityOccurrence, 'id' | 'reachability' | 'fixability' | 'impliedSeverity' | 'isSeverityOverridden' | 'dynamicRiskLevel'>
          & { vulnerability: (
            { __typename?: 'Vulnerability' }
            & Pick<Vulnerability, 'id' | 'identifier' | 'summary' | 'fixedVersions'>
          ), package: (
            { __typename?: 'Package' }
            & Pick<Package, 'id' | 'name'>
          ), checkPackage: (
            { __typename?: 'CheckPackage' }
            & Pick<CheckPackage, 'id' | 'packageType'>
          ), packageVersion: (
            { __typename?: 'PackageVersion' }
            & Pick<PackageVersion, 'id' | 'version'>
          ) }
        )> }
      )>> }
    ) }
  )> }
);

export type SuperuserListQueryVariables = Exact<{ [key: string]: never; }>;


export type SuperuserListQuery = (
  { __typename?: 'Query' }
  & { enterprise?: Maybe<(
    { __typename?: 'EnterpriseInstallationRoot' }
    & { installation?: Maybe<(
      { __typename?: 'EnterpriseInstallationSetup' }
      & Pick<EnterpriseInstallationSetup, 'logo'>
    )>, superusers?: Maybe<(
      { __typename?: 'EnterpriseUserConnection' }
      & Pick<EnterpriseUserConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'EnterpriseUserEdge' }
        & { node?: Maybe<(
          { __typename?: 'EnterpriseUser' }
          & Pick<EnterpriseUser, 'id' | 'fullName' | 'email' | 'avatar'>
        )> }
      )>> }
    )> }
  )> }
);

export type GetGroupGeneralSettingsQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetGroupGeneralSettingsQuery = (
  { __typename?: 'Query' }
  & { repositoryGroup?: Maybe<(
    { __typename?: 'RepositoryGroup' }
    & Pick<RepositoryGroup, 'id' | 'name' | 'overrideRepoSetting' | 'isDefaultGroup' | 'repositoryCount'>
    & { primaryUser?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'fullName' | 'email'>
    )> }
  )> }
);

export type GetGroupRepositorySettingsQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetGroupRepositorySettingsQuery = (
  { __typename?: 'Query' }
  & { repositoryGroup?: Maybe<(
    { __typename?: 'RepositoryGroup' }
    & Pick<RepositoryGroup, 'id' | 'overrideRepoSetting'>
    & { repositoryGroupSetting?: Maybe<(
      { __typename?: 'RepositoryGroupSetting' }
      & Pick<RepositoryGroupSetting, 'id' | 'inferDefaultBranchCoverage' | 'inferDefaultBranchCommunity' | 'shouldTimeoutDataTrigger' | 'analyzeChangesetOnly' | 'encPublicKey'>
    )> }
  )> }
);

export type GetRepositoryGroupsListQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
  login: Scalars['String'];
  provider: VcsProviderChoices;
}>;


export type GetRepositoryGroupsListQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { repositoryGroups?: Maybe<(
      { __typename?: 'RepositoryGroupConnection' }
      & Pick<RepositoryGroupConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'RepositoryGroupEdge' }
        & { node?: Maybe<(
          { __typename?: 'RepositoryGroup' }
          & Pick<RepositoryGroup, 'id' | 'name' | 'repositoryCount' | 'isDefaultGroup' | 'slug' | 'createdAt' | 'modifiedAt'>
          & { primaryUser?: Maybe<(
            { __typename?: 'User' }
            & Pick<User, 'id' | 'fullName' | 'email' | 'avatar'>
          )> }
        )> }
      )>>, pageInfo: (
        { __typename?: 'PageInfo' }
        & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    )> }
  )> }
);

export type GetRepositoryGroupRepositoryIDsQueryVariables = Exact<{
  slug: Scalars['String'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  provider?: Maybe<VcsProviderChoices>;
}>;


export type GetRepositoryGroupRepositoryIDsQuery = (
  { __typename?: 'Query' }
  & { repositoryGroup?: Maybe<(
    { __typename?: 'RepositoryGroup' }
    & Pick<RepositoryGroup, 'id'>
    & { repositories?: Maybe<(
      { __typename?: 'RepositoryConnection' }
      & Pick<RepositoryConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'RepositoryEdge' }
        & { node?: Maybe<(
          { __typename?: 'Repository' }
          & Pick<Repository, 'id'>
        )> }
      )>>, pageInfo: (
        { __typename?: 'PageInfo' }
        & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    )> }
  )> }
);

export type GetRepositoryGroupRepositoriesQueryVariables = Exact<{
  slug: Scalars['String'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
  provider?: Maybe<VcsProviderChoices>;
}>;


export type GetRepositoryGroupRepositoriesQuery = (
  { __typename?: 'Query' }
  & { repositoryGroup?: Maybe<(
    { __typename?: 'RepositoryGroup' }
    & Pick<RepositoryGroup, 'id'>
    & { repositories?: Maybe<(
      { __typename?: 'RepositoryConnection' }
      & Pick<RepositoryConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'RepositoryEdge' }
        & { node?: Maybe<(
          { __typename?: 'Repository' }
          & Pick<Repository, 'id' | 'name' | 'displayName' | 'codeAnalysisStatus' | 'hasTestCoverage' | 'isScaEnabled' | 'isPrivate' | 'kind'>
        )> }
      )>>, pageInfo: (
        { __typename?: 'PageInfo' }
        & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    )> }
  )> }
);

export type GetRepositoryGroupQualityGatesSettingsQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetRepositoryGroupQualityGatesSettingsQuery = (
  { __typename?: 'Query' }
  & { repositoryGroup?: Maybe<(
    { __typename?: 'RepositoryGroup' }
    & Pick<RepositoryGroup, 'id'>
    & { issueTypeSettings?: Maybe<Array<Maybe<(
      { __typename?: 'IssueTypeSetting' }
      & Pick<IssueTypeSetting, 'slug' | 'name' | 'isIgnoredInCheckStatus' | 'isIgnoredToDisplay'>
    )>>>, issueSeveritySettings?: Maybe<Array<Maybe<(
      { __typename?: 'IssueSeveritySetting' }
      & Pick<IssueSeveritySetting, 'severity' | 'isIgnoredInCheckStatus'>
    )>>>, metricSettings?: Maybe<Array<Maybe<(
      { __typename?: 'RepositoryGroupMetricSetting' }
      & Pick<RepositoryGroupMetricSetting, 'shortcode' | 'name' | 'isIgnoredInCheckStatus' | 'isIgnoredToDisplay' | 'threshold'>
    )>>>, repositoryGroupSetting?: Maybe<(
      { __typename?: 'RepositoryGroupSetting' }
      & Pick<RepositoryGroupSetting, 'id' | 'vcsReportingOptionsEnabled' | 'gitlabIntegrationUseStatus'>
    )> }
  )> }
);

export type FetchGroupCodeCoverageReportQueryVariables = Exact<{
  slug: Scalars['String'];
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  q?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
}>;


export type FetchGroupCodeCoverageReportQuery = (
  { __typename?: 'Query' }
  & { repositoryGroup?: Maybe<(
    { __typename?: 'RepositoryGroup' }
    & Pick<RepositoryGroup, 'id'>
    & { repositoriesCoverageReport?: Maybe<(
      { __typename?: 'RepositoryCoverageReportItemConnection' }
      & Pick<RepositoryCoverageReportItemConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'RepositoryCoverageReportItemEdge' }
        & { node?: Maybe<(
          { __typename?: 'RepositoryCoverageReportItem' }
          & Pick<RepositoryCoverageReportItem, 'id' | 'name' | 'lcvValue' | 'lcvIsPassing' | 'bcvValue' | 'bcvIsPassing'>
        )> }
      )>> }
    )> }
  )> }
);

export type FetchGroupInformationQueryVariables = Exact<{
  groupSlug: Scalars['String'];
}>;


export type FetchGroupInformationQuery = (
  { __typename?: 'Query' }
  & { repositoryGroup?: Maybe<(
    { __typename?: 'RepositoryGroup' }
    & Pick<RepositoryGroup, 'id' | 'name' | 'isDefaultGroup'>
  )> }
);

export type FetchGroupPinnedReportsQueryVariables = Exact<{
  groupSlug: Scalars['String'];
}>;


export type FetchGroupPinnedReportsQuery = (
  { __typename?: 'Query' }
  & { repositoryGroup?: Maybe<(
    { __typename?: 'RepositoryGroup' }
    & Pick<RepositoryGroup, 'id'>
    & { repoGroupSetting?: Maybe<(
      { __typename?: 'RepositoryGroupSetting' }
      & Pick<RepositoryGroupSetting, 'id'>
      & { pinnedReports?: Maybe<Array<Maybe<(
        { __typename?: 'PinnedReport' }
        & Pick<PinnedReport, 'key' | 'metadata'>
      )>>> }
    )> }
  )> }
);

export type FetchReposWithIssuesInGroupQueryVariables = Exact<{
  groupSlug: Scalars['String'];
  tag: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  q?: Maybe<Scalars['String']>;
}>;


export type FetchReposWithIssuesInGroupQuery = (
  { __typename?: 'Query' }
  & { repositoryGroup?: Maybe<(
    { __typename?: 'RepositoryGroup' }
    & Pick<RepositoryGroup, 'id'>
    & { repositoriesWithComplianceIssue?: Maybe<(
      { __typename?: 'RepositoryComplianceReportItemConnection' }
      & Pick<RepositoryComplianceReportItemConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'RepositoryComplianceReportItemEdge' }
        & { node?: Maybe<(
          { __typename?: 'RepositoryComplianceReportItem' }
          & Pick<RepositoryComplianceReportItem, 'id' | 'name' | 'displayName' | 'minorCount' | 'majorCount' | 'criticalCount' | 'totalCount' | 'kind' | 'isPrivate'>
          & { availableAnalyzers?: Maybe<(
            { __typename?: 'AnalyzerConnection' }
            & { edges: Array<Maybe<(
              { __typename?: 'AnalyzerEdge' }
              & { node?: Maybe<(
                { __typename?: 'Analyzer' }
                & Pick<Analyzer, 'id' | 'name' | 'shortcode' | 'analyzerLogo'>
              )> }
            )>> }
          )> }
        )> }
      )>> }
    )> }
  )> }
);

export type HealthCheckAnalyzersQueryVariables = Exact<{ [key: string]: never; }>;


export type HealthCheckAnalyzersQuery = (
  { __typename?: 'Query' }
  & { analyzers?: Maybe<(
    { __typename?: 'AnalyzerConnection' }
    & Pick<AnalyzerConnection, 'totalCount'>
  )> }
);

export type IntegrationDetailQueryVariables = Exact<{
  shortcode: Scalars['String'];
  level?: Maybe<IntegrationSettingsLevel>;
  ownerId?: Maybe<Scalars['ID']>;
  repositoryId?: Maybe<Scalars['ID']>;
}>;


export type IntegrationDetailQuery = (
  { __typename?: 'Query' }
  & { integration?: Maybe<(
    { __typename?: 'IntegrationProvider' }
    & Pick<IntegrationProvider, 'shortcode' | 'logo' | 'status' | 'installed' | 'installedOn' | 'enabledOn' | 'settings' | 'options'>
    & { enabledBy?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'email' | 'avatar' | 'fullName'>
    )> }
  )> }
);

export type IntegrationInstallationStatusQueryVariables = Exact<{
  shortcode: Scalars['String'];
  level?: Maybe<IntegrationSettingsLevel>;
  ownerId?: Maybe<Scalars['ID']>;
  repositoryId?: Maybe<Scalars['ID']>;
}>;


export type IntegrationInstallationStatusQuery = (
  { __typename?: 'Query' }
  & { integration?: Maybe<(
    { __typename?: 'IntegrationProvider' }
    & Pick<IntegrationProvider, 'installed'>
  )> }
);

export type IntegrationLogoUrlQueryVariables = Exact<{
  shortcode: Scalars['String'];
  level?: Maybe<IntegrationSettingsLevel>;
  ownerId?: Maybe<Scalars['ID']>;
  repositoryId?: Maybe<Scalars['ID']>;
}>;


export type IntegrationLogoUrlQuery = (
  { __typename?: 'Query' }
  & { integration?: Maybe<(
    { __typename?: 'IntegrationProvider' }
    & Pick<IntegrationProvider, 'logo'>
  )> }
);

export type ListIntegrationsQueryVariables = Exact<{
  level?: Maybe<IntegrationSettingsLevel>;
  ownerId?: Maybe<Scalars['ID']>;
  repositoryId?: Maybe<Scalars['ID']>;
  onlyInstalled?: Maybe<Scalars['Boolean']>;
}>;


export type ListIntegrationsQuery = (
  { __typename?: 'Query' }
  & { integrations?: Maybe<Array<Maybe<(
    { __typename?: 'IntegrationProvider' }
    & Pick<IntegrationProvider, 'shortcode' | 'name' | 'logo' | 'installed' | 'status'>
  )>>> }
);

export type GetTeamInviteInfoQueryVariables = Exact<{
  invitationCode: Scalars['String'];
}>;


export type GetTeamInviteInfoQuery = (
  { __typename?: 'Query' }
  & { getTeamInviteInfo?: Maybe<(
    { __typename?: 'TeamInviteInfo' }
    & Pick<TeamInviteInfo, 'teamLogin' | 'teamName' | 'teamLogo' | 'vcsProvider' | 'joined' | 'role'>
  )> }
);

export type GetAnIssueQueryVariables = Exact<{
  shortcode: Scalars['String'];
}>;


export type GetAnIssueQuery = (
  { __typename?: 'Query' }
  & { issue?: Maybe<(
    { __typename?: 'Issue' }
    & Pick<Issue, 'title' | 'descriptionRendered' | 'severity' | 'autofixAvailable' | 'shortcode' | 'issueType' | 'tags'>
  )> }
);

export type ConfigGenerationRunQueryVariables = Exact<{
  runId: Scalars['String'];
}>;


export type ConfigGenerationRunQuery = (
  { __typename?: 'Query' }
  & { configGenerationRun: (
    { __typename?: 'ConfigGenerationRun' }
    & Pick<ConfigGenerationRun, 'id' | 'runId' | 'status'>
  ) }
);

export type OnboardingInviteInfoQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
}>;


export type OnboardingInviteInfoQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { team?: Maybe<(
      { __typename?: 'EnterpriseTeam' }
      & Pick<EnterpriseTeam, 'id' | 'invitationUrl'>
    )> }
  )> }
);

export type FetchLatestConfigGenerationRunQueryVariables = Exact<{
  repo: Scalars['String'];
  owner: Scalars['String'];
  provider: VcsProviderChoices;
}>;


export type FetchLatestConfigGenerationRunQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id' | 'vcsHost'>
    & { configGenerationRuns: (
      { __typename?: 'ConfigGenerationRunConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ConfigGenerationRunEdge' }
        & { node?: Maybe<(
          { __typename?: 'ConfigGenerationRun' }
          & Pick<ConfigGenerationRun, 'id' | 'status' | 'generatedConfig'>
        )> }
      )>> }
    ) }
  )> }
);

export type OnboardingOwnerProfileQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
}>;


export type OnboardingOwnerProfileQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'isTeam'>
    & { profile?: Maybe<(
      { __typename?: 'OwnerProfile' }
      & Pick<OwnerProfile, 'id' | 'productInterests'>
    )> }
  )>, viewer?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id'>
    & { profile?: Maybe<(
      { __typename?: 'UserProfile' }
      & Pick<UserProfile, 'id' | 'firstName' | 'lastName' | 'company' | 'companySize' | 'role' | 'referralSource' | 'completedAt'>
    )> }
  )> }
);

export type FetchRepositoryVcsPullRequestsQueryVariables = Exact<{
  name: Scalars['String'];
  owner: Scalars['String'];
  provider: VcsProviderChoices;
  q?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type FetchRepositoryVcsPullRequestsQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id'>
    & { vcsPullRequests: (
      { __typename?: 'VCSPullRequestConnection' }
      & { edges: Array<(
        { __typename?: 'VCSPullRequestEdge' }
        & Pick<VcsPullRequestEdge, 'cursor'>
        & { node: (
          { __typename?: 'VCSPullRequest' }
          & Pick<VcsPullRequest, 'number' | 'title'>
        ) }
      )> }
    ) }
  )> }
);

export type FetchOnboardingRepositoryListQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
  query?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type FetchOnboardingRepositoryListQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { repositories?: Maybe<(
      { __typename?: 'RepositoryConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'RepositoryEdge' }
        & Pick<RepositoryEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'Repository' }
          & Pick<Repository, 'id' | 'name'>
        )> }
      )>> }
    )> }
  )> }
);

export type FetchOnboardingBaselineStatusQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
}>;


export type FetchOnboardingBaselineStatusQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id' | 'vcsUrl'>
    & { latestAnalysisRun?: Maybe<(
      { __typename?: 'Run' }
      & Pick<Run, 'id' | 'status'>
    )> }
  )> }
);

export type FetchOnboardingPrRunStatusQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
  q: Scalars['String'];
}>;


export type FetchOnboardingPrRunStatusQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id'>
    & { prs?: Maybe<(
      { __typename?: 'PRConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'PREdge' }
        & { node?: Maybe<(
          { __typename?: 'PR' }
          & Pick<Pr, 'id' | 'number' | 'vcsUrl'>
          & { latestAnalysisRun?: Maybe<(
            { __typename?: 'Run' }
            & Pick<Run, 'id' | 'status'>
          )> }
        )> }
      )>> }
    )> }
  )> }
);

export type AccountSetupStatusQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
}>;


export type AccountSetupStatusQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'accountSetupStatus'>
  )> }
);

export type AppConfigQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
}>;


export type AppConfigQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'appConfigurationUrl' | 'hasGrantedAllRepoAccess'>
  )> }
);

export type BillingQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
}>;


export type BillingQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'login' | 'billingVersion' | 'vcsInstallationId' | 'hasPremiumPlan'>
    & { billingInfo?: Maybe<(
      { __typename?: 'BillingInfo' }
      & Pick<BillingInfo, 'billingEmail' | 'billingAddress' | 'planSlug' | 'status' | 'upgradePlans' | 'downgradePlans' | 'seatsTotal' | 'seatsUsed' | 'lastBillAmount' | 'upcomingBillAmount' | 'lastPaymentDate' | 'upcomingPaymentDate' | 'lastInvoiceUrl' | 'cancelAtPeriodEnd' | 'upcomingCancellationDate' | 'outstandingCredits' | 'billingBackend' | 'synced' | 'pendingUpdate' | 'clientSecret'>
      & { couponApplied?: Maybe<(
        { __typename?: 'AppliedCoupon' }
        & Pick<AppliedCoupon, 'code' | 'description'>
      )>, activeCard?: Maybe<(
        { __typename?: 'Card' }
        & Pick<Card, 'brand' | 'endingIn' | 'expYear' | 'expMonth'>
      )>, invoices?: Maybe<Array<Maybe<(
        { __typename?: 'Invoice' }
        & Pick<Invoice, 'invoiceId' | 'date' | 'amount' | 'url'>
      )>>> }
    )> }
  )> }
);

export type OwnerDetailsQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
  fetchPrimaryUser: Scalars['Boolean'];
}>;


export type OwnerDetailsQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'isTeam' | 'avatar' | 'vcsInstallationId' | 'hasSubscribedToPlan' | 'autofixInstallationUrl' | 'isAutofixEnabled' | 'isAutoonboardAllowed' | 'hasPremiumPlan' | 'canOnboard' | 'isViewerPrimaryUser' | 'IsBetaTester' | 'billingVersion'>
    & { team?: Maybe<(
      { __typename?: 'EnterpriseTeam' }
      & Pick<EnterpriseTeam, 'id'>
    )>, primaryUser?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'email' | 'fullName'>
    )> }
  )> }
);

export type GeneralDataQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
}>;


export type GeneralDataQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'vcsInstallationId' | 'autofixInstallationUrl' | 'isAutofixEnabled'>
    & { team?: Maybe<(
      { __typename?: 'EnterpriseTeam' }
      & Pick<EnterpriseTeam, 'id' | 'name' | 'avatar' | 'login'>
      & { membersCount: EnterpriseTeam['numMembersTotal'] }
    )> }
  )> }
);

export type OwnerIdQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
}>;


export type OwnerIdQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
  )> }
);

export type OwnerBetaStatusQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
}>;


export type OwnerBetaStatusQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'IsBetaTester'>
  )> }
);

export type MaxUsagePercentageQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
}>;


export type MaxUsagePercentageQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'login' | 'maxUsagePercentage'>
    & { billingInfo?: Maybe<(
      { __typename?: 'BillingInfo' }
      & Pick<BillingInfo, 'planSlug'>
    )> }
  )> }
);

export type OwnerInstalledIntegrationQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
  feature?: Maybe<IntegrationFeature>;
}>;


export type OwnerInstalledIntegrationQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { installedIntegrations?: Maybe<Array<Maybe<(
      { __typename?: 'IntegrationProvider' }
      & Pick<IntegrationProvider, 'shortcode'>
    )>>> }
  )> }
);

export type OwnerRepoCountsQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
}>;


export type OwnerRepoCountsQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { activeRepoCount?: Maybe<(
      { __typename?: 'RepositoryConnection' }
      & Pick<RepositoryConnection, 'totalCount'>
    )>, inactiveRepoCount?: Maybe<(
      { __typename?: 'RepositoryConnection' }
      & Pick<RepositoryConnection, 'totalCount'>
    )>, monorepoCount?: Maybe<(
      { __typename?: 'RepositoryConnection' }
      & Pick<RepositoryConnection, 'totalCount'>
    )> }
  )> }
);

export type OwnerRepoListQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
  getSubrepoCount: Scalars['Boolean'];
  isActivated?: Maybe<Scalars['Boolean']>;
  kindIn?: Maybe<Array<Maybe<RepositoryKindChoices>> | Maybe<RepositoryKindChoices>>;
  limit?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
  fetchSupportedAnalyzers?: Maybe<Scalars['Boolean']>;
}>;


export type OwnerRepoListQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { repositories?: Maybe<(
      { __typename?: 'RepositoryConnection' }
      & Pick<RepositoryConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'RepositoryEdge' }
        & { node?: Maybe<(
          { __typename?: 'Repository' }
          & MakeOptional<Pick<Repository, 'id' | 'name' | 'displayName' | 'kind' | 'vcsProvider' | 'ownerLogin' | 'createdAt' | 'modifiedAt' | 'isActivated' | 'isPrivate' | 'latestCommitOid' | 'defaultBranchName' | 'lastAnalyzedAt' | 'canBeActivated' | 'supportedAnalyzers'>, 'supportedAnalyzers'>
          & { availableAnalyzers?: Maybe<(
            { __typename?: 'AnalyzerConnection' }
            & { edges: Array<Maybe<(
              { __typename?: 'AnalyzerEdge' }
              & { node?: Maybe<(
                { __typename?: 'Analyzer' }
                & Pick<Analyzer, 'id' | 'shortcode' | 'name' | 'logo' | 'analyzerLogo'>
              )> }
            )>> }
          )>, subRepos?: Maybe<(
            { __typename?: 'RepositoryConnection' }
            & Pick<RepositoryConnection, 'totalCount'>
          )> }
        )> }
      )>> }
    )> }
  )> }
);

export type GetOwnerRepoListSlimQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  kindIn?: Maybe<Array<Maybe<RepositoryKindChoices>> | Maybe<RepositoryKindChoices>>;
  query?: Maybe<Scalars['String']>;
  is_monorepo: Scalars['Boolean'];
}>;


export type GetOwnerRepoListSlimQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { repositories?: Maybe<(
      { __typename?: 'RepositoryConnection' }
      & Pick<RepositoryConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'RepositoryEdge' }
        & { node?: Maybe<(
          { __typename?: 'Repository' }
          & MakeOptional<Pick<Repository, 'id' | 'name' | 'displayName' | 'kind' | 'isPrivate' | 'codeAnalysisStatus' | 'hasTestCoverage' | 'isScaEnabled'>, 'codeAnalysisStatus' | 'hasTestCoverage' | 'isScaEnabled'>
          & { subRepos?: Maybe<(
            { __typename?: 'RepositoryConnection' }
            & Pick<RepositoryConnection, 'totalCount'>
          )>, repositoryGroup?: Maybe<(
            { __typename?: 'RepositoryGroup' }
            & Pick<RepositoryGroup, 'id' | 'name' | 'slug' | 'isDefaultGroup'>
          )> }
        )> }
      )>> }
    )> }
  )> }
);

export type FetchOwnerStatsQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
}>;


export type FetchOwnerStatsQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { monthlyStats: (
      { __typename?: 'OwnerMonthlyStats' }
      & Pick<OwnerMonthlyStats, 'commitsAnalyzed' | 'issuesPrevented' | 'dependenciesUpdated' | 'vulnerabilitiesDetected'>
    ) }
  )> }
);

export type OwnerPinnedReportsQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
}>;


export type OwnerPinnedReportsQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { setting?: Maybe<(
      { __typename?: 'OwnerSetting' }
      & { pinnedReports?: Maybe<Array<Maybe<(
        { __typename?: 'PinnedReport' }
        & Pick<PinnedReport, 'key' | 'metadata'>
      )>>> }
    )> }
  )> }
);

export type PublicReportListOwnerQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  q?: Maybe<Scalars['String']>;
}>;


export type PublicReportListOwnerQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { publicReports?: Maybe<(
      { __typename?: 'PublicReportConnection' }
      & Pick<PublicReportConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'PublicReportEdge' }
        & { node?: Maybe<(
          { __typename?: 'PublicReport' }
          & Pick<PublicReport, 'reportId' | 'label' | 'views' | 'createdAt' | 'isRestricted' | 'shareHistoricalData' | 'reportKeys' | 'source'>
          & { sourcedRepositories?: Maybe<(
            { __typename?: 'RepositoryConnection' }
            & Pick<RepositoryConnection, 'totalCount'>
          )> }
        )> }
      )>> }
    )> }
  )> }
);

export type OwnerPullRequestsQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
  isAuthorViewer?: Maybe<Scalars['Boolean']>;
  first?: Maybe<Scalars['Int']>;
}>;


export type OwnerPullRequestsQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { pullRequests?: Maybe<(
      { __typename?: 'PRConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'PREdge' }
        & { node?: Maybe<(
          { __typename?: 'PR' }
          & Pick<Pr, 'id' | 'number' | 'title' | 'status' | 'modifiedAt' | 'raisedCount' | 'resolvedCount' | 'suppressedCount'>
          & { repository?: Maybe<(
            { __typename?: 'Repository' }
            & Pick<Repository, 'id' | 'name' | 'isPrivate' | 'vcsProvider' | 'ownerLogin'>
          )>, latestAnalysisRun?: Maybe<(
            { __typename?: 'Run' }
            & Pick<Run, 'id' | 'runId' | 'status'>
            & { reportCard?: Maybe<(
              { __typename?: 'RunReport' }
              & { aggregate?: Maybe<(
                { __typename?: 'RunReportAggregate' }
                & Pick<RunReportAggregate, 'grade'>
              )> }
            )> }
          )> }
        )> }
      )>> }
    )> }
  )> }
);

export type ScaBillingQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
}>;


export type ScaBillingQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { productSubscription?: Maybe<(
      { __typename?: 'ProductSubscription' }
      & Pick<ProductSubscription, 'id' | 'status' | 'billingBackend'>
      & { product: { __typename?: 'AgentsProduct' } | { __typename?: 'CodeQualityProduct' } | { __typename?: 'IDEProduct' } | (
        { __typename?: 'SCAProduct' }
        & Pick<ScaProduct, 'id' | 'plan' | 'targetQuantity'>
      ) | { __typename?: 'UnifiedProduct' }, billingDetails: (
        { __typename?: 'BillingDetails' }
        & Pick<BillingDetails, 'id' | 'billingInterval' | 'nextBillingCycle' | 'upcomingBillingAmount' | 'cancelAtPeriodEnd'>
      ) }
    )> }
  )> }
);

export type SeatsInfoQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
}>;


export type SeatsInfoQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { billingInfo?: Maybe<(
      { __typename?: 'BillingInfo' }
      & Pick<BillingInfo, 'seatsTotal' | 'seatsUsed'>
    )> }
  )> }
);

export type GetOwnerDynamicRiskConfigQueryVariables = Exact<{
  ownerLogin: Scalars['String'];
  vcsProvider: VcsProviderChoices;
}>;


export type GetOwnerDynamicRiskConfigQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'login' | 'vcsProvider'>
    & { ownerSetting?: Maybe<(
      { __typename?: 'OwnerSetting' }
      & Pick<OwnerSetting, 'id'>
      & { dynamicRiskConfig?: Maybe<(
        { __typename?: 'OwnerDynamicRiskConfig' }
        & Pick<OwnerDynamicRiskConfig, 'id' | 'cvssWeight' | 'epssWeight' | 'percentileStrategy' | 'reachableWeight' | 'unreachableWeight' | 'unknownWeight'>
      )> }
    )> }
  )> }
);

export type GetLicensePolicyQueryVariables = Exact<{
  ownerLogin: Scalars['String'];
  vcsProvider: VcsProviderChoices;
}>;


export type GetLicensePolicyQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'login' | 'vcsProvider'>
    & { ownerSetting?: Maybe<(
      { __typename?: 'OwnerSetting' }
      & Pick<OwnerSetting, 'id'>
      & { licensePolicy?: Maybe<(
        { __typename?: 'OwnerLicensePolicy' }
        & Pick<OwnerLicensePolicy, 'id' | 'isNonOsiApprovedSafe' | 'isNonFsfFreeLibreSafe' | 'isDeprecatedSafe' | 'customSafeLicenseIdentifiers' | 'customUnsafeLicenseIdentifiers'>
      )> }
    )> }
  )> }
);

export type GetOwnerAiPolicyQueryVariables = Exact<{
  ownerLogin: Scalars['String'];
  vcsProvider: VcsProviderChoices;
}>;


export type GetOwnerAiPolicyQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'login' | 'vcsProvider'>
    & { ownerSetting?: Maybe<(
      { __typename?: 'OwnerSetting' }
      & Pick<OwnerSetting, 'id'>
      & { aiPolicy?: Maybe<(
        { __typename?: 'OwnerAIPolicy' }
        & Pick<OwnerAiPolicy, 'id' | 'isAiAgentsEnabled' | 'useAiSecretsDetection' | 'useAiAutofix' | 'autoTriggerAiReview' | 'isAutofixCommitSuggestionsEnabled'>
      )> }
    )> }
  )> }
);

export type GetOwnerScaPolicyQueryVariables = Exact<{
  ownerLogin: Scalars['String'];
  vcsProvider: VcsProviderChoices;
}>;


export type GetOwnerScaPolicyQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'login' | 'vcsProvider'>
    & { ownerSetting?: Maybe<(
      { __typename?: 'OwnerSetting' }
      & Pick<OwnerSetting, 'id' | 'vulnerabilityNotificationAlertAllAdmins' | 'vulnerabilityNotificationEmails' | 'vulnerabilityNotificationThreshold'>
      & { scaPolicy?: Maybe<(
        { __typename?: 'OwnerSCAPolicy' }
        & Pick<OwnerScaPolicy, 'id' | 'blockPrs' | 'packageTypes' | 'packageGroups' | 'severity' | 'reachability' | 'fixability' | 'dynamicRisk' | 'cvssV4Min' | 'cvssV4Max' | 'cvssV3Min' | 'cvssV3Max' | 'cvssV2Min' | 'cvssV2Max' | 'epssScoreMin' | 'epssScoreMax' | 'epssPercentileMin' | 'epssPercentileMax'>
      )> }
    )> }
  )> }
);

export type IssueTypeSettingsQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
}>;


export type IssueTypeSettingsQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { ownerSetting?: Maybe<(
      { __typename?: 'OwnerSetting' }
      & Pick<OwnerSetting, 'id'>
      & { issueTypeSettings?: Maybe<Array<Maybe<(
        { __typename?: 'IssueTypeSetting' }
        & Pick<IssueTypeSetting, 'slug' | 'name' | 'isIgnoredInCheckStatus' | 'isIgnoredToDisplay' | 'description'>
      )>>> }
    )> }
  )> }
);

export type SearchLicensesQueryVariables = Exact<{
  query?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type SearchLicensesQuery = (
  { __typename?: 'Query' }
  & { licenses?: Maybe<(
    { __typename?: 'LicenseConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'LicenseEdge' }
      & { node?: Maybe<(
        { __typename?: 'License' }
        & Pick<License, 'id' | 'identifier'>
      )> }
    )>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'endCursor'>
    ) }
  )> }
);

export type FetchAutofixAiSettingsQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
}>;


export type FetchAutofixAiSettingsQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { ownerSetting?: Maybe<(
      { __typename?: 'OwnerSetting' }
      & Pick<OwnerSetting, 'id' | 'useLegacyAutofix'>
    )> }
  )> }
);

export type LegacySecretAnalyzerSettingQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
}>;


export type LegacySecretAnalyzerSettingQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { ownerSetting?: Maybe<(
      { __typename?: 'OwnerSetting' }
      & Pick<OwnerSetting, 'id' | 'useLegacySecretAnalyzer'>
    )> }
  )> }
);

export type OwnerPreferencesQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
}>;


export type OwnerPreferencesQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { ownerSetting?: Maybe<(
      { __typename?: 'OwnerSetting' }
      & Pick<OwnerSetting, 'id' | 'shouldTimeoutDataTrigger'>
    )> }
  )> }
);

export type OwnerPublicKeyQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
}>;


export type OwnerPublicKeyQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { ownerSetting?: Maybe<(
      { __typename?: 'OwnerSetting' }
      & Pick<OwnerSetting, 'id' | 'publicKey'>
    )> }
  )> }
);

export type ShouldCommitConfigSettingQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
}>;


export type ShouldCommitConfigSettingQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { ownerSetting?: Maybe<(
      { __typename?: 'OwnerSetting' }
      & Pick<OwnerSetting, 'id' | 'shouldCommitConfig'>
    )> }
  )> }
);

export type OwnerTrialInfoQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
}>;


export type OwnerTrialInfoQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'login'>
    & { team?: Maybe<(
      { __typename?: 'EnterpriseTeam' }
      & Pick<EnterpriseTeam, 'id'>
      & { slackConnectChannel?: Maybe<(
        { __typename?: 'SlackConnectChannelType' }
        & Pick<SlackConnectChannelType, 'status' | 'channelName'>
      )> }
    )>, productSubscription?: Maybe<(
      { __typename?: 'ProductSubscription' }
      & Pick<ProductSubscription, 'id'>
      & { product: { __typename?: 'AgentsProduct' } | { __typename?: 'CodeQualityProduct' } | { __typename?: 'IDEProduct' } | { __typename?: 'SCAProduct' } | (
        { __typename?: 'UnifiedProduct' }
        & Pick<UnifiedProduct, 'id' | 'plan' | 'createdAt'>
      ), billingDetails: (
        { __typename?: 'BillingDetails' }
        & Pick<BillingDetails, 'id' | 'trialEndsAt'>
      ) }
    )> }
  )> }
);

export type UnifiedBillingQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
}>;


export type UnifiedBillingQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'login'>
    & { productSubscription?: Maybe<(
      { __typename?: 'ProductSubscription' }
      & Pick<ProductSubscription, 'id' | 'status' | 'billingBackend'>
      & { product: { __typename?: 'AgentsProduct' } | { __typename?: 'CodeQualityProduct' } | { __typename?: 'IDEProduct' } | { __typename?: 'SCAProduct' } | (
        { __typename?: 'UnifiedProduct' }
        & Pick<UnifiedProduct, 'id' | 'plan' | 'seatQuantity' | 'scaTargetQuantity' | 'isAutoTopupEnabled' | 'autoTopupThreshold' | 'autoTopupAmount' | 'autoTopupMax'>
      ), billingDetails: (
        { __typename?: 'BillingDetails' }
        & Pick<BillingDetails, 'id' | 'billingEmail' | 'billingInterval' | 'nextBillingCycle' | 'cancelAtPeriodEnd' | 'lastBillingAmount' | 'upcomingBillingAmount' | 'usageCredits' | 'promotionalCredits'>
        & { billingAddress?: Maybe<(
          { __typename?: 'BillingAddress' }
          & Pick<BillingAddress, 'line1' | 'line2' | 'city' | 'country' | 'state' | 'postalCode'>
        )>, cards?: Maybe<Array<Maybe<(
          { __typename?: 'Card' }
          & Pick<Card, 'id' | 'brand' | 'endingIn' | 'expYear' | 'expMonth' | 'isDefault'>
        )>>>, invoices?: Maybe<Array<Maybe<(
          { __typename?: 'Invoice' }
          & Pick<Invoice, 'invoiceId' | 'date' | 'amount' | 'amountCents' | 'status' | 'url'>
        )>>> }
      ) }
    )> }
  )> }
);

export type UnifiedBillingCardsQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
}>;


export type UnifiedBillingCardsQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { productSubscription?: Maybe<(
      { __typename?: 'ProductSubscription' }
      & Pick<ProductSubscription, 'id'>
      & { billingDetails: (
        { __typename?: 'BillingDetails' }
        & Pick<BillingDetails, 'id'>
        & { cards?: Maybe<Array<Maybe<(
          { __typename?: 'Card' }
          & Pick<Card, 'id' | 'brand' | 'endingIn' | 'expYear' | 'expMonth' | 'isDefault'>
        )>>> }
      ) }
    )> }
  )> }
);

export type UnifiedBillingCreditsQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
}>;


export type UnifiedBillingCreditsQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { productSubscription?: Maybe<(
      { __typename?: 'ProductSubscription' }
      & Pick<ProductSubscription, 'id'>
      & { billingDetails: (
        { __typename?: 'BillingDetails' }
        & Pick<BillingDetails, 'id' | 'usageCredits' | 'promotionalCredits'>
      ) }
    )> }
  )> }
);

export type UsagePageQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
}>;


export type UsagePageQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { usage: (
      { __typename?: 'Usage' }
      & { totalSpend?: Maybe<(
        { __typename?: 'GroupedUsageMetric' }
        & Pick<GroupedUsageMetric, 'labels'>
        & { series: Array<(
          { __typename?: 'UsageMetricSeries' }
          & Pick<UsageMetricSeries, 'name' | 'total' | 'values'>
        )> }
      )>, locProcessedCodeReview?: Maybe<(
        { __typename?: 'GroupedUsageMetric' }
        & Pick<GroupedUsageMetric, 'labels'>
        & { series: Array<(
          { __typename?: 'UsageMetricSeries' }
          & Pick<UsageMetricSeries, 'name' | 'total' | 'values'>
        )> }
      )>, locProcessedSecrets?: Maybe<(
        { __typename?: 'GroupedUsageMetric' }
        & Pick<GroupedUsageMetric, 'labels'>
        & { series: Array<(
          { __typename?: 'UsageMetricSeries' }
          & Pick<UsageMetricSeries, 'name' | 'total' | 'values'>
        )> }
      )>, commitsReviewed?: Maybe<(
        { __typename?: 'GroupedUsageMetric' }
        & Pick<GroupedUsageMetric, 'labels'>
        & { series: Array<(
          { __typename?: 'UsageMetricSeries' }
          & Pick<UsageMetricSeries, 'name' | 'total' | 'values'>
        )> }
      )>, prsReviewed?: Maybe<(
        { __typename?: 'GroupedUsageMetric' }
        & Pick<GroupedUsageMetric, 'labels'>
        & { series: Array<(
          { __typename?: 'UsageMetricSeries' }
          & Pick<UsageMetricSeries, 'name' | 'total' | 'values'>
        )> }
      )> }
    ) }
  )> }
);

export type UsageDetailsQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
}>;


export type UsageDetailsQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'features' | 'featureUsage'>
  )> }
);

export type FetchUsageSummaryQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
}>;


export type FetchUsageSummaryQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'login'>
    & { usageSummary: (
      { __typename?: 'UsageSummary' }
      & Pick<UsageSummary, 'id' | 'creditsAvailable' | 'creditsUsed' | 'creditsAllocated' | 'prReviewedCount' | 'commitReviewedCount' | 'ossTargetsCount'>
    ) }
  )> }
);

export type UsageTargetsQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type UsageTargetsQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { usage: (
      { __typename?: 'Usage' }
      & { activatedTargets?: Maybe<(
        { __typename?: 'RepositoryTargetConnection' }
        & Pick<RepositoryTargetConnection, 'totalCount'>
        & { edges: Array<Maybe<(
          { __typename?: 'RepositoryTargetEdge' }
          & { node?: Maybe<(
            { __typename?: 'RepositoryTarget' }
            & Pick<RepositoryTarget, 'id' | 'lockfilePath'>
            & { repository: (
              { __typename?: 'Repository' }
              & Pick<Repository, 'id' | 'name'>
            ) }
          )> }
        )>> }
      )> }
    ) }
  )> }
);

export type WebhookEventDeliveryQueryVariables = Exact<{
  ownerId: Scalars['ID'];
  deliveryId: Scalars['ID'];
}>;


export type WebhookEventDeliveryQuery = (
  { __typename?: 'Query' }
  & { webhookEventDelivery?: Maybe<(
    { __typename?: 'WebhookEventDelivery' }
    & Pick<WebhookEventDelivery, 'id' | 'eventId' | 'deliveryId' | 'finishedIn' | 'createdAt' | 'retryCount' | 'httpStatusCode' | 'payload'>
    & { webhook: (
      { __typename?: 'Webhook' }
      & Pick<Webhook, 'id' | 'url'>
    ), eventType: (
      { __typename?: 'WebhookEventTypes' }
      & Pick<WebhookEventTypes, 'id' | 'name' | 'shortcode' | 'shortDescription'>
    ) }
  )> }
);

export type WebhookDeliveriesQueryVariables = Exact<{
  webhookId: Scalars['ID'];
  limit?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type WebhookDeliveriesQuery = (
  { __typename?: 'Query' }
  & { webhook?: Maybe<(
    { __typename?: 'Webhook' }
    & Pick<Webhook, 'id'>
    & { deliveries: (
      { __typename?: 'WebhookEventDeliveryConnection' }
      & Pick<WebhookEventDeliveryConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'WebhookEventDeliveryEdge' }
        & { node?: Maybe<(
          { __typename?: 'WebhookEventDelivery' }
          & Pick<WebhookEventDelivery, 'id' | 'eventId' | 'createdAt' | 'retryCount' | 'finishedIn' | 'deliveryId' | 'httpStatusCode'>
          & { eventType: (
            { __typename?: 'WebhookEventTypes' }
            & Pick<WebhookEventTypes, 'id' | 'name' | 'shortcode'>
          ) }
        )> }
      )>> }
    ) }
  )> }
);

export type ListWebhooksQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
  limit?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type ListWebhooksQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { webhooks?: Maybe<(
      { __typename?: 'WebhookConnection' }
      & Pick<WebhookConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'WebhookEdge' }
        & { node?: Maybe<(
          { __typename?: 'Webhook' }
          & Pick<Webhook, 'id' | 'createdAt' | 'modifiedAt' | 'url' | 'alive' | 'active'>
          & { eventsSubscribed: (
            { __typename?: 'WebhookEventTypesConnection' }
            & Pick<WebhookEventTypesConnection, 'totalCount'>
          ) }
        )> }
      )>> }
    )> }
  )> }
);

export type ListWebhookEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListWebhookEventsQuery = (
  { __typename?: 'Query' }
  & { webhookEventTypes?: Maybe<(
    { __typename?: 'WebhookEventTypesConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'WebhookEventTypesEdge' }
      & { node?: Maybe<(
        { __typename?: 'WebhookEventTypes' }
        & Pick<WebhookEventTypes, 'name' | 'shortcode' | 'shortDescription'>
      )> }
    )>> }
  )> }
);

export type GetSingleWebhookQueryVariables = Exact<{
  webhookId: Scalars['ID'];
}>;


export type GetSingleWebhookQuery = (
  { __typename?: 'Query' }
  & { webhook?: Maybe<(
    { __typename?: 'Webhook' }
    & Pick<Webhook, 'id' | 'url' | 'active' | 'secret' | 'version' | 'apiSigning' | 'createdAt' | 'modifiedAt'>
    & { eventsSubscribed: (
      { __typename?: 'WebhookEventTypesConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'WebhookEventTypesEdge' }
        & { node?: Maybe<(
          { __typename?: 'WebhookEventTypes' }
          & Pick<WebhookEventTypes, 'shortcode' | 'name' | 'shortDescription'>
        )> }
      )>> }
    ) }
  )> }
);

export type AccessTokenQueryVariables = Exact<{
  tokenId: Scalars['ID'];
}>;


export type AccessTokenQuery = (
  { __typename?: 'Query' }
  & { accessToken?: Maybe<(
    { __typename?: 'AccessToken' }
    & Pick<AccessToken, 'id' | 'description' | 'lastUsedAt' | 'expirationStatus' | 'expiresAt'>
  )> }
);

export type AccessTokenListQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type AccessTokenListQuery = (
  { __typename?: 'Query' }
  & { viewer?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id'>
    & { accessTokens?: Maybe<(
      { __typename?: 'AccessTokenConnection' }
      & Pick<AccessTokenConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'AccessTokenEdge' }
        & { node?: Maybe<(
          { __typename?: 'AccessToken' }
          & Pick<AccessToken, 'id' | 'description' | 'expirationStatus' | 'expiresAt' | 'lastUsedAt'>
        )> }
      )>> }
    )> }
  )> }
);

export type ActiveThirdPartyVulnerabilitiesByReachabilityQueryVariables = Exact<{
  reportKey: Scalars['String'];
  level: ReportLevel;
  objectId: Scalars['ID'];
}>;


export type ActiveThirdPartyVulnerabilitiesByReachabilityQuery = (
  { __typename?: 'Query' }
  & { activeThirdPartyVulnerabilitiesByReachability?: Maybe<Array<Maybe<(
    { __typename?: 'ActiveThirdPartyVulnerabilitiesReportItem' }
    & Pick<ActiveThirdPartyVulnerabilitiesReportItem, 'slug' | 'name' | 'value'>
  )>>> }
);

export type ActiveThirdPartyVulnerabilitiesBySeverityQueryVariables = Exact<{
  reportKey: Scalars['String'];
  level: ReportLevel;
  objectId: Scalars['ID'];
}>;


export type ActiveThirdPartyVulnerabilitiesBySeverityQuery = (
  { __typename?: 'Query' }
  & { activeThirdPartyVulnerabilitiesBySeverity?: Maybe<Array<Maybe<(
    { __typename?: 'ActiveThirdPartyVulnerabilitiesReportItem' }
    & Pick<ActiveThirdPartyVulnerabilitiesReportItem, 'slug' | 'name' | 'value'>
  )>>> }
);

export type AnalyzerDistributionQueryVariables = Exact<{
  reportKey: Scalars['String'];
  level: ReportLevel;
  objectId: Scalars['ID'];
}>;


export type AnalyzerDistributionQuery = (
  { __typename?: 'Query' }
  & { issueDistributionByAnalyzer?: Maybe<Array<Maybe<(
    { __typename?: 'IssueDistribution' }
    & Pick<IssueDistribution, 'slug' | 'name' | 'value' | 'logoUrl'>
  )>>> }
);

export type CategoryDistributionQueryVariables = Exact<{
  reportKey: Scalars['String'];
  level: ReportLevel;
  objectId: Scalars['ID'];
}>;


export type CategoryDistributionQuery = (
  { __typename?: 'Query' }
  & { issueDistributionByCategory?: Maybe<Array<Maybe<(
    { __typename?: 'IssueDistribution' }
    & Pick<IssueDistribution, 'slug' | 'name' | 'value'>
  )>>> }
);

export type CodeCoverageReportQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  q?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
}>;


export type CodeCoverageReportQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { repositoriesCoverageReport?: Maybe<(
      { __typename?: 'RepositoryCoverageReportItemConnection' }
      & Pick<RepositoryCoverageReportItemConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'RepositoryCoverageReportItemEdge' }
        & { node?: Maybe<(
          { __typename?: 'RepositoryCoverageReportItem' }
          & Pick<RepositoryCoverageReportItem, 'id' | 'name' | 'lcvValue' | 'lcvIsPassing' | 'bcvValue' | 'bcvIsPassing'>
        )> }
      )>> }
    )> }
  )> }
);

export type ComplianceIssuesQueryVariables = Exact<{
  level: ReportLevel;
  objectId: Scalars['ID'];
  reportKey: Scalars['String'];
  fetchSeverityMap: Scalars['Boolean'];
}>;


export type ComplianceIssuesQuery = (
  { __typename?: 'Query' }
  & { complianceIssues?: Maybe<Array<Maybe<(
    { __typename?: 'ComplianceIssue' }
    & Pick<ComplianceIssue, 'issueId' | 'title' | 'category' | 'rank'>
    & { occurrence?: Maybe<(
      { __typename?: 'ComplianceIssueOccurrence' }
      & Pick<ComplianceIssueOccurrence, 'high' | 'medium' | 'low' | 'total'>
    )> }
  )>>>, complianceIssuesSeverityMap?: Maybe<(
    { __typename?: 'ComplianceIssueOccurrence' }
    & Pick<ComplianceIssueOccurrence, 'high' | 'medium' | 'low' | 'total'>
  )> }
);

export type FetchPublicReportKeysQueryVariables = Exact<{
  reportId: Scalars['String'];
}>;


export type FetchPublicReportKeysQuery = (
  { __typename?: 'Query' }
  & { publicReport?: Maybe<(
    { __typename?: 'PublicReport' }
    & Pick<PublicReport, 'reportKeys'>
  )> }
);

export type FetchReposWithIssuesQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
  tag: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  q?: Maybe<Scalars['String']>;
}>;


export type FetchReposWithIssuesQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id' | 'login'>
    & { repositoriesWithComplianceIssue?: Maybe<(
      { __typename?: 'RepositoryComplianceReportItemConnection' }
      & Pick<RepositoryComplianceReportItemConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'RepositoryComplianceReportItemEdge' }
        & { node?: Maybe<(
          { __typename?: 'RepositoryComplianceReportItem' }
          & Pick<RepositoryComplianceReportItem, 'id' | 'name' | 'displayName' | 'minorCount' | 'majorCount' | 'criticalCount' | 'totalCount' | 'kind' | 'isPrivate'>
          & { availableAnalyzers?: Maybe<(
            { __typename?: 'AnalyzerConnection' }
            & { edges: Array<Maybe<(
              { __typename?: 'AnalyzerEdge' }
              & { node?: Maybe<(
                { __typename?: 'Analyzer' }
                & Pick<Analyzer, 'id' | 'name' | 'shortcode' | 'analyzerLogo'>
              )> }
            )>> }
          )> }
        )> }
      )>> }
    )> }
  )> }
);

export type HistoricalValuesQueryVariables = Exact<{
  level: ReportLevel;
  objectId: Scalars['ID'];
  key: Scalars['String'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
}>;


export type HistoricalValuesQuery = (
  { __typename?: 'Query' }
  & { report?: Maybe<(
    { __typename?: 'Report' }
    & Pick<Report, 'key' | 'historicalValues'>
  )> }
);

export type PinnedReportDataQueryVariables = Exact<{
  level: ReportLevel;
  objectId: Scalars['ID'];
  key: Scalars['String'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
}>;


export type PinnedReportDataQuery = (
  { __typename?: 'Query' }
  & { report?: Maybe<(
    { __typename?: 'Report' }
    & Pick<Report, 'key' | 'status' | 'currentValue' | 'historicalValues'>
  )> }
);

export type PublicReportActiveThirdPartyVulnerabilitiesByReachabilityDataQueryVariables = Exact<{
  key: Scalars['String'];
  reportId: Scalars['String'];
  token?: Maybe<Scalars['String']>;
}>;


export type PublicReportActiveThirdPartyVulnerabilitiesByReachabilityDataQuery = (
  { __typename?: 'Query' }
  & { publicReport?: Maybe<(
    { __typename?: 'PublicReport' }
    & Pick<PublicReport, 'id'>
    & { activeThirdPartyVulnerabilitiesByReachability?: Maybe<Array<Maybe<(
      { __typename?: 'ActiveThirdPartyVulnerabilitiesReportItem' }
      & Pick<ActiveThirdPartyVulnerabilitiesReportItem, 'slug' | 'name' | 'value'>
    )>>> }
  )> }
);

export type PublicReportActiveThirdPartyVulnerabilitiesBySeverityDataQueryVariables = Exact<{
  key: Scalars['String'];
  reportId: Scalars['String'];
  token?: Maybe<Scalars['String']>;
}>;


export type PublicReportActiveThirdPartyVulnerabilitiesBySeverityDataQuery = (
  { __typename?: 'Query' }
  & { publicReport?: Maybe<(
    { __typename?: 'PublicReport' }
    & Pick<PublicReport, 'id'>
    & { activeThirdPartyVulnerabilitiesBySeverity?: Maybe<Array<Maybe<(
      { __typename?: 'ActiveThirdPartyVulnerabilitiesReportItem' }
      & Pick<ActiveThirdPartyVulnerabilitiesReportItem, 'slug' | 'name' | 'value'>
    )>>> }
  )> }
);

export type PublicReportAnalyzerDistributionQueryVariables = Exact<{
  key: Scalars['String'];
  reportId: Scalars['String'];
  token?: Maybe<Scalars['String']>;
}>;


export type PublicReportAnalyzerDistributionQuery = (
  { __typename?: 'Query' }
  & { publicReport?: Maybe<(
    { __typename?: 'PublicReport' }
    & Pick<PublicReport, 'id'>
    & { issueDistributionByAnalyzer?: Maybe<Array<Maybe<(
      { __typename?: 'IssueDistribution' }
      & Pick<IssueDistribution, 'slug' | 'name' | 'value' | 'logoUrl'>
    )>>> }
  )> }
);

export type PublicReportBaseQueryVariables = Exact<{
  reportId: Scalars['String'];
  token?: Maybe<Scalars['String']>;
}>;


export type PublicReportBaseQuery = (
  { __typename?: 'Query' }
  & { publicReport?: Maybe<(
    { __typename?: 'PublicReport' }
    & Pick<PublicReport, 'id' | 'reportId' | 'label' | 'createdAt' | 'views' | 'isRestricted' | 'reportKeys' | 'source' | 'level' | 'shareHistoricalData'>
    & { owner?: Maybe<(
      { __typename?: 'Owner' }
      & Pick<Owner, 'id' | 'login' | 'avatar'>
    )> }
  )> }
);

export type PublicReportBaseReportQueryVariables = Exact<{
  reportId: Scalars['String'];
  token?: Maybe<Scalars['String']>;
  reportKey: Scalars['String'];
}>;


export type PublicReportBaseReportQuery = (
  { __typename?: 'Query' }
  & { publicReport?: Maybe<(
    { __typename?: 'PublicReport' }
    & Pick<PublicReport, 'id'>
    & { report?: Maybe<(
      { __typename?: 'Report' }
      & Pick<Report, 'key' | 'status' | 'currentValue' | 'type'>
    )> }
  )> }
);

export type PublicReportCategoryDistributionQueryVariables = Exact<{
  key: Scalars['String'];
  reportId: Scalars['String'];
  token?: Maybe<Scalars['String']>;
}>;


export type PublicReportCategoryDistributionQuery = (
  { __typename?: 'Query' }
  & { publicReport?: Maybe<(
    { __typename?: 'PublicReport' }
    & Pick<PublicReport, 'id'>
    & { issueDistributionByCategory?: Maybe<Array<Maybe<(
      { __typename?: 'IssueDistribution' }
      & Pick<IssueDistribution, 'slug' | 'name' | 'value' | 'logoUrl'>
    )>>> }
  )> }
);

export type PublicReportComplianceIssuesQueryVariables = Exact<{
  reportId: Scalars['String'];
  token?: Maybe<Scalars['String']>;
  reportKey: Scalars['String'];
  fetchSeverityMap: Scalars['Boolean'];
}>;


export type PublicReportComplianceIssuesQuery = (
  { __typename?: 'Query' }
  & { publicReport?: Maybe<(
    { __typename?: 'PublicReport' }
    & Pick<PublicReport, 'id'>
    & { complianceIssues?: Maybe<Array<Maybe<(
      { __typename?: 'ComplianceIssue' }
      & Pick<ComplianceIssue, 'issueId' | 'title' | 'category' | 'rank'>
      & { occurrence?: Maybe<(
        { __typename?: 'ComplianceIssueOccurrence' }
        & Pick<ComplianceIssueOccurrence, 'high' | 'medium' | 'low' | 'total'>
      )> }
    )>>>, complianceIssuesSeverityMap?: Maybe<(
      { __typename?: 'ComplianceIssueOccurrence' }
      & Pick<ComplianceIssueOccurrence, 'high' | 'medium' | 'low' | 'total'>
    )> }
  )> }
);

export type PublicReportCoverageReportQueryVariables = Exact<{
  reportId: Scalars['String'];
  token?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  q?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
}>;


export type PublicReportCoverageReportQuery = (
  { __typename?: 'Query' }
  & { publicReport?: Maybe<(
    { __typename?: 'PublicReport' }
    & Pick<PublicReport, 'id'>
    & { repositoriesCoverageReport?: Maybe<(
      { __typename?: 'RepositoryCoverageReportItemConnection' }
      & Pick<RepositoryCoverageReportItemConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'RepositoryCoverageReportItemEdge' }
        & { node?: Maybe<(
          { __typename?: 'RepositoryCoverageReportItem' }
          & Pick<RepositoryCoverageReportItem, 'id' | 'name' | 'lcvValue' | 'lcvIsPassing' | 'bcvValue' | 'bcvIsPassing'>
        )> }
      )>> }
    )> }
  )> }
);

export type PublicReportHistoricValuesQueryVariables = Exact<{
  reportId: Scalars['String'];
  token?: Maybe<Scalars['String']>;
  reportKey: Scalars['String'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
}>;


export type PublicReportHistoricValuesQuery = (
  { __typename?: 'Query' }
  & { publicReport?: Maybe<(
    { __typename?: 'PublicReport' }
    & Pick<PublicReport, 'id'>
    & { report?: Maybe<(
      { __typename?: 'Report' }
      & Pick<Report, 'key' | 'historicalValues'>
    )> }
  )> }
);

export type PublicReportRecentStatsQueryVariables = Exact<{
  reportId: Scalars['String'];
  token?: Maybe<Scalars['String']>;
  reportKey: Scalars['String'];
}>;


export type PublicReportRecentStatsQuery = (
  { __typename?: 'Query' }
  & { publicReport?: Maybe<(
    { __typename?: 'PublicReport' }
    & Pick<PublicReport, 'id'>
    & { report?: Maybe<(
      { __typename?: 'Report' }
      & { recentStats?: Maybe<Array<Maybe<(
        { __typename?: 'RecentStat' }
        & Pick<RecentStat, 'statLabel' | 'statValue' | 'trendValue' | 'trendDirection' | 'trendPositive'>
      )>>> }
    )> }
  )> }
);

export type PublicReportRepoListQueryVariables = Exact<{
  reportId: Scalars['String'];
  token?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type PublicReportRepoListQuery = (
  { __typename?: 'Query' }
  & { publicReport?: Maybe<(
    { __typename?: 'PublicReport' }
    & Pick<PublicReport, 'id'>
    & { sourcedRepositories?: Maybe<(
      { __typename?: 'RepositoryConnection' }
      & Pick<RepositoryConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'RepositoryEdge' }
        & { node?: Maybe<(
          { __typename?: 'Repository' }
          & Pick<Repository, 'id' | 'name' | 'displayName' | 'isPrivate'>
        )> }
      )>> }
    )> }
  )> }
);

export type PublicReportScaTargetsReportQueryVariables = Exact<{
  reportId: Scalars['String'];
  token?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  q?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
}>;


export type PublicReportScaTargetsReportQuery = (
  { __typename?: 'Query' }
  & { publicReport?: Maybe<(
    { __typename?: 'PublicReport' }
    & Pick<PublicReport, 'id'>
    & { scaTargetsReport?: Maybe<(
      { __typename?: 'RepositoryScaTargetReportItemConnection' }
      & Pick<RepositoryScaTargetReportItemConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'RepositoryScaTargetReportItemEdge' }
        & { node?: Maybe<(
          { __typename?: 'RepositoryScaTargetReportItem' }
          & Pick<RepositoryScaTargetReportItem, 'id' | 'manifestPath' | 'lockfilePath' | 'packageManager' | 'lowSeverityVulnerabilityCount' | 'mediumSeverityVulnerabilityCount' | 'highSeverityVulnerabilityCount' | 'criticalSeverityVulnerabilityCount'>
          & { repository: (
            { __typename?: 'Repository' }
            & Pick<Repository, 'id' | 'name'>
          ) }
        )> }
      )>> }
    )> }
  )> }
);

export type PublicReportSourceableRepositoriesQueryVariables = Exact<{
  ownerLogin: Scalars['String'];
  vcsProvider: VcsProviderChoices;
  publicReportId?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
}>;


export type PublicReportSourceableRepositoriesQuery = (
  { __typename?: 'Query' }
  & { publicReportSourceableRepositories?: Maybe<(
    { __typename?: 'SourceableRepositoryConnection' }
    & Pick<SourceableRepositoryConnection, 'totalCount'>
    & { edges: Array<Maybe<(
      { __typename?: 'SourceableRepositoryEdge' }
      & { node?: Maybe<(
        { __typename?: 'SourceableRepository' }
        & Pick<SourceableRepository, 'id' | 'name' | 'displayName' | 'ownerLogin' | 'isSourced'>
      )> }
    )>> }
  )> }
);

export type RecentStatsQueryVariables = Exact<{
  level: ReportLevel;
  objectId: Scalars['ID'];
  key: Scalars['String'];
}>;


export type RecentStatsQuery = (
  { __typename?: 'Query' }
  & { report?: Maybe<(
    { __typename?: 'Report' }
    & Pick<Report, 'key'>
    & { recentStats?: Maybe<Array<Maybe<(
      { __typename?: 'RecentStat' }
      & Pick<RecentStat, 'statLabel' | 'statValue' | 'trendValue' | 'trendDirection' | 'trendPositive'>
    )>>> }
  )> }
);

export type ReportBaseQueryVariables = Exact<{
  level: ReportLevel;
  objectId: Scalars['ID'];
  key: Scalars['String'];
}>;


export type ReportBaseQuery = (
  { __typename?: 'Query' }
  & { report?: Maybe<(
    { __typename?: 'Report' }
    & Pick<Report, 'key' | 'status' | 'currentValue'>
  )> }
);

export type ScaTargetsReportQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  q?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
}>;


export type ScaTargetsReportQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { mostRecentScaTargets?: Maybe<(
      { __typename?: 'RepositoryScaTargetReportItemConnection' }
      & Pick<RepositoryScaTargetReportItemConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'RepositoryScaTargetReportItemEdge' }
        & { node?: Maybe<(
          { __typename?: 'RepositoryScaTargetReportItem' }
          & Pick<RepositoryScaTargetReportItem, 'id' | 'manifestPath' | 'lockfilePath' | 'packageManager' | 'lowSeverityVulnerabilityCount' | 'mediumSeverityVulnerabilityCount' | 'highSeverityVulnerabilityCount' | 'criticalSeverityVulnerabilityCount'>
          & { repository: (
            { __typename?: 'Repository' }
            & Pick<Repository, 'id' | 'name'>
          ) }
        )> }
      )>> }
    )> }
  )> }
);

export type RepositoryToActivateListQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  query?: Maybe<Scalars['String']>;
  kindIn: Array<Maybe<RepositoryKindChoices>> | Maybe<RepositoryKindChoices>;
}>;


export type RepositoryToActivateListQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { activatableRepositories?: Maybe<(
      { __typename?: 'RepositoryConnection' }
      & Pick<RepositoryConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'RepositoryEdge' }
        & { node?: Maybe<(
          { __typename?: 'Repository' }
          & Pick<Repository, 'id' | 'createdAt' | 'displayName' | 'name' | 'vcsProvider' | 'ownerLogin' | 'isPrivate' | 'isStarred' | 'latestCommitOid' | 'defaultBranchName' | 'lastAnalyzedAt' | 'isActivated' | 'kind' | 'supportedAnalyzers'>
          & { subRepos?: Maybe<(
            { __typename?: 'RepositoryConnection' }
            & Pick<RepositoryConnection, 'totalCount'>
          )> }
        )> }
      )>> }
    )> }
  )> }
);

export type AddableMembersQueryVariables = Exact<{
  name: Scalars['String'];
  owner: Scalars['String'];
  provider: VcsProviderChoices;
  q: Scalars['String'];
}>;


export type AddableMembersQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id'>
    & { addableMembers?: Maybe<(
      { __typename?: 'TeamMemberConnection' }
      & Pick<TeamMemberConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'TeamMemberEdge' }
        & { node?: Maybe<(
          { __typename?: 'TeamMember' }
          & Pick<TeamMember, 'id' | 'role' | 'isPrimaryUser'>
          & { user: (
            { __typename?: 'User' }
            & Pick<User, 'id' | 'firstName' | 'lastName' | 'fullName' | 'email' | 'avatar' | 'dateJoined'>
          ) }
        )> }
      )>> }
    )> }
  )> }
);

export type AnalysisRunQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
  status: Scalars['String'];
}>;


export type AnalysisRunQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id'>
    & { runs?: Maybe<(
      { __typename?: 'RunConnection' }
      & Pick<RunConnection, 'totalCount'>
    )> }
  )> }
);

export type RepoAutofixStatsQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
}>;


export type RepoAutofixStatsQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id'>
    & { autofixableIssuesMetadata?: Maybe<(
      { __typename?: 'AutofixableIssuesMetadata' }
      & Pick<AutofixableIssuesMetadata, 'autofixableIssueCount'>
    )> }
  )> }
);

export type AvailableAnalyzersQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
}>;


export type AvailableAnalyzersQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id' | 'name' | 'supportedAnalyzers'>
    & { availableAnalyzers?: Maybe<(
      { __typename?: 'AnalyzerConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'AnalyzerEdge' }
        & { node?: Maybe<(
          { __typename?: 'Analyzer' }
          & Pick<Analyzer, 'id' | 'shortcode' | 'name' | 'logo' | 'analyzerLogo'>
        )> }
      )>> }
    )> }
  )> }
);

export type BaseRepoQueryQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
}>;


export type BaseRepoQueryQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id' | 'vcsUrl' | 'isActivated' | 'codeAnalysisStatus' | 'scaStatus' | 'autofixInstallationUrl' | 'isPrivate' | 'isStarred' | 'kind' | 'errorCode' | 'renderedErrorMessage' | 'name' | 'fullName' | 'displayName' | 'defaultBranchName' | 'vcsProvider' | 'canBeActivated' | 'isAutofixEnabled' | 'blobUrlRoot' | 'path' | 'config'>
    & { repositoryGroup?: Maybe<(
      { __typename?: 'RepositoryGroup' }
      & Pick<RepositoryGroup, 'id' | 'name' | 'slug' | 'overrideRepoSetting'>
    )>, lastRun?: Maybe<(
      { __typename?: 'Run' }
      & Pick<Run, 'id' | 'runId' | 'config' | 'commitOid' | 'status' | 'finishedAt'>
    )>, latestAnalysisRun?: Maybe<(
      { __typename?: 'Run' }
      & Pick<Run, 'id' | 'runId' | 'config' | 'commitOid' | 'status' | 'finishedAt'>
    )>, parentMonorepo?: Maybe<(
      { __typename?: 'Repository' }
      & Pick<Repository, 'id' | 'name' | 'displayName'>
    )> }
  )> }
);

export type RepoDetailsQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
}>;


export type RepoDetailsQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id' | 'name' | 'displayName' | 'isPrivate' | 'isStarred' | 'kind' | 'canBeActivated' | 'fullName' | 'errorCode' | 'renderedErrorMessage' | 'userPermissionMeta' | 'hasTestCoverage' | 'isActivated' | 'codeAnalysisStatus' | 'scaStatus' | 'blobUrlRoot' | 'defaultBranchName' | 'widgetsAvailable' | 'allWidgets' | 'vcsDefaultBranchUrl' | 'hasViewerEditAccess' | 'vcsUrl' | 'vcsHost' | 'vcsProvider' | 'config' | 'supportedAnalyzers' | 'isAutofixEnabled' | 'autofixInstallationUrl'>
    & { latestAnalysisRun?: Maybe<(
      { __typename?: 'Run' }
      & Pick<Run, 'id' | 'runId' | 'config' | 'commitOid' | 'branchRunCount' | 'status' | 'finishedAt'>
    )>, repositorySetting?: Maybe<(
      { __typename?: 'RepositorySetting' }
      & Pick<RepositorySetting, 'id' | 'enableCodeAnalysis' | 'enableCodeFormatting'>
    )>, repositoryGroup?: Maybe<(
      { __typename?: 'RepositoryGroup' }
      & Pick<RepositoryGroup, 'id' | 'name' | 'slug' | 'overrideRepoSetting'>
    )>, availableAnalyzers?: Maybe<(
      { __typename?: 'AnalyzerConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'AnalyzerEdge' }
        & { node?: Maybe<(
          { __typename?: 'Analyzer' }
          & Pick<Analyzer, 'id' | 'shortcode' | 'name' | 'logo' | 'analyzerLogo'>
        )> }
      )>> }
    )> }
  )> }
);

export type DetailForActivationQueryVariables = Exact<{
  repositoryId: Scalars['ID'];
}>;


export type DetailForActivationQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<{ __typename?: 'AccessToken' } | { __typename?: 'AgentsProduct' } | { __typename?: 'Analyzer' } | { __typename?: 'AnalyzerCISnippet' } | { __typename?: 'AnalyzerReview' } | { __typename?: 'AnalyzerSyncJob' } | { __typename?: 'AuditLog' } | { __typename?: 'AutoOnboardEvent' } | { __typename?: 'AutofixRun' } | { __typename?: 'BilledRepositoryTarget' } | { __typename?: 'CallStackFrame' } | { __typename?: 'Check' } | { __typename?: 'CheckIssue' } | { __typename?: 'CheckPackage' } | { __typename?: 'CodeQualityProduct' } | { __typename?: 'ConfigGenerationRun' } | { __typename?: 'ConfigTemplate' } | { __typename?: 'EnterpriseBilledRepositoryTarget' } | { __typename?: 'EnterpriseGroup' } | { __typename?: 'EnterpriseInstallationSetup' } | { __typename?: 'EnterpriseTeam' } | { __typename?: 'EnterpriseUser' } | { __typename?: 'FeatureDefinition' } | { __typename?: 'GroupTeamMembership' } | { __typename?: 'GroupUserMembership' } | { __typename?: 'IDEProduct' } | { __typename?: 'IdentityProvider' } | { __typename?: 'Issue' } | { __typename?: 'IssuePriority' } | { __typename?: 'IssuePriorityType' } | { __typename?: 'License' } | { __typename?: 'Metric' } | { __typename?: 'Owner' } | { __typename?: 'OwnerAIPolicy' } | { __typename?: 'OwnerDynamicRiskConfig' } | { __typename?: 'OwnerLicensePolicy' } | { __typename?: 'OwnerProfile' } | { __typename?: 'OwnerSCAPolicy' } | { __typename?: 'OwnerSetting' } | { __typename?: 'PR' } | { __typename?: 'PRAuthor' } | { __typename?: 'Package' } | { __typename?: 'PackageUpgradeSummary' } | { __typename?: 'PackageVersion' } | { __typename?: 'ProductSubscription' } | { __typename?: 'PublicReport' } | (
    { __typename?: 'Repository' }
    & Pick<Repository, 'id' | 'name' | 'displayName' | 'defaultBranchName' | 'hasViewerEditAccess' | 'vcsUrl' | 'vcsHost' | 'supportedAnalyzers' | 'isAutofixEnabled' | 'autofixInstallationUrl'>
  ) | { __typename?: 'RepositoryCollaborator' } | { __typename?: 'RepositoryComplianceReportItem' } | { __typename?: 'RepositoryCoverageReportItem' } | { __typename?: 'RepositoryGroup' } | { __typename?: 'RepositoryGroupSetting' } | { __typename?: 'RepositoryIssue' } | { __typename?: 'RepositoryMetricValue' } | { __typename?: 'RepositoryPackage' } | { __typename?: 'RepositoryScaTargetReportItem' } | { __typename?: 'RepositorySetting' } | { __typename?: 'RepositoryTarget' } | { __typename?: 'Run' } | { __typename?: 'RunReport' } | { __typename?: 'Runner' } | { __typename?: 'RunnerApp' } | { __typename?: 'RuntimeLog' } | { __typename?: 'SCACheck' } | { __typename?: 'SCAProduct' } | { __typename?: 'SSOIdentityProvider' } | { __typename?: 'SilenceRule' } | { __typename?: 'SourceableRepository' } | { __typename?: 'Team' } | { __typename?: 'TeamBasePermissionSet' } | { __typename?: 'TeamMember' } | { __typename?: 'TeamMemberAdditionRequest' } | { __typename?: 'TeamMemberInvitation' } | { __typename?: 'Transaction' } | { __typename?: 'TransformerReview' } | { __typename?: 'TransformerRun' } | { __typename?: 'TransformerTool' } | { __typename?: 'UnifiedProduct' } | { __typename?: 'User' } | { __typename?: 'UserPreference' } | { __typename?: 'UserProfile' } | { __typename?: 'UserSocialConnection' } | { __typename?: 'VerifiableDomain' } | { __typename?: 'Vulnerability' } | { __typename?: 'VulnerabilityCallStack' } | { __typename?: 'VulnerabilityOccurrence' } | { __typename?: 'VulnerabilityRemediationFixPath' } | { __typename?: 'VulnerabilityRemediationFixPathUpdate' } | { __typename?: 'VulnerabilityRemediationPatchRun' } | { __typename?: 'Webhook' } | { __typename?: 'WebhookEventDelivery' } | { __typename?: 'WebhookEventTypes' }> }
);

export type RepositoryIdQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
}>;


export type RepositoryIdQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id'>
  )> }
);

export type IssueDetailQueryVariables = Exact<{
  repositoryId: Scalars['ID'];
  shortcode: Scalars['String'];
}>;


export type IssueDetailQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<{ __typename?: 'AccessToken' } | { __typename?: 'AgentsProduct' } | { __typename?: 'Analyzer' } | { __typename?: 'AnalyzerCISnippet' } | { __typename?: 'AnalyzerReview' } | { __typename?: 'AnalyzerSyncJob' } | { __typename?: 'AuditLog' } | { __typename?: 'AutoOnboardEvent' } | { __typename?: 'AutofixRun' } | { __typename?: 'BilledRepositoryTarget' } | { __typename?: 'CallStackFrame' } | { __typename?: 'Check' } | { __typename?: 'CheckIssue' } | { __typename?: 'CheckPackage' } | { __typename?: 'CodeQualityProduct' } | { __typename?: 'ConfigGenerationRun' } | { __typename?: 'ConfigTemplate' } | { __typename?: 'EnterpriseBilledRepositoryTarget' } | { __typename?: 'EnterpriseGroup' } | { __typename?: 'EnterpriseInstallationSetup' } | { __typename?: 'EnterpriseTeam' } | { __typename?: 'EnterpriseUser' } | { __typename?: 'FeatureDefinition' } | { __typename?: 'GroupTeamMembership' } | { __typename?: 'GroupUserMembership' } | { __typename?: 'IDEProduct' } | { __typename?: 'IdentityProvider' } | { __typename?: 'Issue' } | { __typename?: 'IssuePriority' } | { __typename?: 'IssuePriorityType' } | { __typename?: 'License' } | { __typename?: 'Metric' } | { __typename?: 'Owner' } | { __typename?: 'OwnerAIPolicy' } | { __typename?: 'OwnerDynamicRiskConfig' } | { __typename?: 'OwnerLicensePolicy' } | { __typename?: 'OwnerProfile' } | { __typename?: 'OwnerSCAPolicy' } | { __typename?: 'OwnerSetting' } | { __typename?: 'PR' } | { __typename?: 'PRAuthor' } | { __typename?: 'Package' } | { __typename?: 'PackageUpgradeSummary' } | { __typename?: 'PackageVersion' } | { __typename?: 'ProductSubscription' } | { __typename?: 'PublicReport' } | (
    { __typename?: 'Repository' }
    & Pick<Repository, 'id' | 'config' | 'blobUrlRoot' | 'vcsProvider' | 'hasViewerEditAccess'>
    & { issue?: Maybe<(
      { __typename?: 'RepositoryIssue' }
      & Pick<RepositoryIssue, 'id' | 'descriptionRendered' | 'issueType' | 'title' | 'shortcode' | 'firstSeen' | 'lastSeen' | 'modifiedAt' | 'occurrenceCount' | 'analyzerName' | 'analyzerShortcode' | 'analyzerLogo' | 'analyzerType' | 'autofixAvailable' | 'newVcsIssueUrl' | 'raisedInFiles' | 'tags' | 'severity'>
    )> }
  ) | { __typename?: 'RepositoryCollaborator' } | { __typename?: 'RepositoryComplianceReportItem' } | { __typename?: 'RepositoryCoverageReportItem' } | { __typename?: 'RepositoryGroup' } | { __typename?: 'RepositoryGroupSetting' } | { __typename?: 'RepositoryIssue' } | { __typename?: 'RepositoryMetricValue' } | { __typename?: 'RepositoryPackage' } | { __typename?: 'RepositoryScaTargetReportItem' } | { __typename?: 'RepositorySetting' } | { __typename?: 'RepositoryTarget' } | { __typename?: 'Run' } | { __typename?: 'RunReport' } | { __typename?: 'Runner' } | { __typename?: 'RunnerApp' } | { __typename?: 'RuntimeLog' } | { __typename?: 'SCACheck' } | { __typename?: 'SCAProduct' } | { __typename?: 'SSOIdentityProvider' } | { __typename?: 'SilenceRule' } | { __typename?: 'SourceableRepository' } | { __typename?: 'Team' } | { __typename?: 'TeamBasePermissionSet' } | { __typename?: 'TeamMember' } | { __typename?: 'TeamMemberAdditionRequest' } | { __typename?: 'TeamMemberInvitation' } | { __typename?: 'Transaction' } | { __typename?: 'TransformerReview' } | { __typename?: 'TransformerRun' } | { __typename?: 'TransformerTool' } | { __typename?: 'UnifiedProduct' } | { __typename?: 'User' } | { __typename?: 'UserPreference' } | { __typename?: 'UserProfile' } | { __typename?: 'UserSocialConnection' } | { __typename?: 'VerifiableDomain' } | { __typename?: 'Vulnerability' } | { __typename?: 'VulnerabilityCallStack' } | { __typename?: 'VulnerabilityOccurrence' } | { __typename?: 'VulnerabilityRemediationFixPath' } | { __typename?: 'VulnerabilityRemediationFixPathUpdate' } | { __typename?: 'VulnerabilityRemediationPatchRun' } | { __typename?: 'Webhook' } | { __typename?: 'WebhookEventDelivery' } | { __typename?: 'WebhookEventTypes' }> }
);

export type IssueChildrenQueryVariables = Exact<{
  nodeId: Scalars['ID'];
  limit?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  q?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
}>;


export type IssueChildrenQuery = (
  { __typename?: 'Query' }
  & { node?: Maybe<{ __typename?: 'AccessToken' } | { __typename?: 'AgentsProduct' } | { __typename?: 'Analyzer' } | { __typename?: 'AnalyzerCISnippet' } | { __typename?: 'AnalyzerReview' } | { __typename?: 'AnalyzerSyncJob' } | { __typename?: 'AuditLog' } | { __typename?: 'AutoOnboardEvent' } | { __typename?: 'AutofixRun' } | { __typename?: 'BilledRepositoryTarget' } | { __typename?: 'CallStackFrame' } | { __typename?: 'Check' } | { __typename?: 'CheckIssue' } | { __typename?: 'CheckPackage' } | { __typename?: 'CodeQualityProduct' } | { __typename?: 'ConfigGenerationRun' } | { __typename?: 'ConfigTemplate' } | { __typename?: 'EnterpriseBilledRepositoryTarget' } | { __typename?: 'EnterpriseGroup' } | { __typename?: 'EnterpriseInstallationSetup' } | { __typename?: 'EnterpriseTeam' } | { __typename?: 'EnterpriseUser' } | { __typename?: 'FeatureDefinition' } | { __typename?: 'GroupTeamMembership' } | { __typename?: 'GroupUserMembership' } | { __typename?: 'IDEProduct' } | { __typename?: 'IdentityProvider' } | { __typename?: 'Issue' } | { __typename?: 'IssuePriority' } | { __typename?: 'IssuePriorityType' } | { __typename?: 'License' } | { __typename?: 'Metric' } | { __typename?: 'Owner' } | { __typename?: 'OwnerAIPolicy' } | { __typename?: 'OwnerDynamicRiskConfig' } | { __typename?: 'OwnerLicensePolicy' } | { __typename?: 'OwnerProfile' } | { __typename?: 'OwnerSCAPolicy' } | { __typename?: 'OwnerSetting' } | { __typename?: 'PR' } | { __typename?: 'PRAuthor' } | { __typename?: 'Package' } | { __typename?: 'PackageUpgradeSummary' } | { __typename?: 'PackageVersion' } | { __typename?: 'ProductSubscription' } | { __typename?: 'PublicReport' } | { __typename?: 'Repository' } | { __typename?: 'RepositoryCollaborator' } | { __typename?: 'RepositoryComplianceReportItem' } | { __typename?: 'RepositoryCoverageReportItem' } | { __typename?: 'RepositoryGroup' } | { __typename?: 'RepositoryGroupSetting' } | (
    { __typename?: 'RepositoryIssue' }
    & Pick<RepositoryIssue, 'shortcode'>
    & { checkIssues: (
      { __typename?: 'CheckIssueConnection' }
      & Pick<CheckIssueConnection, 'totalCount'>
      & { pageInfo: (
        { __typename?: 'PageInfo' }
        & Pick<PageInfo, 'hasNextPage'>
      ), edges: Array<Maybe<(
        { __typename?: 'CheckIssueEdge' }
        & { node?: Maybe<(
          { __typename?: 'CheckIssue' }
          & Pick<CheckIssue, 'id' | 'severity' | 'path' | 'text' | 'beginLine' | 'beginColumn' | 'endLine' | 'endColumn' | 'sourceCodeMarkup' | 'createdAt'>
        )> }
      )>> }
    ) }
  ) | { __typename?: 'RepositoryMetricValue' } | { __typename?: 'RepositoryPackage' } | { __typename?: 'RepositoryScaTargetReportItem' } | { __typename?: 'RepositorySetting' } | { __typename?: 'RepositoryTarget' } | { __typename?: 'Run' } | { __typename?: 'RunReport' } | { __typename?: 'Runner' } | { __typename?: 'RunnerApp' } | { __typename?: 'RuntimeLog' } | { __typename?: 'SCACheck' } | { __typename?: 'SCAProduct' } | { __typename?: 'SSOIdentityProvider' } | { __typename?: 'SilenceRule' } | { __typename?: 'SourceableRepository' } | { __typename?: 'Team' } | { __typename?: 'TeamBasePermissionSet' } | { __typename?: 'TeamMember' } | { __typename?: 'TeamMemberAdditionRequest' } | { __typename?: 'TeamMemberInvitation' } | { __typename?: 'Transaction' } | { __typename?: 'TransformerReview' } | { __typename?: 'TransformerRun' } | { __typename?: 'TransformerTool' } | { __typename?: 'UnifiedProduct' } | { __typename?: 'User' } | { __typename?: 'UserPreference' } | { __typename?: 'UserProfile' } | { __typename?: 'UserSocialConnection' } | { __typename?: 'VerifiableDomain' } | { __typename?: 'Vulnerability' } | { __typename?: 'VulnerabilityCallStack' } | { __typename?: 'VulnerabilityOccurrence' } | { __typename?: 'VulnerabilityRemediationFixPath' } | { __typename?: 'VulnerabilityRemediationFixPathUpdate' } | { __typename?: 'VulnerabilityRemediationPatchRun' } | { __typename?: 'Webhook' } | { __typename?: 'WebhookEventDelivery' } | { __typename?: 'WebhookEventTypes' }> }
);

export type RepositoryIssueListQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  issueType?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  analyzer?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
  q?: Maybe<Scalars['String']>;
  autofixAvailable?: Maybe<Scalars['Boolean']>;
  auditRequired?: Maybe<Scalars['Boolean']>;
  recommended?: Maybe<Scalars['Boolean']>;
  all?: Maybe<Scalars['Boolean']>;
  severity?: Maybe<Scalars['String']>;
}>;


export type RepositoryIssueListQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id'>
    & { issues?: Maybe<(
      { __typename?: 'RepositoryIssueConnection' }
      & Pick<RepositoryIssueConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'RepositoryIssueEdge' }
        & { node?: Maybe<(
          { __typename?: 'RepositoryIssue' }
          & Pick<RepositoryIssue, 'id' | 'issueType' | 'title' | 'shortcode' | 'description' | 'occurrenceCount' | 'createdAt' | 'analyzerName' | 'analyzerLogo' | 'seenIn' | 'firstSeen' | 'lastSeen' | 'modifiedAt' | 'autofixAvailable' | 'raisedInFiles' | 'severity'>
          & { trend?: Maybe<(
            { __typename?: 'IssueTrend' }
            & Pick<IssueTrend, 'trendHint' | 'trendValue' | 'trendDirection' | 'trendPositive'>
          )> }
        )> }
      )>> }
    )> }
  )> }
);

export type RepoSilenceRulesQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  issueCode?: Maybe<Scalars['String']>;
}>;


export type RepoSilenceRulesQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id'>
    & { silenceRules?: Maybe<(
      { __typename?: 'SilenceRuleConnection' }
      & Pick<SilenceRuleConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'SilenceRuleEdge' }
        & { node?: Maybe<(
          { __typename?: 'SilenceRule' }
          & Pick<SilenceRule, 'silenceLevel' | 'id' | 'filePath' | 'createdAt' | 'metadata'>
          & { issue: (
            { __typename?: 'Issue' }
            & Pick<Issue, 'shortcode' | 'title'>
            & { analyzer: (
              { __typename?: 'Analyzer' }
              & Pick<Analyzer, 'shortcode'>
            ) }
          ), creator?: Maybe<(
            { __typename?: 'User' }
            & Pick<User, 'firstName' | 'lastName' | 'email' | 'avatar'>
          )> }
        )> }
      )>> }
    )> }
  )> }
);

export type SingleRepositoryIssueQueryVariables = Exact<{
  shortcode: Scalars['String'];
}>;


export type SingleRepositoryIssueQuery = (
  { __typename?: 'Query' }
  & { issue?: Maybe<(
    { __typename?: 'Issue' }
    & Pick<Issue, 'shortcode' | 'title' | 'issueType' | 'descriptionRendered' | 'tags' | 'severity'>
    & { analyzer: (
      { __typename?: 'Analyzer' }
      & Pick<Analyzer, 'id' | 'shortcode' | 'name'>
    ) }
  )> }
);

export type RepositoryIssueTotalCountQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
  issueType?: Maybe<Scalars['String']>;
}>;


export type RepositoryIssueTotalCountQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id'>
    & { issues?: Maybe<(
      { __typename?: 'RepositoryIssueConnection' }
      & Pick<RepositoryIssueConnection, 'totalCount'>
    )> }
  )> }
);

export type IssueOccurrenceDistributionByIssueTypeQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
  analyzer?: Maybe<Scalars['String']>;
  q?: Maybe<Scalars['String']>;
  autofixAvailable?: Maybe<Scalars['Boolean']>;
  severity?: Maybe<Scalars['String']>;
}>;


export type IssueOccurrenceDistributionByIssueTypeQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id'>
    & { issueOccurrenceDistributionByIssueType: Array<(
      { __typename?: 'IssueOccurrenceFrequency' }
      & Pick<IssueOccurrenceFrequency, 'key' | 'count'>
    )> }
  )> }
);

export type IssueOccurrenceDistributionByProductQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
  analyzer?: Maybe<Scalars['String']>;
  q?: Maybe<Scalars['String']>;
  autofixAvailable?: Maybe<Scalars['Boolean']>;
  severity?: Maybe<Scalars['String']>;
}>;


export type IssueOccurrenceDistributionByProductQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id'>
    & { issueOccurrenceDistributionByProduct: Array<(
      { __typename?: 'IssueOccurrenceFrequency' }
      & Pick<IssueOccurrenceFrequency, 'key' | 'count'>
    )> }
  )> }
);

export type IssueRaisedInFilesQueryVariables = Exact<{
  repositoryId: Scalars['ID'];
  shortcode: Scalars['String'];
}>;


export type IssueRaisedInFilesQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<{ __typename?: 'AccessToken' } | { __typename?: 'AgentsProduct' } | { __typename?: 'Analyzer' } | { __typename?: 'AnalyzerCISnippet' } | { __typename?: 'AnalyzerReview' } | { __typename?: 'AnalyzerSyncJob' } | { __typename?: 'AuditLog' } | { __typename?: 'AutoOnboardEvent' } | { __typename?: 'AutofixRun' } | { __typename?: 'BilledRepositoryTarget' } | { __typename?: 'CallStackFrame' } | { __typename?: 'Check' } | { __typename?: 'CheckIssue' } | { __typename?: 'CheckPackage' } | { __typename?: 'CodeQualityProduct' } | { __typename?: 'ConfigGenerationRun' } | { __typename?: 'ConfigTemplate' } | { __typename?: 'EnterpriseBilledRepositoryTarget' } | { __typename?: 'EnterpriseGroup' } | { __typename?: 'EnterpriseInstallationSetup' } | { __typename?: 'EnterpriseTeam' } | { __typename?: 'EnterpriseUser' } | { __typename?: 'FeatureDefinition' } | { __typename?: 'GroupTeamMembership' } | { __typename?: 'GroupUserMembership' } | { __typename?: 'IDEProduct' } | { __typename?: 'IdentityProvider' } | { __typename?: 'Issue' } | { __typename?: 'IssuePriority' } | { __typename?: 'IssuePriorityType' } | { __typename?: 'License' } | { __typename?: 'Metric' } | { __typename?: 'Owner' } | { __typename?: 'OwnerAIPolicy' } | { __typename?: 'OwnerDynamicRiskConfig' } | { __typename?: 'OwnerLicensePolicy' } | { __typename?: 'OwnerProfile' } | { __typename?: 'OwnerSCAPolicy' } | { __typename?: 'OwnerSetting' } | { __typename?: 'PR' } | { __typename?: 'PRAuthor' } | { __typename?: 'Package' } | { __typename?: 'PackageUpgradeSummary' } | { __typename?: 'PackageVersion' } | { __typename?: 'ProductSubscription' } | { __typename?: 'PublicReport' } | (
    { __typename?: 'Repository' }
    & { issue?: Maybe<(
      { __typename?: 'RepositoryIssue' }
      & Pick<RepositoryIssue, 'id' | 'raisedInFiles'>
    )> }
  ) | { __typename?: 'RepositoryCollaborator' } | { __typename?: 'RepositoryComplianceReportItem' } | { __typename?: 'RepositoryCoverageReportItem' } | { __typename?: 'RepositoryGroup' } | { __typename?: 'RepositoryGroupSetting' } | { __typename?: 'RepositoryIssue' } | { __typename?: 'RepositoryMetricValue' } | { __typename?: 'RepositoryPackage' } | { __typename?: 'RepositoryScaTargetReportItem' } | { __typename?: 'RepositorySetting' } | { __typename?: 'RepositoryTarget' } | { __typename?: 'Run' } | { __typename?: 'RunReport' } | { __typename?: 'Runner' } | { __typename?: 'RunnerApp' } | { __typename?: 'RuntimeLog' } | { __typename?: 'SCACheck' } | { __typename?: 'SCAProduct' } | { __typename?: 'SSOIdentityProvider' } | { __typename?: 'SilenceRule' } | { __typename?: 'SourceableRepository' } | { __typename?: 'Team' } | { __typename?: 'TeamBasePermissionSet' } | { __typename?: 'TeamMember' } | { __typename?: 'TeamMemberAdditionRequest' } | { __typename?: 'TeamMemberInvitation' } | { __typename?: 'Transaction' } | { __typename?: 'TransformerReview' } | { __typename?: 'TransformerRun' } | { __typename?: 'TransformerTool' } | { __typename?: 'UnifiedProduct' } | { __typename?: 'User' } | { __typename?: 'UserPreference' } | { __typename?: 'UserProfile' } | { __typename?: 'UserSocialConnection' } | { __typename?: 'VerifiableDomain' } | { __typename?: 'Vulnerability' } | { __typename?: 'VulnerabilityCallStack' } | { __typename?: 'VulnerabilityOccurrence' } | { __typename?: 'VulnerabilityRemediationFixPath' } | { __typename?: 'VulnerabilityRemediationFixPathUpdate' } | { __typename?: 'VulnerabilityRemediationPatchRun' } | { __typename?: 'Webhook' } | { __typename?: 'WebhookEventDelivery' } | { __typename?: 'WebhookEventTypes' }> }
);

export type IssueTypeSettingsIgnoredQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
}>;


export type IssueTypeSettingsIgnoredQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id'>
    & { issueTypeSettings?: Maybe<Array<Maybe<(
      { __typename?: 'IssueTypeSetting' }
      & Pick<IssueTypeSetting, 'slug' | 'isIgnoredToDisplay'>
    )>>> }
  )> }
);

export type RepositoryKindQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
}>;


export type RepositoryKindQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id' | 'kind'>
  )> }
);

export type RepositoryListQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
  isActivated?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
}>;


export type RepositoryListQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { repositories?: Maybe<(
      { __typename?: 'RepositoryConnection' }
      & Pick<RepositoryConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'RepositoryEdge' }
        & { node?: Maybe<(
          { __typename?: 'Repository' }
          & Pick<Repository, 'id' | 'displayName' | 'name' | 'vcsProvider' | 'ownerLogin' | 'modifiedAt' | 'isActivated' | 'isFork' | 'isPrivate' | 'isStarred' | 'latestCommitOid' | 'defaultBranchName' | 'lastAnalyzedAt' | 'kind' | 'canBeActivated' | 'supportedAnalyzers'>
          & { availableAnalyzers?: Maybe<(
            { __typename?: 'AnalyzerConnection' }
            & { edges: Array<Maybe<(
              { __typename?: 'AnalyzerEdge' }
              & { node?: Maybe<(
                { __typename?: 'Analyzer' }
                & Pick<Analyzer, 'id' | 'name' | 'shortcode' | 'analyzerLogo'>
              )> }
            )>> }
          )>, primaryAnalyzer?: Maybe<(
            { __typename?: 'Analyzer' }
            & Pick<Analyzer, 'id' | 'name' | 'shortcode' | 'analyzerLogo'>
          )> }
        )> }
      )>> }
    )> }
  )> }
);

export type ListForAnalyzerDirectoryQueryVariables = Exact<{
  q?: Maybe<Scalars['String']>;
}>;


export type ListForAnalyzerDirectoryQuery = (
  { __typename?: 'Query' }
  & { viewer?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id'>
    & { repositories?: Maybe<(
      { __typename?: 'RepositoryConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'RepositoryEdge' }
        & { node?: Maybe<(
          { __typename?: 'Repository' }
          & Pick<Repository, 'name' | 'isPrivate' | 'isFork' | 'configGenerationRoute'>
          & { owner: (
            { __typename?: 'Owner' }
            & Pick<Owner, 'login'>
          ) }
        )> }
      )>> }
    )> }
  )> }
);

export type FetchRepositoryMetricCapturedQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
  shortcode: Scalars['String'];
  lastDays: Scalars['Int'];
  metricType?: Maybe<MetricTypeChoices>;
}>;


export type FetchRepositoryMetricCapturedQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id' | 'displayName' | 'userPermissionMeta' | 'hasTestCoverage'>
    & { repositoryGroup?: Maybe<(
      { __typename?: 'RepositoryGroup' }
      & Pick<RepositoryGroup, 'id' | 'name' | 'overrideRepoSetting'>
    )>, metricsCaptured?: Maybe<Array<Maybe<(
      { __typename?: 'Metric' }
      & Pick<Metric, 'id' | 'shortcode' | 'name' | 'category' | 'description' | 'supportsAggregateThreshold' | 'unit' | 'newCodeMetricShortcode'>
      & { namespacesTrends?: Maybe<Array<Maybe<(
        { __typename?: 'MetricNamespaceTrend' }
        & Pick<MetricNamespaceTrend, 'key' | 'valueTrend' | 'isPassing' | 'valueDisplay' | 'analyzerShortcode' | 'analyzerLogo' | 'threshold' | 'newCodeThreshold'>
      )>>> }
    )>>> }
  )> }
);

export type FetchRepositoryMetricsCapturedQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
  metricType?: Maybe<MetricTypeChoices>;
  fetchPerms: Scalars['Boolean'];
}>;


export type FetchRepositoryMetricsCapturedQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & MakeOptional<Pick<Repository, 'id' | 'userPermissionMeta'>, 'userPermissionMeta'>
    & { metricsCaptured?: Maybe<Array<Maybe<(
      { __typename?: 'Metric' }
      & Pick<Metric, 'id' | 'shortcode' | 'name' | 'category'>
    )>>> }
  )> }
);

export type RepositoryPermissionsQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
}>;


export type RepositoryPermissionsQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id' | 'name' | 'userPermissionMeta'>
  )> }
);

export type RepositoryPinnedReportsQueryVariables = Exact<{
  name: Scalars['String'];
  owner: Scalars['String'];
  provider: VcsProviderChoices;
}>;


export type RepositoryPinnedReportsQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id'>
    & { setting?: Maybe<(
      { __typename?: 'RepositorySetting' }
      & { pinnedReports?: Maybe<Array<Maybe<(
        { __typename?: 'PinnedReport' }
        & Pick<PinnedReport, 'key' | 'metadata'>
      )>>> }
    )> }
  )> }
);

export type PublicReportListRepoQueryVariables = Exact<{
  name: Scalars['String'];
  owner: Scalars['String'];
  provider: VcsProviderChoices;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  q?: Maybe<Scalars['String']>;
}>;


export type PublicReportListRepoQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id'>
    & { publicReports?: Maybe<(
      { __typename?: 'PublicReportConnection' }
      & Pick<PublicReportConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'PublicReportEdge' }
        & { node?: Maybe<(
          { __typename?: 'PublicReport' }
          & Pick<PublicReport, 'reportId' | 'label' | 'views' | 'createdAt' | 'isRestricted' | 'shareHistoricalData' | 'reportKeys'>
        )> }
      )>> }
    )> }
  )> }
);

export type RecentlyActiveRepoListQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
  limit?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  fetchAnalyzers: Scalars['Boolean'];
}>;


export type RecentlyActiveRepoListQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { repositories?: Maybe<(
      { __typename?: 'RepositoryConnection' }
      & Pick<RepositoryConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'RepositoryEdge' }
        & { node?: Maybe<(
          { __typename?: 'Repository' }
          & Pick<Repository, 'id' | 'displayName' | 'name' | 'vcsProvider' | 'ownerLogin' | 'isActivated' | 'isFork' | 'isPrivate' | 'lastAnalyzedAt' | 'defaultBranchName' | 'kind'>
          & { availableAnalyzers?: Maybe<(
            { __typename?: 'AnalyzerConnection' }
            & { edges: Array<Maybe<(
              { __typename?: 'AnalyzerEdge' }
              & { node?: Maybe<(
                { __typename?: 'Analyzer' }
                & Pick<Analyzer, 'id' | 'name' | 'shortcode' | 'analyzerLogo'>
              )> }
            )>> }
          )>, latestPr?: Maybe<(
            { __typename?: 'PR' }
            & Pick<Pr, 'id' | 'number' | 'modifiedAt'>
          )> }
        )> }
      )>> }
    )> }
  )> }
);

export type AutofixRunDetailQueryVariables = Exact<{
  runId: Scalars['String'];
}>;


export type AutofixRunDetailQuery = (
  { __typename?: 'Query' }
  & { autofixRun: (
    { __typename?: 'AutofixRun' }
    & Pick<AutofixRun, 'id' | 'errorsRendered' | 'runId' | 'staleRedirectUrl' | 'finishedIn' | 'isGeneratedFromPr' | 'issuesAffected' | 'committedToBranchStatus' | 'resolvedIssuesCount' | 'pullRequestStatus' | 'pullRequestTitle' | 'pullRequestNumber' | 'status' | 'createdAt' | 'changeset' | 'vcsPrUrl'>
    & { createdBy?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'fullName' | 'email' | 'avatar'>
    )>, analyzer?: Maybe<(
      { __typename?: 'Analyzer' }
      & Pick<Analyzer, 'name' | 'shortcode' | 'analyzerLogo'>
    )>, issue?: Maybe<(
      { __typename?: 'Issue' }
      & Pick<Issue, 'title' | 'issueType' | 'shortcode'>
    )> }
  ) }
);

export type AutofixRunsQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  statusIn?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  prStatusIn?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  q?: Maybe<Scalars['String']>;
}>;


export type AutofixRunsQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id'>
    & { autofixRuns?: Maybe<(
      { __typename?: 'AutofixRunConnection' }
      & Pick<AutofixRunConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'AutofixRunEdge' }
        & { node?: Maybe<(
          { __typename?: 'AutofixRun' }
          & Pick<AutofixRun, 'runId' | 'status' | 'filesAffected' | 'finishedIn' | 'isGeneratedFromPr' | 'gitCompareDisplay' | 'pullRequestTitle' | 'pullRequestNumber' | 'pullRequestStatus' | 'vcsPrUrl' | 'createdAt' | 'resolvedIssuesCount' | 'changeset'>
          & { createdBy?: Maybe<(
            { __typename?: 'User' }
            & Pick<User, 'fullName' | 'email' | 'avatar'>
          )>, analyzer?: Maybe<(
            { __typename?: 'Analyzer' }
            & Pick<Analyzer, 'name' | 'shortcode' | 'analyzerLogo'>
          )>, issue?: Maybe<(
            { __typename?: 'Issue' }
            & Pick<Issue, 'title' | 'issueType' | 'shortcode'>
          )> }
        )> }
      )>> }
    )> }
  )> }
);

export type GlobalStateIndicatorQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
  status?: Maybe<Scalars['String']>;
}>;


export type GlobalStateIndicatorQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & { runs?: Maybe<(
      { __typename?: 'RunConnection' }
      & Pick<RunConnection, 'totalCount'>
    )>, autofixRuns?: Maybe<(
      { __typename?: 'AutofixRunConnection' }
      & Pick<AutofixRunConnection, 'totalCount'>
    )>, transformerRuns?: Maybe<(
      { __typename?: 'TransformerRunConnection' }
      & Pick<TransformerRunConnection, 'totalCount'>
    )> }
  )> }
);

export type FetchRepoPrsListQueryVariables = Exact<{
  name: Scalars['String'];
  owner: Scalars['String'];
  provider: VcsProviderChoices;
  prStatus?: Maybe<PrStateChoices>;
  runStatusIn?: Maybe<Array<Maybe<RunStatusChoice>> | Maybe<RunStatusChoice>>;
  q?: Maybe<Scalars['String']>;
  limit: Scalars['Int'];
  after?: Maybe<Scalars['String']>;
}>;


export type FetchRepoPrsListQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id'>
    & { prs?: Maybe<(
      { __typename?: 'PRConnection' }
      & Pick<PrConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'PREdge' }
        & { node?: Maybe<(
          { __typename?: 'PR' }
          & Pick<Pr, 'id' | 'title' | 'number' | 'raisedCount' | 'resolvedCount' | 'suppressedCount' | 'branch' | 'runCount'>
          & { latestAnalysisRun?: Maybe<(
            { __typename?: 'Run' }
            & Pick<Run, 'id' | 'status' | 'createdAt' | 'finishedIn' | 'runId' | 'commitOid'>
          )> }
        )> }
      )>> }
    )> }
  )> }
);

export type FetchPrStatsQueryVariables = Exact<{
  name: Scalars['String'];
  owner: Scalars['String'];
  provider: VcsProviderChoices;
  defaultBranchName: Scalars['String'];
  runStatusIn?: Maybe<Array<Maybe<RunStatusChoice>> | Maybe<RunStatusChoice>>;
  statusIn?: Maybe<Array<Maybe<RunStatusChoice>> | Maybe<RunStatusChoice>>;
  qPr?: Maybe<Scalars['String']>;
  qRun?: Maybe<Scalars['String']>;
}>;


export type FetchPrStatsQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id'>
    & { prs?: Maybe<(
      { __typename?: 'PRConnection' }
      & Pick<PrConnection, 'totalCount'>
    )>, openPrs?: Maybe<(
      { __typename?: 'PRConnection' }
      & Pick<PrConnection, 'totalCount'>
    )>, closedPrs?: Maybe<(
      { __typename?: 'PRConnection' }
      & Pick<PrConnection, 'totalCount'>
    )>, branchRuns?: Maybe<(
      { __typename?: 'RunConnection' }
      & Pick<RunConnection, 'totalCount'>
    )> }
  )> }
);

export type RepositoryBranchRunsQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
  branchName: Scalars['String'];
  limit: Scalars['Int'];
  statusIn?: Maybe<Array<Maybe<RunStatusChoice>> | Maybe<RunStatusChoice>>;
  q?: Maybe<Scalars['String']>;
}>;


export type RepositoryBranchRunsQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id' | 'name'>
    & { branchRuns?: Maybe<(
      { __typename?: 'RunConnection' }
      & Pick<RunConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'RunEdge' }
        & { node?: Maybe<(
          { __typename?: 'Run' }
          & Pick<Run, 'id' | 'config' | 'createdAt' | 'runId' | 'status' | 'branchName' | 'commitOid' | 'commitMessage' | 'finishedIn' | 'vcsCommitUrl' | 'vcsPrUrl' | 'gitCompareDisplay' | 'pullRequestNumberDisplay' | 'issuesRaisedCount' | 'issuesResolvedCount' | 'issuesSuppressedCount' | 'isForDefaultBranch'>
        )> }
      )>> }
    )> }
  )> }
);

export type CheckAllIssuesQueryVariables = Exact<{
  checkId: Scalars['ID'];
  limit?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  q?: Maybe<Scalars['String']>;
  category?: Maybe<IssueType>;
  severity?: Maybe<IssueSeverity>;
}>;


export type CheckAllIssuesQuery = (
  { __typename?: 'Query' }
  & { check: (
    { __typename?: 'Check' }
    & Pick<Check, 'id'>
    & { allIssues?: Maybe<(
      { __typename?: 'AnalysisIssueUnionConnection' }
      & Pick<AnalysisIssueUnionConnection, 'totalCount'>
      & { pageInfo: (
        { __typename?: 'PageInfo' }
        & Pick<PageInfo, 'hasNextPage' | 'endCursor'>
      ), edges: Array<Maybe<(
        { __typename?: 'AnalysisIssueUnionEdge' }
        & Pick<AnalysisIssueUnionEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename: 'StaticAnalysisIssue' }
          & Pick<StaticAnalysisIssue, 'id' | 'path' | 'text' | 'explanation' | 'shortExplanation' | 'shortcode' | 'category' | 'severity' | 'createdAt' | 'modifiedAt' | 'sourceCodeRendered' | 'beginLine' | 'beginColumn' | 'endLine' | 'endColumn'>
        ) | (
          { __typename: 'AIReviewIssue' }
          & Pick<AiReviewIssue, 'id' | 'path' | 'text' | 'explanation' | 'shortExplanation' | 'category' | 'severity' | 'createdAt' | 'modifiedAt' | 'sourceCodeRendered' | 'beginLine' | 'beginColumn' | 'endLine' | 'endColumn'>
        )> }
      )>> }
    )> }
  ) }
);

export type AutofixableIssuesQueryVariables = Exact<{
  checkId: Scalars['ID'];
}>;


export type AutofixableIssuesQuery = (
  { __typename?: 'Query' }
  & { check: (
    { __typename?: 'Check' }
    & Pick<Check, 'id' | 'filesAffectedByAutofix'>
    & { autofixableIssues?: Maybe<Array<Maybe<(
      { __typename?: 'AutofixableIssueDetail' }
      & Pick<AutofixableIssueDetail, 'title' | 'shortcode' | 'occurrenceCount' | 'category'>
    )>>> }
  ) }
);

export type CheckIssuesQueryVariables = Exact<{
  checkId: Scalars['ID'];
  limit?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  shortcode?: Maybe<Scalars['String']>;
  q?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
}>;


export type CheckIssuesQuery = (
  { __typename?: 'Query' }
  & { checkIssues?: Maybe<(
    { __typename?: 'CheckIssueConnection' }
    & Pick<CheckIssueConnection, 'totalCount'>
    & { edges: Array<Maybe<(
      { __typename?: 'CheckIssueEdge' }
      & { node?: Maybe<(
        { __typename?: 'CheckIssue' }
        & Pick<CheckIssue, 'id' | 'path' | 'text' | 'modifiedAt' | 'createdAt' | 'beginLine' | 'beginColumn' | 'endLine' | 'endColumn' | 'sourceCodeMarkup' | 'shortcode'>
      )> }
    )>> }
  )> }
);

export type ConcreteIssuesQueryVariables = Exact<{
  checkId: Scalars['ID'];
  q?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
  issueType?: Maybe<Scalars['String']>;
}>;


export type ConcreteIssuesQuery = (
  { __typename?: 'Query' }
  & { check: (
    { __typename?: 'Check' }
    & Pick<Check, 'id'>
    & { concreteIssues?: Maybe<(
      { __typename?: 'IssueConnection' }
      & Pick<IssueConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'IssueEdge' }
        & { node?: Maybe<(
          { __typename?: 'Issue' }
          & Pick<Issue, 'id' | 'shortcode' | 'title' | 'severity' | 'occurrenceCount' | 'issueType'>
        )> }
      )>> }
    )> }
  ) }
);

export type RepositoryRunCheckDetailsQueryVariables = Exact<{
  checkId: Scalars['ID'];
}>;


export type RepositoryRunCheckDetailsQuery = (
  { __typename?: 'Query' }
  & { check: (
    { __typename?: 'Check' }
    & Pick<Check, 'id' | 'status' | 'filesAffectedByAutofix' | 'errorsRendered' | 'isRetryable'>
    & { autofixableIssues?: Maybe<Array<Maybe<(
      { __typename?: 'AutofixableIssueDetail' }
      & Pick<AutofixableIssueDetail, 'shortcode' | 'title' | 'category' | 'occurrenceCount'>
    )>>>, run: (
      { __typename?: 'Run' }
      & Pick<Run, 'id' | 'isForDefaultBranch' | 'isForCrossRepoPr'>
    ), analyzer?: Maybe<(
      { __typename?: 'Analyzer' }
      & Pick<Analyzer, 'name' | 'shortcode' | 'analyzerLogo' | 'analyzerType'>
    )>, metricsCaptured?: Maybe<Array<Maybe<(
      { __typename?: 'RepositoryMetricValue' }
      & Pick<RepositoryMetricValue, 'id' | 'name' | 'shortcode' | 'value' | 'valueDisplay' | 'valueTrendDisplay' | 'isPassing' | 'extraData' | 'namespace' | 'threshold' | 'isSuppressed' | 'trendPositive'>
    )>>> }
  ) }
);

export type ExportRunAsMarkdownQueryVariables = Exact<{
  runId: Scalars['String'];
  analyzerShortcode?: Maybe<Scalars['String']>;
  targetId?: Maybe<Scalars['String']>;
}>;


export type ExportRunAsMarkdownQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'exportRunAsMarkdown'>
);

export type RepositoryGroupedRunsQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type RepositoryGroupedRunsQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id' | 'name'>
    & { groupedRuns?: Maybe<(
      { __typename?: 'RunConnection' }
      & Pick<RunConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'RunEdge' }
        & { node?: Maybe<(
          { __typename?: 'Run' }
          & Pick<Run, 'id' | 'config' | 'createdAt' | 'runId' | 'status' | 'branchName' | 'branchRunCount' | 'commitOid' | 'finishedIn' | 'vcsCommitUrl' | 'vcsPrUrl' | 'gitCompareDisplay' | 'pullRequestNumberDisplay' | 'issuesRaisedCount' | 'issuesResolvedCount' | 'issuesSuppressedCount'>
        )> }
      )>> }
    )> }
  )> }
);

export type RepositoryRunsListQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type RepositoryRunsListQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id'>
    & { runs?: Maybe<(
      { __typename?: 'RunConnection' }
      & Pick<RunConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'RunEdge' }
        & { node?: Maybe<(
          { __typename?: 'Run' }
          & Pick<Run, 'id' | 'config' | 'createdAt' | 'runId' | 'status' | 'branchName' | 'commitOid' | 'finishedIn' | 'vcsCommitUrl' | 'gitCompareDisplay' | 'pullRequestNumberDisplay' | 'issuesRaisedCount' | 'issuesResolvedCount' | 'issuesSuppressedCount'>
        )> }
      )>> }
    )> }
  )> }
);

export type FetchScaConcreteVulnsQueryVariables = Exact<{
  runId: Scalars['UUID'];
  targetId: Scalars['ID'];
  q?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type FetchScaConcreteVulnsQuery = (
  { __typename?: 'Query' }
  & { scaCheck: (
    { __typename?: 'SCACheck' }
    & Pick<ScaCheck, 'id'>
    & { vulnerabilityOccurrences: (
      { __typename?: 'VulnerabilityOccurrenceConnection' }
      & Pick<VulnerabilityOccurrenceConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'VulnerabilityOccurrenceEdge' }
        & { node?: Maybe<(
          { __typename?: 'VulnerabilityOccurrence' }
          & Pick<VulnerabilityOccurrence, 'id' | 'reachability' | 'fixability' | 'impliedSeverity' | 'isSeverityOverridden' | 'dynamicRiskLevel'>
          & { vulnerability: (
            { __typename?: 'Vulnerability' }
            & Pick<Vulnerability, 'id' | 'identifier' | 'summary' | 'fixedVersions'>
          ), package: (
            { __typename?: 'Package' }
            & Pick<Package, 'id' | 'name'>
          ), checkPackage: (
            { __typename?: 'CheckPackage' }
            & Pick<CheckPackage, 'id' | 'packageType'>
          ), packageVersion: (
            { __typename?: 'PackageVersion' }
            & Pick<PackageVersion, 'id' | 'version'>
          ) }
        )> }
      )>> }
    ) }
  ) }
);

export type FetchScaCheckDetailQueryVariables = Exact<{
  runId: Scalars['UUID'];
  targetId: Scalars['ID'];
}>;


export type FetchScaCheckDetailQuery = (
  { __typename?: 'Query' }
  & { scaCheck: (
    { __typename?: 'SCACheck' }
    & Pick<ScaCheck, 'id' | 'status' | 'createdAt' | 'finishedIn' | 'finishedAt' | 'sequence' | 'vulnerabilityRaisedCount' | 'vulnerabilityResolvedCount' | 'vulnerabilitySuppressedCount'>
    & { errors: Array<Maybe<(
      { __typename?: 'AnalysisError' }
      & Pick<AnalysisError, 'message' | 'level'>
    )>>, errorsRendered: Array<Maybe<(
      { __typename?: 'AnalysisError' }
      & Pick<AnalysisError, 'message' | 'level'>
    )>>, target?: Maybe<(
      { __typename?: 'RepositoryTarget' }
      & Pick<RepositoryTarget, 'id' | 'packageManager' | 'manifestPath' | 'lockfilePath'>
    )>, vulnerabilityOccurrences: (
      { __typename?: 'VulnerabilityOccurrenceConnection' }
      & Pick<VulnerabilityOccurrenceConnection, 'totalCount'>
    ) }
  ) }
);

export type FetchScaRuntimeLogQueryVariables = Exact<{
  runId: Scalars['UUID'];
  targetId: Scalars['ID'];
}>;


export type FetchScaRuntimeLogQuery = (
  { __typename?: 'Query' }
  & { scaCheck: (
    { __typename?: 'SCACheck' }
    & Pick<ScaCheck, 'id'>
    & { runtimeLog?: Maybe<(
      { __typename?: 'RuntimeLog' }
      & Pick<RuntimeLog, 'id' | 'streamKey' | 'entriesCount'>
      & { entries: Array<Maybe<(
        { __typename?: 'RuntimeLogEntry' }
        & Pick<RuntimeLogEntry, 'id' | 'level' | 'message' | 'timestamp'>
      )>> }
    )> }
  ) }
);

export type FetchCheckVulnOccQueryVariables = Exact<{
  runId: Scalars['UUID'];
  targetId: Scalars['ID'];
  occurrenceId: Scalars['ID'];
}>;


export type FetchCheckVulnOccQuery = (
  { __typename?: 'Query' }
  & { scaCheck: (
    { __typename?: 'SCACheck' }
    & Pick<ScaCheck, 'id'>
    & { vulnerabilityOccurrence: (
      { __typename?: 'VulnerabilityOccurrence' }
      & Pick<VulnerabilityOccurrence, 'id' | 'reachability' | 'fixability' | 'impliedSeverity' | 'isSeverityOverridden' | 'dynamicRiskLevel'>
      & { vulnerability: (
        { __typename?: 'Vulnerability' }
        & Pick<Vulnerability, 'id' | 'identifier' | 'aliases' | 'summary' | 'detailsRendered' | 'publishedAt' | 'introducedVersions' | 'fixedVersions' | 'cvssV2Vector' | 'cvssV2BaseScore' | 'cvssV2Severity' | 'cvssV3Vector' | 'cvssV3BaseScore' | 'cvssV3Severity' | 'cvssV4Vector' | 'cvssV4BaseScore' | 'cvssV4Severity' | 'epssScore' | 'epssPercentile'>
        & { referenceUrls: Array<Maybe<(
          { __typename?: 'VulnerabilityReferenceUrl' }
          & Pick<VulnerabilityReferenceUrl, 'category' | 'url'>
        )>> }
      ), checkPackage: (
        { __typename?: 'CheckPackage' }
        & Pick<CheckPackage, 'id' | 'packageType' | 'packageGroup'>
      ), package: (
        { __typename?: 'Package' }
        & Pick<Package, 'id' | 'name'>
      ), packageVersion: (
        { __typename?: 'PackageVersion' }
        & Pick<PackageVersion, 'id' | 'version'>
      ), callStacks: (
        { __typename?: 'VulnerabilityCallStackConnection' }
        & Pick<VulnerabilityCallStackConnection, 'totalCount'>
        & { edges: Array<Maybe<(
          { __typename?: 'VulnerabilityCallStackEdge' }
          & { node?: Maybe<(
            { __typename?: 'VulnerabilityCallStack' }
            & Pick<VulnerabilityCallStack, 'id'>
            & { frames: (
              { __typename?: 'CallStackFrameConnection' }
              & Pick<CallStackFrameConnection, 'totalCount'>
              & { edges: Array<Maybe<(
                { __typename?: 'CallStackFrameEdge' }
                & { node?: Maybe<(
                  { __typename?: 'CallStackFrame' }
                  & Pick<CallStackFrame, 'id' | 'method' | 'filepath' | 'lineNumber' | 'code'>
                )> }
              )>> }
            ) }
          )> }
        )>> }
      ) }
    ) }
  ) }
);

export type RepositoryRunDetailQueryVariables = Exact<{
  runId: Scalars['String'];
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
}>;


export type RepositoryRunDetailQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id'>
    & { run?: Maybe<(
      { __typename?: 'Run' }
      & Pick<Run, 'id' | 'createdAt' | 'blobUrlRoot' | 'runId' | 'status' | 'branchName' | 'commitOid' | 'commitMessage' | 'finishedIn' | 'vcsCommitUrl' | 'gitCompareDisplay' | 'vcsPrUrl' | 'pullRequestNumberDisplay' | 'isForDefaultBranch'>
      & { checks: (
        { __typename?: 'CheckConnection' }
        & { edges: Array<Maybe<(
          { __typename?: 'CheckEdge' }
          & { node?: Maybe<(
            { __typename?: 'Check' }
            & Pick<Check, 'id' | 'issuesRaisedCount' | 'issuesResolvedCount' | 'issuesSuppressedCount' | 'status' | 'isRetryable' | 'hasInferredArtifacts'>
            & { autofixableIssues?: Maybe<Array<Maybe<(
              { __typename?: 'AutofixableIssueDetail' }
              & Pick<AutofixableIssueDetail, 'shortcode'>
            )>>>, analyzer?: Maybe<(
              { __typename?: 'Analyzer' }
              & Pick<Analyzer, 'name' | 'shortcode' | 'analyzerLogo'>
            )>, inferredArtifactsPr?: Maybe<(
              { __typename?: 'PR' }
              & Pick<Pr, 'id' | 'vcsUrl' | 'number'>
            )> }
          )> }
        )>> }
      ), scaChecks: (
        { __typename?: 'SCACheckConnection' }
        & { edges: Array<Maybe<(
          { __typename?: 'SCACheckEdge' }
          & { node?: Maybe<(
            { __typename?: 'SCACheck' }
            & Pick<ScaCheck, 'id' | 'status' | 'vulnerabilityRaisedCount' | 'vulnerabilityResolvedCount' | 'vulnerabilitySuppressedCount'>
            & { target?: Maybe<(
              { __typename?: 'RepositoryTarget' }
              & Pick<RepositoryTarget, 'id' | 'manifestPath' | 'lockfilePath' | 'packageManager'>
            )> }
          )> }
        )>> }
      ), pullRequest?: Maybe<(
        { __typename?: 'PR' }
        & Pick<Pr, 'title'>
      )>, reportCard?: Maybe<(
        { __typename?: 'RunReport' }
        & Pick<RunReport, 'status' | 'insightsRendered'>
        & { security?: Maybe<(
          { __typename?: 'RunReportDimension' }
          & Pick<RunReportDimension, 'grade'>
        )>, reliability?: Maybe<(
          { __typename?: 'RunReportDimension' }
          & Pick<RunReportDimension, 'grade'>
        )>, complexity?: Maybe<(
          { __typename?: 'RunReportDimension' }
          & Pick<RunReportDimension, 'grade'>
        )>, hygiene?: Maybe<(
          { __typename?: 'RunReportDimension' }
          & Pick<RunReportDimension, 'grade'>
        )>, coverage?: Maybe<(
          { __typename?: 'RunReportCoverage' }
          & Pick<RunReportCoverage, 'grade'>
        )>, aggregate?: Maybe<(
          { __typename?: 'RunReportAggregate' }
          & Pick<RunReportAggregate, 'grade'>
        )>, focusArea?: Maybe<(
          { __typename?: 'RunReportFocusArea' }
          & Pick<RunReportFocusArea, 'dimension' | 'action'>
        )> }
      )> }
    )> }
  )> }
);

export type TransformerRunBranchQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
  branchName: Scalars['String'];
}>;


export type TransformerRunBranchQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id' | 'name'>
    & { transformerBranchRuns?: Maybe<(
      { __typename?: 'TransformerRunConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'TransformerRunEdge' }
        & { node?: Maybe<(
          { __typename?: 'TransformerRun' }
          & Pick<TransformerRun, 'createdAt' | 'runId' | 'status' | 'branchName' | 'commitOid' | 'finishedIn' | 'vcsCommitUrl' | 'gitCompareDisplay' | 'pullRequestNumberDisplay' | 'changedFilesCount' | 'tools'>
        )> }
      )>> }
    )> }
  )> }
);

export type TransformerRunGroupQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type TransformerRunGroupQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id' | 'name'>
    & { groupedTransformerRuns?: Maybe<(
      { __typename?: 'TransformerRunConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'TransformerRunEdge' }
        & { node?: Maybe<(
          { __typename?: 'TransformerRun' }
          & Pick<TransformerRun, 'createdAt' | 'runId' | 'status' | 'branchName' | 'commitOid' | 'finishedIn' | 'vcsCommitUrl' | 'vcsPrUrl' | 'gitCompareDisplay' | 'pullRequestNumberDisplay' | 'changedFilesCount' | 'tools'>
        )> }
      )>> }
    )> }
  )> }
);

export type TransformerRunListQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type TransformerRunListQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id'>
    & { transformerRuns?: Maybe<(
      { __typename?: 'TransformerRunConnection' }
      & Pick<TransformerRunConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'TransformerRunEdge' }
        & { node?: Maybe<(
          { __typename?: 'TransformerRun' }
          & Pick<TransformerRun, 'createdAt' | 'runId' | 'status' | 'branchName' | 'commitOid' | 'finishedIn' | 'changedFilesCount' | 'tools' | 'committedToBranchStatus' | 'gitCompareDisplay' | 'pullRequestNumber' | 'vcsPrUrl'>
        )> }
      )>> }
    )> }
  )> }
);

export type RepositorySearchListQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
  isActivated?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  query?: Maybe<Scalars['String']>;
  kindIn: Array<Maybe<RepositoryKindChoices>> | Maybe<RepositoryKindChoices>;
}>;


export type RepositorySearchListQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { repositories?: Maybe<(
      { __typename?: 'RepositoryConnection' }
      & Pick<RepositoryConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'RepositoryEdge' }
        & { node?: Maybe<(
          { __typename?: 'Repository' }
          & Pick<Repository, 'id' | 'vcsProvider' | 'ownerLogin' | 'name' | 'displayName' | 'kind' | 'isPrivate' | 'isActivated'>
        )> }
      )>> }
    )> }
  )> }
);

export type RepositoryLevelAuditLogQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  createdAtGte?: Maybe<Scalars['Date']>;
  createdAtLte?: Maybe<Scalars['Date']>;
  q?: Maybe<Scalars['String']>;
}>;


export type RepositoryLevelAuditLogQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id' | 'name'>
    & { logs?: Maybe<(
      { __typename?: 'AuditLogConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'AuditLogEdge' }
        & { node?: Maybe<(
          { __typename?: 'AuditLog' }
          & Pick<AuditLog, 'id' | 'eventName' | 'description' | 'ipAddress' | 'location' | 'createdAt'>
          & { actor?: Maybe<(
            { __typename?: 'User' }
            & Pick<User, 'fullName' | 'firstName' | 'email' | 'avatar'>
          )> }
        )> }
      )>> }
    )>, fullLogs?: Maybe<(
      { __typename?: 'AuditLogConnection' }
      & Pick<AuditLogConnection, 'totalCount'>
    )> }
  )> }
);

export type BadgesQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
}>;


export type BadgesQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id' | 'name' | 'badge' | 'token'>
  )> }
);

export type CodeCoverageQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
}>;


export type CodeCoverageQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id' | 'hasTestCoverage' | 'dsn'>
    & { repositorySetting?: Maybe<(
      { __typename?: 'RepositorySetting' }
      & Pick<RepositorySetting, 'id' | 'inferDefaultBranchCoverage'>
    )>, repositoryGroup?: Maybe<(
      { __typename?: 'RepositoryGroup' }
      & Pick<RepositoryGroup, 'id' | 'name' | 'slug' | 'overrideRepoSetting'>
    )> }
  )> }
);

export type CodeFormattersPageQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
}>;


export type CodeFormattersPageQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id' | 'config' | 'kind' | 'autofixInstallationStatus' | 'autofixInstallationUrl' | 'userPermissionMeta'>
    & { repositorySetting?: Maybe<(
      { __typename?: 'RepositorySetting' }
      & Pick<RepositorySetting, 'id' | 'enableCodeFormatting'>
    )> }
  )>, owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { ownerSetting?: Maybe<(
      { __typename?: 'OwnerSetting' }
      & Pick<OwnerSetting, 'id' | 'shouldCommitConfig'>
    )> }
  )>, analyzers?: Maybe<(
    { __typename?: 'AnalyzerConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'AnalyzerEdge' }
      & { node?: Maybe<(
        { __typename?: 'Analyzer' }
        & Pick<Analyzer, 'id' | 'name' | 'shortcode' | 'logo' | 'analyzerLogo' | 'analyzerType' | 'metaSchema'>
        & { transformertoolSet: (
          { __typename?: 'TransformerToolConnection' }
          & { edges: Array<Maybe<(
            { __typename?: 'TransformerToolEdge' }
            & { node?: Maybe<(
              { __typename?: 'TransformerTool' }
              & Pick<TransformerTool, 'id' | 'name' | 'shortcode' | 'logo' | 'description'>
            )> }
          )>> }
        ) }
      )> }
    )>> }
  )> }
);

export type CodeReviewPageQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
  exclude?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
}>;


export type CodeReviewPageQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id' | 'config' | 'userPermissionMeta'>
    & { repositorySetting?: Maybe<(
      { __typename?: 'RepositorySetting' }
      & Pick<RepositorySetting, 'id' | 'enableCodeAnalysis'>
    )> }
  )>, owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { ownerSetting?: Maybe<(
      { __typename?: 'OwnerSetting' }
      & Pick<OwnerSetting, 'id' | 'shouldCommitConfig'>
    )> }
  )>, analyzers?: Maybe<(
    { __typename?: 'AnalyzerConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'AnalyzerEdge' }
      & { node?: Maybe<(
        { __typename?: 'Analyzer' }
        & Pick<Analyzer, 'id' | 'name' | 'shortcode' | 'analyzerLogo' | 'analyzerType' | 'metaSchema'>
        & { transformertoolSet: (
          { __typename?: 'TransformerToolConnection' }
          & { edges: Array<Maybe<(
            { __typename?: 'TransformerToolEdge' }
            & { node?: Maybe<(
              { __typename?: 'TransformerTool' }
              & Pick<TransformerTool, 'id' | 'name' | 'shortcode' | 'logo' | 'description'>
            )> }
          )>> }
        ) }
      )> }
    )>> }
  )> }
);

export type RepoGeneralDataQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
}>;


export type RepoGeneralDataQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id' | 'analyzeChangesetOnly' | 'defaultBranchName' | 'isSubmoduleEnabled' | 'config' | 'isActivated' | 'isPrivate' | 'autofixInstallationStatus' | 'autofixInstallationUrl'>
    & { repositoryGroup?: Maybe<(
      { __typename?: 'RepositoryGroup' }
      & Pick<RepositoryGroup, 'id' | 'name' | 'slug' | 'overrideRepoSetting'>
      & { repositoryGroupSetting?: Maybe<(
        { __typename?: 'RepositoryGroupSetting' }
        & Pick<RepositoryGroupSetting, 'id'>
      )> }
    )>, repositorySetting?: Maybe<(
      { __typename?: 'RepositorySetting' }
      & Pick<RepositorySetting, 'id' | 'inferDefaultBranchCommunity'>
    )> }
  )> }
);

export type IgnoreRulesQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type IgnoreRulesQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id' | 'hasViewerEditAccess'>
    & { silenceRules?: Maybe<(
      { __typename?: 'SilenceRuleConnection' }
      & Pick<SilenceRuleConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'SilenceRuleEdge' }
        & { node?: Maybe<(
          { __typename?: 'SilenceRule' }
          & Pick<SilenceRule, 'silenceLevel' | 'id' | 'filePath' | 'createdAt' | 'metadata'>
          & { issue: (
            { __typename?: 'Issue' }
            & Pick<Issue, 'shortcode' | 'title'>
            & { analyzer: (
              { __typename?: 'Analyzer' }
              & Pick<Analyzer, 'shortcode'>
            ) }
          ), creator?: Maybe<(
            { __typename?: 'User' }
            & Pick<User, 'firstName' | 'lastName' | 'email' | 'avatar'>
          )> }
        )> }
      )>> }
    )> }
  )> }
);

export type ManageRepositoryAccessQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
  q: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type ManageRepositoryAccessQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id'>
    & { collaborators?: Maybe<(
      { __typename?: 'RepositoryCollaboratorConnection' }
      & Pick<RepositoryCollaboratorConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'RepositoryCollaboratorEdge' }
        & { node?: Maybe<(
          { __typename?: 'RepositoryCollaborator' }
          & Pick<RepositoryCollaborator, 'id' | 'permission' | 'isPermFromVcs'>
          & { repository: (
            { __typename?: 'Repository' }
            & Pick<Repository, 'id'>
          ), user: (
            { __typename?: 'User' }
            & Pick<User, 'id' | 'firstName' | 'lastName' | 'fullName' | 'email' | 'avatar' | 'dateJoined'>
          ) }
        )> }
      )>> }
    )> }
  )> }
);

export type RepositoryReportingMetricSettingsQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
}>;


export type RepositoryReportingMetricSettingsQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id'>
    & { metricSettings?: Maybe<Array<Maybe<(
      { __typename?: 'MetricSetting' }
      & Pick<MetricSetting, 'name' | 'shortcode' | 'isIgnoredInCheckStatus' | 'isIgnoredToDisplay'>
    )>>> }
  )> }
);

export type RepositoryReportingSettingsQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
}>;


export type RepositoryReportingSettingsQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id' | 'name' | 'dsn'>
    & { repositoryGroup?: Maybe<(
      { __typename?: 'RepositoryGroup' }
      & Pick<RepositoryGroup, 'id' | 'name' | 'slug' | 'overrideRepoSetting'>
    )>, issueTypeSettings?: Maybe<Array<Maybe<(
      { __typename?: 'IssueTypeSetting' }
      & Pick<IssueTypeSetting, 'name' | 'slug' | 'description' | 'isIgnoredInCheckStatus' | 'isIgnoredToDisplay'>
    )>>>, issueSeveritySettings?: Maybe<Array<Maybe<(
      { __typename?: 'IssueSeveritySetting' }
      & Pick<IssueSeveritySetting, 'severity' | 'isIgnoredInCheckStatus'>
    )>>>, metricSettings?: Maybe<Array<Maybe<(
      { __typename?: 'MetricSetting' }
      & Pick<MetricSetting, 'name' | 'shortcode' | 'isIgnoredInCheckStatus' | 'isIgnoredToDisplay'>
    )>>> }
  )> }
);

export type SshQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SshQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<{ __typename?: 'AccessToken' } | { __typename?: 'AgentsProduct' } | { __typename?: 'Analyzer' } | { __typename?: 'AnalyzerCISnippet' } | { __typename?: 'AnalyzerReview' } | { __typename?: 'AnalyzerSyncJob' } | { __typename?: 'AuditLog' } | { __typename?: 'AutoOnboardEvent' } | { __typename?: 'AutofixRun' } | { __typename?: 'BilledRepositoryTarget' } | { __typename?: 'CallStackFrame' } | { __typename?: 'Check' } | { __typename?: 'CheckIssue' } | { __typename?: 'CheckPackage' } | { __typename?: 'CodeQualityProduct' } | { __typename?: 'ConfigGenerationRun' } | { __typename?: 'ConfigTemplate' } | { __typename?: 'EnterpriseBilledRepositoryTarget' } | { __typename?: 'EnterpriseGroup' } | { __typename?: 'EnterpriseInstallationSetup' } | { __typename?: 'EnterpriseTeam' } | { __typename?: 'EnterpriseUser' } | { __typename?: 'FeatureDefinition' } | { __typename?: 'GroupTeamMembership' } | { __typename?: 'GroupUserMembership' } | { __typename?: 'IDEProduct' } | { __typename?: 'IdentityProvider' } | { __typename?: 'Issue' } | { __typename?: 'IssuePriority' } | { __typename?: 'IssuePriorityType' } | { __typename?: 'License' } | { __typename?: 'Metric' } | { __typename?: 'Owner' } | { __typename?: 'OwnerAIPolicy' } | { __typename?: 'OwnerDynamicRiskConfig' } | { __typename?: 'OwnerLicensePolicy' } | { __typename?: 'OwnerProfile' } | { __typename?: 'OwnerSCAPolicy' } | { __typename?: 'OwnerSetting' } | { __typename?: 'PR' } | { __typename?: 'PRAuthor' } | { __typename?: 'Package' } | { __typename?: 'PackageUpgradeSummary' } | { __typename?: 'PackageVersion' } | { __typename?: 'ProductSubscription' } | { __typename?: 'PublicReport' } | (
    { __typename?: 'Repository' }
    & Pick<Repository, 'id' | 'encPublicKey'>
  ) | { __typename?: 'RepositoryCollaborator' } | { __typename?: 'RepositoryComplianceReportItem' } | { __typename?: 'RepositoryCoverageReportItem' } | { __typename?: 'RepositoryGroup' } | { __typename?: 'RepositoryGroupSetting' } | { __typename?: 'RepositoryIssue' } | { __typename?: 'RepositoryMetricValue' } | { __typename?: 'RepositoryPackage' } | { __typename?: 'RepositoryScaTargetReportItem' } | { __typename?: 'RepositorySetting' } | { __typename?: 'RepositoryTarget' } | { __typename?: 'Run' } | { __typename?: 'RunReport' } | { __typename?: 'Runner' } | { __typename?: 'RunnerApp' } | { __typename?: 'RuntimeLog' } | { __typename?: 'SCACheck' } | { __typename?: 'SCAProduct' } | { __typename?: 'SSOIdentityProvider' } | { __typename?: 'SilenceRule' } | { __typename?: 'SourceableRepository' } | { __typename?: 'Team' } | { __typename?: 'TeamBasePermissionSet' } | { __typename?: 'TeamMember' } | { __typename?: 'TeamMemberAdditionRequest' } | { __typename?: 'TeamMemberInvitation' } | { __typename?: 'Transaction' } | { __typename?: 'TransformerReview' } | { __typename?: 'TransformerRun' } | { __typename?: 'TransformerTool' } | { __typename?: 'UnifiedProduct' } | { __typename?: 'User' } | { __typename?: 'UserPreference' } | { __typename?: 'UserProfile' } | { __typename?: 'UserSocialConnection' } | { __typename?: 'VerifiableDomain' } | { __typename?: 'Vulnerability' } | { __typename?: 'VulnerabilityCallStack' } | { __typename?: 'VulnerabilityOccurrence' } | { __typename?: 'VulnerabilityRemediationFixPath' } | { __typename?: 'VulnerabilityRemediationFixPathUpdate' } | { __typename?: 'VulnerabilityRemediationPatchRun' } | { __typename?: 'Webhook' } | { __typename?: 'WebhookEventDelivery' } | { __typename?: 'WebhookEventTypes' }> }
);

export type VcsReportingOptionsQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
  includeGitlabIntegrationUseStatus: Scalars['Boolean'];
}>;


export type VcsReportingOptionsQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & MakeOptional<Pick<Repository, 'id' | 'gitlabIntegrationUseStatus'>, 'gitlabIntegrationUseStatus'>
    & { repositorySetting?: Maybe<(
      { __typename?: 'RepositorySetting' }
      & Pick<RepositorySetting, 'id' | 'vcsReportingOptionsEnabled'>
    )> }
  )> }
);

export type RepoStatusPollQueryQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
}>;


export type RepoStatusPollQueryQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id' | 'errorCode' | 'defaultBranchName'>
    & { lastRun?: Maybe<(
      { __typename?: 'Run' }
      & Pick<Run, 'id' | 'runId' | 'config' | 'commitOid' | 'branchRunCount' | 'status' | 'finishedAt'>
    )>, latestAnalysisRun?: Maybe<(
      { __typename?: 'Run' }
      & Pick<Run, 'id' | 'runId' | 'config' | 'commitOid' | 'branchRunCount' | 'status' | 'finishedAt'>
    )> }
  )> }
);

export type SubRepositoryListQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  nameFuzzy?: Maybe<Scalars['String']>;
}>;


export type SubRepositoryListQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id'>
    & { subRepos?: Maybe<(
      { __typename?: 'RepositoryConnection' }
      & Pick<RepositoryConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'RepositoryEdge' }
        & { node?: Maybe<(
          { __typename?: 'Repository' }
          & Pick<Repository, 'id' | 'name' | 'displayName' | 'vcsProvider' | 'isActivated' | 'isPrivate' | 'latestCommitOid' | 'defaultBranchName' | 'lastAnalyzedAt' | 'kind'>
        )> }
      )>> }
    )> }
  )> }
);

export type TeamHomeSearchRepoListQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
  first?: Maybe<Scalars['Int']>;
  query?: Maybe<Scalars['String']>;
  kindIn?: Maybe<Array<Maybe<RepositoryKindChoices>> | Maybe<RepositoryKindChoices>>;
}>;


export type TeamHomeSearchRepoListQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { repositories?: Maybe<(
      { __typename?: 'RepositoryConnection' }
      & Pick<RepositoryConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'RepositoryEdge' }
        & { node?: Maybe<(
          { __typename?: 'Repository' }
          & Pick<Repository, 'id' | 'name' | 'displayName' | 'kind' | 'isPrivate' | 'vcsProvider' | 'ownerLogin' | 'lastAnalyzedAt' | 'defaultBranchName'>
          & { availableAnalyzers?: Maybe<(
            { __typename?: 'AnalyzerConnection' }
            & { edges: Array<Maybe<(
              { __typename?: 'AnalyzerEdge' }
              & { node?: Maybe<(
                { __typename?: 'Analyzer' }
                & Pick<Analyzer, 'id' | 'name' | 'shortcode' | 'analyzerLogo'>
              )> }
            )>> }
          )>, latestPr?: Maybe<(
            { __typename?: 'PR' }
            & Pick<Pr, 'id' | 'number' | 'modifiedAt'>
          )> }
        )> }
      )>> }
    )> }
  )> }
);

export type RepositoryWidgetsQueryVariables = Exact<{
  provider: VcsProviderChoices;
  owner: Scalars['String'];
  name: Scalars['String'];
}>;


export type RepositoryWidgetsQuery = (
  { __typename?: 'Query' }
  & { repository?: Maybe<(
    { __typename?: 'Repository' }
    & Pick<Repository, 'id' | 'widgets' | 'widgetsDisplay' | 'widgetsAvailable' | 'allWidgets'>
  )> }
);

export type TeamLevelAuditLogQueryVariables = Exact<{
  provider: VcsProviderChoices;
  login: Scalars['String'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  createdAtGte?: Maybe<Scalars['Date']>;
  createdAtLte?: Maybe<Scalars['Date']>;
  q?: Maybe<Scalars['String']>;
}>;


export type TeamLevelAuditLogQuery = (
  { __typename?: 'Query' }
  & { team?: Maybe<(
    { __typename?: 'Team' }
    & Pick<Team, 'id' | 'name'>
    & { logs?: Maybe<(
      { __typename?: 'AuditLogConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'AuditLogEdge' }
        & { node?: Maybe<(
          { __typename?: 'AuditLog' }
          & Pick<AuditLog, 'id' | 'eventName' | 'description' | 'ipAddress' | 'location' | 'createdAt'>
          & { actor?: Maybe<(
            { __typename?: 'User' }
            & Pick<User, 'fullName' | 'firstName' | 'email' | 'avatar'>
          )> }
        )> }
      )>> }
    )>, fullLogs?: Maybe<(
      { __typename?: 'AuditLogConnection' }
      & Pick<AuditLogConnection, 'totalCount'>
    )> }
  )> }
);

export type GetTeamMemberRequestStatusQueryVariables = Exact<{
  teamId: Scalars['ID'];
}>;


export type GetTeamMemberRequestStatusQuery = (
  { __typename?: 'Query' }
  & { getTeamMemberAdditionRequests?: Maybe<(
    { __typename?: 'GetTeamMemberRequestStatus' }
    & Pick<GetTeamMemberRequestStatus, 'status'>
  )> }
);

export type InviteUrlQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
}>;


export type InviteUrlQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { team?: Maybe<(
      { __typename?: 'EnterpriseTeam' }
      & Pick<EnterpriseTeam, 'id' | 'invitationUrl'>
    )> }
  )> }
);

export type TeamInvitesQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
  limit?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  q?: Maybe<Scalars['String']>;
}>;


export type TeamInvitesQuery = (
  { __typename?: 'Query' }
  & { team?: Maybe<(
    { __typename?: 'Team' }
    & Pick<Team, 'id'>
    & { invites?: Maybe<(
      { __typename?: 'TeamMemberInvitationConnection' }
      & Pick<TeamMemberInvitationConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'TeamMemberInvitationEdge' }
        & { node?: Maybe<(
          { __typename?: 'TeamMemberInvitation' }
          & Pick<TeamMemberInvitation, 'email' | 'createdAt' | 'role'>
        )> }
      )>> }
    )> }
  )> }
);

export type TeamMemberListQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
  limit?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
  canInvite: Scalars['Boolean'];
}>;


export type TeamMemberListQuery = (
  { __typename?: 'Query' }
  & { team?: Maybe<(
    { __typename?: 'Team' }
    & MakeOptional<Pick<Team, 'id' | 'numMembersTotal' | 'invitationUrl'>, 'invitationUrl'>
    & { teamMembers: (
      { __typename?: 'TeamMemberConnection' }
      & Pick<TeamMemberConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'TeamMemberEdge' }
        & { node?: Maybe<(
          { __typename?: 'TeamMember' }
          & Pick<TeamMember, 'id' | 'role' | 'isPrimaryUser' | 'isRoleFromVcs'>
          & { user: (
            { __typename?: 'User' }
            & Pick<User, 'id' | 'fullName' | 'email' | 'avatar' | 'dateJoined'>
          ) }
        )> }
      )>> }
    ) }
  )> }
);

export type TeamMemberAdditionRequestsQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
  limit?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  q?: Maybe<Scalars['String']>;
}>;


export type TeamMemberAdditionRequestsQuery = (
  { __typename?: 'Query' }
  & { team?: Maybe<(
    { __typename?: 'Team' }
    & Pick<Team, 'id'>
    & { additionRequests?: Maybe<(
      { __typename?: 'TeamMemberAdditionRequestConnection' }
      & Pick<TeamMemberAdditionRequestConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'TeamMemberAdditionRequestEdge' }
        & { node?: Maybe<(
          { __typename?: 'TeamMemberAdditionRequest' }
          & Pick<TeamMemberAdditionRequest, 'id' | 'createdAt'>
          & { user: (
            { __typename?: 'User' }
            & Pick<User, 'email'>
          ) }
        )> }
      )>> }
    )> }
  )> }
);

export type MemberRoleCountQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
  query?: Maybe<Scalars['String']>;
}>;


export type MemberRoleCountQuery = (
  { __typename?: 'Query' }
  & { team?: Maybe<(
    { __typename?: 'Team' }
    & Pick<Team, 'id'>
    & { adminCount: (
      { __typename?: 'TeamMemberConnection' }
      & Pick<TeamMemberConnection, 'totalCount'>
    ) }
  )> }
);

export type MembersBaseDetailsQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
  limit?: Maybe<Scalars['Int']>;
}>;


export type MembersBaseDetailsQuery = (
  { __typename?: 'Query' }
  & { team?: Maybe<(
    { __typename?: 'Team' }
    & Pick<Team, 'id'>
    & { teamMembers: (
      { __typename?: 'TeamMemberConnection' }
      & Pick<TeamMemberConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'TeamMemberEdge' }
        & { node?: Maybe<(
          { __typename?: 'TeamMember' }
          & Pick<TeamMember, 'id'>
          & { user: (
            { __typename?: 'User' }
            & Pick<User, 'id' | 'fullName' | 'avatar'>
          ) }
        )> }
      )>> }
    ) }
  )> }
);

export type ModifiedPermsCountQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
  isRoleFromVcs: Scalars['Boolean'];
  first?: Maybe<Scalars['Int']>;
}>;


export type ModifiedPermsCountQuery = (
  { __typename?: 'Query' }
  & { team?: Maybe<(
    { __typename?: 'Team' }
    & Pick<Team, 'id'>
    & { teamMembers: (
      { __typename?: 'TeamMemberConnection' }
      & Pick<TeamMemberConnection, 'totalCount'>
    ), repositoryCollaborators: (
      { __typename?: 'RepositoryCollaboratorConnection' }
      & Pick<RepositoryCollaboratorConnection, 'totalCount'>
    ) }
  )> }
);

export type TeamSecuritySettingsQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
}>;


export type TeamSecuritySettingsQuery = (
  { __typename?: 'Query' }
  & { owner?: Maybe<(
    { __typename?: 'Owner' }
    & Pick<Owner, 'id'>
    & { billingInfo?: Maybe<(
      { __typename?: 'BillingInfo' }
      & Pick<BillingInfo, 'billingBackend'>
    )>, team?: Maybe<(
      { __typename?: 'EnterpriseTeam' }
      & Pick<EnterpriseTeam, 'id' | 'name' | 'vcsProvider'>
      & { verifiableDomain?: Maybe<(
        { __typename?: 'VerifiableDomain' }
        & Pick<VerifiableDomain, 'id' | 'domainName' | 'verified'>
      )>, identityProvider?: Maybe<(
        { __typename?: 'IdentityProvider' }
        & Pick<IdentityProvider, 'id' | 'xmlMetadataUrl' | 'provider' | 'isScimEnabled' | 'isScimAuthTokenSet'>
        & { domain: (
          { __typename?: 'VerifiableDomain' }
          & Pick<VerifiableDomain, 'id' | 'domainName' | 'verified'>
        ) }
      )> }
    )> }
  )> }
);

export type FetchTeamPermissionsQueryVariables = Exact<{
  login: Scalars['String'];
  provider: VcsProviderChoices;
}>;


export type FetchTeamPermissionsQuery = (
  { __typename?: 'Query' }
  & { team?: Maybe<(
    { __typename?: 'Team' }
    & Pick<Team, 'id' | 'login' | 'syncPermissionsWithVcs'>
    & { basePermissionSet?: Maybe<(
      { __typename?: 'TeamBasePermissionSet' }
      & Pick<TeamBasePermissionSet, 'id' | 'defaultRepositoryPermission' | 'canMembersIgnoreIssues' | 'canContributorsIgnoreIssues' | 'canMembersModifyMetricThresholds' | 'canContributorsModifyMetricThresholds' | 'canMembersIgnoreFailingMetrics' | 'canContributorsIgnoreFailingMetrics'>
      & { team: (
        { __typename?: 'EnterpriseTeam' }
        & Pick<EnterpriseTeam, 'id'>
      ) }
    )> }
  )> }
);

export type ActiveUserAccountInfoQueryVariables = Exact<{
  login?: Maybe<Scalars['String']>;
  isViewerPrimaryUser?: Maybe<Scalars['Boolean']>;
}>;


export type ActiveUserAccountInfoQuery = (
  { __typename?: 'Query' }
  & { viewer?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'connectedVcsProviders' | 'fullName' | 'firstName' | 'lastName' | 'email' | 'avatar' | 'lastLogin' | 'isActive' | 'isAsgardian' | 'isBetaTester' | 'isStaff' | 'dashboardContext' | 'availableCredits' | 'dateJoined'>
    & { socialConnections: Array<(
      { __typename?: 'UserSocialConnection' }
      & Pick<UserSocialConnection, 'uid' | 'enabledOn' | 'provider'>
    )>, personalAccounts?: Maybe<(
      { __typename?: 'OwnerConnection' }
      & Pick<OwnerConnection, 'totalCount'>
    )>, teamAccounts?: Maybe<(
      { __typename?: 'TeamConnection' }
      & Pick<TeamConnection, 'totalCount'>
    )>, primaryTeamAccounts?: Maybe<(
      { __typename?: 'TeamConnection' }
      & Pick<TeamConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'TeamEdge' }
        & { node?: Maybe<(
          { __typename?: 'Team' }
          & Pick<Team, 'id' | 'login' | 'vcsProvider'>
        )> }
      )>> }
    )> }
  )> }
);

export type ActiveUserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveUserInfoQuery = (
  { __typename?: 'Query' }
  & { viewer?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'analyticsId' | 'connectedVcsProviders' | 'fullName' | 'firstName' | 'lastName' | 'email' | 'avatar' | 'lastLogin' | 'isActive' | 'isAsgardian' | 'isBetaTester' | 'isStaff' | 'isIdeUser' | 'dashboardContext' | 'availableCredits' | 'dateJoined'>
    & { primaryOwner?: Maybe<(
      { __typename?: 'Owner' }
      & Pick<Owner, 'id' | 'login' | 'vcsProvider'>
    )>, socialConnections: Array<(
      { __typename?: 'UserSocialConnection' }
      & Pick<UserSocialConnection, 'id' | 'uid' | 'enabledOn' | 'provider'>
    )>, profile?: Maybe<(
      { __typename?: 'UserProfile' }
      & Pick<UserProfile, 'id' | 'companySize'>
    )> }
  )> }
);

export type EnterpriseUserDetailQueryVariables = Exact<{ [key: string]: never; }>;


export type EnterpriseUserDetailQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'isViewerSuperadmin'>
  & { enterprise?: Maybe<(
    { __typename?: 'EnterpriseInstallationRoot' }
    & { installation?: Maybe<(
      { __typename?: 'EnterpriseInstallationSetup' }
      & Pick<EnterpriseInstallationSetup, 'logo'>
    )> }
  )> }
);

export type RecommendedIssuesQueryVariables = Exact<{ [key: string]: never; }>;


export type RecommendedIssuesQuery = (
  { __typename?: 'Query' }
  & { viewer?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id'>
    & { recommendedIssues?: Maybe<(
      { __typename?: 'RepositoryIssueConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'RepositoryIssueEdge' }
        & { node?: Maybe<(
          { __typename?: 'RepositoryIssue' }
          & Pick<RepositoryIssue, 'id' | 'title' | 'shortcode' | 'issueType' | 'modifiedAt' | 'createdAt' | 'seenIn' | 'firstSeen' | 'lastSeen' | 'occurrenceCount' | 'autofixAvailable' | 'raisedInFiles'>
          & { repositoryInstance: (
            { __typename?: 'Repository' }
            & Pick<Repository, 'id' | 'name' | 'vcsProvider'>
            & { owner: (
              { __typename?: 'Owner' }
              & Pick<Owner, 'id' | 'login'>
            ) }
          ) }
        )> }
      )>> }
    )> }
  )> }
);

export type ViewerStarredReposQueryVariables = Exact<{
  provider?: Maybe<VcsProviderChoices>;
  login?: Maybe<Scalars['String']>;
}>;


export type ViewerStarredReposQuery = (
  { __typename?: 'Query' }
  & { viewer?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id'>
    & { preference?: Maybe<(
      { __typename?: 'UserPreference' }
      & { starredRepositories: (
        { __typename?: 'RepositoryConnection' }
        & { edges: Array<Maybe<(
          { __typename?: 'RepositoryEdge' }
          & { node?: Maybe<(
            { __typename?: 'Repository' }
            & Pick<Repository, 'id' | 'name' | 'displayName' | 'vcsProvider' | 'ownerLogin' | 'kind' | 'isPrivate'>
          )> }
        )>> }
      ) }
    )> }
  )> }
);

export type SuperAdminCheckQueryVariables = Exact<{ [key: string]: never; }>;


export type SuperAdminCheckQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'isViewerSuperadmin'>
);

export type UserAdsOrganizationInfoQueryVariables = Exact<{
  login: Scalars['String'];
}>;


export type UserAdsOrganizationInfoQuery = (
  { __typename?: 'Query' }
  & { viewer?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id'>
    & { adsOrganization?: Maybe<(
      { __typename?: 'ADSOrganization' }
      & Pick<AdsOrganization, 'login' | 'hasInstalled' | 'hasEnabledThirdPartyAccess'>
    )> }
  )> }
);

export type UserAdsOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserAdsOrganizationsQuery = (
  { __typename?: 'Query' }
  & { viewer?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id'>
    & { adsOrganizations?: Maybe<Array<Maybe<(
      { __typename?: 'ADSOrganization' }
      & Pick<AdsOrganization, 'login' | 'hasInstalled' | 'isViewerOwner' | 'hasEnabledThirdPartyAccess' | 'orgSettingsUrl'>
    )>>> }
  )> }
);

export type UserBbdProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserBbdProjectsQuery = (
  { __typename?: 'Query' }
  & { viewer?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id'>
    & { bitbucketDatacenterProjects?: Maybe<Array<Maybe<(
      { __typename?: 'BitbucketDataCenterProject' }
      & Pick<BitbucketDataCenterProject, 'key' | 'name' | 'isViewerOwner' | 'hasInstalled'>
    )>>> }
  )> }
);

export type UserGitlabAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserGitlabAccountsQuery = (
  { __typename?: 'Query' }
  & { viewer?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'gitlabAccounts'>
  )> }
);

export type ActiveUserWorkspacesQueryVariables = Exact<{
  login?: Maybe<Scalars['String']>;
}>;


export type ActiveUserWorkspacesQuery = (
  { __typename?: 'Query' }
  & { viewer?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id'>
    & { personalAccounts?: Maybe<(
      { __typename?: 'OwnerConnection' }
      & Pick<OwnerConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'OwnerEdge' }
        & { node?: Maybe<(
          { __typename?: 'Owner' }
          & Pick<Owner, 'login' | 'vcsProvider' | 'avatar' | 'activeRepositoryCount'>
        )> }
      )>> }
    )>, teamAccounts?: Maybe<(
      { __typename?: 'TeamConnection' }
      & Pick<TeamConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'TeamEdge' }
        & { node?: Maybe<(
          { __typename?: 'Team' }
          & Pick<Team, 'login' | 'vcsProvider' | 'avatar' | 'activeRepositoryCount' | 'numMembersTotal' | 'roleInGroup' | 'isViewerPrimaryUser'>
        )> }
      )>> }
    )> }
  )> }
);
